/* material tiers (owner 2026-11-01: base / ultra / exotic, exotic like a Destiny weapon) */
    (function(){ if(document.getElementById('va-tier-css')) return; var st=document.createElement('style'); st.id='va-tier-css';
      st.textContent='.va-tier{display:inline-flex;align-items:center;gap:4px;margin-left:6px;padding:2px 8px 2px 6px;border-radius:4px;font-size:10.5px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;vertical-align:middle;line-height:1.5;border:1px solid currentColor;white-space:nowrap}.va-tier svg{flex:none}.va-tier-base{color:#9aa7bd;background:rgba(154,167,189,.10)}.va-tier-ultra{color:#b98cff;background:rgba(150,95,255,.16)}.va-tier-exotic{color:#1a1200;border-color:#f3d36b;background:linear-gradient(110deg,#c9971c 0%,#f5d76e 38%,#fff3c4 50%,#f5d76e 62%,#c9971c 100%);background-size:220% 100%;box-shadow:0 0 10px rgba(245,205,90,.45);animation:vaExo 3.2s linear infinite}@keyframes vaExo{0%{background-position:120% 0}100%{background-position:-120% 0}}@media (prefers-reduced-motion:reduce){.va-tier-exotic{animation:none;background-position:50% 0}}html[data-vatheme="light"] .va-tier-base{color:#55627a}html[data-vatheme="light"] .va-tier-ultra{color:#6a3df0;background:rgba(106,61,240,.08)}.matcard .mattx b .va-tier{display:inline-flex;width:auto;margin:0 0 0 6px;padding:1px 7px 1px 5px;font-size:9.5px;vertical-align:2px}.matcard .mattx b .va-tier svg{display:inline-block;width:8px;height:8px}'; document.head.appendChild(st); })();
/* Serial Seal — the seal builder.
 *
 * THIS FILE WAS THE INLINE <script> IN sections/sv-builder.liquid until
 * 2026-08-08. It moved out unchanged because the SECTION hit Shopify's 256 KB
 * template limit — it had 4.3 KB of headroom left, and the three serial types
 * needed more than that. A section that is 93% JavaScript was going to hit
 * that wall on whichever feature came next; this is that wall dealt with once.
 *
 * LOAD ORDER IS LOAD-BEARING and unchanged: the section renders twelve plain
 * synchronous ss-*.js tags (guilloche, render, art, seal, upload, designs,
 * templates, ui) and then this one, in the same position the inline block
 * occupied. No defer, no module — those globals must exist before the first
 * line here runs.
 *
 * AN ASSET CANNOT CARRY LIQUID. Everything this file needs from the theme
 * arrives on `window.SV_CFG`, set by the one inline block left in the section:
 * the product handle and the two material roll photographs. Anything else that
 * ever needs a Liquid value goes there too — never back into this file.
 */
'use strict';
/* Serial Seal builder.
 *
 * Everything the customer sees is derived from the selected template's `caps`
 * metadata (see ss-templates.js) — cards, form controls, validation and the
 * order gate. No control is hardcoded per design, and nothing is inferred from
 * a template's name.
 *
 * Preview == print: every seal on this page, from the card thumbnails to the
 * actual-size reference, is rendered by SS_SEAL.build() from the same template
 * tokens the production payload carries. There is no second renderer.
 */

var QR_MAX = 60;              // longer codes stop scanning reliably at seal size
var BRAND_MAX = 26;
/* worker relay: customer files land in the store's own Shopify Files area the
   moment they're added — the order then carries a permanent CDN URL instead of
   "customer will email". Worker name must not change (webhook + verify_url). */
var SS_WORKER = 'https://slabvane-verify.vialart.workers.dev';
var Q_THUMB = 0.45;           // gallery quality — the guilloche engine is far too dense at 1
// Mobile-first zoom ladder. Index 2 is the default: the preview is the page's
// hero card now, so the portrait seal opens at 176px and the landscape die
// fills the card width (max-width:100% clamps it).
var ZOOMS = [108, 136, 176, 228];

var st = {
  tpl: null,
  /* Which of the two ways in they took — '' until they answer the fork,
     then 'logo' or 'gallery'. It is a STARTING POINT, never a lock: see
     setPath(). */
  path: 'gallery',
  /* 'all' since the filter chips were removed (owner 2026-08-08). The grid
     still filters on st.cat, so anything narrower here renders an EMPTY
     gallery with no control on screen to widen it again. */
  cat: 'all',
  brand: '', color: '',
  /* ——— NO STORE NAME — THE LOGO CARRIES THE SEAL (owner 2026-09-16) ———
     Two values, and the empty one is the whole back-compatibility promise:
       ''      print the store name. Every order ever placed, and every order
               that never touches the new control, is this — and renders
               byte-identically to before this flag existed.
       'logo'  print NO brand text at all. The uploaded logo is what says
               whose seal this is.
     Born from ss1115 (Brett Kleinman, 600 seals): a stadium photo with his
     own logo on it, and our grey brand band laying BKBREAKS across the top
     of it. His design was already finished; the text was the only thing
     wrong with it.

     ⚠ NEVER read this key directly. noBrand() is the only honest test,
     because it re-checks st.logo: a seal with neither a name nor a logo has
     nothing on it that identifies it, so the flag must not survive the logo
     being removed. gateOk() already encodes exactly that rule. */
  brandMode: '',
  qr: '', qty: 60, orientation: 'portrait',   /* 60 = the 2026-08-30 minimum */
  /* ——— QR + numbering (owner 2026-08-05: the registry is retired) ———
     We print and number seals; we do not host records for new orders. So there
     are exactly two QR destinations and exactly one numbering scheme:
       qrMode      'own'  = st.qr, the customer's site / listing / profile
                            (DEFAULT — an empty field simply prints no code)
                   'none' = no QR on the seal at all
     There is no serial MODE any more: the numbering is always the customer's
     own. `serialStart` defaults to '001' so a customer who touches nothing
     still ships valid sequential numbers — an order must never be placed
     without serials. The leading zeros ARE the pad width (see serialAt). */
  /* A FOURTH value since 2026-09-15: 'sku'. The code encodes THIS SEAL'S OWN
     SERIAL as plain text -- no scheme, no host, no padding -- so a
     keyboard-wedge 2D scanner at a shop's till types exactly the serial into
     the item search and the matching catalogue item rings up. It is the one
     mode with no destination: st.qr is not read and no 'QR link' is written.
     Compatibility statement only: it works with Square Point of Sale and any
     till that looks an item up by SKU. Never claim endorsement. */
  qrMode: 'own',
  /* 'list' (2026-10-20): a link PER SEAL from the customer's own sheet -
     qrList is the checked sheet (assets/sv-qrlist.js SVQL.check), null until
     one is uploaded. Serials come from the sheet too; _serial_type 'list'. */
  qrList: null,
  /* the No-QR slot filler — a key from SS_MOTIFS, '' = leave the slot to
     the layout's own reflow */
  motif: '',
  /* WHICH NUMBERING SCHEME (owner 2026-08-08) — 'seq' | 'rand' | 'batch'.
     They differ in what they DO for the seller, not in how they look:
     seq COUNTS (a ledger row per seal), rand CONCEALS (a sequence tells the
     buyer your run size and tells a forger the next number), batch GROUPS
     (which run did this seal come from, months later, in a claim).
     'seq' is the default and is what every order placed before today used. */
  /* ALWAYS RANDOM since 2026-08-17 (owner: "they are just randomly
     generated now") — the picker is gone; 'seq'/'batch' survive only as
     prefill values so old orders reorder exactly as bought. */
  serialType: 'rand',
  /* Pre-filled at boot with a random 4-character code + '-' (see
     sessionPrefix): untouched orders used to ship bare 001, 002, 003, which is
     nobody's numbering. Editable, re-rollable, and NEVER overwritten on a
     reorder or a cart edit. */
  serialPrefix: '',
  /* label size (owner 2026-08-29): standard is the only orderable size; the
     Large card renders COMING SOON and cannot be selected. When the Large
     product exists and is IN STOCK its card auto-enables (see sizeCards) -
     until then nothing about the cart or pricing changes. */
  sizeId: 'standard_177x075',
  serialStart: '001',
  /* Batch numbering only. Defaults to YYMM the moment that scheme is chosen —
     the date is what makes a batch answer "which run was this?". */
  serialBatch: '',
  /* Portrait · Single again (owner 2026-08-16). It was the default until
     2026-08-11, when the Slab Banner took the slot. */
  sealStyle: 'single',
  /* Skip the Production Line. OFF by default and never pre-ticked: a paid
     add-on that is on unless you notice it is the shape of complaint that ends
     in chargebacks, and it is the customer's money. Set to true by
     refreshCartSeals() when the cart ALREADY carries a rush line, so the box
     never contradicts what the order is. */
  rush: false,
  /* Physical stock. Both print identically — the difference is the holographic
     film itself, and it decides WHICH PRESS the job routes to in Label Farm
     (Prism and Aurora each have their roll loaded). */
  material: 'Shattered Prism',
  artwork: null,             // {name, dataUrl, thumb, w, h, kb}
  bg: null,                  // customer background — same shape as st.artwork
  logo: null,                // {name, dataUrl, thumb, w, h, kb}
  grade: '',                 // optional condition call — '10', '9.5', 'NM' …
  /* WHERE THE LOGO GOES — the only key that answers it, on this side and in
     the compositor and on the press:
       'window'  featured in the frame, over the background if there is one
       'mark'    small, above the store name; the picture stays clear
       'off'     their picture already contains the logo, so don't print it
                 a second time on top (this replaced st.bgOwnLogo, a second
                 flag that described the same decision and could disagree
                 with this one — owner 2026-08-08)
     Only meaningful once a background exists; logoPlace() enforces that. */
  logoMode: '',
  /* Always 1 = full slot width. Kept as state (not deleted) because the
     reorder and cart-edit paths restore a past order's logo_scale, so an
     order placed while the slider existed still reprints as it shipped. */
  logoScale: 1,
  siteText: '',          // custom domain for the printed wordmark ('' = ours)
  zoom: 2
};

function caps() { return (st.tpl && st.tpl.caps) || {}; }
/* Pack model: the product has ONE variant per material (a 12-seal pack) and
   the cart line's QUANTITY is the pack count. st.qty stays the TOTAL seal
   count (packs × 12) — the numbering runs across the TOTAL, so every seal in
   every pack still gets its own number. */
/* PACK_PAID === PACK_UNIT since 2026-08-12: the ladder prices per SEAL
   ($0.50 down to $0.30), so the old "10 paid + 2 free" framing is retired.
   The pack of 12 survives as the cart unit because Label Farm's ingest
   derives the seal count from it (`total = packs * 12`) and every rung on the
   new ladder is a multiple of 12. */
var PACK_UNIT = 12, PACK_PAID = 12;
/* HAPTICS (owner 2026-08-17: "haptic touch for the buttons and the slider").
   navigator.vibrate is Android Chrome; iOS Safari has no web vibration API,
   so there this is a silent no-op — never an error, never a fallback sound. */
function buzz(ms) {
  try {
    if (navigator.vibrate) { navigator.vibrate(ms || 8); return; }
    /* iOS Safari has no vibrate API, but 17.4+ ticks the Taptic engine when
       a switch control toggles inside a user gesture — every buzz() call
       here happens in a pointer/click/input handler, which qualifies. The
       control is off-screen and inert; its checked state means nothing. */
    var sw = document.getElementById('ss-haptic');
    if (!sw) {
      sw = document.createElement('input');
      sw.type = 'checkbox';
      try { sw.setAttribute('switch', ''); } catch (_) {}
      sw.id = 'ss-haptic';
      sw.tabIndex = -1;
      sw.setAttribute('aria-hidden', 'true');
      sw.style.cssText = 'position:fixed;left:-99px;top:0;width:1px;height:1px;' +
        'opacity:0;pointer-events:none';
      document.body.appendChild(sw);
    }
    sw.click();
  } catch (_) {}
}
document.addEventListener('pointerdown', function (e) {
  if (!e.target || !e.target.closest) return;
  if (e.target.closest('.qd-tier,.qm,.bgcar-t,.sqk-b,.rushbtn,.cta,.logotile,' +
                       '.va-qsb,.otile,.svq,.qn-go,.btn,.btn2,' +
                       '.rs-thumb,#ss-qsl')) buzz(8);
}, { passive: true });
/* 60 seals = 5 packs = $30.00 — the minimum (owner 2026-08-30, set together
   with the list re-cut to $0.50). History that must stay visible: a 60-seal
   minimum at the OLD $0.60 list shipped Aug 13 and orders stopped for 3 days
   ($36 entry); 24 was the Aug-17 compromise. The owner re-raised to 60 with
   the cheaper $0.50 entry — $30.00 to start. */
var PACK_MIN = 5;
/* ONE PRESS OF + OR - = ONE PACK (12 seals). The 60-at-a-time stepping of
   2026-08-14 assumed a 60-seal floor; from a 24-seal start it would skip 60
   entirely (24 -> 48 -> 72), and 60 is a named tier on every marketing
   surface. The discount chips still jump straight to the 120 and 600 rungs,
   so the stepper only ever covers short distances. */
var QTY_STEP = PACK_UNIT;

/* == THE 60-SEAL MINIMUM IS CART-WIDE (owner 2026-09-05) ==================
   A customer asked to mix designs at different quantities in one order. The
   rule the owner set is about the ORDER, not the line: "as long as all serials
   are above the minimum". So the floor this builder enforces is what is still
   MISSING from the 60 - a cart already holding 60 seals lets the next design
   be one pack.

     effMinPacks() = max(1, PACK_MIN - seal packs already in the cart)

   EVERY minimum on this page reads through effMinPacks(): the setPaid() clamp
   and its toast, the quantity input's min and its typing guard, the slider's
   log origin (slider 0 IS the smallest allowed order), the Starter tile, the
   promo line, blockers() and the quantity the builder boots at. There is no
   second copy of the number, because the two that existed before this - the
   input's `min` and the slider's origin - are exactly the pair that would let
   a 12-seal line through a 60-seal gate.

   WHAT COUNTS (and what emphatically does not): seal packs only, by SKU -
   SVN-PACK* (standard) and SVN-WIDE* (large), both foils. Grading stickers
   (SVN-TAG), Lost & Found labels (SVN-LOST / SVN-LOSTW), the priority fee
   (PRIORITY-PROD), certificates and the Business plan are different products
   with their own minimums and must never buy down this one.

   THE LINE BEING EDITED IS EXCLUDED. Editing the 60-seal line re-adds it, so
   counting it would let a 60-seal order be rewritten to 12 by pressing Edit -
   the exact hole the cart page's locked quantity stepper exists to close.

   CART UNREADABLE => THE FULL 60. Shopify answers /cart.js with a challenge
   page under load, and a fetch that failed is not evidence of a cart that
   qualifies. Failing open here would publish a 12-seal entry price.

   THE REMOVAL PATH IS OPEN, AND IT IS AN OWNER DECISION, NOT AN OVERSIGHT
   (raised 2026-09-08). This builder is now the ONLY gate on the 60: add 60
   seals, add a 12-seal second design, then press Remove on the 60-line on
   /cart (ss-cart.js posts quantity 0 and reloads) and a 12-seal, $6.00 order
   checks out. Shopify has no server-side minimum and the cart page's quantity
   LOCK does not cover removal. Nothing downstream breaks - it is a valid
   1-pack SVN-PACK line and Label Farm ingests it as one 12-seal job on one
   sheet - so this is a pricing/ops exposure, not a data one. Closing it needs
   a file this task does not own: either a cart-page guard in ss-cart.js
   (1..4 total seal packs => disable checkout and state the shortfall) or a
   Shopify Function for a real server-side floor. Considered and left open on
   purpose; do not "fix" it here by failing the builder closed again. */
var _lastCart = null;         /* the last /cart.js body, or null = never read */
/* Quantity the CUSTOMER chose. Until this is true the builder still owns the
   number and may lower it to the effective minimum when the cart read lands;
   after it, the number is theirs and only a cart that SHRANK may raise it. */
var _qtyUserSet = false;

function _skuOf(it) { return String((it && it.sku) || '').toUpperCase(); }
/* a seal pack line - the SKU, never a property a browser wrote */
function isSealPackLine(it) {
  var k = _skuOf(it);
  return k.indexOf('SVN-PACK') === 0 || k.indexOf('SVN-WIDE') === 0;
}
/* which ladder the line pools into: Standard and Large are two Shopify
   products behind two separate sets of automatic discounts, so their packs
   never add up for a tier (ss-cart.js paintLadder holds the same line) */
function isLargeSealLine(it) {
  return _skuOf(it).indexOf('SVN-WIDE') === 0 ||
         !!(it && it.properties && it.properties._label_size_id === 'large_250x100');
}
/* Seal PACKS already in the cart, split by product, EXCLUDING the line this
   builder is editing. Recomputed from the cached cart on every read rather
   than cached itself: window._ssEditKey is set during boot and cleared in
   placeOrder(), and a number cached across either of those would be a
   minimum that disagrees with the cart it came from. */
function cartSealPacks() {
  var o = { total: 0, standard: 0, large: 0 };
  var skip = String(window._ssEditKey || '');
  var items = (_lastCart && _lastCart.items) || [];
  for (var i = 0; i < items.length; i++) {
    var it = items[i];
    if (!isSealPackLine(it)) continue;
    if (skip && String(it.key) === skip) continue;
    var q = parseInt(it.quantity, 10) || 0;
    o.total += q;
    if (isLargeSealLine(it)) o.large += q; else o.standard += q;
  }
  return o;
}
/* THE ONE MINIMUM. Packs, never seals - every caller multiplies by PACK_UNIT
   itself so the unit is visible at the point of use. */
function effMinPacks() {
  if (!_lastCart) return PACK_MIN;
  return Math.max(1, PACK_MIN - cartSealPacks().total);
}
/* Seal packs of THIS design's product already in the cart - what the tier has
   to count, because that is what Shopify counts. */
function orderPacksOther() {
  if (!_lastCart) return 0;
  var o = cartSealPacks();
  return (typeof st === 'object' && st && st.sizeId === 'large_250x100')
    ? o.large : o.standard;
}
/* The minimum, said once, for the promo line under the hero. The empty-cart
   string is byte-for-byte what it has always been - a first design must not
   be able to tell that any of this exists. */
function promoLine() {
  var mnPk = effMinPacks();
  if (mnPk < PACK_MIN) {
    return (PACK_MIN * PACK_UNIT) + '-seal order minimum \u2014 your cart already has ' +
      sealNum(cartSealPacks().total * PACK_UNIT) + ' seals, so this design can be as small as ' +
      sealNum(mnPk * PACK_UNIT);
  }
  return 'From ' + fmtMoney(PACK_MIN * packUnitPrice()) + ' \u00b7 ' +
    (PACK_MIN * PACK_UNIT) + '-seal minimum \u00b7 as low as ' +
    fmtPerSeal(floorSealPrice()) + ' each in bulk';
}
/* Repaint every surface that states the minimum. Called after each cart read
   (boot, tab return, bfcache restore) - the cart can be emptied in another tab
   while this page sits open, and a stale 12-seal floor is an addable order
   below the one the owner set. */
function paintMinSurfaces() {
  var mnPk = effMinPacks(), mn = mnPk * PACK_UNIT;
  var qin = document.getElementById('ss-qin');
  if (qin) qin.min = mn;
  /* the hero strip's promo line was removed in 2026-08-07; this keeps working
     if it ever comes back, and is the ONE place the minimum is worded */
  var pr = document.getElementById('ph-promo');
  if (pr) pr.textContent = promoLine();
  /* SAY IT WHERE THE NUMBER IS. With the hero strip gone the only surfaces
     that state the minimum are the Starter tile and the input's own `min`,
     and neither of those explains why this design may suddenly be ordered in
     twelves. One short line under the quantity box does, and it exists ONLY
     when the cart has bought the floor down - a first design sees nothing. */
  var mnHost = document.getElementById('packs');
  var mnEl = document.getElementById('ss-qmin');
  if (mnPk < PACK_MIN) {
    if (!mnEl && mnHost) {
      mnEl = document.createElement('div');
      mnEl.id = 'ss-qmin';
      mnEl.style.cssText = 'margin:8px auto 0;font-size:12.5px;line-height:1.5;' +
        'color:var(--muted);text-align:center;max-width:430px';
      var _slw = mnHost.querySelector('.va-qslw');
      if (_slw && _slw.parentNode) _slw.parentNode.insertBefore(mnEl, _slw.nextSibling);
      else mnHost.appendChild(mnEl);
    }
    if (mnEl) { mnEl.style.display = ''; mnEl.textContent = promoLine(); }
  } else if (mnEl) {
    mnEl.style.display = 'none';
  }
  /* the Starter tile names the effective minimum, so tapping it can never
     land on a quantity setPaid() would clamp away underneath the customer */
  try { renderQtiers(); } catch (_) {}
  try { if (typeof renderPacks === 'function') { renderPacks(); sync(); } } catch (_) {}
}
/* The floor as of the LAST read, so a toast can tell "the cart changed under
   you" apart from "this saved order predates the minimum". 0 = never read. */
var _lastMin = 0;
/* What a fresh cart read means for the quantity on screen. */
function onCartRead() {
  var mn = effMinPacks() * PACK_UNIT;
  /* only a floor that had ALREADY been read and then ROSE is a cart change */
  var _rose = _lastMin > 0 && mn > _lastMin;
  _lastMin = mn;
  if (!window._ssEditKey && !_qtyUserSet) {
    /* second design, first paint: open at the smallest run the ORDER allows
       (one pack when the cart already covers the 60) */
    st.qty = mn;
  } else if (st.qty < mn) {
    /* the cart shrank under them - the 60-line was removed in another tab */
    st.qty = mn;
    if (_qtyUserSet) {
      /* A My Seals reorder of a legacy 24-seal order sets _qtyUserSet before
         the first cart read lands, so this clamp fires on an EMPTY cart with
         nothing having changed at all. "Your cart changed" there is a claim
         the customer can check and find false. */
      try {
        SS_UI.toast(_rose
          ? 'Your cart changed \u2014 this design now needs at least ' +
            sealNum(mn) + ' seals'
          : 'This design needs at least ' + sealNum(mn) + ' seals');
      } catch (_) {}
    }
  }
  paintMinSurfaces();
}

/* ——— the brand field demonstrates itself (owner 2026-08-14: "have the
   placeholder do fake typing of tcg companies fictional so they see and get an
   idea what to do") ———
   A static "YOUR BRAND" tells someone what the field is called, not what to
   put in it. These type themselves in, hold, delete, and move on, so within a
   few seconds the customer has seen four examples of the SHAPE of answer that
   belongs here — a shop name, not their own name, not a product.

   EVERY NAME IS INVENTED. No real shop, no trademark, nothing that could read
   as an endorsement or as us using someone's business without asking. They are
   deliberately generic-sounding for the hobby. */
var BRAND_DEMOS = [
  'Hunter Trading Card Co.',
  'Slab City Breaks',
  'Chase Hit Cards',
  'Foil & Ink Collectibles',
  'Mint Nine Trading Co.',
  'Top Shelf Pulls'
];
var _bdT = null, _bdI = 0, _bdC = 0, _bdDel = false;
function stopBrandDemo() {
  if (_bdT) { clearTimeout(_bdT); _bdT = null; }
  var el = document.getElementById('f-brand');
  if (el) el.placeholder = 'YOUR BRAND';
}
function startBrandDemo() {
  /* WCAG 2.2.2 Pause, Stop, Hide — this used to type a fake shop name into
     the placeholder character by character and loop forever (~21s a cycle).
     It honoured reduced-motion and paused while the field was in use, but
     there was no way for anyone else to stop it, and it runs in parallel
     with the rest of the form. One static example instead. */
  stopBrandDemo();
  var el = document.getElementById('f-brand');
  if (el) el.placeholder = BRAND_DEMOS[0];
}
/* Self-serve ceiling, in PAID seals (8340 paid = 834 packs = 10,008 seals).
   Was 500, which sat BELOW the top pricing tier and forced a 1200-seal buyer
   into two add-to-carts whose numbering then collided (ss1006, 2026-08-05);
   then 5000, which stopped at 6000 seals and made the new 9,996-seal rung
   unbuyable the day it was added.

   WHY EXACTLY 8340 AND NOT A ROUNDER NUMBER (2026-08-08): the ceiling is set
   to the largest run PRODUCTION has actually been proven at — 10,008 seals,
   chunked render + chunked imposition. It is deliberately not higher. A
   quantity this control will accept is a quantity we have promised to print,
   so the ceiling tracks the press, not the ladder. It clears the top rung
   (833 packs = 9,996 seals) by one whole pack, so the deepest tier is
   reachable in a single line and the numbering cannot collide across two
   add-to-carts. Past this a run really is a production conversation — stock,
   press time, lead time — and the "Bigger run? Ask about bulk pricing" link
   takes it. */
/* SELF-SERVE CEILING = THE QUOTE GATE (owner 2026-08-14, after the pricing
   review). 208 packs x 12 = 2,496 seals. Production can still run 10,008 in
   one go — that has not changed — but the four rungs below $0.45 published a
   price for volumes nobody has ever bought, and a 5,000-seal buyer arriving
   at a posted $0.33 concedes ~$600 against the $0.45 two real buyers already
   accepted, before anyone has spoken. Above this the "Bigger run? Ask about
   bulk pricing" link takes over and the number is negotiated, not posted.
   In SEALS, the same unit as PACK_PAID x packs. */
/* RAISED TO 10,008 (owner 2026-08-30: "make the slider go to 10k ... over
   10k"): self-serve now runs to 834 packs - exactly production's proven
   ceiling - and the volume-quote lane takes over past that. The 50% rung has
   no upper bound, so the whole extension rides the existing discounts. */
var PAID_MAX = 10008;
var SV_PRODUCT = null;
/* LARGE die pricing (owner 2026-08-30, second cut: "+40%, the tradeoff at
   100% more is crazy"): $8.40 a pack of twelve = 70c list. Its ladder is
   BULK_TIERS_LG (four 10%-step rungs, clean per-seal cents) behind its OWN
   four Shopify discounts - mixed std+large carts do NOT pool packs. While the product is draft (coming soon) its storefront json 404s
   and the constant below quotes the preview; once the product goes live the
   market-localized price wins, exactly as it does for the standard seal.
   EVERY quote on the page derives from packUnitPrice(), so being size-aware
   here re-prices the whole builder - totals, per-seal, min toast, tiles. */
var SV_PRODUCT_LG = null;
var LG_PACK_FALLBACK = 9.00;   /* +50% over the $6.00 standard pack (owner 2026-09-02) */
function packUnitPrice() {
  if (typeof st === 'object' && st && st.sizeId === 'large_250x100') {
    return SV_PRODUCT_LG ? SV_PRODUCT_LG.variants[0].price / 100 : LG_PACK_FALLBACK;
  }
  return SV_PRODUCT ? SV_PRODUCT.variants[0].price / 100 : SS_UI.PRICING.pack;
}
/* /products/<handle>.js is MARKET-LOCALIZED: in a non-USD market the variant
   prices arrive in the buyer's currency and checkout charges the same - the
   MATH above is right for everyone. What was wrong was the label: seven
   hardcoded '$' prefixes printed kronor as dollars ("$142.00" for the 24-pack,
   screenshotted publicly, 2026-08-28). USD keeps the exact old string; any
   other active currency gets real formatting. */
function fmtMoney(x) {
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  if (cur === 'USD') return '$' + x.toFixed(2);
  try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(x); }
  catch (e) { return '$' + x.toFixed(2); }
}
/* PER-SEAL money keeps a third decimal when it needs one: the Large ladder's
   10%/30% rungs land on $0.675 / $0.525, and a 2dp round printed "$0.68 each"
   beside an $8.10 pack (x12 = $8.16). Same trim rule as ss-cart's perSealOf. */
function fmtPerSeal(x) {
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var s3 = x.toFixed(3);
  var v = /0$/.test(s3) ? x.toFixed(2) : s3;
  if (cur === 'USD') return '$' + v;
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur,
      minimumFractionDigits: 2, maximumFractionDigits: /0$/.test(s3) ? 2 : 3 }).format(x);
  } catch (e) { return '$' + v; }
}
/* THE LADDER IS PER-SEAL. The owner sets PER-SEAL prices, not percentages.
   On the $6.00 pack (2026-08-30) every whole percentage is cent-exact by
   construction (1% of $6.00 = 6c), so the old 8.34% floored-cent hack is
   retired. If the pack price ever moves again, re-prove every rung against a
   measured cart before trusting a round number. */
/* ══ THE LADDER (owner 2026-08-17) ══════════════════════
   A 24-seal starter entry, a $0.30 floor, and a volume quote above 10,008:

     60+     $0.50   $30.00       (starter minimum — list price)
     120+    $0.45   $54.00       10% off
     600+    $0.40   $240.00      20% off
     1,200+  $0.36   $432.00      28% off
     2,400+  $0.33   $792.00      34% off
     4,200+  $0.30   $1,260.00    40% off — THE FLOOR
     past 10,008    request volume pricing — negotiated, never posted

   WHY THIS SHAPE (2026-08-17, after the funnel audit): orders stopped the
   day the 60-seal minimum shipped, and half the recent buyers had been
   buying 12 seals. The fix is at the BOTTOM of the ladder, not the top:
   reopen an affordable entry (24), and do NOT concede the top — the store's
   own history has four-figure buyers at $0.45 with no deeper rung ever
   fired. Nothing below $0.45 is published anywhere, ever.

   The VialArt 8-rung ladder (5%..40%, 2026-08-14) lasted three orderless
   days and is retired; its Shopify discounts are deactivated, not deleted.

   These pairs are the SAME automatic discounts Shopify applies, scoped to
   the seal product and set NOT to combine with any code — a discount can
   never take an order below the rate on this ladder. */
/* 2026-08-30 (owner, second cut): list re-set to $0.50, minimum to 60, and
   the rungs re-cut as whole percents of the $6.00 pack (all cent-exact).
   The Shopify discounts were repriced FIRST (deeper-first rule). */
var BULK_TIERS = [[350, 0.40], [200, 0.34], [100, 0.28], [50, 0.20], [10, 0.10]];
/* LARGE ladder (owner 2026-08-30: "+40%, not +100%"): $8.40 pack, and its
   rungs are 10%-STEPS because that is what lands clean per-seal cents on a
   70c list (28/34% would price a seal at $0.504/$0.462). Four rungs, no
   2,400 tier, and its OWN four Shopify discounts - the large product was
   DETACHED from the standard five. activeTiers() is the one switch every
   consumer reads through. */
var BULK_TIERS_LG = [[350, 0.40], [100, 0.30], [50, 0.20], [10, 0.10]];
function activeTiers() {
  return (typeof st === 'object' && st && st.sizeId === 'large_250x100')
    ? BULK_TIERS_LG : BULK_TIERS;
}
/* Where the everyday ladder ends and the deep-volume drawer begins, as a PACK
   threshold that must exist in BULK_TIERS above. With a two-rung ladder there
   is no deep half left to split off, so this is set ABOVE every threshold: the
   `t[0] >= DEEP_FROM` test in renderQtiers() then never fires and CHIP_SHOW
   alone decides the strip. Do not set it to a real threshold "to tidy up" —
   that would silently mark a live rung as deep-volume. */
var DEEP_FROM = Infinity;
/* the ladder's floor price, per seal — every "as low as" and "from" figure on
   the page derives from these two so a price can never be typed twice */
function baseSealPrice() { return packUnitPrice() / PACK_UNIT; }
function floorSealPrice() {
  var deepest = activeTiers()[0][1];
  return baseSealPrice() * (1 - deepest);
}

/* ══ WHICH RUNGS GET A CHIP (owner 2026-08-08) ═══════════════════════════
   "customers are buying a lot at a time — clean up the discount chips and
   only show what's actually selling".

   ⚠ THIS HIDES CHIPS. IT DOES NOT REMOVE DISCOUNTS. Every rung in BULK_TIERS
   is still applied by Shopify at checkout and still quoted by quoteFor(), so a
   customer who lands on a rung with no chip is charged the same as before. Do
   NOT "tidy" BULK_TIERS to match this list: deleting the 15-pack rung would
   take 25% off down to 20% for the customer who bought 240 seals — about $9
   more out of their pocket to make a UI shorter.

   The first nine orders (on the retired ladder) paid at, by rung in seals:
     36 x1 · 120 x3 · 180 x1 · 600 x2 · 996 x2

   THE MINIMUM IS 24 SEALS (2 packs) since 2026-08-17; no rung exists under
   120. asc[0] is the 120 rung, so the strip's first cell describes the
   60–119 band, which pays the $0.50 list rate.
                   first chip and the strip reads "no discount until 60 seals",
                   which is false and costs money on every 24–59 seal order.
     60  — the smallest rung the owner wants shown.
     120 — the modal order.
     600 — the volume order.
   Then the deep rungs, which are always shown.

   The rungs with no chip are not silent: the near-miss nudge (#ss-qnudge) is
   driven by nextTier() over the WHOLE array, so a customer at 132 seals is
   still told "48 more seals -> 25% off". A chip is an anchor; the nudge is the
   on-ramp, and it is personalised, which a fixed chip can never be.

   PACK thresholds, matching BULK_TIERS. The 2026-08-12 ladder is only six
   rungs, so ALL of them get a chip — there is no wall to hide any more, and
   the ladder the customer taps is exactly the ladder Shopify applies. */
/* Two rungs, two chips. The strip's implicit first band (24–119) pays the
   $0.50 list rate the quantity box already states in dollars. */
var CHIP_SHOW = [10, 50, 100, 200, 350];
/* shallowest-first, for anything that READS as a ladder (chips, hero, nudge) */
function bulkAsc() { return activeTiers().slice().reverse(); }
/* the tier immediately above k, or null at the top — the near-miss nudge and
   the "on" chip both hang off this so they can never name a threshold that
   isn't in the array */
function nextTier(k) {
  var asc = bulkAsc();
  for (var i = 0; i < asc.length; i++) if (k < asc[i][0]) return asc[i];
  return null;
}
/* A rate as a percentage STRING, one decimal only when it needs one: "40",
   "42.6". Math.round(rate * 100) used to live here and would print the 42.6%
   rung as "43%" — a page quoting a discount deeper than checkout applies,
   which is the same class of defect as the paid-vs-total bug and just as
   invisible. Returns a string; every caller concatenates. */
function pctOf(rate) {
  var t = Math.round(rate * 1000) / 10;
  return t % 1 === 0 ? String(t) : t.toFixed(1);
}
/* The ladder rate as an INTEGER number of tenths of a percent — the unit the
   discount is actually computed in (see quoteFor). Derived, so 0.426 can never
   drift from the 42.6% the storefront prints or the 0.426 Shopify stores. */
function pct10Of(rate) { return Math.round(rate * 1000); }
function bulkRate(k) {
  var _bt = activeTiers();
  for (var i = 0; i < _bt.length; i++) {
    if (k >= _bt[i][0]) return _bt[i][1];
  }
  return 0;
}
/* Quote any pack count. Since 2026-08-12 a pack is simply 12 seals priced
   at the ladder's per-seal rate — there are no free seals, paid === total.
 *
 * ══ THE DISCOUNT RULE IS MEASURED, NOT DERIVED ═════════════════════
 * This function used to claim Shopify truncated the PER-UNIT discount to the
 * cent and multiplied by quantity. It does not, and the site had been quoting
 * MORE than checkout charged ever since: $24.30 vs $24.28 at 3 packs, $72.00
 * vs $71.92 at 10, $270.00 vs $269.70 at 50. The error grew with quantity and
 * only vanished at 1 pack, where the discount is zero.
 *
 * A 32-cart sweep against real /cart.js reads (2026-08-08, including seven
 * blind forward predictions) fitted this instead, exactly, on every point.
 * The pack price moved to $7.20 on 2026-08-12; the RULE is unchanged and was
 * re-measured on the new ladder:
 *
 *     subtotal = 720 * packs              (cents; the $7.20 pack of 12)
 *     discount = floor(subtotal * pct / 100)      <- INTEGER FLOOR, CART-WIDE
 *     charged  = subtotal - discount
 *
 * Three properties the sweep proved, each with a discriminating case:
 *   TRUNCATE, NOT ROUND — 35 packs: 31465 * 0.35 = 11012.75, charged 11012.
 *   CART LEVEL, NOT PER UNIT — the old model was wrong at 24 of 25 points.
 *   CART LEVEL, NOT PER LINE — two-line carts settle to the CART floor and
 *   allocate the remainder across lines (1+1 packs -> 45 + 44 = 89, where a
 *   per-line floor would give 88). final_price stays 899 on every line.
 *
 * The four 2026-08-08 rungs are fractional, so the integer step is in TENTHS
 * of a percent — floor(subtotal * pct10 / 1000). Confirmed live at 83, 208,
 * 416 and 833 packs; all four land on the owner's per-seal targets.
 *
 * Everything is computed in integer CENTS and divided once at the end, so the
 * struck-through gross, the saving and the price are the same three integers
 * checkout will use and gross - save === price on every surface, always. */
/* `poolPacks` = packs of the SAME product already in the cart. Shopify's
   automatic volume discounts count the QUALIFYING ITEMS ACROSS THE CART, not
   per line (ss-cart.js paintLadder pools the same way, per size, because
   Standard and Large sit behind separate discounts). So a second design added
   beside 60 carted seals is charged at the pooled rung, and quoting this line
   in isolation would print a price ABOVE what checkout takes - the same class
   of defect as the paid-vs-total bug, pointing the other way.
   Omitted (every rung quote, tierEachC, the chips) => the rung's own price,
   which is what a control that SETS a quantity has to state. */
function quoteFor(k, poolPacks) {
  var unit = packUnitPrice();
  var unitCents = Math.round(unit * 100);
  var cents = unitCents * k;
  var pool = k + (parseInt(poolPacks, 10) || 0);
  var rate = bulkRate(pool);
  /* PER-UNIT FLOOR, re-measured 2026-08-12 on the $7.20 pack across 14 real
     carts. Checkout floors the discount on ONE unit and multiplies by the
     quantity — it does not floor the cart total. The two models agree only
     when the per-unit discount is already whole: at 49 packs they differ by
     2c, and the old cart-wide model quoted $323.89 where checkout charged
     $323.40. Every rung's per-unit discount is whole by construction, which
     is why the ladder lands on exact per-seal rates. */
  /* +1e-6 BEFORE the floor. 720 * 0.35 is 251.99999999999997 in IEEE754, so a
     bare floor() returned 251 and quoted $164.15 where Shopify — which does
     this in decimal — charges $163.80. The epsilon is far below a cent, so it
     cannot round a genuinely fractional rung the wrong way; it only repairs
     the binary representation of a rate that is exact in decimal. */
  var discount = Math.floor(unitCents * rate + 1e-6) * k;
  return { packs: k, n: k * PACK_UNIT, paid: k * PACK_PAID,
           /* the pack count the RATE came off - the nudge, the lit chip and
              the pooling note all read this, never `packs`, or they would
              name a rung this line alone does not reach */
           poolPacks: pool,
           free: k * (PACK_UNIT - PACK_PAID),
           gross: cents / 100, rate: rate,
           /* the saving is the SAME truncated number the price came off, so
              gross − save === price to the cent on every surface that shows
              both. Never recompute it from a percentage. */
           save: discount / 100,
           price: (cents - discount) / 100 };
}
/* THE PRODUCT IS THE SIZE (launch 2026-09-02): Standard and Large are two
   Shopify products with the same material axis. Every variant lookup goes
   through here so a Large seal can never be carted on the Standard SKU. */
function productForSize(sizeId) {
  return (sizeId || st.sizeId) === 'large_250x100' ? SV_PRODUCT_LG : SV_PRODUCT;
}
function variantForMaterial(name, product) {
  var P = product || productForSize();
  if (!P) return null;
  /* One variant per material now. Match on the variant title rather than an
     index — the option order in Shopify is not ours to rely on. */
  var want = String(name || '').toLowerCase();
  for (var i = 0; i < P.variants.length; i++) {
    var v = P.variants[i];
    if (String(v.title || '').toLowerCase().indexOf(want) >= 0) return v;
    if (String(v.option2 || '').toLowerCase() === want) return v;
  }
  return null;
}
/* Inventory is not tracked on these variants today, so `available` is always
   true and this reads as a no-op. It exists so that the day a roll is marked
   sold out in Shopify, the card disables itself instead of letting someone buy
   a stock we cannot print. Unknown variant = available (fail open). */
function materialSoldOut(name, product) {
  var P = product || productForSize();
  var v = variantForMaterial(name, P);
  /* NOT SOLD ON THIS SIZE (owner 2026-10-20: "Only Gloss White on Large" -
     the site was offering it). A product that HAS loaded and carries no
     variant for this stock does not sell it: Gloss White has no Large
     variant, and failing open here let the picker offer it on Large, add the
     Large AURORA variant (packVariant's fallback) and tag the line Gloss
     White - a stock no 10 mL press runs. Fail open only before the product
     has loaded, exactly as before. */
  if (!v) return materialNotOnSize(name, P);
  return v.available === false;
}
/* true when the size's product is loaded and simply has no variant for this
   stock (Gloss White on Large) - as opposed to a variant marked sold out */
function materialNotOnSize(name, product) {
  var P = product || productForSize();
  return !!(P && P.variants && P.variants.length && !variantForMaterial(name, P));
}
function packVariant() {
  var P = productForSize();
  if (!P) return null;
  /* never fall back onto a sold-out variant: /cart/add.js would 422 */
  return variantForMaterial(st.material, P) ||
         (P.variants || []).filter(function (v) { return v.available !== false; })[0] ||
         P.variants[0];
}
/* ═══ THE TIER SURFACES ARE CONTROLS ═════════════════════════════════════
   Owner, 2026-08-06, from Clarity replays: "people are trying to click the
   discount chips". They were inert <span>s. Three surfaces now act on the tap
   — the step-2 chip grid (#ss-qtier), the hero ladder strip (#ph-tiers) and
   the near-miss nudge (#ss-qnudge) — and all three carry data-sstier="<pack
   threshold>" and funnel through applyTier() below.

   applyTier() computes NOTHING. It converts packs to PAID seals and calls
   setPaid(), the exact function the -/+ buttons and the number input call, so
   a chip tap and a manual quantity change are the same event downstream:
   clamping, rounding, re-quoting, renderPacks() and sync() all happen once, in
   the one place they already lived. If the ladder moves, every chip moves with
   it, because every chip's threshold came out of BULK_TIERS. */

/* A tier is only offerable if its minimum fits under the self-serve ceiling.
   Past PAID_MAX the honest answer is the "Bigger run? Ask about bulk pricing"
   link under the stepper, so an unreachable rung stays an inert <span> rather
   than a button that sets a quantity setPaid() would silently clamp away
   underneath the customer. Today the top rung is 833 packs = 8330 paid <=
   8340, so nothing is unreachable — this exists so a future ladder edit
   cannot create a dead tap, and it is what would catch a rung being added
   above PAID_MAX without the ceiling being raised with it. */
function tierReachable(packs) { return packs * PACK_PAID <= PAID_MAX; }

/* EVERY CHIP ANSWERS, IN BOTH DIRECTIONS.
   This used to move the quantity only UPWARD, to protect a customer from
   fat-fingering "3+ 10%" while holding 20 packs and being quietly downsold.
   The protection was worse than the risk: after climbing two or three rungs
   every chip below you was inert, and the owner hit it immediately —
   "after the 3rd chip click it stops letting me press". Chips that do
   nothing are the exact complaint this feature existed to fix, so a rule
   that manufactures more of them is the wrong rule.

   A tap now always sets its own tier. That is what the customer expects, it
   is reversible in one tap on the rung above, and the drop is never silent:
   the toast names the new seal count and rate, and revealQty() scrolls the
   quantity box into view and pulses it. Predictable beats clever. */
function applyTier(packs) {
  packs = parseInt(packs, 10);
  if (!packs || packs < 1 || !tierReachable(packs)) return;
  var cur = pack().packs;
  /* buy what the CHIP SAYS, not the raw rung: the labels round up (996 ->
     "1,000+"), so a tap has to land on the rounded number in whole packs or
     the box would answer a "10,000+" chip with 9,996 (owner 2026-08-12). */
  packs = Math.max(packs, tierSeals(packs) / PACK_UNIT);
  if (packs !== cur) {
    setPaid(packs * PACK_PAID);          /* the ONE quantity path — never st.qty */
    var q = pack();
    /* q.n, never q.paid: this toast is the receipt for the chip they just
       tapped, so it has to say the same number the chip promised */
    SS_UI.toast(sealNum(q.n) + ' seals' +
      (q.rate ? ' — ' + pctOf(q.rate) + '% off' : ''));
  } else {
    var r = bulkRate(cur);
    SS_UI.toast(r
      ? 'You already have ' + pctOf(r) + '% off at ' + sealNum(cur * PACK_UNIT) + ' seals'
      : 'You have ' + sealNum(cur * PACK_UNIT) + ' seals — use + to add more');
  }
  revealQty();
}

/* Show them what changed. The tapped chip can be the only thing on screen —
   certain from the hero strip, likely on a phone from the chip grid — so bring
   the quantity box into view when it isn't already and pulse it either way, so
   the customer sees WHICH number holds the answer. Runs on the no-op path too:
   a tap that deliberately changed nothing still has to point at the state that
   made it a no-op, or it reads as another dead tap. */
function revealQty() {
  var box = document.getElementById('packs');
  if (!box) return;
  var r = box.getBoundingClientRect();
  var vh = window.innerHeight || document.documentElement.clientHeight || 0;
  if (r.top < 8 || r.bottom > vh - 8) smoothTo(box, 'center');
  box.classList.remove('ss-qflash');
  void box.offsetWidth;                  /* reflow, or the animation won't restart */
  box.classList.add('ss-qflash');
}

/* Light the earned rung on every surface that states the ladder.

   ⚠ BOTH STRIPS ARE NOW KEYED BY THRESHOLD, NOT BY INDEX. #ss-qtier used to be
   indexed (cell 0 = "under", cell i+1 = ascending tier i), which was correct
   only while the strip rendered EVERY rung. CHIP_SHOW makes it render a subset,
   so an index into the DOM no longer means anything about the ladder: with
   chips at 24/120/600 the old code lit the 600 chip for a customer holding 60
   seals — a control stating a discount they are not getting. Keying off the
   data-sstier the cell already carries cannot drift, however the strip is
   filtered. Every tier cell carries it (buttons and unreachable spans alike);
   (the old "under" cell carried data-ssunder and lit at live 0; it was
   removed on 2026-08-12, so that branch is a no-op kept only for safety.)

   aria-pressed rides along so a screen reader gets the same "this is the tier
   you're on" the colour gives. */
function markTierState(onIdx, asc) {
  var live = onIdx > 0 && asc[onIdx - 1] ? asc[onIdx - 1][0] : 0;
  document.querySelectorAll('#ss-qtier .qd-tier').forEach(function (t) {
    var on = t.hasAttribute('data-ssunder')
      ? live === 0
      : parseInt(t.getAttribute('data-sstier'), 10) === live;
    t.classList.toggle('on', on);
    if (t.tagName === 'BUTTON') t.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  /* (there was a force-open of the deep drawer here — the drawer is gone and
     every rung is on the strip, so the earned one can no longer be hidden) */
  document.querySelectorAll('#ph-tiers [data-sstier]').forEach(function (t) {
    var on = parseInt(t.getAttribute('data-sstier'), 10) === live;
    t.classList.toggle('on', on);
    t.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
}

/* one label shape for every tier button on the page, so the ladder reads the
   same to a screen reader as it does to an eye. Plain ASCII: no entity survives
   an aria-label, and "%" is announced as "percent" inconsistently.
   Takes PACKS (the argument the button carries and applyTier acts on) and says
   SEALS, exactly like the visible chip — a screen-reader user must not be told
   a different unit than the one printed on the control. */
function tierAria(packs, rate) {
  return 'Set quantity to ' + (packs * PACK_UNIT) + ' seals for ' +
         pctOf(rate) + ' percent off';
}

/* How many columns for n cells: as close to 4 as possible, but never leaving a
   ragged last row when an even split exists. 9 cells becomes 3x3 (105px cells
   on a 320px phone) instead of 4+4+1 with three holes in it. */
function gridCols(cells) {
  var cols = Math.min(4, Math.ceil(cells / 2));
  if (cells % cols) {
    for (var c = cols; c >= 2; c--) if (cells % c === 0) { cols = c; break; }
  }
  return cols;
}

/* The per-seal price of a rung, derived from quoteFor() and rounded to the
   whole cent. Never typed: a number that sells a tier has to be the number the
   customer is actually charged. Kept after the drawer that used it was removed
   — it is the only honest way to quote a rung's per-seal rate on this page. */
function tierEachC(packs) {
  var q = quoteFor(packs);
  return Math.round(q.price / q.n * 100);
}
function tierEach(packs) { return tierEachC(packs) + '\u00a2'; }
/* deepEl / deepOpen / setDeepOpen are GONE with the #ss-qmore drawer (owner
   2026-08-08: "remove it, always show all the chips"). Nothing may put a rung
   behind a control again without also re-solving the strip width that CHIP_SHOW
   solved -- see the note above renderQtiers(). */

/* The quantity-step discount chips, generated from BULK_TIERS.
   Each chip names its threshold in SEALS as `threshold * PACK_UNIT` — the TOTAL
   the customer receives and the number the stepper above shows them, so the
   threshold read is the threshold applied. NOT `* PACK_PAID`: that printed the
   paid count against a pack-counting ladder and mis-sold the discount. That is
   also why the deep rungs read "996+" and "9,996+" rather than the rounder
   1,000 and 10,000 the marketing copy may use: a CONTROL states the number it
   actually applies at, and rounding it UP would recreate the old defect where
   the advertised figure sat below the real threshold.

   ══ ONE GRID, NOTHING BEHIND A BUTTON (2026-08-08, owner) ═══════════
   "ordering 9996+ is a button — remove it, always show all the chips."

   The deep rungs used to sit in a #ss-qdeep drawer behind a #ss-qmore toggle,
   because thirteen nowrap chips on a 320px phone is a wall. CHIP_SHOW removed
   that pressure: the strip is 8 cells now, not 13, and 8 fits. So the drawer
   earned nothing and cost a tap on the deepest tiers — the ones the biggest
   customers come for. A rung the customer cannot see is a rung they do not
   know they can reach.

   If a future ladder edit pushes CHIP_SHOW back past ~9 cells, bring the
   drawer back rather than letting the strip grow: going 4 chips -> 6 is what
   set the page width 7px wide in July, and 13 is what the drawer was for. */
/* CHIP LABELS ARE ROUNDED UP (owner 2026-08-12: "the chips they click need to
   be rounded up — instead of 9996 say 10,000+ and keep all round larger
   numbers"). The rungs land on multiples of twelve (996, 2,496, 4,992,
   9,996), which reads like a typo on a button. The label rounds UP to the
   nearest clean number; the RUNG ITSELF does not move, so a customer who
   lands on 996 still gets the rate the chip advertises — they reach it a
   little earlier than the label promises, never later.
   tierSeals() is what a TAP buys: the rounded number, converted back to whole
   packs, so tapping "10,000+" puts 10,008 in the box and not 9,996. */
/* NO ROUNDING (2026-08-14). Rounding up existed because the old ladder had
   thresholds like 996 and 9,996 that read badly on a chip. VialArt's rungs are
   60 / 120 / 180 / 300 / 420 / 600 — already round, already whole sets — and
   rounding pushed the 420 chip to "500+", which then set the quantity to 504
   seals: 84 more than the rung needs, for the same 35%. A chip must name the
   quantity it actually buys. */
function tierLabel(packs) {
  return packs * PACK_UNIT;
}
function tierSeals(packs) {
  return Math.ceil(tierLabel(packs) / PACK_UNIT) * PACK_UNIT;
}
function renderQtiers() {
  var host = document.getElementById('ss-qtier');
  if (!host) return;
  var asc = bulkAsc();
  /* ONE list, in ladder order. The deep rungs (>= DEEP_FROM) are always shown;
     below that CHIP_SHOW picks which everyday rungs get a chip — see its
     comment. Either way the rung is still in BULK_TIERS, still applied at
     checkout, and still named by the near-miss nudge. */
  /* FOUR CLICKABLE TILES (owner 2026-08-17: "restore them so people can
     just click on a discount and it will autoload how many labels") — the
     two list anchors plus the two real discount rungs. data-sstier feeds the
     existing delegated applyTier() listener, so a tap loads the quantity;
     renderPacks() lights the tile for the band the order is in. */
  host.style.display = '';
  host.style.gridTemplateColumns = '';
  /* the WHOLE strip derives from activeTiers() + packUnitPrice(): rung
     count, thresholds, percentages and money all follow the selected size
     (standard: five rungs; large: four, at 10%-steps). Never hardcode a
     rung or a dollar figure here again. */
  var _pu = packUnitPrice(), _ps = _pu / PACK_UNIT;
  var _asc2 = bulkAsc();
  function _tep(pct) { return fmtPerSeal(_ps * (1 - pct)) + ' each'; }
  /* the Starter rung is the SMALLEST ORDERABLE run, which is cart-wide since
     2026-09-05: with 60 seals already carted this tile reads "12 seals" and
     tapping it sets one pack, exactly what setPaid() will now accept. */
  var _mnPk = effMinPacks();
  var TILES = [[_mnPk, String(_mnPk * PACK_UNIT), 'Starter', fmtMoney(_mnPk * _pu)]];
  _asc2.forEach(function (t) {
    TILES.push([t[0], (t[0] * PACK_UNIT).toLocaleString('en-US') + '+',
                _tep(t[1]), Math.round(t[1] * 100) + '% off']);
  });
  var _capPk = PAID_MAX / PACK_PAID, _deep2 = _asc2[_asc2.length - 1][1];
  TILES.push([_capPk, sealNum(PAID_MAX), _tep(_deep2),
              fmtMoney(_capPk * _pu * (1 - _deep2))]);
  host.innerHTML = '<div class="qd-grid" ' +
    'style="grid-template-columns:repeat(4,minmax(0,1fr))">' +
    TILES.map(function (t) {
      return '<button type="button" class="qd-tier" data-sstier="' + t[0] + '"' +
        ' aria-pressed="false" aria-label="Set quantity to ' + (t[0] * PACK_UNIT) +
        ' seals">' + t[1] + ' seals<b>' + t[2] + '</b>' +
        '<i class="qd-sub">' + t[3] + '</i></button>';
    }).join('') + '</div>';
  /* re-light after a rebuild: renderQtiers() can run after renderPacks() (the
     product fetch resolves late), and a strip built empty of state would show
     no earned tier at all */
  if (typeof renderPacks === 'function') { try { renderPacks(); } catch (_) {} }
}

/* Thousands separator for the two BIG seal counts (hero, order card). The
   quantity input itself stays bare — it is type=number and a separator would
   make its own value unparseable — so "10,008" in the hero over "10008" in
   the box is deliberate, not drift. */
function sealNum(n) {
  try { return Number(n).toLocaleString('en-US'); }
  catch (_) { return String(n); }
}

/* ═══ THE HERO MIRRORS THE LIVE ORDER ════════════════════════════════════
   Owner 2026-08-06: "show total labels larger — so they see it". This strip
   used to quote quoteFor(1) forever — a standing "12 seals · $0.75 each" in
   13px under a 22px price. Two things changed and they depend on each other:

     · the TOTAL seal count is now the headline and the price steps down;
     · the strip tracks the CURRENT quantity instead of the standing one.

   The second is not decoration. A permanent "12" set in 34px over a customer
   holding 600 seals is a bigger, louder version of exactly the paid-vs-total
   defect this file has already shipped once — a number the customer can read
   off the page that is not the number they are buying. If the count is going
   to lead here, it has to be THEIR count.

   pack(), never quoteFor(1), and q.n, never q.paid. #ph-promo keeps quoteFor(1)
   because the 10-paid/2-free split IS a standing fact about a pack and the one
   place the paid count is legitimately customer-facing. */
function renderHeroQty() {
  var el = document.getElementById('ph-n');
  if (!el) return;
  var q = pack();
  el.textContent = sealNum(q.n);
  /* no #ph-price any more (owner 2026-08-07) — the total lives on the quantity
     control; the strip states the per-seal rate, which reads cheap where a
     total reads like a bill */
  document.getElementById('ph-per').textContent =
    fmtMoney(q.price / q.n) + ' each';
}

/* the strip's standing parts — the promo and the ladder. Price now arrives
   through renderHeroQty(), so if the price ever moves in Shopify the hero
   still follows it without a theme edit. */
function renderPriceHero() {
  /* NO EARLY RETURN. The top strip is gone, but this function still builds the
     STEP 2 discount chips through renderQtiers() below — guarding on a hero node
     would silently empty #ss-qtier, i.e. delete the controls the customer taps
     to pick a quantity, with no error anywhere. Every hero-specific write is
     guarded individually instead, so this stays correct whether the strip
     exists or not. */
  var q = quoteFor(1);
  renderHeroQty();                     /* already no-ops without #ph-n */
  var _promo = document.getElementById('ph-promo');
  if (_promo) _promo.textContent = promoLine();
  /* the escalation line derives from BULK_TIERS so the hero can never promise
     a different ladder than the one Shopify actually applies at checkout.
     Stated in SEALS as threshold * PACK_UNIT — the total in the box — and the
     first rung spells the unit out once so the rest can stay short. The strip
     ships hidden and is only revealed here — an unfilled strip must never flash
     typed-in numbers, because it has none. */
  renderQtiers();
  /* GUARDED. Everything below this line in boot is load-bearing (the buy
     surfaces among it), and this is an optional upsell. When the first version
     of this threw a ReferenceError on deploy it silently killed the rest of the
     sequence — a whole builder lost to an add-on. It never gets to do that
     twice, and the cart read that prices the tier is fire-and-forget for the
     same reason. */
  try {
    renderRush();
    /* UNCONDITIONAL since 2026-09-05: this read sets the cart-wide minimum as
       well as the rush tier, and RUSH.ok is false whenever the priority
       product is Draft - which would have left the 60-seal floor in place for
       a customer whose cart already covered it. */
    refreshCartSeals();
  } catch (e) { if (window.console) console.error('rush', e); }
  /* Each rung is its own NODE now (owner 2026-08-06). The strip used to be one
     joined string, so it read exactly like a row of offers and there was nothing
     on the page to tap — the worst version of a dead tap, because the copy is
     doing the selling. Same words, same order, same separators; the rung is just
     a button around them. */
  var tiers = bulkAsc().map(function (t, i) {
    var body = (t[0] * PACK_UNIT) + '+ ' +
               (i === 0 ? 'seals <b>' + pctOf(t[1]) + '% off</b>'
                        : '<b>' + pctOf(t[1]) + '%</b>');
    return tierReachable(t[0])
      ? '<button type="button" class="ph-tier" data-sstier="' + t[0] + '"' +
        ' aria-pressed="false" aria-label="' + tierAria(t[0], t[1]) + '">' +
        body + '</button>'
      : '<span class="ph-tier off">' + body + '</span>';
  });
  var _pht = document.getElementById('ph-tiers');
  if (_pht) {
    /* separator wrapped, not bare text: it is decoration between controls and
       has to be reachable from CSS if this strip is ever re-laid out */
    /* The "(1 pack = 12 seals)" tail is GONE (owner 2026-08-06). It existed to
       translate a ladder stated in packs; with every rung stated in seals there
       is no pack left on this strip to define, and #ph-promo directly above
       already shows the minimum and the floor rate. Defining a unit nobody is
       being quoted in just re-imports the word the customer did not
       understand. */
    _pht.innerHTML = 'Buy more, save more &mdash; ' +
      tiers.join('<span class="ph-sep"> &middot; </span>');
    _pht.hidden = false;
  }
  /* OUTSIDE the #ph-tiers guard: this re-light exists because the chips are
     built after the product loads, which can land either side of a
     renderPacks(). That is true of the step-2 chips too, and #ph-tiers no
     longer exists — leaving it inside would mean the chips never got lit. */
  if (typeof renderPacks === 'function') { try { renderPacks(); } catch (_) {} }
}
(function loadProduct() {
  var handle = (window.SV_CFG && SV_CFG.productHandle) || '';
  if (!handle) return;
  /* PAINT THE PRICE SURFACES EITHER WAY. This used to swallow the failure and
     render nothing, so a transient product fetch (Shopify answers 429 under
     load) left the customer with NO price, NO per-seal rate and an EMPTY tier
     strip — the whole ladder missing, with no error on screen. packUnitPrice()
     already falls back to SS_UI.PRICING.pack for exactly this case; it just
     never got the chance to run. The fallback must track the live price:
     both are $7.20 as of 2026-08-12. */
  function paintPrice() {
    try { renderPriceHero(); } catch (_) {}
    if (typeof renderPacks === 'function') { try { renderPacks(); sync(); } catch (_) {} }
  }
  /* reachable from the size cards + the Large probe (they sit outside this
     IIFE; their bare paintPrice() calls were dead no-ops) */
  window._svPaintPrice = paintPrice;
  /* RETRY, and keep a handle on the attempt. A single failed fetch used to be
     terminal: SV_PRODUCT stayed null for the life of the page, packVariant()
     returned null, and every press of Add to cart died on "Store is still
     loading" — while the ladder and the per-seal price painted happily from
     the SS_UI.PRICING fallback, so the page looked completely healthy. The
     store 429s under load, which is exactly when this fires. */
  var _tries = 0;
  window._svLoadProduct = function () {
    if (SV_PRODUCT) return Promise.resolve(SV_PRODUCT);
    if (window._svLoadP) return window._svLoadP;
    window._svLoadP = fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function (p) { SV_PRODUCT = p; paintPrice(); return p; })
      .catch(function (e) {
        window._svLoadP = null;
        paintPrice();
        if (++_tries <= 4) setTimeout(window._svLoadProduct, _tries * 1500);
        throw e;
      });
    return window._svLoadP;
  };
  window._svLoadProduct().catch(function () {});
})();
function pack() {
  return quoteFor(Math.max(1, Math.round(st.qty / PACK_UNIT)), orderPacksOther());
}

/* ——— the numbering is the CUSTOMER's, always ————————————————————————
 * The browser used to mint random serials; then the registry Worker minted
 * them against the order. With the registry retired (owner 2026-08-05)
 * neither happens. The customer sets a prefix and a first number and we print
 * that sequence — the numbers are theirs, on their goods, and the uniqueness
 * that matters is one number per item inside their own run.
 *
 * The preview still needs something in the slot before they finish typing.
 * SERIAL_SAMPLE is a neutral stand-in, deliberately NOT the old K7D-4QM:
 * that was a REGISTERED marketing serial, and showing it now would advertise
 * a verification record a new order does not come with. */
var SERIAL_SAMPLE = '001';

/* ——— own-numbering helpers ———————————————————————————————————————————
 * The customer types a prefix and a first number; everything else is derived.
 * Leading zeros in the start number ARE the pad width, so "001" prints
 * 001, 002 … 010 and "1" prints 1, 2 … 10. The same rule has to hold in
 * Label Farm when it expands prefix+start into the printed list, so the
 * preview and the print agree.
 */
function padNum(n, w) {
  var s = String(n);
  while (s.length < w) s = '0' + s;
  return s;
}

/* ——— the generated alphabet ————————————————————————————————————————
 * Anything this file INVENTS is drawn from here and nowhere else — the same
 * alphabet the Business codes use. The serial prints ~1.3mm on holographic
 * foil and gets read aloud in damage claims, so O/0, I/1, S/5 and B/8 are
 * deliberately absent. */
var SS_ALPHA = 'ACDEFGHJKMNPRTUVWXY34679';
var RAND_LEN = 5;
/* THE LEGIBILITY CAP. ss-seal.js fits the serial into an 11.2–14mm slot with
   data-fit, so a longer string is not clipped — it is SET SMALLER. About five
   characters fill the slot at the design size of 3.6mm and it scales down from
   there, so 14 characters lands near 1.3mm, the floor for reading a number off
   foil down a phone. Every default here fits with room to spare (sequential 8,
   random 10, batch 13); only a long typed prefix can reach the cap, and
   serialProblem() blocks the order rather than shipping an unreadable number.
   Label Farm knows the same number and warns rather than truncates — a line
   quoted before the cap existed must still print what it was quoted. */
var SERIAL_MAX = 14;

function randCode(n) {
  var s = '', i;
  for (i = 0; i < n; i++) s += SS_ALPHA.charAt(Math.floor(Math.random() * SS_ALPHA.length));
  return s;
}

/* ——— the sample random codes ————————————————————————————————————————
 * A random serial is minted ONCE, at order ingest, by Label Farm — this
 * browser never sees the real ones and must not pretend to. What it shows is a
 * SAMPLE, generated ONCE PER SESSION and remembered: re-rolling it per render
 * would reshuffle the preview while the customer watched it. Every surface
 * that needs an example (the picker rows, the seal preview, the review
 * summary, the cart quote) reads it from here, so they all agree. */
var _randSample = null;
function randSample(i) {
  if (!_randSample) {
    try {
      var v = JSON.parse(sessionStorage.getItem('ss_rsample') || 'null');
      if (v && v.length === 4) _randSample = v;
    } catch (_) {}
    if (!_randSample) {
      _randSample = [randCode(RAND_LEN), randCode(RAND_LEN),
                     randCode(RAND_LEN), randCode(RAND_LEN)];
      try { sessionStorage.setItem('ss_rsample', JSON.stringify(_randSample)); } catch (_) {}
    }
  }
  return _randSample[Math.abs(i) % _randSample.length];
}

/* Today's run code — YYMM. A batch number that is not a date answers nothing;
   this is the shape that makes "which batch was that?" a question with an
   answer. Editable, because plenty of sellers already have their own lot
   codes. */
function defaultBatch() {
  var d = new Date();
  return ('0' + (d.getFullYear() % 100)).slice(-2) + ('0' + (d.getMonth() + 1)).slice(-2);
}
/* The middle segment a batch serial carries, '' for every other scheme — which
   is what keeps serialAt() one function instead of three. */
function batchSeg() {
  if (st.serialType !== 'batch') return '';
  var b = String(st.serialBatch || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
  return b ? b + '-' : '';
}

/* ——— the prefix ships PRE-FILLED (owner 2026-08-08) ——————————————————
 * st.serialStart has always defaulted to '001', but the prefix was empty, so
 * an order nobody touched shipped bare 001, 002, 003 — a number with no owner
 * on it. A random 4-character code plus their separator is a real starting
 * point they can keep, edit or re-roll.
 *
 * ONCE PER SESSION, held in sessionStorage. Generating per render would
 * renumber the preview under them mid-scroll. And it must never land on top of
 * a prefix restored from a reorder or a cart edit — clobbering either silently
 * renumbers a repeat customer's run (see the boot guard). */
function sessionPrefix() {
  var v = '';
  try { v = sessionStorage.getItem('ss_pfx') || ''; } catch (_) {}
  if (!/^[A-Z0-9-]{1,8}$/.test(v)) {
    v = randCode(4) + '-';
    try { sessionStorage.setItem('ss_pfx', v); } catch (_) {}
  }
  return v;
}
/* AUTO PREFIX — now the ONLY way a prefix is set (owner 2026-08-12: "theyre
   confused remove prefix and it will auto put 3 letters from the name").
   There is no prefix field any more. It was a text box sitting under the
   brand name with no explanation of what a prefix is, so customers typed
   their brand into it a second time and got seals reading VINTAGEPU-001
   under a brand line that already said VINTAGE PULLS.

   THREE letters, from the store name: "Vintage Pulls" -> VP-, "First Round
   Picks" -> FRP-, one word -> its first three ("Shadowless" -> SHA-).

   `_prefixAuto` survives because a REORDER or a cart edit still owns its
   numbering — a past order has to reprint with the prefix it was sold with,
   even if the brand has been renamed since. Nothing else can clear it now. */
var _prefixAuto = true;
function prefixFromBrand(b) {
  var words = String(b || '').toUpperCase().replace(/[^A-Z0-9 ]/g, ' ')
    .trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '';
  var p = words.length >= 2
    ? words.map(function (w) { return w.charAt(0); }).join('').slice(0, 3)
    : words[0].slice(0, 3);
  return p ? p + '-' : '';
}
/* What the seal in position `i` carries. ONE rule per scheme, mirrored exactly
   by ownSerials() in ss-cart.js and _seal_own_serials() in Label Farm — the
   three of them quote, re-quote and then print the same numbers, so they move
   together or not at all. */
function serialAt(i) {
  if (st.serialType === 'rand') return (st.serialPrefix || '') + randSample(i);
  var raw = String(st.serialStart == null ? '' : st.serialStart).trim();
  var base = parseInt(raw, 10);
  if (isNaN(base) || base < 0) base = 1;
  var w = /^0\d/.test(raw) ? raw.length : 0;
  return (st.serialPrefix || '') + batchSeg() +
         (w ? padNum(base + i, w) : String(base + i));
}
/* One row of the picker: the scheme, and what it prints WITH THEIR OWN PREFIX
   in it. The customer is choosing an outcome, not a word. */
function serialSample(kind) {
  var pre = st.serialPrefix || '';
  if (kind === 'rand') return pre + randSample(0);
  var raw = String(st.serialStart == null ? '' : st.serialStart).trim();
  var num = /^\d{1,9}$/.test(raw) ? raw : SERIAL_SAMPLE;
  if (kind !== 'batch') return pre + num;
  var b = String(st.serialBatch || defaultBatch())
    .toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
  return pre + (b ? b + '-' : '') + num;
}
/* What goes in the seal's serial slot RIGHT NOW: the customer's own first
   number, or the neutral sample while the start field is empty or half-typed.
   Never a registered demo serial — that would advertise a record this order
   does not get. */
/* --- slider drag affordance (owner 2026-08-30): wiggle the slider once
   when it first scrolls into view; kill the wiggle AND the hint line on the
   first real drag. IntersectionObserver so the nudge fires when the buyer
   is actually looking at the quantity step, not on page load. --- */
(function qslAffordance() {
  var sl = document.getElementById('ss-qsl');
  var hint = document.getElementById('ss-qsl-hint');
  if (!sl) return;
  function used() {
    sl.classList.remove('qsl-nudge');
    /* re-query: on a render-cached page the hint div can mount after this
       script ran (or not at all) - never trust the load-time capture */
    var h2 = hint || document.getElementById('ss-qsl-hint');
    if (h2) h2.classList.add('off');
    sl.removeEventListener('pointerdown', used);
    sl.removeEventListener('input', used);
  }
  sl.addEventListener('pointerdown', used);
  sl.addEventListener('input', used);
  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { sl.classList.add('qsl-nudge'); io.disconnect(); }
      });
    }, { threshold: 0.6 });
    io.observe(sl);
  } else {
    sl.classList.add('qsl-nudge');
  }
})();

function previewSerial2() {
  /* the duo's SECOND half: the next number in the buyer's scheme, so the
     preview shows two different codes exactly as the cut seals will */
  if (st.serialType === 'none') return 'none';
  if (st.serialType === 'rand') return (st.serialPrefix || '') + randSample(1);
  return serialAt(1) || previewSerial();
}
function previewSerial() {
  /* a link per seal: the serial the customer listed beside the shown link */
  if (st.qrMode === 'list') {
    var _lr = qrListRow();
    if (_lr) return _lr.serial;
  }
  /* plain stickers: the literal 'none' is the renderer's no-serial sentinel —
     the same contract f.qr === 'none' already uses for the QR. Every preview
     surface reads its serial through here, so none of them can show a number
     the seal will not carry. */
  if (st.serialType === 'none') return 'none';
  /* random: a sample, held for the session — the real codes are minted at
     ingest and this browser is not allowed to invent one and call it theirs */
  if (st.serialType === 'rand') return (st.serialPrefix || '') + randSample(0);
  var raw = String(st.serialStart == null ? '' : st.serialStart).trim();
  if (!/^\d{1,9}$/.test(raw)) return (st.serialPrefix || '') + batchSeg() + SERIAL_SAMPLE;
  return serialAt(0) || ((st.serialPrefix || '') + batchSeg() + SERIAL_SAMPLE);
}
/* What goes down the renderer's `qr` channel. The engine reads '' as "build
   the verification URL for this serial" — a destination we no longer issue —
   so this function must NEVER return ''. A real URL prints their code with the
   OFFICIAL LINK caption; the literal 'none' suppresses the code entirely, and
   that is what an empty or unusable link resolves to. Every surface that draws
   a seal (main preview, gallery tiles, slideshow, mini) reads its qr through
   here, so none of them can fall back to /verify. */
/* A code to SHOW while the link box is still empty. It is the shop's own
   homepage, so if anyone ever scans a screenshot of the preview they land
   somewhere real and ours rather than on a dead demo host.

   PREVIEW ONLY, and that distinction is load-bearing: fields() takes a `demo`
   flag that ONLY renderPreview passes. The cart payload, the cart proof image
   and the print sidecar all call fields() with no argument, so a customer who
   never types a link still gets a seal with no code — which is what they
   bought. The summary's 'QR code' row states "None — the seal prints
   without a code" for exactly this case, so the demo code cannot quietly
   become an expectation nobody checked (the confirm-modal that used to do
   this was removed 2026-08-17 — it intercepted the buy tap). */
var DEMO_QR = 'https://serialseal.com';
/* A REPRESENTATIVE own-link, for the one place that compares a POS code's
   density against a link's. Never encoded on anything -- measured only. */
var DEMO_QR_LONG = 'https://www.ebay.com/usr/vintagepullsco';
/* Byte-mode capacity at EC level H, versions 1..6 -- lifted verbatim from the
   fourth column of QRCodeLimitLength in assets/qr-code-generator.js, which is
   the table the real encoder walks (ss-render.js passes no correctLevel, so
   the library default H applies). Versions 1-6 covers the whole range a seal
   can produce: the builder caps a link at 60 bytes and a serial at 14. */
var _QRH_BYTES = [7, 14, 24, 34, 44, 58];
function qrGrid(s) {
  var t = String(s == null ? '' : s), n = 0, i, c;
  /* UTF-8 byte length -- the same quantity getUTF8Length() measures */
  for (i = 0; i < t.length; i++) {
    c = t.charCodeAt(i);
    n += c < 0x80 ? 1 : c < 0x800 ? 2 : 3;
  }
  for (i = 0; i < _QRH_BYTES.length; i++) {
    if (n <= _QRH_BYTES[i]) { var m = 17 + 4 * (i + 1); return m + '\u00d7' + m; }
  }
  return 'over 41\u00d741';
}
/* What the POS code on THIS seal will encode. VERBATIM, matching skuCode() in
   ss-seal.js exactly: the payload, the number on the foil and the SKU column of
   the shop's catalogue import are one string, and anything that normalises it
   here would quote the customer a code their scanner will not produce. */
function skuPreviewCode() {
  var s = previewSerial();
  if (!s || s === 'none') return '';
  return String(s).trim() ? String(s) : '';
}

function qrField(demo) {
  if (st.qrMode === 'none') return 'none';
  /* Business prints OUR short link, not the customer's destination — that is
     the entire feature: the foil is fixed, the destination is editable. So the
     preview must encode the SHORT link, scheme-less and exactly as printed, or
     the customer is shown a QR at the wrong density: ss-seal.js encodes this
     string verbatim, and 's.serialseal.com/K7D4RM' (23 bytes) is version 3
     where 'https://…' (31) would be version 4 with ~20% smaller modules.
     Their destination still has to be valid — blockers() enforces that — but
     it never reaches the foil. */
  if (st.qrMode === 'business') return BIZ_LINK;
  /* POS item code: the sentinel, NOT a payload. ss-seal.js substitutes the
     serial it is already drawing (skuCode/isSku there), so the preview, the
     cart proof and the press all encode the same characters from the same
     line of code and cannot drift. Sending the serial itself down this
     channel would make this file a second source of truth for it. */
  if (st.qrMode === 'sku') return 'sku';
  /* a link per seal: the tapped row's own link (every row passed the same
     checks the single link gets); the demo code until a sheet is in */
  if (st.qrMode === 'list') {
    var _lr = qrListRow();
    return _lr ? _lr.link : (demo ? DEMO_QR : 'none');
  }
  /* A link we would refuse at checkout must not be drawn on the seal either —
     otherwise the proof shows a scannable code for something that can never
     ship (normUrl pastes https:// in front of `javascript:…` and the preview
     happily encodes the mangled result). No valid link yet = no code yet. */
  var u = qrProblem() ? '' : normUrl(st.qr);
  /* nothing usable typed yet -> show the demo code in the PREVIEW only */
  if (!u && demo) return DEMO_QR;
  return u || 'none';
}

/* Fields handed to the renderer. `image` carries whichever upload the template
   asks for, so the compositor never has to know which category it is. */
function fields(demo) {
  var c = caps();
  return {
    label_size_id: st.sizeId || 'standard_177x075',
    /* 'none' is the RENDERER'S sentinel for "print no brand text", the twin
       of f.serial === 'none' and f.qr === 'none'. It is not the same thing as
       '' — an empty name falls through to st.tpl.defaults.brand below, which
       is how a customer who has typed nothing yet still previews a finished
       seal carrying a demo name. Without the sentinel there is no way to say
       "I mean it, leave it off" in this channel. */
    brand: c.supportsTitle === false ? ''
         : noBrand() ? 'none'
         : (st.brand || st.tpl.defaults.brand || ''),
    color: c.supportsAccent === false ? st.tpl.defaults.color : (st.color || st.tpl.defaults.color),
    serial: previewSerial(),
    serial2: st.sealStyle === 'duo' ? previewSerial2() : '',
    run_total: '',            // random serials carry no /12 fraction — see ss-seal.js
    qr: c.supportsQR ? qrField(demo) : '',
    motif: st.qrMode === 'none' ? st.motif : '',
    image: st.artwork ? st.artwork.dataUrl : '',
    /* per-customer background: rides the same channel a studio design.bg
       takes — the compositor zones the whole seal around it (bgz/bgf) */
    /* the upload is KEPT in state while browsing (owner 2026-08-05: picking
       another layout used to delete it) — but only a design that takes a
       background may receive one, or a gallery design would render the
       customer's image over its own artwork */
    bg: (st.bg && c.requiresBackground) ? bgCropUrl() : '',
    /* The logo is ALWAYS handed over; where it lands (or that it is not
       printed at all) is logo_mode's job and nowhere else's. placeOrder
       reads the same logoPlace() call, so the preview and the printed seal
       cannot disagree. */
    logo: st.logo ? st.logo.dataUrl : '',
    logo_mode: logoPlace(),
    logo_scale: st.logoScale,
    site_text: st.qrMode === 'list' ? 'serialseal.com' : st.siteText,
    logo_plate: !!(st.logo && st.logo.plate),
    grade: st.grade,
    orientation: st.orientation,
    style: st.sealStyle,
    /* Gloss White: the renderer paints its foil-knockout gradients white */
    white: whiteStock()
  };
}

/* ═══ WHERE THE LOGO GOES ══════════════════════════════════════════
   A background and a logo are two LAYERS, and this is the single question
   that arranges them (owner 2026-08-08). It replaces the lone "my design
   already has my logo in it" checkbox, which was one half of this decision
   stated as a flag of its own.

   The three answers cover exactly what the owner asked for: a background on
   its own (upload no logo), a logo on its own (upload no background), or
   both — and with both, whether the logo sits ON the picture, ABOVE it, or
   is already IN it and must not print twice. */
var LOGO_PLACES = [
  ['window', 'On the picture',
   'Big and centred, with a backing so it stays readable.'],
  ['mark', 'Above your name',
   'Small, at the top \u2014 your picture stays clear.'],
  ['off', 'Don\u2019t print it',
   'My picture already has my logo in it.']
];
/* Resolved for the design they are ACTUALLY on. 'mark' and 'off' only mean
   anything when there is a background to sit clear of / hide inside, and a
   stale choice must never follow a customer to a design where 'off' would
   silently delete the logo they just uploaded. */
function logoPlace() {
  if (!(st.bg && caps().requiresBackground)) return 'window';
  var m = st.logoMode || 'window';
  return (m === 'mark' || m === 'off') ? m : 'window';
}
/* Shown only when BOTH files exist — with one of them the question has no
   second answer, and asking it would be friction for nothing. */
function logoPlaceOn() { return !!(st.logo && st.bg && caps().requiresBackground); }
function logoPlaceHtml() {
  if (!logoPlaceOn()) return '';
  var cur = logoPlace();
  var h = '<div class="lplace"><span class="lplace-q">Where should your logo go?</span>' +
    '<div class="lmode" role="group" aria-label="Where your logo goes">';
  LOGO_PLACES.forEach(function (p) {
    h += '<button type="button" data-lp="' + p[0] + '" aria-pressed="' +
      (cur === p[0] ? 'true' : 'false') + '"><b>' + p[1] + '</b>' +
      '<span>' + p[2] + '</span></button>';
  });
  return h + '</div></div>';
}
/* Every mount point paints from logoPlaceHtml() and wires with this, so the
   copy of the control in the fit sheet and the copy under the logo card can
   never say different things. */
/* FOCUS SURVIVES A REBUILD (a11y sweep 2026-08-20, SC 2.4.3 Focus Order).
   Several builder controls re-render their own container when activated,
   which destroys the very node holding focus: focus falls to <body> and the
   next Tab restarts at the top of the page. Each such handler now ends by
   focusing the equivalent node in the fresh markup. */
function _refocus(sel, delay) {
  setTimeout(function () {
    var n = document.querySelector(sel);
    if (!n) return;
    try { n.focus({ preventScroll: true }); } catch (_) { try { n.focus(); } catch (__) {} }
  }, delay || 0);
}
function wireLogoPlace(host) {
  if (!host) return;
  host.querySelectorAll('[data-lp]').forEach(function (b) {
    b.onclick = function () {
      st.logoMode = this.dataset.lp;
      /* the same row is mounted twice (logo card + the open fit sheet) —
         come back to the copy they actually pressed */
      var _scope = (this.closest && this.closest('#ssfit-hl')) ? '#ssfit-hl' : '#logo-place';
      paintLogoPlace();
      _refocus(_scope + ' [data-lp="' + st.logoMode + '"]');
      refreshGridSoon();
      sync();
      bgPreviewSoon();
    };
  });
}
/* Repaint BOTH mounts: the sheet is open over the logo card while the
   customer taps, and finding the other copy on the old answer afterwards is
   how a customer stops trusting the preview. */
function paintLogoPlace() {
  var on = logoPlaceOn(), sig = on ? logoPlace() : '-';
  ['logo-place', 'ssfit-hl'].forEach(function (id) {
    var h = document.getElementById(id);
    if (!h) return;
    h.hidden = !on;
    /* sync() calls this on every keystroke; rebuilding three buttons per
       character is waste, and it would also drop a tap landing mid-rebuild */
    if (h._lpSig === sig) return;
    h._lpSig = sig;
    h.innerHTML = on ? logoPlaceHtml() : '';
    wireLogoPlace(h);
  });
}

/* ——————————————— design gallery ——————————————— */
function catOf(t) { return (t.caps && t.caps.category) || 'artwork'; }

function badgesFor(t) {
  var c = t.caps || {}, out = [];
  out.push(c.requiresBackground ? '<span class="bdg need">Upload a background</span>'
         : c.requiresArtwork ? '<span class="bdg need">Upload artwork</span>'
         : c.requiresLogo ? '<span class="bdg need">Upload logo</span>'
         : '<span class="bdg free">No upload needed</span>');
  out.push(c.supportsQR
    ? '<span class="bdg qr">QR included</span>'
    : '<span class="bdg">No QR</span>');
  return '<div class="badges">' + out.join('') + '</div>';
}

/* Photographs of the actual rolls, not a CSS approximation. A gradient cannot
   show what Shattered Prism IS — a field of shattered foil shards — and a
   customer choosing a stock from a made-up swatch is being misled about what
   arrives. Same two files VialArt ships, uploaded to this theme so the picker
   never depends on the other store's assets. */
/* the two URLs arrive on SV_CFG because this file is an ASSET now and assets
   carry no Liquid — see the SV_CFG block in sections/sv-builder.liquid */
var MATERIALS = [
  ['Shattered Prism', 'A field of shattered foil shards — hard, glittering, breaks the light into colour.',
   (window.SV_CFG && SV_CFG.matPrism) || ''],
  ['Aurora', 'Smooth rainbow bands that sweep as the seal turns — softer, more liquid.',
   (window.SV_CFG && SV_CFG.matAurora) || ''],
  /* Gloss White (2026-10-18): plain white gloss vinyl, no holographic shine —
     the press lays no white ink, so what prints "white" on foil prints as the
     white stock here. Previewed on a white ground with the film off. */
  ['Gloss White', 'Plain white gloss vinyl — no rainbow shine. Unprinted areas print white.',
   (window.SV_CFG && SV_CFG.matWhite) || '']
];
function whiteStock(name) { return /white|gloss/i.test(String(name == null ? st.material : name) || ''); }
function renderMaterial() {
  var host = document.getElementById('matpick');
  if (!host) return;
  var wrapEl = document.querySelector('.wrap.bwrap');
  if (wrapEl) wrapEl.classList.toggle('mat-aurora', st.material === 'Aurora');
  if (wrapEl) wrapEl.classList.toggle('mat-white', whiteStock());
  var _pvEl = document.getElementById('pv');
  if (_pvEl) _pvEl.classList.toggle('white', whiteStock());
  /* If the selected stock has gone sold out, move off it before painting so
     the builder can never sit on an unbuyable material. */
  if (materialSoldOut(st.material)) {
    var _was = st.material, _why = materialNotOnSize(st.material);
    for (var k = 0; k < MATERIALS.length; k++) {
      if (!materialSoldOut(MATERIALS[k][0])) { st.material = MATERIALS[k][0]; break; }
    }
    /* say it when the SIZE moved them off their stock (Gloss White -> Large):
       a silent swap would change what they are buying under them */
    if (_why && st.material !== _was) {
      try { SS_UI.toast(_was + ' is Standard size only \u2014 switched to ' + st.material); } catch (_) {}
    }
  }
  host.innerHTML = '';
  MATERIALS.forEach(function (m) {
    var b = document.createElement('button');
    b.type = 'button';
    var on = st.material === m[0];
    var out = materialSoldOut(m[0]);
    /* not stocked on this size at all (Gloss White on Large) reads as that,
       not as a roll that ran out */
    var notHere = out && materialNotOnSize(m[0]);
    var outWord = notHere ? (st.sizeId === 'large_250x100' ? 'Standard size only'
                                                           : 'not on this size')
                          : 'sold out';
    b.className = 'matcard' + (on ? ' on' : '') + (out ? ' out' : '');
    b.disabled = out;
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', m[0] + ' — ' + m[1] + (out ? ' (' + outWord + ')' : ''));
    b.innerHTML = '<span class="matsw" aria-hidden="true">' +
                    '<img src="' + m[2] + '" alt="" loading="lazy" decoding="async">' +
                  '</span>' +
                  '<span class="mattx"><b>' + SS.esc(m[0]) + (function(n){ var t=/prism|shatter/i.test(n)?['exotic','Exotic']:(/aurora/i.test(n)?['ultra','Ultra']:['base','Base']); return ' <span class="va-tier va-tier-'+t[0]+'" title="'+t[1]+' tier"><svg viewBox="0 0 12 12" width="9" height="9" aria-hidden="true"><path d="M6 .6 11.4 6 6 11.4 .6 6z" fill="currentColor"/></svg>'+t[1]+'</span>'; })(m[0]) +
                  (out ? ' <i>' + outWord + '</i>' : '') + '</b>' +
                  '<span>' + SS.esc(m[1]) + '</span></span>';
    /* Deliberately NOT behind gateOk(): the gate exists because the design
       gallery previews need brand text. Which foil the seal prints on is a
       stock choice that stands on its own, so it stays pickable from the
       first paint. */
    b.onclick = function () {
      st.material = m[0];
      renderMaterial();
      _refocus('#matpick .matcard[aria-pressed="true"], #matpick .matcard.on');
      sync();
    };
    host.appendChild(b);
  });
}

/* The four seal styles differ in ONE thing: whether the seal crosses an edge of
   what it is stuck to. The old icon was a bare rectangle — identical for Single
   and Folded — and the sentence explaining the difference is hidden on phones,
   so all four tiles looked the same and you were picking from words alone.
   These draw it: the box being sealed, the seal on it, and for folded styles
   the seal bending over an edge with the fold marked. */
function styleIcon(shape, style, i) {
  /* Miniature SCENES (owner 2026-08-10): the seal drawn on the thing it
     actually goes on. Generic objects only — a rounded graded case with a
     plain card back, an open-top toploader, a deck box — never any grading
     company's label design. The portrait-fold tile honestly shows the seal
     covering the card; the banner tiles show the card staying visible. */
  var g = 'sgi' + i;
  var crease = function (x1, y1, x2, y2) {
    return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 +
      '" stroke="#fff" stroke-opacity=".95" stroke-width="1.1" stroke-dasharray="2 1.6"/>';
  };
  var card = function (x, y, w, h) {
    return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h +
      '" rx="1.4" fill="#5a7bd8" fill-opacity=".32"/>' +
      '<rect x="' + (x + w * 0.16) + '" y="' + (y + h * 0.13) + '" width="' + (w * 0.68) +
      '" height="' + (h * 0.74) + '" rx="1" fill="none" stroke="#8fa8e8" stroke-opacity=".55" stroke-width="1"/>' +
      '<circle cx="' + (x + w / 2) + '" cy="' + (y + h / 2) + '" r="' + (Math.min(w, h) * 0.16) +
      '" fill="#8fa8e8" fill-opacity=".5"/>';
  };
  var slab = function () {
    return '<rect x="12" y="1.5" width="24" height="41" rx="3" fill="none" ' +
      'stroke="currentColor" stroke-opacity=".45" stroke-width="1.5"/>' +
      '<rect x="14.5" y="4" width="19" height="5.5" rx="1" fill="currentColor" fill-opacity=".14"/>' +
      card(15.5, 12, 17, 27);
  };
  var toploader = function () {
    return '<path d="M13.5 2.5 V40.5 Q13.5 42 15 42 H33 Q34.5 42 34.5 40.5 V2.5" ' +
      'fill="none" stroke="currentColor" stroke-opacity=".45" stroke-width="1.5"/>' +
      card(15.5, 6, 17, 33);
  };
  var box3d = function () {
    return '<rect x="10" y="10" width="28" height="28" rx="2" fill="none" ' +
      'stroke="currentColor" stroke-opacity=".45" stroke-width="1.5"/>' +
      '<path d="M10 10 L4.5 5.5 V29.5 L10 34 Z" fill="none" ' +
      'stroke="currentColor" stroke-opacity=".45" stroke-width="1.5"/>' +
      '<path d="M10 10 L15.5 4 H43 L38 10 Z" fill="none" ' +
      'stroke="currentColor" stroke-opacity=".45" stroke-width="1.5"/>';
  };
  var holo = function (x, y, w, h, shaded) {
    return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h +
      '" rx="0.8" fill="url(#' + g + ')"/>' +
      (shaded ? '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h +
        '" rx="0.8" fill="#000" fill-opacity=".3"/>' : '');
  };
  var art;
  if (style === 'topfold') {
    /* Slab Banner: slim band over the case top — the card stays visible */
    art = slab() +
      holo(10.5, 0.5, 27, 3, true) +
      holo(10.5, 3.8, 27, 4.2, false) +
      crease(10.5, 3.8, 37.5, 3.8);
  } else if (style === 'topfold2') {
    /* Toploader Banner: band over the open edge — card stays visible */
    art = toploader() +
      holo(11.5, 0.5, 25, 3, true) +
      holo(11.5, 3.8, 25, 4.2, false) +
      crease(11.5, 3.8, 36.5, 3.8);
  } else if (shape === 'p' && style !== 'fold') {
    /* Portrait Single: flat on the graded case face */
    art = slab() + holo(20.5, 14, 7, 22, false);
  } else if (shape === 'p') {
    /* Portrait Folded: wraps the case top — honestly covers the card */
    art = slab() +
      holo(20.5, 0.5, 7, 2.6, true) +
      holo(20.5, 3.4, 7, 20, false) +
      crease(20.5, 3.4, 27.5, 3.4);
  } else if (shape === 'l' && style !== 'fold') {
    /* Landscape Single: along a toploader sleeve */
    art = toploader() + holo(15, 19, 18, 7, false);
  } else {
    /* Landscape Folded: wraps a deck box's side seam */
    art = box3d() +
      '<path d="M10 19 L5.5 15.2 V24.2 L10 28 Z" fill="url(#' + g + ')"/>' +
      '<path d="M10 19 L5.5 15.2 V24.2 L10 28 Z" fill="#000" fill-opacity=".3"/>' +
      holo(10, 19, 22, 9, false) +
      crease(10, 19, 10, 28);
  }
  return '<svg class="oic" viewBox="0 0 48 44" aria-hidden="true">' +
    '<defs><linearGradient id="' + g + '" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#9ad7ff"/><stop offset=".45" stop-color="#d9b6ff"/>' +
    '<stop offset="1" stop-color="#ffd39b"/></linearGradient></defs>' + art + '</svg>';
}

/* Four seal styles = orientation \u00d7 application. The option copy IS the
   difference explainer: folded styles wrap a seam (half the seal on each
   face, both reading upright), single styles are one-piece for flat spots. */
/* PORTRAIT LEADS AND IS THE DEFAULT (owner 2026-08-16). The Slab Banner held
   the slot from 2026-08-11; the rule that came with it stands \u2014 whatever is
   the default leads the list, so the first tile and the opening preview agree.
   Row order IS tile order; nothing indexes into this array.
   Claim-contract note: descriptions may never say the seal breaks/is
   destroyed on opening \u2014 that is the tamper claim this brand dropped
   (2026-08-07). Placement facts only. */
var SHAPES = [
  ['portrait', 'single', 'Portrait \u00b7 Single',
   'flat on a slab face, toploader, team bag or booster-box flap \u2014 no fold line', 'p'],
  ['portrait', 'fold', 'Portrait \u00b7 Folded',
   'wraps a graded slab\u2019s opening edge (PSA / BGS / CGC) \u2014 half on the front, half on the back', 'p'],
  ['landscape', 'topfold', 'Slab Banner \u00b7 Top Fold',
   'a slim band across the TOP of a graded slab \u2014 half front, half back, the card stays visible. Brand, logo + serial up front; the QR prints on the flat top edge (short links scan best)', 'l'],
  ['landscape', 'topfold2', 'Toploader Banner \u00b7 Top Fold',
   'the same slim band for a TOPLOADER\u2019s open edge \u2014 a knife-edge fold, half front, half back. Brand, logo + serial up front; the QR prints full size on the back face', 'l'],
  ['landscape', 'single', 'Landscape \u00b7 Single',
   'along a toploader sleeve or bubble-mailer flap \u2014 flat, no fold line', 'l'],
  ['landscape', 'duo', 'Duo Landscape \u00b7 2 Per Seal',
   'TWO seals side by side on one label with a dashed guide down the middle \u2014 YOU cut them apart with scissors (they are NOT pre-cut) and get double the seals per label', 'l'],
  ['portrait', 'duo', 'Duo Portrait \u00b7 2 Per Seal',
   'TWO seals stacked on one label with a dashed guide across the middle \u2014 YOU cut them apart with scissors (they are NOT pre-cut) and get double the seals per label', 'p'],
  ['landscape', 'fold', 'Landscape \u00b7 Folded',
   'across the side seam of a deck box, storage tin or bundle \u2014 design on the front, serial on the back', 'l']];
/* SHORT NAMES FOR THE TILES. SHAPES[2] is the long formal name and it is
   used in the summary rows, the cart line and the order properties, so it
   cannot be shortened there — but inside a ~90mm-wide tile on a 320px phone
   "Toploader Banner - Top Fold" wraps to three lines and drags the tile to
   139px tall. The tile shows this instead; everything else keeps the long
   name. */
var SHAPE_SHORT = {
  'topfold':  'Slab Banner',
  'topfold2': 'Toploader',
  'fold':     'Folded',
  'single':   'Flat'
};
function shapeShort(o) {
  var n = SHAPE_SHORT[o[1]] || o[2];
  /* the two folds and the two flats exist in both orientations, so those need
     the orientation to stay distinguishable; the banners are landscape-only */
  return (o[1] === 'fold' || o[1] === 'single')
    ? (o[0] === 'portrait' ? 'Portrait ' : 'Landscape ') + n
    : n;
}

/* the tag is derived, not stored, so it can never drift out of sync */
function shapeTag(o) {
  return o[1] === 'topfold2'
    ? 'wraps a toploader’s edge — card stays visible'
    : o[1] === 'topfold'
    ? 'wraps the top — card stays visible'
    : o[1] === 'fold'
    ? (o[0] === 'portrait' ? 'folds over the top' : 'folds over the side')
    : 'lies flat';
}
/* 2x2 grid of all four shapes (owner 2026-08-05: "change layout from
   dropdown to a 2x2 table showing them"). Every behaviour the dropdown
   carried is kept: artwork is invalidated on any shape change, the background
   only when the ORIENTATION flips (the die itself changes shape), the
   dimension callouts follow, and the tap is preview-first. */
/* The four shapes the owner wants one tap away, in the order asked for:
   "portrait, foldded portrait, slab, and top loader". Each entry is a
   [orientation, style] pair that MUST exist in SHAPES — the lookup below
   throws nothing if it does not match, it simply renders no button, so a
   typo here fails quiet rather than breaking the row. */
var QUICK_SHAPES = [
  ['portrait',  'single',   'Portrait'],
  ['portrait',  'fold',     'Folded'],
  ['landscape', 'topfold',  'Slab'],
  ['landscape', 'topfold2', 'Toploader'],
  /* the two landscape shapes, back on mobile (owner 2026-08-18: "add the 2
     missing shapes we excluded") — the strip already scrolls, and the
     rotation + pane ratchet handle their heights */
  ['landscape', 'single',   'Wide'],
  ['landscape', 'fold',     'Wide Fold'],
  /* DUO (owner 2026-08-30): the full picker is hidden at every width, so a
     shape that is not on this strip does not exist for the customer - the
     exact miss that hid Duo on launch day ("i dont see them on the shapes") */
  ['portrait',  'duo',      'Duo'],
  ['landscape', 'duo',      'Duo Wide']
];

/* WHICH HOLDER EACH SHAPE FITS (customer 2026-08-20: "not all of the
   choices describe what type of holders each seal works best with"). The
   long SHAPES[3] copy lives in the full picker, which is hidden at every
   width now — so the strip carries its own one-line version, named by the
   holders people actually buy. Keyed orientation|style. */
var SHAPE_FITS = {
  'portrait|single':    'Flat on a slab, One-Touch, toploader or team bag — no fold',
  'portrait|fold':      'Wraps the opening edge of a graded slab or One-Touch',
  'landscape|topfold':  'Slim band across the top of a slab or One-Touch — card stays visible',
  'landscape|topfold2': 'Slim band across a toploader’s open edge',
  'landscape|single':   'Flat along a sleeve, mailer flap or box lid',
  'landscape|fold':     'Across the seam of a deck box, tin or bundle',
  'portrait|duo':       'TWO seals stacked on one label — you hand-cut them apart, double the seals',
  'landscape|duo':      'TWO seals side by side on one label — you hand-cut them apart, double the seals'
};
function paintShapeNote() {
  var host = document.getElementById('shapequick');
  if (!host || !host.parentNode) return;
  var n = document.getElementById('sqk-note');
  if (!n) {
    n = document.createElement('div');
    n.id = 'sqk-note';
    n.className = 'sqk-note';
    host.parentNode.insertBefore(n, host.nextSibling);
  }
  n.textContent = SHAPE_FITS[st.orientation + '|' + st.sealStyle] || '';
}
function renderShapeQuick() {
  var host = document.getElementById('shapequick');
  if (!host) return;
  try { paintShapeNote(); } catch (_) {}              /* render-cached page from before this shipped */
  host.innerHTML = '';
  QUICK_SHAPES.forEach(function (q) {
    var idx = -1;
    for (var i = 0; i < SHAPES.length; i++) {
      if (SHAPES[i][0] === q[0] && SHAPES[i][1] === q[1]) { idx = i; break; }
    }
    if (idx < 0) return;
    var on = st.orientation === q[0] && st.sealStyle === q[1];
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sqk-b' + (on ? ' on' : '');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', q[2] + ' shape');
    /* the same miniature scene the full picker draws — the tile shows what
       the shape IS instead of naming it. Gradient ids are index-keyed inside
       styleIcon, so the +40 offset keeps them clear of the #orient tiles'. */
    b.innerHTML = '<span class="sqk-ic" aria-hidden="true">' +
      styleIcon(SHAPES[idx][4], q[1], 40 + idx) + '</span>' +
      '<i>' + q[2] + '</i>';
    b.onclick = function () {
      /* the loop rotates shapes now, so a shape pick must end it or the
         choice would be overwritten on the next tick */
      stopSlideshow();
      /* click the REAL tile — see the note at the top of this block */
      var tiles = document.querySelectorAll('#orient .otile');
      if (tiles[idx]) tiles[idx].click();
      else { st.orientation = q[0]; st.sealStyle = q[1]; renderOrient(); sync(); }
      /* renderOrient re-queues renderShapeQuick on its own 0ms timer, so this
         one waits behind it and lands on the REBUILT tile */
      _refocus('#shapequick .sqk-b.on', 24);
    };
    host.appendChild(b);
  });
}

function renderOrient() {
  var host = document.getElementById('orient');
  host.innerHTML = '';
  SHAPES.forEach(function (o, oi) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'otile';
    var on = st.orientation === o[0] && st.sealStyle === o[1];
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', o[2] + ', ' + o[3]);
    b.title = o[3];
    b.innerHTML = styleIcon(o[4], o[1], oi) +
      '<span class="otx"><b>' + shapeShort(o) + '</b>' +
      '<i class="otag">' + shapeTag(o) + '</i></span>';
    b.onclick = function () {
      if (st.orientation === o[0] && st.sealStyle === o[1]) return;
      stopSlideshow();   /* the loop rotates shapes now — a pick ends it */
      /* the quick row mirrors this selection, so it repaints with it */
      setTimeout(renderShapeQuick, 0);
      var oriFlip = st.orientation !== o[0];
      st.orientation = o[0];
      st.sealStyle = o[1];
      /* the shape requirement changed, so any artwork validated against the old
         one is no longer known-good \u2014 make them re-check rather than silently
         printing a crop they never approved */
      if (st.artwork) { st.artwork = null; SS_UI.toast('Seal style changed \u2014 please re-upload your artwork'); }
      /* the background target is the DIE itself, which only changes shape when
         the orientation flips \u2014 a single/fold toggle keeps the same canvas,
         so that upload stays validated and stays put */
      /* the die turns, so the crop is re-centred for the new aspect — the
         file itself is KEPT (bgCropUrl() re-crops per orientation) */
      if (st.bg && oriFlip) {
        _bgFit = { s: 1, x: 0, y: 0 };
        _bgCropCache = { sig: '', url: '' };
        var bz = document.getElementById('bg-zoom');
        if (bz) bz.value = 100;
      }
      /* The rebuild rides inside pvFade so the proof crossfades and the
         pane height glides instead of snapping (owner 2026-08-18). Focus
         restore stays in here — it needs the tiles renderOrient just
         rebuilt — and keeps preventScroll (owner 2026-08-14: a bare
         .focus() yanked the page down to the shape area). */
      pvFade(function () {
        renderOrient(); sync();
        setDims();
        if (typeof applyZoom === 'function') applyZoom();
        setTimeout(function () { renderGrid(); renderExtras(); }, 16);
        var nb = document.querySelector('#orient .otile[aria-pressed="true"]');
        if (nb) { try { nb.focus({ preventScroll: true }); } catch (_) { nb.focus(); } }
      });
    };
    host.appendChild(b);
  });
}
/* ═══════════════════ SerialSeal Business — the dynamic QR ═══════════════════
 *
 * A third QR destination. The code PRINTED on the foil is a short link we own
 * (s.serialseal.com/K7D4RM); where that link sends people is a setting the
 * customer can change afterwards, for ever, without reprinting a seal.
 *
 * ── THE ONE THING THIS MODULE EXISTS TO PREVENT ───────────────────────────
 * Being charged $359.88 twice. The plan belongs to the CUSTOMER ACCOUNT, not
 * to an order: buy 800 seals + Business today, order 2,000 more in six months,
 * and the second order must find the same live plan and add NOTHING. Every
 * other identifier in this file is order-shaped (cart line, serial range,
 * design key) — the plan deliberately is not.
 *
 * That is why:
 *   · a signed-OUT visitor is never sold this. There is no account for the
 *     plan to attach to, so the money would buy a plan with no owner. Sign-in
 *     is required, and asked for BEFORE any charge, never after.
 *   · a plan we cannot VERIFY is never sold either. If the Worker is
 *     unreachable, "no plan found" and "couldn't ask" are the same silence,
 *     and treating the second as the first is precisely how an existing
 *     subscriber gets invited to buy again. Unknown blocks the sale and says
 *     so — see bizCheck()/BIZ.state.
 *
 * ── THE PRINTED CODE ─────────────────────────────────────────────────────
 * BIZ_HOST is the host the Worker actually serves (SHORT_HOST in
 * cloud/wrangler-business.toml) and it is LOAD-BEARING ON THE FOIL, not just
 * copy: 's.serialseal.com/' is 17 bytes, the code is 6, and 23 bytes is the
 * last byte count that fits QR version 3 at error-correction H. Version 4
 * shrinks every module by ~20% on an 8.4mm patch. Lengthen this host and the
 * seal's QR gets denser everywhere — preview and print alike, because
 * ss-seal.js encodes whatever string it is handed, verbatim.
 *
 * BIZ_SAMPLE is a stand-in. Real codes are minted by the Worker at order time
 * (the same move serial minting made), so the builder has none to show — it
 * shows a correctly-shaped one. Its letters are from the Worker's alphabet
 * ACDEFGHJKMNPRTUVWXY34679, which has no I/L/O/S/B/0/1/2/5/8 in it so a code
 * can't be misread off foil. NOTE the spec illustrates this as 'K7D4QM' — Q is
 * NOT in that alphabet (it is an O look-alike); business-worker.js's /health
 * makes the same correction. Same length, same bytes, same QR version.
 */
var BIZ_HOST = 's.serialseal.com';
var BIZ_SAMPLE = 'K7D4RM';
var BIZ_LINK = BIZ_HOST + '/' + BIZ_SAMPLE;

var BIZ = {
  cfg: window.SS_BIZ_CFG || {},
  /* Can this actually be sold right now? False while the product is Draft,
     which is how it ships — so none of this renders until the owner activates
     it. See the Liquid block above. */
  ok: false,
  /* guest    — not signed in, so there is no account to attach a plan to
     checking — the entitlement read is in flight
     active   — they already pay for this; add NOTHING to the cart
     none     — verified as not on a plan; the $359.88 line is honest here
     unknown  — we could not ask. NOT the same as 'none'. Blocks the sale. */
  state: 'guest',
  endsOn: '', daysLeft: 0, detail: ''
};
/* THE GATE. All three, because each rules out a different way of having no
   sellable plan (see the Liquid note above):
     variantId  — null when the handle resolved to an empty product
     handle     — '' likewise, and it is what the cart line needs
     publishedAt— null while the product is DRAFT, which is how it ships. A draft
                  variant is a 422 at /cart/add.js, so this is the one that
                  stops the feature appearing before the owner turns it on. */
BIZ.ok = !!(BIZ.cfg.variantId && BIZ.cfg.handle && BIZ.cfg.publishedAt);
/* A signed-in visitor opens on 'checking', not 'guest': renderOptions() paints
   the panel during boot, BEFORE bizCheck() has had a chance to run, and a
   subscriber must never be shown "Add Business QR — $359.88" for the frame and
   a half before their plan comes back. */
BIZ.state = BIZ.cfg.signedIn ? 'checking' : 'guest';

/* $359.88 is the number the customer is charged. It leads every line that
   mentions money, and $29.99 only ever appears as a stated equivalent behind
   it — never as "the price". Showing $29.99 as the amount charged today is the
   exact shape of claim that cost this business a Google Merchant Center
   Misrepresentation suspension once already. */
function bizPriceStr() {
  var cents = parseInt(BIZ.cfg.price, 10);
  if (!isFinite(cents) || cents <= 0) cents = 35988;
  return '$' + (cents / 100).toFixed(2);
}
function bizBillingLine() {
  return bizPriceStr() + ' billed today for 12 months ($29.99/month equivalent)';
}
var BIZ_TICKS = [
  'Change where your QR code goes at any time',
  'Track every scan',
  'See scan time, location and device',
  'Manage hundreds or thousands of codes',
  'One plan covers your future orders'
];

/* Term end, for the line-item property. Informational — the Worker sets the
   authoritative term when the order lands — so it is derived the plain way. */
function bizTermEnd() {
  var d = new Date();
  d.setFullYear(d.getFullYear() + 1);
  return d;
}
function bizDay(d) {
  try {
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  } catch (_) { return d.toISOString().slice(0, 10); }
}

/* ── the entitlement read ───────────────────────────────────────────────────
 * POST /api/entitlement {cid, e}. The Worker requires BOTH, and answers with a
 * plan state and nothing else. It is not authentication and nothing of value
 * hangs off it — it decides whether we show a price or a badge.
 *
 * The failure branch is the point of the whole function. A DNS record that
 * does not exist yet, a Worker mid-deploy, a phone that dropped off wifi — all
 * land in 'unknown', and 'unknown' NEVER renders as "you don't have a plan".
 */
/* Set when a cart-edit or reorder record asked for Business. Held because the
   ask arrives during boot and the answer arrives later — see applyOptionPrefill. */
var _bizWanted = false;
var _bizReq = 0;
function bizCheck() {
  if (!BIZ.ok) return;
  if (!BIZ.cfg.signedIn || !BIZ.cfg.cid || !BIZ.cfg.email) {
    BIZ.state = 'guest';
    renderBiz();
    return;
  }
  var mine = ++_bizReq;
  BIZ.state = 'checking';
  renderBiz();

  var ctl = null, timer = null;
  try { ctl = new AbortController(); } catch (_) {}
  var opts = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ cid: String(BIZ.cfg.cid), e: BIZ.cfg.email })
  };
  if (ctl) { opts.signal = ctl.signal; timer = setTimeout(function () { ctl.abort(); }, 9000); }

  fetch(String(BIZ.cfg.api || '').replace(/\/+$/, '') + '/api/entitlement', opts)
    .then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    })
    .then(function (j) {
      if (mine !== _bizReq) return;              // a newer check already won
      if (!j || j.ok !== true) throw new Error('bad body');
      /* 'grace' is still a paying customer — a term that lapsed days ago must
         not be re-sold at full price from a builder page. */
      var live = j.active === true || j.state === 'active' || j.state === 'grace';
      BIZ.state = live ? 'active' : 'none';
      BIZ.endsOn = j.ends_on || '';
      BIZ.daysLeft = j.days_left || 0;
      BIZ.detail = '';
    })
    .catch(function (e) {
      if (mine !== _bizReq) return;
      BIZ.state = 'unknown';
      BIZ.detail = String((e && e.message) || e).slice(0, 60);
    })
    .then(function () {
      if (timer) clearTimeout(timer);
      if (mine !== _bizReq) return;
      renderBiz();
      /* A customer who had already picked Business and turns out to be
         unverifiable must not sit on a mode we cannot honour. */
      if (st.qrMode === 'business' && (BIZ.state === 'guest' || BIZ.state === 'unknown')) {
        st.qrMode = 'own';
        renderOptions(); sync();
      } else if (_bizWanted && BIZ.ok && st.qrMode === 'own' &&
                 (BIZ.state === 'active' || BIZ.state === 'none')) {
        /* The other direction: a Business line being edited was parked on the
           own-link field while we asked. The answer is in and it is a real
           one, so give them back the mode they configured — otherwise Update
           rewrites their line as own-link and leaves a $359.88 plan in the
           cart paying for nothing. */
        st.qrMode = 'business';
        renderOptions(); sync();
      }
    });
}

/* Do we have to put the $359.88 line in the cart for this order?
   ONLY when we have positively verified there is no live plan. 'active' adds
   nothing (that is the promise); 'guest' and 'unknown' never reach the cart at
   all, because chooseBusiness() refuses to select the mode in those states. */
function bizNeedsPurchase() {
  return st.qrMode === 'business' && BIZ.ok && BIZ.state === 'none';
}

/* The plan's cart line. Quantity is 1 and is re-locked to 1 on the cart page
   (assets/ss-cart.js) — a customer nudging the native stepper must not be able
   to buy two years of the same plan by accident.
   'Plan', 'Term' and 'Billing' carry no leading underscore, so they are PUBLIC
   properties: they show in the cart AND on Shopify's hosted checkout, which is
   the one screen of this purchase the theme does not render. Checkout is
   exactly where "$359.88 for 12 months" has to be legible. */
function bizPlanLine() {
  var end = bizTermEnd();
  return {
    id: BIZ.cfg.variantId,
    quantity: 1,
    properties: {
      'Plan': 'SerialSeal Business — dynamic QR, 12 months',
      'Term': bizDay(new Date()) + ' – ' + bizDay(end),
      'Billing': bizBillingLine() + '. One charge, not a recurring subscription.',
      'QR destination': (st.qr && !qrProblem()) ? normUrl(st.qr) : '',
      '_ss_business': '1',
      '_biz_term_end': end.toISOString().slice(0, 10),
      '_biz_customer_id': String(BIZ.cfg.cid || '')
    }
  };
}

/* ═══ SKIP THE PRODUCTION LINE — PRIORITY PRODUCTION, PRICED BY SIZE ═════
   Owner 2026-08-08: "Skip the Line / Rush Production should scale with label
   quantity, because jumping a 10,000-label job ahead of the queue has a
   completely different production impact than rushing 24 labels."

   Eight variants on one product, all carrying SKU PRIORITY-PROD so Label Farm's
   exact-match routing (_enqueue_seal_jobs_from_order_locked) keeps dispatching
   these seal jobs at priority 5 without needing to know the ladder exists.

   ⚠ THE FEE IS PRICED ON THE WHOLE CART, NOT ON THIS DESIGN. Owner:
   "calculate it dynamically from the entire cart quantity, not per design or
   line item." Three consequences, all load-bearing:
     · the price shown here depends on seals ALREADY in the cart, so the cart
       is read on boot and after every add;
     · adding a second design UPGRADES the existing fee line instead of adding
       a second one — two designs must never pay the fee twice;
     · every add re-prices an existing fee line, ticked or not.

   PRICES MATCH VIALART (owner 2026-08-14: "restore the old pricing we had same
   as vial art"). Read off vialart.myshopify.com product 10287272886548 rather
   than retyped, so the two stores cannot drift:
       29.99 / 49.99 / 79.99 / 119.99 / 179.99 / 259.99 / 359.99 / 499.99
   Note this is NOT what Serial Seal charged before — its own old ladder was
   199.99 / 299.99 / 399.99 in the three tiers above 1,000, so matching VialArt
   made the top of the ladder CHEAPER by $20-$40. Prices live on the Shopify
   variants; this file only maps quantity bands to them.
   ss-cart.js repeats the same reconciliation on the cart page, because a
   quantity edited there would otherwise strand the fee at a tier the order no
   longer sits in.

   IT IS NOT A DELIVERY PROMISE. It buys queue position. "Printed today" is not
   sayable at 10,000 labels, which is the entire reason this ladder exists. */
var RUSH = { cfg: window.SS_RUSH_CFG || {} };

/* min seals, max seals (0 = open-ended), and the variant option title carrying
   the price. The bounds land exactly on pack multiples, so no purchasable
   quantity ever straddles two tiers: 8 packs = 96 and 9 = 108; 83 = 996 and
   84 = 1,008; 833 = 9,996 and 834 = 10,008. */
var RUSH_LADDER = [
  [12,      99, '12-99 labels'],
  [100,    249, '100-249 labels'],
  [250,    499, '250-499 labels'],
  [500,    999, '500-999 labels'],
  [1000,  2499, '1,000-2,499 labels'],
  [2500,  4999, '2,500-4,999 labels'],
  [5000,  9999, '5,000-9,999 labels'],
  [10000,    0, '10,000+ labels']
];
RUSH.tiers = RUSH_LADDER.map(function (t) {
  var v = (RUSH.cfg.variants || []).filter(function (x) { return x.title === t[2]; })[0];
  return v ? { min: t[0], max: t[1], id: v.id, cents: parseInt(v.price, 10), label: t[2] } : null;
}).filter(Boolean);
/* ALL EIGHT, or the feature is off. A partial ladder would quietly charge the
   wrong tier at whatever sizes went missing, and undercharging by $470 is not a
   degraded experience — it is a bug that looks like it worked. publishedAt is
   null while the product is Draft, and a draft variant 422s at /cart/add.js. */
RUSH.ok = !!(RUSH.cfg.publishedAt && RUSH.tiers.length === RUSH_LADDER.length);

/* Seals already sitting in the cart, so the tier reflects the ORDER rather than
   just the design on screen. Refreshed on boot and after every add. */
var _cartSeals = 0, _cartHasRush = false;

function cartSealsOf(cart) {
  /* the rush ladder is priced on LABELS, and grading tags (SVN-TAG-<qty>) are
     the same physical label off the same die — a cart holding 600 seals and
     500 tags is a 1,100-label production event and must price as one. The tag
     count comes from the SKU, never from a property a browser wrote. */
  return (cart.items || []).reduce(function (n, it) {
    var sku = String(it.sku || '').toUpperCase();
    /* SVN-WIDE (Large) packs are the same twelve labels off the 10 mL die */
    if (sku.indexOf('SVN-PACK') === 0 || sku.indexOf('SVN-WIDE') === 0) return n + it.quantity * PACK_UNIT;
    var m = /^SVN-TAG-(\d+)$/.exec(sku);
    if (m) return n + parseInt(m[1], 10) * it.quantity;
    /* Lost & Found contact labels (SVN-LOST-12-<MAT> standard die,
       SVN-LOSTW-12-<MAT> large die): twelve labels a pack off the same two
       presses, so they belong to the same production event as seals and tags.
       The FOUR counters that price this fee — here, ss-cart.js rushLabelsOf,
       gt-builder.js cartLabelsOf and lt-builder.js — must agree, or the two
       builders and the cart each quote a different tier for one order. */
    var lf = /^SVN-LOST(W?)-(\d+)(?:-|$)/.exec(sku);
    if (lf) return n + (parseInt(lf[2], 10) || PACK_UNIT) * it.quantity;
    return n;
  }, 0);
}
function cartRushLine(cart) {
  return (cart.items || []).filter(function (it) {
    return String(it.sku || '').toUpperCase() === 'PRIORITY-PROD' ||
           (it.properties && it.properties._ss_rush);
  })[0] || null;
}
/* One read in flight at a time. paintPrice() can fire several times (the
   product fetch retries, and switching size repaints), and this used to be
   gated by RUSH.ok; unguarded it would put four identical /cart.js reads on
   the wire at boot, which is how a storefront starts answering with a
   challenge page. */
var _cartReadP = null, _cartReadAt = 0;
/* BOOT AND pageshow FIRE TOGETHER. The pageshow handler lost its `e.persisted`
   test when the minimum started riding on it, so an ordinary load now runs both
   it and the boot read about a second apart - two /cart.js hits on this site's
   hottest page, which is how a storefront starts answering with a challenge.
   _cartReadP only de-dupes reads that OVERLAP in flight, and these do not.
   1500ms collapses that pair into one read while still letting a genuine tab
   return (many seconds later) read fresh, so the stale-cart protection is
   untouched. `force` skips the window: a buy press must see the live cart,
   never a copy up to 1.5s old. */
function refreshCartSeals(force) {
  if (_cartReadP) return _cartReadP;
  if (!force && _lastCart && Date.now() - _cartReadAt < 1500) {
    return Promise.resolve(_lastCart);
  }
  _cartReadP = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) {
      _cartReadP = null;
      /* the cart-wide minimum reads THIS object (never a cached count), so
         the edit key can be set after the fetch was issued and still be
         honoured - see cartSealPacks() */
      _lastCart = c;
      _cartReadAt = Date.now();
      _cartSeals = cartSealsOf(c);
      _cartHasRush = !!cartRushLine(c);
      /* A fee already on the order means the order IS on priority production.
         An unticked box beside a paid rush line is the builder disagreeing with
         the cart, so show what they actually bought. */
      if (_cartHasRush) st.rush = true;
      paintRush();
      try { onCartRead(); } catch (e) { if (window.console) console.error('cartmin', e); }
      return c;
    })
    .catch(function () { _cartReadP = null; return null; });
  return _cartReadP;
}

/* The cart can change while this page sits open — the customer edits a quantity
   on /cart, empties it, or checks out in another tab, then comes back here (or
   is restored from the bfcache, where no script re-runs at all). Without this
   the builder keeps quoting the rush tier for a cart that no longer exists, and
   the fee looks stuck at whatever the old total bought. */
if (typeof document !== 'undefined') {
  /* NO RUSH.ok GATE (2026-09-05): the minimum rides on this read too. A
     customer who removes the 60-seal line on /cart and comes back to this tab
     must not still be looking at a 12-seal floor, so the re-read happens
     whether or not the priority product is live. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshCartSeals();
  });
  window.addEventListener('pageshow', function () { refreshCartSeals(); });
}

function rushTotalSeals() { return _cartSeals + pack().n; }
function rushTierFor(n) {
  for (var i = RUSH.tiers.length - 1; i >= 0; i--) {
    if (n >= RUSH.tiers[i].min) return RUSH.tiers[i];
  }
  return RUSH.tiers[0];
}
function rushTier() { return rushTierFor(rushTotalSeals()); }
function rushPriceStr(t) { return fmtMoney((t || rushTier()).cents / 100); }

/* Built once, repainted on every quantity change. Rebuilding the markup each
   time would drop keyboard focus out of the checkbox mid-interaction. */
function renderRush() {
  var host = document.getElementById('ss-day');
  if (!host) return;
  if (!RUSH.ok) { host.innerHTML = ''; st.rush = false; return; }
  if (!document.getElementById('ss-rush-cb')) {
    /* A BIG BRIGHT BUTTON, not a checkbox with fine print (owner
       2026-08-17). The price rides on the button; the note node survives
       hidden because paintRush() writes into it. */
    host.innerHTML =
      '<div class="rushslide" id="ss-rush-cb" role="switch" tabindex="0" aria-checked="false"' +
        ' aria-label="Slide or tap to add priority production">' +
        '<span class="rs-track-label"><span class="rs-shimmer">\u26a1 Slide to Skip the Print Line</span>' +
        '<i id="ss-rush-price"></i></span>' +
        '<span class="rs-thumb" aria-hidden="true">\u00bb</span>' +
      '</div>' +
      /* the context the bar itself can't fit (owner 2026-08-18: "needs
         context. What line") — one quiet line, and the honest scope */
      '<span class="rs-cap">Your seals print ahead of the standard queue ' +
      '\u00b7 production speed, not shipping speed</span>' +
      '<span id="ss-rush-note" hidden></span>';
    var cb = document.getElementById('ss-rush-cb');
    var th = cb.querySelector('.rs-thumb');
    function rsMax() { return Math.max(60, cb.clientWidth - th.offsetWidth - 10); }
    /* the parked (engaged) position is MEASURED, not guessed — a fixed
       translate left the thumb stranded mid-bar on wider phones (owner
       screenshot 2026-08-17 23:02) */
    function rsPark() { try { cb.style.setProperty('--rs-max', rsMax() + 'px'); } catch (_) {} }
    rsPark();
    addEventListener('resize', rsPark);
    /* ENGAGING IS A SLIDE, never a tap — a paid add-on must not be a
       fat-thumb accident. Removing is a tap on the green bar. */
    var _rsDrag = null;
    th.addEventListener('pointerdown', function (e) {
      if (st.rush) return;
      _rsDrag = { x: e.clientX, dx: 0 };
      cb.classList.add('drag');
      try { th.setPointerCapture(e.pointerId); } catch (_) {}
    });
    th.addEventListener('pointermove', function (e) {
      if (!_rsDrag) return;
      _rsDrag.dx = Math.max(0, Math.min(rsMax(), e.clientX - _rsDrag.x));
      th.style.transform = 'translateX(' + _rsDrag.dx + 'px)';
    });
    var _rsSwallow = false;
    function rsEnd() {
      if (!_rsDrag) return;
      /* WCAG 2.5.7 Dragging Movements: a plain TAP on the thumb engages it
         too, so a pointer user who cannot drag still has a path. The target
         is the 50px thumb, NOT the whole bar, so this keeps the
         accident-resistance the drag was chosen for (owner 2026-08-17: a
         paid add-on must not be a fat-thumb accident). */
      var ok = _rsDrag.dx > rsMax() * 0.7 || _rsDrag.dx < 4;
      _rsDrag = null;
      cb.classList.remove('drag');
      th.style.transform = '';
      /* the browser synthesizes a CLICK after the drag; without this it
         landed on the track handler and switched the fee straight back off */
      _rsSwallow = true;
      setTimeout(function () { _rsSwallow = false; }, 350);
      if (ok) { st.rush = true; buzz(20); renderPacks(); }
    }
    th.addEventListener('pointerup', rsEnd);
    th.addEventListener('pointercancel', rsEnd);
    cb.addEventListener('click', function () {
      if (_rsSwallow) return;             /* the post-drag synthetic click */
      if (st.rush) { st.rush = false; buzz(10); renderPacks(); }
    });
    cb.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); st.rush = !st.rush; buzz(12); renderPacks();
      }
    });
  }
  paintRush();
}

var _rushBuilding = false;
function paintRush() {
  if (!RUSH.ok) return;
  /* SELF-HEAL (owner 2026-08-11: the fee "stuck", and on some loads the card
     never appeared at all). renderRush() runs once in boot and returns early
     if #ss-day is not in the DOM yet; nothing retried, and paintRush only
     UPDATES nodes it does not create — so a single unlucky boot order left the
     upsell missing for the whole session with no error anywhere. renderPacks()
     calls this on every quantity change, so building here means the card
     appears at the first interaction at the latest. */
  if (!document.getElementById('ss-rush-cb') && document.getElementById('ss-day')
      && !_rushBuilding) {
    _rushBuilding = true;
    try { renderRush(); } catch (e) { if (window.console) console.error('rush', e); }
    _rushBuilding = false;
    return;                        /* renderRush() ends in paintRush() */
  }
  var cb = document.getElementById('ss-rush-cb');
  if (cb) {
    try {
      var _thW = (cb.querySelector('.rs-thumb') || {}).offsetWidth || 50;
      cb.style.setProperty('--rs-max', Math.max(60, cb.clientWidth - _thW - 10) + 'px');
    } catch (_) {}
    cb.classList.toggle('on', !!st.rush);
    cb.setAttribute('aria-checked', st.rush ? 'true' : 'false');
    var _sh = cb.querySelector('.rs-shimmer');
    if (_sh) _sh.textContent = st.rush
      ? 'Priority added \u2014 tap to remove'
      : '\u26a1 Slide to Skip the Print Line';
    var _th2 = cb.querySelector('.rs-thumb');
    if (_th2 && !cb.classList.contains('drag')) _th2.style.transform = '';
  }
  var t = rushTier(), total = rushTotalSeals();
  var pe = document.getElementById('ss-rush-price');
  if (pe) pe.textContent = '\u2014 ' + rushPriceStr(t);
  /* Say WHY the price is what it is — otherwise a fee that jumped because of
     a design already in the cart reads as a mistake. */
  var ne = document.getElementById('ss-rush-note');
  if (ne) {
    /* SHOW THE SPLIT when the cart is what set the tier (owner 2026-08-11:
       "$119.99 stuck at that, I went back to 12 and it's 119"). With 600 seals
       already in the cart, every press of −/+ here leaves the whole-cart total
       inside the same rung, so a correct fee reads as a frozen one. Naming
       both halves is the difference between "this is broken" and "oh, that is
       my cart". */
    ne.textContent = _cartSeals > 0
      ? ', currently ' + sealNum(_cartSeals) + ' already in your cart + ' +
        sealNum(pack().n) + ' here = ' + sealNum(total) + ' labels'
      : ', currently ' + sealNum(total);
  }
}

/* THE WHOLE DECISION, IN ONE PURE FUNCTION.

   It lives outside placeOrder() so it can be exercised against a made-up cart
   without writing to a real one. That matters more than it looks: proving the
   anti-gaming branch by driving the live storefront means a dozen cart writes,
   and Shopify starts answering /cart.js with an HTML challenge page long before
   the test finishes — at which point the check fails for a reason that has
   nothing to do with the ladder.

   Takes the cart as Shopify returns it, the seals about to be added, and
   whether the box is ticked. Returns what to do:
     tier  — the tier the ORDER should be on afterwards, or null for no fee
     stale — true when a fee line exists at the wrong tier and must be removed
             first (Shopify can change a line's quantity but never its variant)
     line  — the existing fee line, if any

   `wantRush || line` is the anti-gaming clause: an existing fee is re-priced
   even when this design was not ticked, because the customer already paid to
   jump the queue and the queue just got longer. Without it, 12 labels rushed
   for $29.99 followed by 10,000 plain ones sends 10,012 labels to the front for
   $29.99. */
function rushPlan(cart, addedSeals, wantRush) {
  var line = cartRushLine(cart);
  var seals = cartSealsOf(cart) + addedSeals;
  var tier = ((wantRush || !!line) && RUSH.ok) ? rushTierFor(seals) : null;
  var stale = !!line && (!tier || String(line.variant_id) !== String(tier.id));
  return { line: line, seals: seals, tier: tier, stale: stale,
           add: !!tier && (stale || !line) };
}

/* quantity 1, ALWAYS. One fee for one order, and a cart line's quantity means
   PACK COUNT everywhere else in this file. */
function rushLine(tier, seals) {
  return {
    id: tier.id,
    quantity: 1,
    properties: {
      'Service': 'Skip the Production Line \u2014 priority production, not shipping speed',
      'Order size': tier.label,
      'Labels in order': String(seals),
      'Refund': 'Refunded in full if we do not move your order ahead of the queue',
      '_ss_rush': '1'
    }
  };
}

/* Selecting Business. Every refusal below is a refusal to TAKE MONEY in a
   state where we could not deliver, or could double-charge. */
function chooseBusiness() {
  if (!BIZ.ok) return;
  if (BIZ.state === 'checking') { SS_UI.toast('Checking your plan…'); return; }

  if (BIZ.state === 'guest') {
    var back = encodeURIComponent(location.pathname + location.search);
    SS_UI.modal(
      '<h3 style="margin:0 0 8px">Business needs an account</h3>' +
      '<p style="margin:0 0 16px;color:var(--muted);font-size:14px;line-height:1.5">' +
      'Your plan is attached to your account, not to one order — that is what ' +
      'lets a later order use the same plan at no extra cost, and what lets you ' +
      'change where your codes point. Sign in first and we will bring you ' +
      'straight back to this seal.</p>' +
      '<a class="btn" style="width:100%;margin-bottom:9px;text-align:center;' +
      'display:block;text-decoration:none" href="' + BIZ.cfg.loginUrl +
      '?return_url=' + back + '">Sign in</a>' +
      '<a class="btn2" style="width:100%;text-align:center;display:block;' +
      'text-decoration:none" href="' + BIZ.cfg.registerUrl +
      '?return_url=' + back + '">Create an account</a>');
    return;
  }

  if (BIZ.state === 'unknown') {
    /* The honest dead end. We will not quote $359.88 to somebody who might
       already be paying it, and we will not hand out a plan we cannot confirm.
       Retry, or carry on with their own link — which still prints a scannable
       code to the same destination. */
    SS_UI.modal(
      '<h3 style="margin:0 0 8px">We can’t confirm your plan right now</h3>' +
      '<p style="margin:0 0 16px;color:var(--muted);font-size:14px;line-height:1.5">' +
      'We couldn’t reach the plan service, so we can’t tell whether you are ' +
      'already on Business. Rather than risk charging you a second time, we’ve ' +
      'left it off this order. Try again in a moment — or use your own link for ' +
      'now, which prints the same scannable code.</p>' +
      '<button class="btn" type="button" id="biz-retry" style="width:100%;margin-bottom:9px">' +
      'Try again</button>' +
      '<button class="btn2" type="button" id="biz-own" style="width:100%">' +
      'Use my own link instead</button>');
    var rt = document.getElementById('biz-retry');
    if (rt) rt.onclick = function () { SS_UI.close(); bizCheck(); };
    var ow = document.getElementById('biz-own');
    if (ow) ow.onclick = function () { SS_UI.close(); setQrMode('own'); };
    return;
  }

  /* 'active' or 'none' — both are verified answers, so both may be selected.
     'none' will add the plan line at checkout; 'active' adds nothing. */
  st.qrMode = 'business';
  renderOptions();
  optionsChanged();
  var i = document.getElementById('f-qr');
  if (i) i.focus();
}

/* The panel. Rendered inside renderOptions(), so it is rebuilt whenever the
   QR row is, and repainted on its own by renderBiz() when a check lands. */
function bizPanelHtml() {
  if (!BIZ.ok) return '';
  var on = st.qrMode === 'business';
  var h = '<div class="bizcard' + (on ? ' on' : '') + '" id="bizcard">';

  h += '<div class="bizhead"><b>Business QR</b>';
  if (BIZ.state === 'active') {
    h += '<span class="bizbadge live">Plan active</span>';
  } else {
    h += '<span class="bizprice">' + bizPriceStr() + '</span>';
  }
  h += '</div>';

  /* THE MONEY LINE. $359.88 first, always. */
  if (BIZ.state === 'active') {
    h += '<p class="bizbill">Your plan covers these seals — <b>nothing extra to pay</b>' +
      (BIZ.endsOn ? '. Runs through ' + SS.esc(BIZ.endsOn) : '') + '.</p>';
  } else {
    h += '<p class="bizbill">' + bizBillingLine() + '</p>';
  }

  h += '<ul class="bizticks">';
  BIZ_TICKS.forEach(function (t) { h += '<li>' + t + '</li>'; });
  h += '</ul>';

  if (on) {
    h += '<p class="bizsel">✓ Business QR is on these seals. Your code prints as ' +
      '<code>' + BIZ_HOST + '/' + BIZ_SAMPLE + '</code> — that is an example; ' +
      'each seal gets its own code when we print.</p>';
    h += BIZ.state === 'active'
      ? '<p class="bizsel quiet">Covered by your active plan — nothing added to your cart.</p>'
      : '<p class="bizsel quiet">Adds one ' + bizPriceStr() +
        ' plan to your cart, charged once for 12 months.</p>';
    h += '<button type="button" class="bizbtn2" id="biz-off">Remove Business QR</button>';
  } else if (BIZ.state === 'checking') {
    h += '<button type="button" class="bizbtn" disabled>Checking your plan…</button>';
  } else if (BIZ.state === 'guest') {
    h += '<button type="button" class="bizbtn" data-biz="go">Add Business QR</button>' +
      '<p class="bizfoot">Needs a Serial Seal account — we’ll ask you to sign in ' +
      'before anything is added.</p>';
  } else if (BIZ.state === 'unknown') {
    /* Never a price, never an Add button. */
    h += '<button type="button" class="bizbtn2" data-biz="retry">Try again</button>' +
      '<p class="bizfoot bad">We couldn’t reach the plan service, so we can’t check ' +
      'whether you already have Business. We’ve left it off rather than risk ' +
      'charging you twice.</p>';
  } else if (BIZ.state === 'active') {
    h += '<button type="button" class="bizbtn" data-biz="go">Use Business QR — no extra charge</button>';
  } else {
    h += '<button type="button" class="bizbtn" data-biz="go">Add Business QR</button>' +
      '<p class="bizfoot">One charge, not a recurring subscription. Covers every ' +
      'order you place in the next 12 months.</p>';
  }
  return h + '</div>';
}

/* Repaint the panel in place. Never rebuilds the whole options block, so a
   check landing mid-typing cannot steal focus from the destination field. */
function renderBiz() {
  var old = document.getElementById('bizcard');
  if (!old) return;
  var html = bizPanelHtml();
  if (!html) { old.remove(); return; }
  var tmp = document.createElement('div');
  tmp.innerHTML = html;
  old.parentNode.replaceChild(tmp.firstChild, old);
  bindBiz();
  if (typeof updateOptions === 'function') updateOptions();
}
function bindBiz() {
  var card = document.getElementById('bizcard');
  if (!card) return;
  card.querySelectorAll('[data-biz]').forEach(function (b) {
    b.onclick = function () {
      if (this.dataset.biz === 'retry') { bizCheck(); return; }
      chooseBusiness();
    };
  });
  var off = document.getElementById('biz-off');
  if (off) off.onclick = function () { setQrMode('own'); };
}

/* ═══════════ QR code & serial numbers ═══════════
 * Owner 2026-08-05: the verification registry is RETIRED for new orders. We
 * print and number seals; we do not host a public record for them any more.
 * That leaves two honest choices, and both of them are the customer's:
 *   · where the QR goes  — their own link, or no QR at all
 *   · what the numbers are — their prefix, their starting number
 * There is no "issued by us" mode and no registry toggle, because there is no
 * registry to join. Seals already shipped keep resolving on /pages/verify;
 * nothing in this block issues a new record.
 */

function optionsChanged() {
  refreshGridSoon();      // the gallery tiles carry the QR + serial too
  sync();
}
function setQrMode(mode) {
  /* Business has gates in front of it (sign-in, and a plan state we actually
     verified) so it is never assigned here — chooseBusiness() decides whether
     the mode may be entered at all, and sets it itself. */
  if (mode === 'business') { chooseBusiness(); return; }
  st.qrMode = mode === 'none' ? 'none' : mode === 'sku' ? 'sku'
            : (mode === 'list' && qrListOffered()) ? 'list' : 'own';
  /* the sheet supplies the serials, so plain stickers make no sense here */
  if (st.qrMode === 'list' && st.serialType === 'none') st.serialType = 'rand';
  renderOptions();
  /* the address field lives in #controls now, so the block that actually
     shows or hides it has to repaint too */
  renderDetails();
  optionsChanged();
  if (st.qrMode === 'own') {
    var i = document.getElementById('f-qr');
    if (i) i.focus();
  } else {
    /* 'No QR code' rebuilt the whole form and dropped focus on the floor */
    _refocus('.qrmode:not(.sermode) .qm[data-qm="' + st.qrMode + '"]');
  }
}

/* Restore the options from a reorder record or a cart-edit payload. Records
   and cart lines written before the registry was retired carry values that no
   longer exist — `qr_mode: 'record'`, `serial_mode: 'random'`, `registry: 1`.
   They are mapped FORWARD rather than honoured: a record QR has nothing to
   point at on a new order, so it lands on the (empty) own-link field, and
   registry numbering becomes the customer's own starting at the default. The
   old registry flag is read and discarded. */
/* Set by applyOptionPrefill so the boot-time prefix seeding knows a past order
   has already spoken for the numbering — including by leaving it blank, which
   is what a pre-2026-08-08 order looks like. Seeding over that would renumber
   a run the customer is repeating on purpose. */
var _prefilled = false;
function applyOptionPrefill(o) {
  if (!o) return;
  _prefilled = true;
  st.qr = o.qr || '';
  /* only an explicit "no code" survives; 'record' and anything unrecognised
     become the own-link field, prefilled if that line carried a link */
  /* 'business' only survives if Business can actually be sold AND we have a
     VERIFIED answer about this visitor's plan. Otherwise it degrades to their
     own link with the destination prefilled — the seal still prints a
     scannable code to the same page, which is a real product, rather than
     printing a short code with nothing behind it.

     ⚠ This runs during boot, and bizCheck() is asynchronous — so at this
     moment the state is almost always 'checking' and the test below would
     degrade EVERY edit of a Business line, silently turning it into an
     own-link line while the $359.88 plan stayed in the cart. `_bizWanted`
     records the intent so the answer, when it lands, can restore it (see the
     tail of bizCheck). */
  var _pm = String(o.qr_mode || '');
  _bizWanted = _pm === 'business';
  /* 'sku' survives a reorder or a cart edit unchanged: it has no gate in
     front of it (no plan, no sign-in, no destination to re-validate), so
     unlike 'business' there is nothing that could fail to come back. */
  st.qrMode = _pm === 'none' ? 'none'
    : _pm === 'sku' ? 'sku'
    : (_pm === 'list' && qrListOffered()) ? 'list'
    : (_bizWanted && BIZ.ok && (BIZ.state === 'active' || BIZ.state === 'none'))
      ? 'business' : 'own';
  /* a cart edit of a per-seal-link line: the stored sheet is RE-CHECKED from
     scratch (never trusted) and comes back un-ticked - they look again */
  st.qrList = null;
  if (st.qrMode === 'list' && o.qr_list) {
    SVQL.fromStored(o.qr_list).then(function (r) {
      if (st.qrMode !== 'list') return;
      r.ack = false;
      st.qrList = r;
      renderDetails();
      sync();
    });
  }
  st.motif = (window.SS_MOTIFS && SS_MOTIFS[String(o.motif || '')]) ? String(o.motif) : '';
  st.serialPrefix = String(o.serial_prefix || '')
    .toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 8);
  if (st.serialPrefix) _prefixAuto = false;   /* a prefill owns its numbering */
  /* A record with NO prefix (every My Seals "Reorder this design" record -
     it carries no numbering fields at all) gets the prefix a NEW order gets:
     three letters of the store name, else the session code. Left blank, the
     reorder printed bare numbers with nothing of the seller in them. */
  else if (String(o.serial_type || '').toLowerCase() !== 'none') {
    st.serialPrefix = prefixFromBrand(st.brand) || sessionPrefix();
  }
  st.serialStart = /^\d{1,9}$/.test(String(o.serial_start || ''))
    ? String(o.serial_start) : SERIAL_SAMPLE;
  /* Which scheme the order bought. Records and cart lines written before the
     three types existed carry nothing here and are sequential — which is
     exactly what they were, so the fallback reproduces them unchanged. */
  var _sty = String(o.serial_type || '').toLowerCase();
  /* 'none' survives a round-trip: a cart edit or reorder of plain no-number
     stickers must come back plain, not silently renumbered.
     EVERYTHING ELSE COMES BACK RANDOM (owner 2026-10-20: recent orders "had
     concurrent serials. They weren't all random"). This used to fall back to
     'seq' whenever the record named no scheme - and a My Seals "Reorder this
     design" record names none - so ss1108, ss1128, ss1169 and ss1187 printed
     001, 002, 003 ... with a blank prefix. There has been no sequential or
     batch chip since 2026-08-17 ("they are just randomly generated now"), so
     a prefill may only land on a scheme the builder actually offers. */
  st.serialType = _sty === 'none' ? 'none' : 'rand';
  st.serialBatch = String(o.serial_batch || '')
    .toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
  if (st.serialType === 'batch' && !st.serialBatch) st.serialBatch = defaultBatch();
  renderOptions();
}

/* host only — the chip has one short line to say where the code goes */
function qrHost(u) {
  var s = String(u || '').trim().replace(/^[a-z][a-z0-9+.-]*:\/\//i, '').replace(/^www\./i, '');
  return s.split(/[\/?#]/)[0];
}

/* The line beside the heading, so the setting reads without parsing the
   controls. Numbering is not in it — the range line below says that in full. */
function optionsChip() {
  if (caps().supportsQR === false) return 'No QR on this design';
  if (st.qrMode === 'sku') return 'Item code \u2014 the serial';
  if (st.qrMode === 'list') {
    return st.qrList && st.qrList.ok ? 'A link per seal (' + st.qrList.n + ')' : 'A link per seal';
  }
  if (st.qrMode === 'none') return 'No QR';
  var h = qrHost(st.qr);
  if (st.qrMode === 'business') return h ? 'Business QR → ' + h : 'Business QR';
  return h ? 'QR → ' + h : 'Your own link';
}

/* One numbering row. The EXAMPLE carries the customer's own prefix and updates
   as they type it (updateOptions refreshes .snex in place, so the DOM is never
   rebuilt under a focused field). */
function snOpt(val, name, why) {
  var on = val === st.serialType;
  return '<button type="button" class="snopt' + (on ? ' on' : '') + '" data-sn="' + val +
    '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '">' +
    '<span class="sntx"><span class="snhd"><b>' + name + '</b>' +
    '<span class="snex">' + SS.esc(serialSample(val)) + '</span></span>' +
    '<span class="snwhy">' + why + '</span></span></button>';
}
function setSerialType(k) {
  if (k !== 'seq' && k !== 'rand' && k !== 'batch' && k !== 'none') return;
  if (st.serialType === k) return;
  st.serialType = k;
  /* a batch line needs a batch code — fill today's rather than present an
     empty required field whose shape they would have to guess */
  if (k === 'batch' && !st.serialBatch) st.serialBatch = defaultBatch();
  renderOptions(); sync();
}

function optSeg(group, val, cur, label) {
  var on = val === cur;
  return '<button type="button" class="optbtn' + (on ? ' on' : '') + '"' +
    ' data-opt="' + group + '" data-val="' + val + '"' +
    ' aria-pressed="' + (on ? 'true' : 'false') + '">' + label + '</button>';
}

function renderOptions() {
  var host = document.getElementById('optbody');
  if (!host) return;
  var c = caps(), h = '';

  /* The QR mode lives IN the QR field now (renderDetails — owner
     2026-08-17: "it needs to actually be the QR code input all in one").
     This card only carries the No-QR motif picker and the Business panel
     while that product is live; it hides entirely when empty. */
  /* the No-QR motif picker is REMOVED (owner 2026-08-17) — a no-QR seal
     simply reflows (the bgz layouts already handle it), and seals from old
     orders that carry a _motif still render it. Only Business remains. */
  if (c.supportsQR !== false) {
    h += bizPanelHtml();
  }

  /* numbering UI REMOVED (owner 2026-08-17: "remove the first number and
     also remove picking how the serials are made"). Serials are random for
     every new order; serialAt()/ownSerials()/Label Farm still honour seq and
     batch for reorder prefills, invisibly. */

  host.innerHTML = h;
  /* nothing to say -> no empty bordered box on the page */
  var _obox = host.closest('.opts') || host.parentElement;
  if (_obox) _obox.style.display = h.replace(/\s+/g, '') ? '' : 'none';

  host.querySelectorAll('.optbtn').forEach(function (b) {
    b.onclick = function () { setQrMode(this.dataset.val); };
  });
  host.querySelectorAll('.snopt').forEach(function (b) {
    b.onclick = function () { setSerialType(this.dataset.sn); };
  });
  bindBiz();
  /* #f-qr is wired in renderDetails(), which owns the element now. Wiring it
     here as well would look harmless and break silently: renderDetails()
     rebuilds #controls on every repaint, so the handler attached from this
     function would be thrown away with the old node and typing a QR address
     would stop updating st.qr. */
  var sb = document.getElementById('f-sb');
  if (sb) sb.oninput = function () {
    /* the batch rides between the prefix and the count, so it takes the same
       characters the prefix does minus the dash — the dash is ours */
    var v = this.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
    if (v !== this.value) this.value = v;
    st.serialBatch = v;
    updateOptions(); sync();
  };
  var ss = document.getElementById('f-ss');
  if (ss) ss.oninput = function () {
    var v = this.value.replace(/[^0-9]/g, '').slice(0, 9);
    if (v !== this.value) this.value = v;
    st.serialStart = v;
    updateOptions(); sync();
  };

  updateOptions();
}

/* Live bits only — never rebuilds the DOM, so it is safe to call from sync()
   on every keystroke without stealing focus from the field being typed in. */
function updateOptions() {
  var chip = document.getElementById('opt-chip');
  if (chip) chip.textContent = optionsChip();
  var hint = document.getElementById('opt-qr-hint');
  if (hint) {
    var prob = qrProblem(), raw = String(st.qr || '').trim();
    hint.className = 'opthint' + (prob ? ' bad' : '');
    /* Business is a different promise, so it gets different words: the link
       length is irrelevant there (the foil carries our short code, never the
       destination) and the destination is changeable afterwards, which is the
       one thing worth saying under the field. */
    hint.textContent = prob ? prob
      : st.qrMode === 'sku'
          ? 'Nothing to type \u2014 the code is the seal\u2019s own serial. Works ' +
            'with Square Point of Sale and any till that looks an item up by SKU.'
      : st.qrMode === 'business'
          ? 'Where your codes point first — change it any time, no reprint.'
      : !raw ? 'eBay, Whatnot, Instagram, Facebook, your own site — or an email ' +
               'address. Leave it blank and the seal prints with no code.'
      : isEmailLink(raw)
          ? 'Scans open a new email to ' + raw.replace(/^mailto:/i, '') + '.'
      : raw.length > QR_MAX
          ? 'Long links print a denser code — a short one scans faster'
          : 'Scans straight to your page. The caption prints OFFICIAL LINK.';
  }
  /* the three examples re-render IN PLACE — rebuilding the picker here would
     steal focus from the prefix field on every keystroke */
  document.querySelectorAll('#optbody .snopt').forEach(function (b) {
    var ex = b.querySelector('.snex');
    if (ex) ex.textContent = serialSample(b.getAttribute('data-sn'));
  });
  var rng = document.getElementById('opt-range');
  if (rng) {
    var bad = serialProblem();
    rng.className = 'opthint' + (bad ? ' bad' : '');
    rng.textContent = bad ? bad
      /* random gets a different sentence because it makes a different promise:
         there is no range to quote, and the thing worth saying is the one the
         customer is buying it for */
      : st.serialType === 'rand'
        ? 'Prints ' + st.qty + ' unique codes like ' + serialAt(0) + ' and ' +
          serialAt(1) + ' — nothing in them says how many you made'
      : 'Prints ' + serialAt(0) + ' → ' + serialAt(Math.max(0, st.qty - 1)) +
        ' across your ' + st.qty + ' seals';
  }
}

/* ——————————— the fork: the two ways to make a seal ———————————
 * Both paths already existed — the logo uploader in step 1, the gallery below
 * it — but nothing on screen said so, and uploading a logo silently re-filtered
 * the gallery to the logo layouts. A first-time visitor could not see there was
 * a choice at all. Asking it out loud is the whole change here; the gallery,
 * the chips and the upload flow underneath are untouched.
 *
 * st.path is only where they START. Switching re-filters the gallery and
 * nothing else — an uploaded logo survives both directions, because plenty of
 * our designs carry a logo as a corner mark too.
 */
function smoothTo(el, block) {
  if (!el) return;
  el.scrollIntoView({
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    block: block || 'start' });
}
function sellCount(cat) {
  return (window.SS_SELLABLE || []).filter(function (t) {
    return !cat || cat === 'all' || catOf(t) === cat;
  }).length;
}
/* The genre categories (Cards / Sports / Arcane / Creatures) are defined in
   ss-templates.js and change without this file ever being touched — read them,
   never list them. "Our designs" = the first category on sale that isn't the
   logo layouts. */
function firstGenreCat() {
  var cats = window.SS_CATEGORIES || [];
  for (var i = 0; i < cats.length; i++) {
    if (cats[i].key === 'all' || cats[i].key === 'logo') continue;
    if (sellCount(cats[i].key)) return cats[i].key;
  }
  return 'all';
}
/* With nothing but logo layouts on sale the fork would be advertising a choice
   that does not exist, so it hides itself and the gallery opens straight away.
   It comes back on its own the day a genre design ships. */
/* The fork is gone (owner's mock, 2026-08-02): the gallery is ALWAYS
   available — templates are pickable with no logo at all — and uploading a
   logo just filters to the layouts that feature it. st.path survives as the
   name of that filter so the upload flow and catnote keep working. */
function setPath(p, silent) {
  st.path = p;
  /* No longer narrows the gallery. The chips are gone (owner 2026-08-08), so a
     filter applied here would be invisible AND un-undoable — the customer would
     simply see fewer designs than exist with nothing to explain it. st.path is
     kept because the upload flow and catnote still read it. */
  renderCats();
  renderGrid();
}
function openStage(p) { st.path = p; }

function focusLogoUploader() {
  var slot = document.getElementById('logo-slot');
  if (!slot) return;
  smoothTo(slot, 'center');
  slot.classList.remove('hilite');
  void slot.offsetWidth;                    // restart the pulse on a repeat tap
  slot.classList.add('hilite');
  var d = document.getElementById('logo-drop');
  if (d) setTimeout(function () { d.focus(); }, 450);
}


function renderCats() {
  var host = document.getElementById('cats');
  if (!host) return;
  host.innerHTML = '';
  /* Chips removed (owner 2026-08-08). Kept as a no-op rather than deleted: it is
     called from setPath(), the prefill paths and boot, and every caller would
     otherwise need a guard. The counting below still informs renderCatNote(). */
  host.hidden = true;
  renderCatNote();
  return;
  /* count what's ON SALE, not every definition — retired designer/artwork
     templates still live in SS_TEMPLATES so past orders keep rendering */
  var counts = {};
  (window.SS_SELLABLE || []).forEach(function (t) {
    counts[catOf(t)] = (counts[catOf(t)] || 0) + 1;
  });
  /* one category on sale = the chip row is noise; hide it entirely */
  var live = Object.keys(counts).length;
  if (live <= 1) { host.hidden = true; renderCatNote(); return; }
  host.hidden = false;
  (window.SS_CATEGORIES || []).forEach(function (c) {
    if (c.key !== 'all' && !counts[c.key]) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'chip' + (st.cat === c.key ? ' on' : '');
    b.setAttribute('role', 'tab');
    b.setAttribute('aria-selected', st.cat === c.key ? 'true' : 'false');
    b.textContent = c.label;
    b.onclick = function () {
      st.cat = c.key; renderCats(); renderGrid();
      /* the fork copy is written off st.cat ("Showing the layouts built around
         your own logo" vs "Your logo goes on whichever design you pick"), so a
         chip that moves off the logo layouts has to repaint it — otherwise the
         note keeps describing a filter the customer just left */
      var nb = document.querySelector('#cats .chip.on');
      if (nb) nb.focus();
    };
    host.appendChild(b);
  });
  renderCatNote();
}

/* Why the gallery is narrowed, said where the narrowing is visible. The
   pathnote up at the fork already offers the way out, but on a phone that is a
   long scroll above the grid — this repeats the escape hatch directly over the
   cards. The filter is a suggestion, not a cage. */
function renderCatNote() {
  var el = document.getElementById('catnote');
  if (!el) return;
  var total = sellCount(null), shown = sellCount(st.cat);
  if (st.path !== 'logo' || st.cat !== 'logo' || shown >= total) { el.hidden = true; return; }
  el.hidden = false;
  el.innerHTML = 'Showing the ' + shown + ' layout' + (shown === 1 ? '' : 's') +
    ' built around your logo. <button type="button" class="lnk" id="cat-all">' +
    'Browse our ' + (total - shown) + ' other designs</button>';
  el.querySelector('#cat-all').onclick = function () { setPath('gallery'); };
}

/* ——— customer-background tiles ———
   The bg design renders with THEIR image the moment one exists; before that
   the tile is an upload invitation (dashed frame + arrow + words), never a
   broken empty seal. tileBg() feeds the thumb into every tile mount. */
function tileBg(t) {
  return (st.bg && t.caps && t.caps.requiresBackground)
    ? (st.bg.thumb || st.bg.dataUrl) : '';
}
function bgInviteSvg() {
  function r2i(n) { return Math.round(n * 100) / 100; }
  var land = st.orientation === 'landscape';
  var W = land ? 44.958 : 19.05, H = land ? 19.05 : 44.958;
  var cx = r2i(W / 2), cy = H / 2;
  var uid = 'bgi' + (land ? 'L' : 'P');
  /* A SOLID plate, not line-art: the old pale-blue dashes vanished against
     the holo substrate and read as a disabled tile (owner 2026-08-05: "it's
     so faint"). Dark ground + holo-gradient frame + white type makes it the
     boldest thing in the gallery, which suits the one option that lets the
     customer put ANY artwork on the seal. */
  var iconY = land ? cy - 1.2 : cy - 5.2;
  var t1 = land ? cy + 3.9 : cy + 2.2;
  var t2 = land ? cy + 6.4 : cy + 4.9;
  var t3 = land ? cy + 8.4 : cy + 7.2;
  var size = land ? 2.5 : 2.35;
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + r2i(W) + ' ' + r2i(H) + '">' +
    '<defs><linearGradient id="' + uid + '" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#7de3ff"/><stop offset=".35" stop-color="#9a8cff"/>' +
    '<stop offset=".7" stop-color="#ff7ad9"/><stop offset="1" stop-color="#ffd36e"/>' +
    '</linearGradient></defs>' +
    /* full-bleed dark plate so the tile never disappears into the foil */
    '<rect x="0" y="0" width="' + r2i(W) + '" height="' + r2i(H) + '" rx="1.6" fill="#0b0c11"/>' +
    '<rect x="0.55" y="0.55" width="' + r2i(W - 1.1) + '" height="' + r2i(H - 1.1) +
    '" rx="1.25" fill="none" stroke="url(#' + uid + ')" stroke-width="0.7"/>' +
    /* arrow rising out of a tray — filled, not hairline */
    '<g transform="translate(' + cx + ' ' + r2i(iconY) + ')">' +
    '<path d="M0 -3.1 L2.5 0.1 H1.05 V3.0 H-1.05 V0.1 H-2.5 Z" fill="url(#' + uid + ')"/>' +
    '<path d="M-3.5 3.9 H3.5" stroke="url(#' + uid + ')" stroke-width="0.85" ' +
    'stroke-linecap="round"/></g>' +
    '<text x="' + cx + '" y="' + r2i(t1) + '" text-anchor="middle" font-family="Helvetica"' +
    ' font-weight="bold" font-size="' + size + '" fill="#ffffff" letter-spacing="0.08">UPLOAD</text>' +
    '<text x="' + cx + '" y="' + r2i(t2) + '" text-anchor="middle" font-family="Helvetica"' +
    ' font-weight="bold" font-size="' + size + '" fill="#ffffff" letter-spacing="0.08">YOUR OWN</text>' +
    '<text x="' + cx + '" y="' + r2i(t3) + '" text-anchor="middle" font-family="Helvetica"' +
    ' font-size="1.5" fill="#9aa3b8">any image \u00b7 full colour</text>' +
    '</svg>';
}function mountTile(seal, t, f, q) {
  if (t.caps && t.caps.requiresBackground && !st.bg) {
    seal.innerHTML = bgInviteSvg();
    return;
  }
  SS.mount(seal, t, f, q);
}

function renderGrid() {
  var host = document.getElementById('grid');
  /* 10 of the 16 per-click mounts went into this CLOSED <details> — never
     painted, and re-rendered on open anyway (the toggle re-render exists for
     the hidden-getBBox logo bug). Skip them and mark the grid dirty; the
     thumb strip lives OUTSIDE the details and must still refresh. */
  var ag = document.getElementById('allgal');
  if (ag && !ag.open) {
    _gridSig = '';
    renderThumbs();
    return;
  }
  host.innerHTML = '';
  host.classList.toggle('land', st.orientation === 'landscape');
  /* A listbox that cannot be driven with the arrow keys is a listbox in name
     only. Cards are real buttons so Enter/Space already work; this adds the
     roving focus that the role promises. */
  host.onkeydown = function (e) {
    var keys = { ArrowRight: 1, ArrowDown: 2, ArrowLeft: -1, ArrowUp: -2 };
    if (!(e.key in keys)) return;
    var cards = [].slice.call(host.querySelectorAll('.dcard'));
    var i = cards.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    var cols = getComputedStyle(host).gridTemplateColumns.split(' ').length;
    var d = keys[e.key];
    var next = Math.abs(d) === 1 ? i + d : i + (d / 2) * cols;
    if (next >= 0 && next < cards.length) cards[next].focus();
  };
  (window.SS_SELLABLE || []).forEach(function (t) {
    /* no category filter: the chips were removed (owner 2026-08-08) and
       st.cat is still written from a template's own category on boot,
       reorder and cart-edit — leaving this in hid designs with nothing on
       screen to bring them back */
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'dcard';
    card.dataset.key = t.key;
    card.setAttribute('role', 'option');
    card.setAttribute('aria-selected', st.tpl && st.tpl.key === t.key ? 'true' : 'false');
    card.setAttribute('aria-label', t.name + ' — ' + t.desc);
    card.innerHTML = '<span class="tick" aria-hidden="true">&#10003;</span>';
    var seal = document.createElement('div');
    seal.className = 'ss-seal flat';
    card.appendChild(seal);
    /* no name/blurb/badges under the tiles (owner 2026-08-02: "remove the
       text under each seal") — the rendered seal IS the information; the
       aria-label above keeps the name + description for screen readers */
    card.onclick = function () { pickDesign(t); };
    host.appendChild(card);

    /* card previews use the SAME renderer as the main preview, rendered with
       the CUSTOMER'S details from step 1 — their brand, colour, logo and link —
       so picking a design is choosing between finished versions of THEIR seal,
       not imagining their name over someone else's sample. Template samples
       only fill in where they haven't entered anything yet. The serial slot
       carries the placeholder for the same reason the main preview does — no
       number shown before checkout is one the customer actually owns. */
    var uBrand = st.brand.trim(), uNoBrand = noBrand();
    mountTile(seal, t, {
      /* Same three-way as fields(): the sentinel FIRST, because the
         `|| t.defaults.brand` fallback below is exactly what would otherwise
         paint a demo shop name onto a gallery of seals the customer has just
         told us carry no name at all. */
      brand: (t.caps && t.caps.supportsTitle === false) ? ''
           : uNoBrand ? 'none'
           : (uBrand || t.defaults.brand),
      color: st.color || t.defaults.color,
      /* the tiles answer "what would MY seal look like on this design", so
         they carry the customer's QR + numbering choices too — a tile still
         showing a verification QR after they turned the QR off would be
         advertising a seal we are not going to print */
      serial: previewSerial(),
      run_total: '',
      qr: (t.caps && t.caps.supportsQR === false) ? '' : qrField(),
      motif: st.qrMode === 'none' ? st.motif : '',
      /* Show THEIR artwork on the tiles, not the stock sample. The logo was
         already wired through here but the uploaded image never was, so after
         uploading, the gallery still advertised somebody else's photo and the
         customer could not tell which design suited their own (owner
         2026-07-28). Thumb, not full-res — this renders across every tile. */
      image: (st.artwork && t.caps && t.caps.requiresArtwork)
        ? (st.artwork.thumb || st.artwork.dataUrl) : (t.image || ''),
      bg: tileBg(t),
      logo: (st.logo && t.caps && (t.caps.requiresLogo || t.caps.category === 'logo'))
        ? (st.logo.thumb || st.logo.dataUrl) : '',
      logo_scale: st.logoScale,
      orientation: st.orientation,
      style: st.sealStyle
    }, Q_THUMB);
    seal.classList.toggle('land', st.orientation === 'landscape');
  });
  _gridSig = gridSig();
  renderThumbs();
}

/* Quick picks beside the preview: the first few designs of the current
   filter, pickable with or without a logo — this strip is what "the templates
   are always there" means on a phone, where the full gallery is a fold away.
   Mounted with the same fields shape as the gallery tiles (keep in sync). */
var _thumbSig = '';
function renderThumbs() {
  var host = document.getElementById('pvthumbs');
  if (!host) return;
  var list = (window.SS_SELLABLE || []).filter(function (t) {
    return true;   /* every sellable design — see renderGrid */
  });
  var picks = [];
  if (st.tpl) picks.push(st.tpl);
  list.forEach(function (t) {
    if (picks.length < 5 && picks.indexOf(t) < 0) picks.push(t);
  });
  /* re-mounting five seals when nothing they render changed was half the
     remaining click cost — selection alone just moves the outline */
  /* noBrand() is in the signature because turning the name OFF changes every
     thumb and changes NOTHING else in this list — st.brand still holds the
     text they typed. Leave it out and the strip keeps painting the old seal
     until some unrelated detail happens to move. */
  var sig = [picks.map(function (t) { return t.key; }).join(','), st.brand.trim(),
    noBrand() ? 'nobrand' : '',
    st.color, st.logo ? st.logo.name + st.logo.kb : '',
    st.artwork ? st.artwork.name : '',
    st.bg ? st.bg.name + st.bg.kb : '', st.orientation, st.sealStyle,
    optSig()].join('|');
  if (sig === _thumbSig && host.firstChild) {
    host.querySelectorAll('.pvth').forEach(function (b) {
      var on = st.tpl && b.getAttribute('aria-label') === 'Use design ' + st.tpl.name;
      b.classList.toggle('on', on);
      if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    return;
  }
  _thumbSig = sig;
  host.innerHTML = '';
  var uBrand = st.brand.trim(), uNoBrand = noBrand();
  picks.forEach(function (t) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pvth' + (st.tpl && st.tpl.key === t.key ? ' on' : '');
    b.setAttribute('aria-label', 'Use design ' + t.name);
    b.setAttribute('aria-pressed', st.tpl && st.tpl.key === t.key ? 'true' : 'false');
    var seal = document.createElement('span');
    seal.className = 'ss-seal flat';
    b.appendChild(seal);
    b.onclick = function () { pickDesign(t); };
    host.appendChild(b);
    mountTile(seal, t, {
      /* keep in sync with renderGrid() above — same three-way, same reason */
      brand: (t.caps && t.caps.supportsTitle === false) ? ''
           : uNoBrand ? 'none'
           : (uBrand || t.defaults.brand),
      color: st.color || t.defaults.color,
      serial: previewSerial(),
      run_total: '',
      qr: (t.caps && t.caps.supportsQR === false) ? '' : qrField(),
      motif: st.qrMode === 'none' ? st.motif : '',
      image: (st.artwork && t.caps && t.caps.requiresArtwork)
        ? (st.artwork.thumb || st.artwork.dataUrl) : (t.image || ''),
      bg: tileBg(t),
      logo: (st.logo && t.caps && (t.caps.requiresLogo || t.caps.category === 'logo'))
        ? (st.logo.thumb || st.logo.dataUrl) : '',
      logo_scale: st.logoScale,
      orientation: st.orientation,
      style: st.sealStyle
    }, Q_THUMB);
  });
  var more = document.createElement('button');
  more.type = 'button';
  more.className = 'pvth more';
  more.innerHTML = '<b>All<br>designs</b>';
  more.setAttribute('aria-label', 'Browse all designs');
  more.onclick = openGallery;
  host.appendChild(more);
}

/* One opener for the strip's All tile and the inspiration card. The re-render
   on open is load-bearing: tiles drawn while the details was closed have
   display:none geometry, and getBBox() there is 0x0 — which silently drops
   injected logos. Drawing again in the open state gives them real geometry. */
function openGallery() {
  var ag = document.getElementById('allgal');
  if (ag && !ag.open) { ag.open = true; renderCats(); renderGrid(); }
  smoothTo(document.getElementById('designarea') || ag, 'start');
}

/* Re-render the gallery only when a detail that shows on the tiles actually
   changed — a debounce alone would still rebuild 20 SVGs on a focus blip. */
var _gridT = null, _gridSig = '';
/* the QR + numbering choices show ON the tiles, so they belong in both
   render signatures or the gallery keeps painting the old seal */
function optSig() {
  return [qrField(), previewSerial()].join('~');
}
function gridSig() {
  // artwork is in the signature because the tiles render it now — without it
  // the gallery keeps showing the stock sample until some other detail changes
  // noBrand() too: st.brand does not change when the name is switched off, so
  // without it the gallery keeps showing seals with a name on them
  return [st.brand.trim(), noBrand() ? 'nobrand' : '',
          st.color, st.logo ? st.logo.name + st.logo.kb : '',
          st.artwork ? st.artwork.name + st.artwork.kb : '',
          st.bg ? st.bg.name + st.bg.kb : '',
          st.orientation, st.sealStyle, st.cat, optSig()].join('|');
}
function refreshGridSoon() {
  clearTimeout(_gridT);
  _gridT = setTimeout(function () {
    if (gridSig() !== _gridSig) renderGrid();
  }, 400);
}

/* ——— "no store name, my logo says it" — THE ONE TEST ————————————————————
   The single predicate behind the whole feature. Every consumer — the
   preview, the gallery tiles, the blockers, the progress rail and the cart
   line — asks THIS, never st.brandMode, for one reason:

     a seal may only drop the store name if it HAS a logo.

   With neither, nothing on the foil says whose seal it is. So the flag is
   re-tested against st.logo on every read rather than being cleaned up at
   each of the places a logo can disappear (the Remove button, a failed
   rehydrate from a cart line, a future path nobody has written yet). A stale
   'logo' flag with no logo therefore cannot print a nameless seal — it just
   falls back to the store name, which is what every order did before today.

   The renderer's half of the contract is the sentinel `brand: 'none'` — the
   twin of f.serial === 'none' and f.qr === 'none' that ss-seal.js already
   speaks. One key, one decision, three sentinels that read alike. */
function noBrand() { return st.brandMode === 'logo' && !!st.logo; }

/* ——— the design gate: details before designs, VialArt-style ———
   The gallery is visible (it still sells) but locked until the customer has
   given us SOMETHING to render — a brand name or a logo. Tapping the locked
   area routes them to step 1 instead of silently ignoring the tap. */
function gateOk() { return !!(st.brand.trim() || st.logo); }
/* Route any interaction with the locked gallery to step 1. Shared by the
   overlay click AND the keyboard path (buttons stay real buttons, so
   pointer-events:none alone is not a lock — the click handlers check too). */
function gateNudge() {
  SS_UI.toast('Add your brand name first — every design previews with it');
  document.getElementById('step1').scrollIntoView({
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    block: 'start' });
  var b = document.getElementById('f-brand');
  if (b) setTimeout(function () { b.focus(); }, 450);
}
function updateGate() {
  /* FIRST, and deliberately ahead of the early return below: this function is
     called on every logo add and every logo remove, which is exactly when the
     "Logo only" row has to appear or disappear. The early return fires on any
     page where #designarea is absent, and the store-name control is not that
     element's business. */
  try { paintBrandMode(); } catch (_) {}
  /* The gallery is NEVER locked (owner 2026-08-02: "let me pick designs
     without typing a store name") — browsing and picking are free, previews
     carry each design's demo brand until the customer types theirs, and the
     caption below the preview is the honesty line. Add to cart still
     requires the store name via valid(); only the browse gate died. */
  var area = document.getElementById('designarea');
  var g = document.getElementById('ggate');
  if (!area || !g) return;
  /* pvsub removed with the explanatory copy */
  area.classList.remove('gated');
  g.hidden = true;
  ['cats', 'grid'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.inert = false;
  });
}

/* ------- attract slideshow + swipe browsing (owner 2026-08-02) -------
   Until the customer PICKS a design, the big preview cycles the catalog on
   2s slides - with their name/colour the moment they type them. A pick
   (tile, thumb, swipe, prefill) ends it permanently. Swiping the preview
   left/right steps through designs and IS a pick. Reduced-motion users get
   no auto-cycle; a hidden tab pauses. Slides mount ONLY #pv - grid and
   thumbs never re-render on a tick. */
var _slide = { on: true, i: 0, t: null, block: false, dead: false, vis: true, io: null };
/* ONLY the studio background designs (owner 2026-08-17: "showing the
   backgrounds that I uploaded not the sports ones") — .bg is what a published
   Seal Studio design carries, bare foil has none, and SS_SELLABLE already
   excludes everything retired, so a dead design cannot rotate back in. */
function slideList() {
  return (window.SS_SELLABLE || []).filter(function (t) { return !!t.bg; });
}
/* THE PANE HUGS EVERY FRAME AND GLIDES BETWEEN HEIGHTS. The old ratchet
   (hold the tallest frame seen) fixed page-shove but left a banner frame
   floating in a portrait-sized void — owner 2026-08-18: "made this big ahh
   gap when auto switched". Now the box animates height between frames, and
   the page-shove case is closed a different way: the slideshow pauses
   whenever the pane is scrolled out of view (see startSlideshow). */
function glideBox(box, h0) {
  box.style.transition = 'none';
  box.style.height = '';
  var h1 = box.offsetHeight;
  if (Math.abs(h1 - h0) < 2) { box.style.transition = ''; return; }
  if (box._gt) clearTimeout(box._gt);
  box.style.height = h0 + 'px';
  void box.offsetHeight;
  box.style.transition = 'height .38s ease';
  box.style.height = h1 + 'px';
  box._gt = setTimeout(function () {
    box.style.transition = '';
    box.style.height = '';
    box._gt = null;
  }, 430);
}
/* Crossfade + glide for a CUSTOMER action (owner 2026-08-18: "when I select
   different shape the main proof doesn't switch smoothly") — the same fade
   the attract loop uses, wrapped around any preview-rebuilding chain. */
function pvFade(run) {
  var pv = document.getElementById('pv');
  var box = document.querySelector('.pvbox');
  var stg = document.querySelector('.pvstage');
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!pv || rm) { run(); return; }
  var pvm = pv.closest('.pvmeas') || pv;
  var h0 = box ? box.offsetHeight : 0;
  pvm.style.opacity = '0';
  setTimeout(function () {           /* full fade-out before the swap */
    if (stg) stg.classList.add('noTween');
    try { run(); } catch (_) {}
    pvm.style.opacity = '1';
    if (box) { try { glideBox(box, h0); } catch (_) {} }
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      if (stg) stg.classList.remove('noTween');
    }); });
  }, 240);
}
/* WCAG 2.2.2 Pause, Stop, Hide — the attract loop is moving content that
   starts automatically and runs well past five seconds, so it needs an
   explicit control. Built in JS (not the liquid) so a render-cached page
   picks it up, and removed the moment the loop dies. */
function pvPauseBtn(show) {
  var box = document.querySelector('.pvbox');
  if (!box) return;
  var b = document.getElementById('pv-pause');
  if (!show) { if (b) b.remove(); return; }
  if (b) return;
  b = document.createElement('button');
  b.type = 'button';
  b.id = 'pv-pause';
  b.className = 'pvpause';
  b.setAttribute('aria-label', 'Stop the preview from changing automatically');
  b.innerHTML = '<span aria-hidden="true">⏸</span> Pause';
  b.onclick = function () { stopSlideshow(); };
  box.appendChild(b);
}
document.addEventListener('focusin', function (e) {
  var t = e.target;
  if (!t || !t.closest || _bootSeat) return;
  if (t.closest('.sv-builder') && !t.closest('#pv-pause')) {
    try { stopSlideshow(); } catch (_) {}
  }
});
function stopSlideshow() {
  _slide.on = false;
  try { pvPauseBtn(false); } catch (_) {}
  var _box = document.querySelector('.pvbox');
  if (_box) { _box.style.height = ''; _box.style.transition = ''; }
  var _pv = document.getElementById('pv');
  if (_pv) {
    _pv.style.opacity = '1';
    var _pvm2 = _pv.closest('.pvmeas');
    if (_pvm2) _pvm2.style.opacity = '1';
  }
  /* permanent by design — "a pick ends it for good" was always the contract,
     but boot's startSlideshow() call used to be able to resurrect the loop
     after an explicit ?design= pick. Dead means dead until the next load. */
  _slide.dead = true;
  if (_slide.t) { clearInterval(_slide.t); _slide.t = null; }
}
function startSlideshow() {
  /* BACK ON (owner 2026-08-17: "instead of doing the bare foil, we need to
     start showing the backgrounds that I uploaded … it will auto rotate").
     Two differences from the loop the 2026-08-14 disable killed:
       · it rotates ONLY the studio backgrounds (see slideList) — never bare
         foil, never anything retired;
       · st.tpl FOLLOWS the paint. The old loop painted #pv while st.tpl
         stayed Clean Foil, which is how a preview full of artwork became a
         Clean Foil order. The shown design IS the selected design on every
         tick, so the preview can never disagree with the cart. */
  if (_slide.block || _slide.dead) return;
  _slide.on = true;
  /* NOTHING changes while the pane is off-screen — a reader further down
     the page can never be shoved by the attract loop (this replaces the
     tallest-frame ratchet, which traded the shove for a giant empty box). */
  if (!_slide.io && 'IntersectionObserver' in window) {
    var _pvp = document.getElementById('pvpane');
    if (_pvp) {
      _slide.io = new IntersectionObserver(function (es) {
        _slide.vis = es[0].isIntersecting;
      }, { threshold: 0.05 });
      _slide.io.observe(_pvp);
    }
  }
  if (_slide.t) return;
  var list = slideList();
  /* land on a real background from the first frame; bare foil stays one tap
     away as the carousel's first tile */
  if (list.length && st.tpl && !st.tpl.bg) {
    _slide.i = Math.floor(Math.random() * list.length);
    _bootSeat = true;
    try { selectTemplate(list[_slide.i].key); } catch (_) {}
    _bootSeat = false;
  }
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (list.length < 2) return;
  try { pvPauseBtn(true); } catch (_) {}
  _slide.t = setInterval(function () {
    if (!_slide.on) { stopSlideshow(); return; }
    if (document.hidden || _slide.vis === false) return;
    var l = slideList();
    if (l.length < 2) return;
    /* RANDOM shape + background every slide (owner 2026-08-17: "rotating
       through random shapes and backgrounds … it's the hook of the whole
       website") — never the same background twice in a row. The shape only
       moves while nobody's focus is in a shape control, and the strip repaint
       is skipped in that case too, so keyboard focus is never destroyed. */
    var ni = _slide.i;
    while (ni === _slide.i) ni = Math.floor(Math.random() * l.length);
    _slide.i = ni;
    var d = l[ni];
    var q = QUICK_SHAPES[Math.floor(Math.random() * QUICK_SHAPES.length)];
    var pv = document.getElementById('pv');
    if (!pv) return;
    var pvm = pv.closest('.pvmeas') || pv;
    var shapeFree = !(document.activeElement && document.activeElement.closest &&
                      document.activeElement.closest('#shapequick, #orient'));
    st.tpl = d;                       /* what you see is what you'd buy */
    if (shapeFree && q) { st.orientation = q[0]; st.sealStyle = q[1]; }
    var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var _gb = document.querySelector('.pvbox');
    var _gh = _gb ? _gb.offsetHeight : 0;
    pvm.style.opacity = rm ? '1' : '0';
    setTimeout(function () {
      if (!_slide.on) { pvm.style.opacity = '1'; return; }
      /* the REAL preview renderer, not a bare mount: it runs
         applyOrientClass() so the stage itself morphs with the shape, and
         applyZoom() widens it 2.1x for landscape. A bare SS.mount drew a
         landscape band inside a portrait stage (owner bug report 2026-08-17,
         "shapes not morphing"). */
      var stg = document.querySelector('.pvstage');
      if (stg) stg.classList.add('noTween');   /* mount at final size */
      try { renderPreview(); } catch (_) {}
      if (window.applyZoom) { try { window.applyZoom(); } catch (_) {} }
      pvm.style.opacity = '1';
      if (!rm && _gb) { try { glideBox(_gb, _gh); } catch (_) {} }
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        if (stg) stg.classList.remove('noTween');
      }); });
      try { bgcarPaint(); } catch (_) {}
      try { svquickPaint(); } catch (_) {}
      if (shapeFree) {
        try { setDims(); } catch (_) {}
        try { renderShapeQuick(); } catch (_) {}
        /* the full picker tracks WITHOUT renderOrient — its rebuild grabs
           focus, which a background loop may never do */
        var ot = document.querySelectorAll('#orient .otile');
        for (var oi2 = 0; oi2 < SHAPES.length && oi2 < ot.length; oi2++) {
          var onb = st.orientation === SHAPES[oi2][0] && st.sealStyle === SHAPES[oi2][1];
          ot[oi2].setAttribute('aria-pressed', onb ? 'true' : 'false');
        }
      }
    }, rm ? 0 : 240);
  }, 2600);
}
(function () {
  var pv = document.getElementById('pv');
  if (!pv) return;
  var sw = null, bgDrag = null;
  pv.addEventListener('pointerdown', function (e) {
    /* with the customer's own design uploaded, dragging the preview MOVES
       the image (owner: "move it to fit"); swipe-to-browse yields */
    if (st.tpl && st.tpl.caps && st.tpl.caps.requiresBackground && st.bg && _bgImg.ok) {
      bgDrag = { px: e.clientX, py: e.clientY, x: +_bgFit.x || 0, y: +_bgFit.y || 0 };
      try { pv.setPointerCapture(e.pointerId); } catch (_) { }
      e.preventDefault();
      return;
    }
    sw = { x: e.clientX, y: e.clientY };
  });
  pv.addEventListener('pointermove', function (e) {
    if (!bgDrag) return;
    var img = _bgImg.img;
    var r = bgCropRect(img.naturalWidth, img.naturalHeight,
                       { s: _bgFit.s, x: bgDrag.x, y: bgDrag.y }, bgAspect());
    var k = r.w / pv.clientWidth;    /* source px per screen px */
    _bgFit.x = Math.min(.5, Math.max(-.5, bgDrag.x - (e.clientX - bgDrag.px) * k / img.naturalWidth));
    _bgFit.y = Math.min(.5, Math.max(-.5, bgDrag.y - (e.clientY - bgDrag.py) * k / img.naturalHeight));
    bgPreviewSoon();
  });
  pv.addEventListener('pointercancel', function () { bgDrag = null; });
  pv.addEventListener('pointerup', function (e) {
    if (bgDrag) { bgDrag = null; return; }
    if (!sw) return;
    var dx = e.clientX - sw.x, dy = e.clientY - sw.y;
    sw = null;
    /* a swipe is decisively horizontal; anything else is a scroll or a tap */
    if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.6) return;
    var list = slideList();
    if (!list.length) return;
    var i = list.indexOf(st.tpl);
    var next = list[((i < 0 ? 0 : i) + (dx < 0 ? 1 : -1) + list.length) % list.length];
    selectTemplate(next.key);   /* stops the slideshow via the pick hook */
  });
  /* steps past the design phase should not keep the attract loop running */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-go]')) stopSlideshow();
  });
})();

/* Set only while boot() seats the landing default. A CUSTOMER'S pick ends the
   attract loop for good; the default one nobody chose must not, or the preview
   freezes on Clean Foil and the range never gets demoed (owner 2026-08-11:
   "templates should carousel before they select … keep clean foil on all for
   the demo"). */
var _bootSeat = false;
function selectTemplate(key, preserve) {
  var t = SS.tpl(key);
  if (!t) return;
  if (!_bootSeat) stopSlideshow();   /* a pick ends the attract loop for good */
  var switched = st.tpl && st.tpl.key !== t.key;
  st.tpl = t;
  /* A design switch invalidates the artwork (unless `preserve` — the reorder
     prefill sets it deliberately): each design's window has its own shape/DPI
     target, so a file validated ±10% against a medallion is NOT known-good in
     a full-bleed. The accent is NOT reset any more — step 1's swatches are the
     global holo-safe palette (never a design-specific hex), so a chosen colour
     carries across designs; '' means "each design's own default". */
  if (switched && !preserve) {
    if (st.artwork) { st.artwork = null; SS_UI.toast('Design changed — please re-upload your artwork'); }
  }
  if (!t.caps.requiresArtwork) st.artwork = null;
  /* the background survives ONLY on a background design — its target is the
     full die either way, but no other design renders it */
  /* st.bg SURVIVES a design switch (owner 2026-08-05) — fields() withholds
     it from designs that take no background, so browsing the gallery and
     coming back keeps the customer's upload exactly where it was */
  /* st.logo and st.qr are step-1 details now — they survive design browsing.
     fields() already withholds them from designs that don't support them. */
  var gh = document.getElementById('grid');
  if (!gh.firstChild) renderGrid();            // first paint
  else gh.querySelectorAll('.dcard').forEach(function (c) {
    c.setAttribute('aria-selected', c.dataset.key === key ? 'true' : 'false');
  });
  renderExtras();
  /* the QR row's copy depends on the design's caps.supportsQR */
  renderOptions();
  sync();
  renderThumbs();
  try { bgcarPaint(); } catch (_) {}
}

/* ——————————————— step 1: the customer's own details ——————————————— */
/* The placeholder used to name ONE platform (instagram.com/yourshop) and the
   owner watched people read it as "Instagram links only". It now cycles, so
   within a few seconds the field has told the customer that eBay, Whatnot,
   Facebook, a plain website and an email are all fair game. */
var QR_PLACEHOLDERS = [
  'instagram.com/yourshop',
  'ebay.com/usr/yourstore',
  'whatnot.com/user/yourshop',
  'facebook.com/yourpage',
  'yourwebsite.com',
  'you@yourshop.com'
];
var _qrPhIv = null, _qrPhI = 0;
function startQrPlaceholder() {
  /* WCAG 2.2.2 — this rotated six example destinations through the
     placeholder on a 2.2s interval with no stop control. Static now; the
     hint under the field already lists what a code can point at. */
  if (_qrPhIv) { clearInterval(_qrPhIv); _qrPhIv = null; }
  var el = document.getElementById('f-qr');
  if (el) el.placeholder = QR_PLACEHOLDERS[0];
}

function field(id, label, inner, hint, cnt) {
  return '<div class="field" id="fw-' + id + '">' +
    '<label for="' + id + '">' + label + (cnt || '') + '</label>' + inner +
    (hint ? '<div class="hint" id="' + id + '-hint">' + hint + '</div>' : '') +
    '<div class="err" id="' + id + '-err" role="alert" hidden></div></div>';
}

function updateLogoTile() {
  var t = document.getElementById('logo-tile');
  if (!t) return;
  if (st.logo) {
    stopSlideshow();   /* a logo upload is customizing — end the attract loop */
    t.classList.add('has');
    t.innerHTML = '<img src="' + (st.logo.thumb || st.logo.dataUrl) + '" alt="Your logo">';
  } else {
    t.classList.remove('has');
    t.innerHTML =
      '<span class="lt-ic" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
        '<path d="M12 16V5M7.5 9 12 4.5 16.5 9" fill="none" stroke="currentColor" ' +
        'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M5 19h14" fill="none" stroke="currentColor" stroke-width="2.2" ' +
        'stroke-linecap="round"/></svg></span>' +
      '<span class="lt-tx"><b>Upload your logo</b>' +
      '<span>PNG or JPG · we place it front &amp; centre</span></span>';
  }
}

/* ——— repaint the store-name control IN PLACE ————————————————————————————
   The twin of updateLogoTile(): everything the "Print my name / Logo only"
   choice changes about the form is written here, and nothing here rebuilds
   #controls. That matters in both directions —

     · a logo landing has to REVEAL the row, and a logo being removed has to
       hide it again and put the name back. Both of those arrive through
       updateGate(), which is called on every logo add and remove and which
       calls this. renderDetails() there would destroy the field the customer
       may be typing in and restart the placeholder demo;
     · tapping a chip must not move their cursor or lose their text.

   ⚠ st.brandMode is NOT cleared when the logo goes away, and that is
   deliberate. noBrand() already refuses to honour it without a logo, so a
   stale flag can print nothing and cart nothing; and the row is hidden in
   that state, so it can show nothing either. Clearing it here would instead
   break the two paths where the logo arrives AFTER the flag does — the cart
   edit rehydrates ed.logo_url asynchronously, and a reorder asks the
   customer to re-upload — by erasing the choice in the gap and putting the
   name back on a seal that was bought without one. */
function paintBrandMode() {
  var row = document.getElementById('brandmode');
  if (!row) return;                       // form not painted yet
  var sub = document.getElementById('brandmode-sub');
  var inp = document.getElementById('f-brand');
  var off = noBrand();
  row.hidden = !st.logo;
  if (sub) {
    sub.hidden = !st.logo;
    /* — not a literal em-dash: the same copy is built as a string in
       renderDetails() too, and the two must be character-identical or the
       sub-line flickers between two spellings of the same sentence. */
    sub.textContent = off
      ? 'No store name is printed — your logo carries the seal.'
      : 'Your name prints above the serial.';
  }
  row.querySelectorAll('.qm').forEach(function (b) {
    var on = (b.getAttribute('data-bm') === 'logo') === off;
    b.classList.toggle('on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  /* Visibly inactive, not silently ignored. Their text stays in st.brand and
     in the box, so switching back restores it to the character. */
  if (inp) {
    inp.disabled = off;
    var fw = document.getElementById('fw-f-brand');
    if (fw) fw.classList.toggle('brandoff', off);
  }
}

/* Details come FIRST and are template-agnostic — that is what lets the whole
   gallery preview with them. Anything a specific design additionally needs
   (artwork upload, a required logo) renders in step 2 via renderExtras(). */
function renderDetails() {
  var host = document.getElementById('controls'), h = '';
  /* Name + logo share the TOP row (owner 2026-08-04: "logo upload needs to
     go on top next to name") — the compact tile IS the upload button; the
     full logo card (thumb, replace, size slider) renders below once a logo
     exists. No required-marker: the flow reaches "Ready to order" without a
     logo (the default design needs none). */
  /* ——— THE NAME CAN BE TURNED OFF (owner 2026-09-16: "just remove the
     text") ————————————————————————————————————————————————————————————
     Two chips in the Numbering row's furniture (.qrmode/.qm — the same
     two-option control this form already uses twice), rendered INSIDE the
     store-name field because it is a question about that field and nothing
     else.

     It only appears once a logo exists. Not because it is fiddly to show
     otherwise, but because "print no name" with no logo is not a seal we
     will make: there would be nothing on the foil that says whose it is.
     Rendered `hidden` and un-hidden in place by paintBrandMode() rather than
     rebuilt, so a logo landing mid-form cannot pull #controls out from under
     a field the customer is typing in.

     The input is left in the DOM and DISABLED when the name is off — a field
     that silently stops mattering is the version of this that generates
     support mail. Their typing survives: st.brand is untouched, so turning
     the name back on restores it exactly. */
  var _nb = noBrand();
  h += field('f-brand', 'Store name',
      '<input type="text" id="f-brand" maxlength="' + BRAND_MAX + '" placeholder="YOUR BRAND" ' +
        'autocomplete="organization" spellcheck="false" aria-describedby="f-brand-hint"' +
        (_nb ? ' disabled' : '') + '>' +
      '<div class="qrmode brandmode" id="brandmode" role="group" ' +
        'aria-label="What identifies your seal"' + (st.logo ? '' : ' hidden') + '>' +
        '<button type="button" class="qm' + (_nb ? '' : ' on') +
          '" data-bm="text" aria-pressed="' + !_nb + '">Print my name</button>' +
        '<button type="button" class="qm' + (_nb ? ' on' : '') +
          '" data-bm="logo" aria-pressed="' + _nb + '">Logo only</button></div>' +
      '<div class="qrsub" id="brandmode-sub"' + (st.logo ? '' : ' hidden') + '>' +
        (_nb ? 'No store name is printed — your logo carries the seal.'
             : 'Your name prints above the serial.') + '</div>',
      '',
      '<span class="cnt" id="brand-cnt"></span>') +
    /* logo sits UNDER the name, full width (owner 2026-08-05) — the tile is
       still the upload button, it just gets its own row now */
    '<div class="field logofld"><label>Logo <span class="dim" style="font-weight:400">(optional)</span></label>' +
    '<button type="button" class="logotile" id="logo-tile" ' +
    'aria-label="Upload your company or store logo (optional)"></button></div>' +
    '<div class="field" id="logo-detail"><div id="logo-slot"></div>' +
    '<div class="err" id="logo-err" role="alert" hidden></div></div>';
  /* QR LINK, DIRECTLY UNDER THE LOGO (owner 2026-08-14: "under logo put qr
     code url"). It used to render inside the options card further down, next
     to the mode picker. There is still exactly ONE #f-qr on the page — the
     options card no longer draws its own — because two inputs bound to st.qr
     is how they drift apart.

     Hidden when the design has no QR slot at all, or when the customer has
     chosen No QR: an address box for a code that is not being printed is a
     question about a feature they already declined. setQrMode() re-renders
     this block so it appears the moment they change their mind. */
  var _qc = caps();
  if (_qc.supportsQR !== false) {
    /* ONE unified QR block (owner 2026-08-17): glyph + label, the mode chips,
       and the input — which yields to a single quiet line when No QR is
       chosen. setQrMode() re-renders this whole block via renderDetails, so
       the chips always tell the truth. */
    var _qrIco = '<span class="qrico" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="14" height="14">' +
      '<g fill="none" stroke="currentColor" stroke-width="1.7">' +
      '<rect x="3.3" y="3.3" width="6.4" height="6.4"/>' +
      '<rect x="14.3" y="3.3" width="6.4" height="6.4"/>' +
      '<rect x="3.3" y="14.3" width="6.4" height="6.4"/></g>' +
      '<g fill="currentColor"><rect x="5.5" y="5.5" width="2" height="2"/>' +
      '<rect x="16.5" y="5.5" width="2" height="2"/>' +
      '<rect x="5.5" y="16.5" width="2" height="2"/>' +
      '<rect x="13.5" y="13.5" width="2.4" height="2.4"/>' +
      '<rect x="18.3" y="13.5" width="2.4" height="2.4"/>' +
      '<rect x="16" y="16" width="2.4" height="2.4"/>' +
      '<rect x="13.5" y="18.6" width="2.4" height="2.4"/>' +
      '<rect x="18.3" y="18.6" width="2.4" height="2.4"/></g></svg></span>';
    var _noQr = st.qrMode === 'none';
    var _biz2 = st.qrMode === 'business';
    /* POS ITEM CODE (2026-09-15). A fourth chip, mutually exclusive with the
       other three because a seal has ONE code slot: a shop that wants both a
       listing link and a till code cannot have both on one seal.
       Like 'No QR code' it hides the link input -- there is no destination to
       type -- but unlike it the seal still PRINTS a code, so the sub-line has
       to say what that code is or the chip reads as a second "no code". */
    var _sku2 = st.qrMode === 'sku';
    /* A LINK PER SEAL (2026-10-20): a fifth chip, offered only while its fee
       product is live. The address field yields to the sheet panel. */
    var _list2 = st.qrMode === 'list';
    var _listOn = qrListOffered();
    h += '<div class="field" id="qrfld"><label for="f-qr">' + _qrIco +
      (_biz2 ? 'Business QR link' : 'QR code') + '</label>' +
      '<div class="qrmode" role="group" aria-label="QR code choice">' +
      '<button type="button" class="qm' + (!_noQr && !_biz2 && !_sku2 && !_list2 ? ' on' : '') +
      '" data-qm="own" aria-pressed="' + (!_noQr && !_biz2 && !_sku2 && !_list2) + '">My link</button>' +
      (BIZ.ok ? '<button type="button" class="qm' + (_biz2 ? ' on' : '') +
        '" data-qm="business" aria-pressed="' + _biz2 + '">Business</button>' : '') +
      '<button type="button" class="qm' + (_sku2 ? ' on' : '') +
      '" data-qm="sku" aria-pressed="' + _sku2 + '">Item code</button>' +
      (_listOn ? '<button type="button" class="qm' + (_list2 ? ' on' : '') +
        '" data-qm="list" aria-pressed="' + _list2 + '">A link per seal</button>' : '') +
      '<button type="button" class="qm' + (_noQr ? ' on' : '') +
      '" data-qm="none" aria-pressed="' + _noQr + '">No QR code</button></div>' +
      (_list2
        ? '<div class="qrsub">Every seal gets its own serial and its own QR link — a website, ' +
          'a listing, a grading company’s certificate page — from a sheet you fill in. ' +
          '<b>+$0.10 a seal.</b></div><div id="qrlist-host"></div>'
      : _sku2
        ? '<div class="qrsub">The code is the seal\u2019s own serial \u2014 scan it ' +
          'at your till and that card rings up.</div>' +
          '<p class="opthint" id="opt-qr-hint"></p>' +
          /* Square is named on this page by the hint above, so the disclaimer
             belongs on this page. Once, small, and only in this mode. */
          '<p class="qrsub tmnote">Square and Square Point of Sale are ' +
          'trademarks of Block, Inc. We are not affiliated with, endorsed by, ' +
          'or sponsored by Block, Inc.</p>'
      : _noQr
        ? '<div class="qrsub">These seals print without a code.</div>'
        : '<div class="qrsub">Scans to your store or social media</div>' +
          '<input type="url" id="f-qr" class="optinp" maxlength="60" inputmode="url" ' +
          'spellcheck="false" autocomplete="url" placeholder="' +
          QR_PLACEHOLDERS[_qrPhI % QR_PLACEHOLDERS.length] + '" ' +
          'aria-label="' + (_biz2
            ? 'The web address your Business QR opens first'
            : 'The web address your QR code opens') + '" value="' + SS.esc(st.qr) + '">' +
          '<p class="opthint" id="opt-qr-hint"></p>') +
      '</div>';
  }
  /* NUMBERING, DIRECTLY UNDER THE QR BLOCK (owner 2026-08-17: plain
     stickers). The scheme picker is gone — serials are random for every
     new order — but "no numbers at all" is a PRODUCT, not a scheme:
     identical plain stickers, nothing minted, nothing printed. Two chips in
     the QR row's furniture (the .qrmode styles); .sermode is the marker the
     delegated handlers key on, so these taps can never fall through to
     setQrMode. st.serialType carries the whole choice — 'none' here,
     'rand' otherwise — and ships on the cart line as _serial_type,
     which is the key every surface downstream gates on. */
  var _noSer = st.serialType === 'none';
  h += st.qrMode === 'list'
    ? '<div class="field" id="serfld"><label>Numbering</label>' +
      '<div class="qrsub">From your sheet \u2014 each seal prints the serial you listed beside its link.</div></div>'
    : '<div class="field" id="serfld"><label>Numbering</label>' +
    '<div class="qrmode sermode" role="group" aria-label="Numbering choice">' +
    '<button type="button" class="qm' + (!_noSer ? ' on' : '') +
    '" data-sm="rand" aria-pressed="' + !_noSer + '">Unique serials</button>' +
    '<button type="button" class="qm' + (_noSer ? ' on' : '') +
    '" data-sm="none" aria-pressed="' + _noSer +
    '">No numbers — plain</button></div>' +
    (_noSer
      ? '<div class="qrsub">Identical seals — no serial numbers printed.</div>'
      : '<div class="qrsub">Every seal prints its own number.</div>') +
    '</div>';
  /* No website field (owner 2026-08-19, an hour after adding one): the
     printed wordmark now FOLLOWS THE QR automatically \u2014 website -> domain,
     eBay/Whatnot -> store link, social -> @username, nothing ->
     serialseal.com. Derivation lives in ss-seal.js so every surface
     (builder, cart, My Seals, print) agrees from the same f.qr. */
  /* Form ENDS at the logo (owner 2026-08-02, final word after the mock went
     back and forth on accent): name, logo, done. st.color still resolves —
     reorders restore a past accent, blank means each design's own ink. */
  /* No accent picker (owner 2026-08-02): every design ships its own curated
     deep ink. st.color still exists — the reorder path restores a past order's
     accent through it, and blank resolves to the design default everywhere. */
/* No grade field (owner 2026-08-02, added then cut the next day). The full
     chain — st.grade, the 'Grade' cart property, the renderer's corner badge,
     Label Farm, the print sidecar — is still wired and simply never fed, so
     reinstating grades is one UI block here, not a re-thread. */
  /* No QR field: the 'What a scan shows' card beside the preview carries
     this now — same handler, one less block between the name and the CTA. */
  host.innerHTML = h;
  /* the sheet panel lives inside the QR block it just rendered */
  window._svqlPanel = null;
  if (st.qrMode === 'list' && window.SVQL) {
    var _qh = document.getElementById('qrlist-host');
    if (_qh) { try { window._svqlPanel = SVQL.panel(_qh, qrListApi()); } catch (_) {} }
  }
  document.getElementById('logo-tile').onclick = function () { pickFile('logo', 'logo'); };
  updateLogoTile();
  /* the QR address field is part of this block now, so it is wired here — the
     same handler renderOptions used to attach */
  var _qi = document.getElementById('f-qr');
  if (_qi) _qi.oninput = function () { st.qr = this.value; updateOptions(); sync(); };
  startQrPlaceholder();
  startBrandDemo();
  updateOptions();          // paint the hint under it on first render
  wireDetails();
  /* after wireDetails(), which seeds #f-brand from st.brand: this settles the
     disabled state and the chips on top of that value */
  paintBrandMode();
}

/* ——————————————— step 2 extras: what the CHOSEN design still needs ——————— */
function renderExtras() {
  var c = caps(), host = document.getElementById('tplextras'), h = '';
  if (!host) return;
  if (!st.tpl || (!c.requiresArtwork && !c.requiresBackground && !(c.requiresLogo && !st.logo))) {
    host.innerHTML = '';
    return;
  }
  if (c.requiresBackground) {
    /* the background uploader mirrors the artwork flow below — same advisor,
       same warning+ack model — but its target is the WHOLE DIE (the template
       is window:'full', so SS_UPLOAD.target quotes L.W × L.H) */
    var TB = SS_UPLOAD.target(st.tpl, st.orientation);
    h += '<div class="field xtra"><label id="bg-lbl">Your own design on the seal</label>' +
      '<div class="spec" id="bg-spec"><b>For the sharpest print</b><dl>' +
      '<dt>Printed size</dt><dd>' + TB.wMm.toFixed(1) + ' × ' + TB.hMm.toFixed(1) + ' mm — the whole seal</dd>' +
      '<dt>Shape</dt><dd>' + SS_UPLOAD.ratioStr(TB.ratio) + ' (others are cropped to fill)</dd>' +
      '<dt>Best size</dt><dd>' + TB.bestPx[0] + ' × ' + TB.bestPx[1] + ' px</dd>' +
      '<dt>Format</dt><dd>Any image your phone or computer can open</dd>' +
      '</dl></div>' +
      '<div id="bg-slot"></div>' +
      '<div class="hint" id="bg-hint">Your image fills the seal edge to edge — ' +
      'drag the big preview to move it, and use the zoom slider to fit. ' +
      'Your name, serial and QR print on dark panels over it, so busy, ' +
      'colourful images work great. There is no white ink: white areas print ' +
      'as the bare stock \u2014 holographic foil, or plain white on Gloss White.</div>' +
      '<div class="rep" id="bg-rep" role="status"></div><div class="acks" id="bg-acks"></div>' +
      '<div class="err" id="bg-err" role="alert" hidden></div>' +
      /* the standing route to the other layer. The kind picker only asks
         once, at the start; this is here every time they look at the card. */
      (st.logo ? '' :
        '<div class="lplace-add"><b>Want your logo on it too?</b>' +
        '<span>We layer it over your picture and back it so it stays ' +
        'readable on the foil.</span>' +
        '<button class="btn2" type="button" id="bg-add-logo">Add my logo</button>' +
        '</div>') +
      '</div>';
  }
  if (c.requiresArtwork) {
    var T = SS_UPLOAD.target(st.tpl, st.orientation);
    h += '<div class="field xtra"><label id="art-lbl">' + SS.esc(st.tpl.name) +
      ' needs your artwork</label>' +
      /* "Best results", not "Required specs" \u2014 nothing here blocks an order
         any more, so stating it as a requirement scared people off files that
         print perfectly well. */
      '<div class="spec" id="art-spec"><b>For the sharpest print</b><dl>' +
      '<dt>Printed size</dt><dd>' + T.wMm.toFixed(1) + ' \u00d7 ' + T.hMm.toFixed(1) + ' mm</dd>' +
      '<dt>Shape</dt><dd>' + SS_UPLOAD.ratioStr(T.ratio) + ' (others are cropped to fill)</dd>' +
      '<dt>Best size</dt><dd>' + T.bestPx[0] + ' \u00d7 ' + T.bestPx[1] + ' px</dd>' +
      '<dt>Format</dt><dd>Any image your phone or computer can open</dd>' +
      '</dl></div>' +
      '<div id="art-slot"></div>' +
      '<div class="hint" id="art-hint">Artwork is cropped to fill the ' +
      (st.tpl.window === 'circle' ? 'circular medallion' :
       st.tpl.window === 'full' ? 'whole seal' : 'framed window') +
      ' of this design, so keep anything important away from the edges. ' +
      'There is no white ink \u2014 white and transparent areas print as the bare stock: live ' +
      'holographic foil (or plain white on Gloss White). Darker artwork makes the foil pop.</div>' +
      '<div class="rep" id="art-rep" role="status"></div><div class="acks" id="art-acks"></div>' +
      '<div class="err" id="art-err" role="alert" hidden></div></div>';
  }
  /* The "features your logo / Add my logo" panel is SUPPRESSED when the
     dedicated logo row exists (owner 2026-08-12: the row now sits directly
     under the three background tiles). Two buttons for one action, one of them
     pointing at a step that is no longer below it, is the opposite of easier
     to use. The row itself reports whether a logo is attached. */
  if (c.requiresLogo && !st.logo && !document.getElementById('svq-logo')) {
    h += '<div class="field xtra"><label>' + SS.esc(st.tpl.name) + ' features your logo</label>' +
      '<div class="hint">This design puts your logo on the foil — add it under ' +
      '<b>step 1 · Your logo</b> and it drops straight in.</div>' +
      '<button class="btn2" type="button" id="x-logo-go" style="margin-top:8px">Add my logo</button></div>';
  }
  host.innerHTML = h;
  if (c.requiresBackground) mountUploader('bg', 'bg');
  var bal = document.getElementById('bg-add-logo');
  if (bal) bal.onclick = function () { pickFile('logo', 'logo'); };
  if (c.requiresArtwork) mountUploader('art', 'artwork');
  var lg = document.getElementById('x-logo-go');
  if (lg) lg.onclick = function () {
    /* "Add my logo" ADDS THE LOGO (owner 2026-08-10: "button doesn't
       work") — the native picker opens on THIS tap; the scroll just brings
       the slot into view for when the file lands. Scroll-only read as a
       dead button on phones. */
    if (typeof pickFile === 'function') { try { pickFile('logo', 'logo'); } catch (_) {} }
    document.getElementById('step1').scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start' });
  };
}

/* Holo-safe palette only. The stock is silver holographic foil with no white
   ink — pale or pastel ink lays down almost nothing and vanishes into the
   foil. Every swatch here is deep and saturated enough to survive print, and
   SS.inkSafe() clamps anything arriving from older orders or design defaults. */
var COLORS = [
  ['#5b21b6', 'Deep violet'], ['#1e40af', 'Navy'], ['#0f766e', 'Deep teal'],
  ['#15803d', 'Forest'], ['#a16207', 'Dark gold'], ['#c2410c', 'Burnt orange'],
  ['#be123c', 'Crimson'], ['#10131c', 'Ink black']
];

function wireDetails() {
  mountUploader('logo', 'logo');

  /* The "See what a scan shows" card and its handler are GONE (owner
     2026-08-05). It opened /pages/verify in preview mode to demo a
     verification record, and new orders no longer get one. The verify page
     itself stays live for seals already shipped — we simply stop advertising
     it as something a new purchase comes with. */



  var brand = document.getElementById('f-brand');
  if (brand) {
    brand.value = st.brand;
    brand.oninput = function () {
      /* typing ends the attract loop (owner 2026-08-04) — but ONLY a real
         keystroke: wireDetails() calls this handler once at boot to seed the
         counter, and that call must not stop the slideshow. Focus is the
         tell: the seed call runs unfocused. */
      if (document.activeElement === this) stopSlideshow();
      /* their own name beats the demo — and once stopped it stays stopped
         for the rest of the session, even if they clear the field again */
      if (this.value) stopBrandDemo();
      st.brand = this.value;
      /* The focus test is gone with the field (owner 2026-08-12). It existed
         so a seed call could not overwrite a prefix the customer was typing
         into #f-sp; there is no #f-sp now, and the derivation is the ONLY
         source of a prefix, so a pasted or programmatically-set brand has to
         produce one too — otherwise that customer ships on the random session
         code with their name nowhere near their numbers. */
      if (_prefixAuto) {
        var _ap = prefixFromBrand(this.value);
        if (_ap && _ap !== st.serialPrefix) {
          st.serialPrefix = _ap;
          try { sessionStorage.setItem('ss_pfx', _ap); } catch (_) {}
          updateOptions();
        }
      }
      var n = this.value.length, cnt = document.getElementById('brand-cnt');
      cnt.textContent = n + '/' + BRAND_MAX;
      cnt.className = 'cnt' + (n > BRAND_MAX - 4 ? ' warn' : '');
      /* hint copy removed (owner: "remove all the extra text") */
      updateGate();
      refreshGridSoon();
      sync();
    };
    brand.oninput.call(brand);
  }

}

/* ——————————————— uploads ——————————————— */
/* Uploads are downscaled before being held in memory: full-resolution art would
   blow past what an order payload can carry, and ~900px across a 19mm seal is
   already beyond what the press resolves. */
/* ——— UPLOAD CEILINGS (owner 2026-08-12: "block large files from uploading
   it kills the whole site") ————————————————————————————————————————————
   Nothing stopped a 200MB file before this: ss-upload.js only WARNED past
   20MB, and the logo path had no size check at all. Every intake then does
   readAsDataURL (a base64 copy ~1.37x the file, held as one JS string) ->
   new Image() (full decode) -> canvas -> toDataURL (another full copy). A
   phone runs out of memory somewhere in that chain and the tab dies with the
   half-built order in it — which is the "kills the whole site" the owner is
   describing.

   Two ceilings, because a file can be lethal either way:
     · BYTES   — what has to be read into memory and base64'd.
     · PIXELS  — a 12MB HEIC can decode to 60 megapixels; the canvas backing
                 store is w*h*4 bytes, so 60MP is ~240MB before we downscale.
   Both are checked BEFORE the read starts. A phone camera shot (~4MB, 12MP)
   clears both with room to spare; the print pipeline only ever keeps 900x2100
   for artwork and 700x700 for a logo, so nothing above these limits could
   have improved the print anyway. */
var UP_MAX_MB = { logo: 12, bg: 20, art: 20 };
var UP_MAX_MP = 40;

function upTooBig(file, kind) {
  var lim = UP_MAX_MB[kind] || 20;
  if (!file || !file.size) return '';
  if (file.size > lim * 1024 * 1024) {
    return 'That file is ' + (file.size / 1048576).toFixed(1) + ' MB — the limit is ' +
      lim + ' MB. Export it smaller (or take a screenshot of it) and try again. ' +
      'A seal is ' + (((window.SS_SEAL && SS_SEAL.SIZES && SS_SEAL.SIZES[st.sizeId]) ||
        { shortIn: 0.75 }).shortIn) + '″ wide, so a big file cannot print any sharper.';
  }
  return '';
}

function downscale(img, maxW, maxH, mime, q) {
  var s = Math.min(maxW / img.width, maxH / img.height, 1);
  var w = Math.round(img.width * s), h = Math.round(img.height * s);
  var cv = document.createElement('canvas');
  cv.width = w; cv.height = h;
  cv.getContext('2d').drawImage(img, 0, 0, w, h);
  return { dataUrl: cv.toDataURL(mime, q), w: w, h: h, cv: cv };
}

/* Logo intake — CLEANS rather than rejects, mirroring the VialArt pipeline in
   assets/va-logo-clean.js. The press is alpha-blind: whatever is opaque prints,
   so a mark sitting on a white or checkerboard backdrop lays a box over the
   foil. Refusing those files was turning away perfectly usable logos
   (2026-07-26), so we key the backdrop out ourselves and only refuse when
   nothing can be salvaged.

   Two cases, and telling them apart is the whole trick:
     - ANY real alpha (even a tightly-cropped wordmark whose only non-opaque
       pixels are antialiased corners) => already print-ready, accept untouched.
       The previous ">4% fully-clear pixels" rule rejected exactly these files:
       a logo cropped to its own bounding box has almost no clear area.
     - opaque edge to edge => genuinely flattened. Look for a dominant light /
       neutral backdrop — including a baked-in transparency checkerboard, which
       reads as TWO light neutral buckets rather than one — and key it out with
       a feathered edge. Only a flattened image with no removable backdrop
       (a photo, a full-bleed gradient) still gets refused.
   Mutates the canvas in place; the caller keeps the cleaned pixels. */
function ssLum(r, g, b) { return 0.2126 * r + 0.7152 * g + 0.0722 * b; }

/* A LOGO THAT CANNOT SHOW ON FOIL IS REFUSED (owner 2026-10-17, ss1181: "block
   these uploads in the future"). This press lays no white ink: white prints as
   the bare holographic stock and pale silver/chrome as faint ink on it, so a
   mark drawn ONLY in those tones - a photoreal chrome diamond with no outline,
   ss1181's "Thoroughbred Gems" - disappears into the material. What survives
   is near-black (lum < 80) and strong colour (channel spread > 115). Measured
   at 120 px, the size render_seals.py already judges logos at (fine outlines
   blur away there the way they effectively do at seal size): ss1181 = 5.7%;
   the lowest of the 151 logos customers uploaded before it = 14.1% (Mayflower,
   black on a white circle, prints fine). Under 10% is refused - none of the
   151 would have been. Transparent pixels and faint edges (alpha <= 60) are
   not part of the logo and are not counted. */
function faintLogo(cv) {
  try {
    var s = Math.min(120 / cv.width, 120 / cv.height, 1);
    var w = Math.max(1, Math.round(cv.width * s)), h = Math.max(1, Math.round(cv.height * s));
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    /* HIGH: the default low-quality downscale point-samples, so a hairline
       outline survives as aliased dark pixels and lifts a chrome logo over
       the line (ss1181 measured 14% instead of 7%) */
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    x.drawImage(cv, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data, vis = 0, strong = 0;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] <= 60) continue;
      vis++;
      var r = d[i], g = d[i + 1], b = d[i + 2];
      if (ssLum(r, g, b) < 80 || (Math.max(r, g, b) - Math.min(r, g, b)) > 115) strong++;
    }
    return vis > 0 && strong < vis * 0.10;
  } catch (_) { return false; }
}

function cleanLogo(cv) {
  var ctx = cv.getContext('2d', { willReadFrequently: true }), img;
  try { img = ctx.getImageData(0, 0, cv.width, cv.height); }
  catch (_) { return { unreadable: true }; }
  var d = img.data, n = cv.width * cv.height, i, r, g, b, a;

  var clear = 0, partial = 0, visible = 0, darkVis = 0, buckets = {}, bk;
  for (i = 0; i < n; i++) {
    a = d[i * 4 + 3];
    if (a < 16) { clear++; continue; }
    if (a < 250) partial++;
    visible++;
    r = d[i * 4]; g = d[i * 4 + 1]; b = d[i * 4 + 2];
    var lum = ssLum(r, g, b);
    if (lum < 170) darkVis++;
    if (lum > 200) {
      bk = ((r >> 4) << 8) | ((g >> 4) << 4) | (b >> 4);
      buckets[bk] = (buckets[bk] || 0) + 1;
    }
  }
  if (visible < n * 0.004) return { blank: true };
  /* transparent logos exit here — they still get the automatic contrast call:
     a mostly-light mark gets the dark container plate behind it */
  if (clear > 0 || partial > 0) {
    return { clearPct: clear / n, cleaned: false, plate: darkVis < visible * 0.45 };
  }

  /* Opaque everywhere — hunt for a backdrop to remove. */
  var topBk = null, topCount = 0, top2Bk = null, top2Count = 0, k;
  for (k in buckets) if (buckets[k] > topCount) { topCount = buckets[k]; topBk = +k; }
  for (k in buckets) if (+k !== topBk && buckets[k] > top2Count) { top2Count = buckets[k]; top2Bk = +k; }
  function bkRgb(v) { return [((v >> 8) & 15) * 16 + 8, ((v >> 4) & 15) * 16 + 8, (v & 15) * 16 + 8]; }
  function neutral(c) { return Math.max(c[0], c[1], c[2]) - Math.min(c[0], c[1], c[2]) < 24; }

  var keyCols = [];
  if (topBk !== null && topCount > visible * 0.40) {
    keyCols = [bkRgb(topBk)];
    if (top2Bk !== null && top2Count > visible * 0.12 &&
        neutral(bkRgb(topBk)) && neutral(bkRgb(top2Bk))) keyCols.push(bkRgb(top2Bk));
  } else if (topBk !== null && top2Bk !== null &&
             (topCount + top2Count) > visible * 0.40 &&
             topCount > visible * 0.12 && top2Count > visible * 0.12 &&
             neutral(bkRgb(topBk)) && neutral(bkRgb(top2Bk))) {
    keyCols = [bkRgb(topBk), bkRgb(top2Bk)];
  }
  if (!keyCols.length) return { solidBox: true };

  var keyed = 0;
  for (i = 0; i < n; i++) {
    a = d[i * 4 + 3];
    if (a <= 8) continue;
    r = d[i * 4]; g = d[i * 4 + 1]; b = d[i * 4 + 2];
    var dist = 999, kk, dd;
    for (kk = 0; kk < keyCols.length; kk++) {
      dd = Math.max(Math.abs(r - keyCols[kk][0]), Math.abs(g - keyCols[kk][1]), Math.abs(b - keyCols[kk][2]));
      if (dd < dist) dist = dd;
    }
    if (dist < 26) { d[i * 4 + 3] = 0; keyed++; }
    else if (dist < 48) { d[i * 4 + 3] = Math.round(a * (dist - 26) / 22); keyed++; }
  }
  if (!keyed) return { solidBox: true };

  /* Light logos are no longer rejected — the compositor backs them with a
     dark container plate (owner rule 2026-07-28), so a white wordmark knocks
     out to bare foil against dark ink instead of vanishing. We only flag HOW
     light the mark is; blank stays blank. */
  var left = 0, dark = 0;
  for (i = 0; i < n; i++) {
    if (d[i * 4 + 3] <= 60) continue;
    left++;
    if (ssLum(d[i * 4], d[i * 4 + 1], d[i * 4 + 2]) < 170) dark++;
  }
  if (left < n * 0.004) return { blank: true };

  ctx.putImageData(img, 0, 0);
  return { clearPct: keyed / n, cleaned: true, plate: dark < left * 0.45 };
}

/* ------- customer bg fit: scale/move their upload on the die -------
   THE SAME MATH lives in render_seals.py (CROP_BG_JS) and, for studio
   designs, sealstudio.py's _bake_crop - a change here changes what ships. */
var _bgFit = { s: 1, x: 0, y: 0 };
var _bgFitFor = '';
var _bgImg = { src: '', img: null, ok: false };
var _bgCropCache = { sig: '', url: '' };
function bgAspect() {
  /* the PHYSICAL aspect of the selected die: crop at the physical aspect,
     paint into the standard-space box, and the whole-drawing stretch lands
     at zero net distortion (sweep 2026-08-29). LAUNCH-PASS NOTE: the print
     crop twins (render_seals.py CROP_BG_JS, sealstudio _bake_crop) still
     crop at 2.36 - sync them before Large becomes orderable. */
  var z = (window.SS_SEAL && SS_SEAL.SIZES && SS_SEAL.SIZES[st.sizeId]) ||
          { longMm: 44.958, shortMm: 19.05 };
  return st.orientation === 'landscape' ? z.longMm / z.shortMm : z.shortMm / z.longMm;
}
function bgCropRect(w0, h0, fit, A) {
  var z = Math.min(4, Math.max(1, +fit.s || 1));
  var fx = Math.min(.5, Math.max(-.5, +fit.x || 0));
  var fy = Math.min(.5, Math.max(-.5, +fit.y || 0));
  var cw0 = Math.min(w0, h0 * A), ch0 = cw0 / A;
  var cw = cw0 / z, ch = ch0 / z;
  var cx2 = Math.min(w0 - cw / 2, Math.max(cw / 2, w0 / 2 + fx * w0));
  var cy2 = Math.min(h0 - ch / 2, Math.max(ch / 2, h0 / 2 + fy * h0));
  return { x: cx2 - cw / 2, y: cy2 - ch / 2, w: cw, h: ch };
}
function analyzeBgImage(img){
  /* one pass, 64px wide: dominant saturated hue (saturation*value weighted
     vector average) + content box with near-uniform light/dark margins
     trimmed (max 12% a side). DUPLICATED in seal_studio.html (Label Farm) - keep in sync. */
  var W=64, H=Math.max(8,Math.round(W*img.naturalHeight/img.naturalWidth));
  var cv=document.createElement('canvas'); cv.width=W; cv.height=H;
  var g=cv.getContext('2d'); g.drawImage(img,0,0,W,H);
  var d; try{ d=g.getImageData(0,0,W,H).data; }catch(_){ return null; }
  var sx=0, sy=0, wsum=0, i, r, gg, b, mx, mn, v, s, h;
  for(i=0;i<d.length;i+=4){
    r=d[i]/255; gg=d[i+1]/255; b=d[i+2]/255;
    mx=Math.max(r,gg,b); mn=Math.min(r,gg,b); v=mx; s=mx?(mx-mn)/mx:0;
    if(s<0.25||v<0.18) continue;
    if(mx===r) h=((gg-b)/(mx-mn))%6; else if(mx===gg) h=(b-r)/(mx-mn)+2; else h=(r-gg)/(mx-mn)+4;
    h*=60; if(h<0)h+=360;
    var w=s*v;
    sx+=Math.cos(h*Math.PI/180)*w; sy+=Math.sin(h*Math.PI/180)*w; wsum+=w;
  }
  var hue=wsum?(Math.atan2(sy,sx)*180/Math.PI+360)%360:262;
  function lum(x,y){ var k=(y*W+x)*4; return (d[k]+d[k+1]+d[k+2])/3; }
  function flat(vals){
    var m=0, dv=0, n=vals.length, j;
    for(j=0;j<n;j++) m+=vals[j]; m/=n;
    for(j=0;j<n;j++) dv+=Math.abs(vals[j]-m); dv/=n;
    return dv<10&&(m>225||m<18);
  }
  function row(y){ var a=[],x; for(x=0;x<W;x++)a.push(lum(x,y)); return a; }
  function col(x){ var a=[],y; for(y=0;y<H;y++)a.push(lum(x,y)); return a; }
  var y0=0; while(y0<H*0.12&&flat(row(y0)))y0++;
  var y1=H; while(y1>H*0.88&&flat(row(y1-1)))y1--;
  var x0=0; while(x0<W*0.12&&flat(col(x0)))x0++;
  var x1=W; while(x1>W*0.88&&flat(col(x1-1)))x1--;
  if(x0||y0||x1<W||y1<H){ x0=Math.min(x0+1,W); y0=Math.min(y0+1,H);
    x1=Math.max(x1-1,0); y1=Math.max(y1-1,0); }
  return { hue: hue, box: [x0/W, y0/H, x1/W, y1/H] };
}
function accentFromHue(hue){
  /* dark + saturated survives the holo lightness clamp (same family as the
     stock swatches): hsl(hue, 62%, 36%) */
  var s2=0.62, l=0.36;
  var c=(1-Math.abs(2*l-1))*s2, hp=hue/60, xx=c*(1-Math.abs(hp%2-1));
  var m=l-c/2, rgb=[0,0,0];
  if(hp<1)rgb=[c,xx,0]; else if(hp<2)rgb=[xx,c,0]; else if(hp<3)rgb=[0,c,xx];
  else if(hp<4)rgb=[0,xx,c]; else if(hp<5)rgb=[xx,0,c]; else rgb=[c,0,xx];
  function hx(n){ n=Math.round((n+m)*255); return (n<16?'0':'')+n.toString(16); }
  return '#'+hx(rgb[0])+hx(rgb[1])+hx(rgb[2]);
}
function fitFromBox(w0,h0,box,A){
  /* inverse of the crop math: the fit whose crop rect is the largest
     A-aspect rect inside the content box */
  var x0=box[0]*w0, y0=box[1]*h0, x1=box[2]*w0, y1=box[3]*h0;
  var bw=x1-x0, bh=y1-y0;
  if(bw<w0*0.4||bh<h0*0.4) return {s:1,x:0,y:0};   /* absurd box: bail */
  var cw=Math.min(bw,bh*A);
  var cw0=Math.min(w0,h0*A);
  return { s: Math.min(4,Math.max(1,cw0/cw)),
           x: Math.min(.5,Math.max(-.5,((x0+x1)/2-w0/2)/w0)),
           y: Math.min(.5,Math.max(-.5,((y0+y1)/2-h0/2)/h0)) };
}
function bgCropUrl() {
  if (!st.bg || !st.bg.dataUrl) return '';
  var srcSig = st.bg.name + '|' + st.bg.dataUrl.length;
  if (_bgFitFor !== srcSig) {         /* a NEW image starts centred */
    _bgFitFor = srcSig;
    _bgFit = { s: 1, x: 0, y: 0 };
  }
  if (_bgImg.src !== srcSig) {
    _bgImg = { src: srcSig, img: new Image(), ok: false };
    _bgImg.img.onload = function () {
      _bgImg.ok = true;
      /* auto accent + scale-to-fit on a fresh upload (owner 2026-08-02):
         dominant hue becomes the accent (still changeable), and uniform
         light/dark margins are trimmed by initializing the fit past them */
      if (_bgFit.s === 1 && !_bgFit.x && !_bgFit.y) {
        var an = analyzeBgImage(_bgImg.img);
        if (an) {
          st.color = SS.inkSafe(accentFromHue(an.hue));
          _bgFit = fitFromBox(_bgImg.img.naturalWidth, _bgImg.img.naturalHeight,
                              an.box, bgAspect());
          var z = document.getElementById('bg-zoom');
          if (z) z.value = Math.round(_bgFit.s * 100);
        }
      }
      if (typeof renderPreview === 'function') renderPreview();
    };
    _bgImg.img.src = st.bg.dataUrl;
  }
  if (!_bgImg.ok) return st.bg.dataUrl;   /* first paint: uncropped, then swaps */
  var A = bgAspect();
  var sig = srcSig + '|' + (+_bgFit.s).toFixed(3) + '|' + (+_bgFit.x).toFixed(4) +
            '|' + (+_bgFit.y).toFixed(4) + '|' + st.orientation;
  if (_bgCropCache.sig === sig) return _bgCropCache.url;
  var r = bgCropRect(_bgImg.img.naturalWidth, _bgImg.img.naturalHeight, _bgFit, A);
  var cv = document.createElement('canvas');
  if (A < 1) { cv.width = 594; cv.height = Math.round(594 / A); }
  else { cv.height = 594; cv.width = Math.round(594 * A); }
  cv.getContext('2d').drawImage(_bgImg.img, r.x, r.y, r.w, r.h, 0, 0, cv.width, cv.height);
  _bgCropCache = { sig: sig, url: cv.toDataURL('image/png') };
  return _bgCropCache.url;
}
var _bgPvT = null;
function bgPreviewSoon() {
  if (_bgPvT) clearTimeout(_bgPvT);
  _bgPvT = setTimeout(function () {
    if (typeof renderPreview === 'function') renderPreview();
  }, 120);
}


/* ═══════════════ WHICH UPLOAD IS THIS, AND DOES IT FIT ═══════════════════
   Owner, 2026-08-07: "when clicking upload it needs to also ask logo or seal
   since theres 2 uploads they just have been doing the bg no logo or
   sometimes the seal have the logo in it already" — and, for the image
   itself, "after upload a new container should open and allow them to scale
   / move the bg if it doesnt fit ... and then click confirm to save and then
   it shows pricing".

   So: ASK, then PICK, then FIT, then CONFIRM, then quantity.

   ONE CROP MODEL. Everything here writes _bgFit and reads bgCropRect() — the
   same pair the big preview drags, the same pair placeOrder ships as _bg_fit,
   and the same maths render_seals.py runs on the press. A second crop model
   would drift from the printed seal within a week. */

/* set by the "both" answer in the kind picker; consumed once, by the fit
   step's Confirm. */
var _wantLogoAfterBg = false;
var SSK_BOTH =
  '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true">' +
  '<rect x="3.5" y="5.5" width="21" height="21" rx="3" stroke="currentColor" ' +
  'stroke-width="1.5" opacity=".5"/>' +
  '<path d="M6 21.5 11 15.5l3.1 3.7L17 16l3.5 5.5z" fill="currentColor" opacity=".45"/>' +
  '<rect x="13.5" y="13.5" width="15" height="11" rx="2.4" fill="#0d111b" ' +
  'stroke="currentColor" stroke-width="1.5"/>' +
  '<path d="M21 16.4 24.6 22h-7.2z" fill="currentColor" opacity=".9"/></svg>';
var SSK_SEAL =
  '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true">' +
  '<rect x="6.5" y="2.5" width="19" height="27" rx="3" stroke="currentColor" stroke-width="1.6"/>' +
  '<path d="M9.5 21.5 14 16l3.2 3.8L20 16.8l2.5 4.7z" fill="currentColor" opacity=".85"/>' +
  '<circle cx="12.4" cy="9.6" r="2" fill="currentColor" opacity=".85"/>' +
  '<rect x="9.5" y="23.8" width="13" height="3" rx="1.2" fill="currentColor" opacity=".35"/></svg>';
var SSK_LOGO =
  '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true">' +
  '<rect x="2.5" y="2.5" width="27" height="27" rx="3" stroke="currentColor" ' +
  'stroke-width="1.4" stroke-dasharray="3 2.6" opacity=".55"/>' +
  '<path d="M16 7.5 24 20H8z" fill="currentColor" opacity=".9"/>' +
  '<circle cx="16" cy="23.4" r="1.9" fill="currentColor" opacity=".55"/></svg>';

function ssSheetClose(el) {
  if (!el || el.hidden) return;
  el.hidden = true;
  document.documentElement.classList.remove('ss-noscroll');
  var r = el._ssReturn;
  el._ssReturn = null;
  if (r && r.focus) { try { r.focus(); } catch (_) { } }
}
function ssSheetOpen(el) {
  el._ssReturn = document.activeElement;
  el.hidden = false;
  document.documentElement.classList.add('ss-noscroll');
  /* .ssheet-in scrolls. Focus the DIALOG, never a control inside it: focusing
     the Confirm button at the foot made the browser scroll it into view, which
     opened "Does it fit?" with the stage at viewport y = -459 on a 390x844
     phone — the customer could not see the picture they came to look at.
     Pin the scroll to the top too, so a re-open never inherits a stale one. */
  var inn = el.querySelector('.ssheet-in');
  if (inn) {
    inn.scrollTop = 0;
    setTimeout(function () { inn.scrollTop = 0; try { inn.focus(); } catch (_) { } }, 30);
  }
}
/* Backdrop tap, the X, and Escape. Bound once per sheet at build time. */
function ssSheetWire(el, onClose) {
  el.addEventListener('click', function (e) {
    if (e.target === el || (e.target.closest && e.target.closest('.ssheet-x'))) onClose();
  });
  el.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.stopPropagation(); onClose(); }
    if (e.key !== 'Tab') return;
    /* a modal that tabs out into the page behind it is not modal */
    var f = el.querySelectorAll('button,input,select,textarea,summary,[href],[tabindex]:not([tabindex="-1"])');
    var vis = [];
    for (var i = 0; i < f.length; i++) if (f[i].offsetParent !== null) vis.push(f[i]);
    if (!vis.length) return;
    var first = vis[0], last = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
}

/* ——————————————— 1. logo or seal? ——————————————— */
/* The distinction is stated as a picture, not as a field name: "one picture
   that fills the whole seal" vs "your logo on its own". Naming our fields
   ("background", "artwork") is what customers were getting wrong. */
function ssAskKind(tplKey) {
  var el = document.getElementById('ssask');
  if (!el) {
    el = document.createElement('div');
    el.id = 'ssask';
    el.className = 'ssheet';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'ssask-h');
    el.innerHTML =
      '<div class="ssheet-in ssask-in" tabindex="-1">' +
        '<button class="ssheet-x" type="button" aria-label="Close">&times;</button>' +
        '<h3 id="ssask-h">What are you uploading?</h3>' +
        '<p class="ssheet-sub">Two different things go on a seal. Pick the one that ' +
          'describes your picture.</p>' +
        '<button class="ssask-opt" type="button" data-k="bg">' +
          '<span class="ssask-ic">' + SSK_SEAL + '</span>' +
          '<span class="ssask-tx"><b>My finished seal design</b><span>' +
          'One picture that fills the whole seal, edge to edge. ' +
          '<i>Pick this if your logo is already in the picture.</i>' +
          '</span></span></button>' +
        '<button class="ssask-opt" type="button" data-k="logo">' +
          '<span class="ssask-ic">' + SSK_LOGO + '</span>' +
          '<span class="ssask-tx"><b>Just my logo</b><span>' +
          'Your logo on its own, nothing around it \u2014 any image works. ' +
          '<i>We put it on one of our designs.</i></span></span></button>' +
        /* the third answer: BOTH layers. Without it the sheet reads as a
           choice between a picture and a logo, which is what left customers
           believing they could not have both (owner 2026-08-08). */
        '<button class="ssask-opt" type="button" data-k="both">' +
          '<span class="ssask-ic">' + SSK_BOTH + '</span>' +
          '<span class="ssask-tx"><b>Both \u2014 my picture and my logo</b><span>' +
          'Your picture fills the seal and your logo goes on top of it. ' +
          '<i>Picture first, then your logo \u2014 you choose where it sits.</i>' +
          '</span></span></button>' +
      '</div>';
    document.body.appendChild(el);
    ssSheetWire(el, function () { ssSheetClose(el); });
    el.querySelectorAll('.ssask-opt').forEach(function (b) {
      b.onclick = function () {
        var k = this.dataset.k, key = el._tplKey;
        ssSheetClose(el);
        if (k === 'bg' || k === 'both') {
          /* only NOW does the upload-your-own design get selected — a
             customer who came in here for a logo must not be left standing on
             a design that demands a background they never meant to give */
          /* 'both' is the SAME route with a promise attached: the logo picker
             opens by itself once the picture is confirmed, so the customer is
             never left to find the logo tile on their own. Cleared by the
             fit step whether or not it fires. */
          _wantLogoAfterBg = (k === 'both');
          /* picker FIRST: it must open inside this tap's activation window —
             selectTemplate's re-render is heavy enough to risk it on iOS */
          pickFile('bg', 'bg');
          selectTemplate(key);
          return;
        }
        _wantLogoAfterBg = false;
        pickFile('logo', 'logo');
        /* logo: filter the gallery to the layouts that feature one, move
           OFF any design that demands a background, and open the logo
           picker.

           The move matters. The builder boots with the upload-your-own design
           already selected (it sorts first in the gallery), so a customer who
           answers "just my logo" was left on a design whose only blocker read
           "Upload your design (tap the Upload Your Own tile)" — the exact
           thing they had just declined. The option says we put the logo on one
           of our designs; this is that sentence being true. The gallery is
           right there if they want a different one. */
        setPath('logo');
        if (caps().requiresBackground && !st.bg) {
          var lgt = (window.SS_SELLABLE || []).filter(function (x) {
            return catOf(x) === 'logo' && !(x.caps && x.caps.requiresBackground);
          })[0];
          if (lgt) selectTemplate(lgt.key);
        }
      };
    });
  }
  el._tplKey = tplKey;
  ssSheetOpen(el);
}

/* Every route into the design tiles. Designs that need nothing still select
   in one tap; the upload-your-own tile asks first. */
function pickDesign(t) {
  /* Picking a tile is EXITING the gallery (owner 2026-08-11: "when I open
     pick bg and then click one it needs to exit the gallery and have me do
     the next required step"). Close the details before the advance so the
     scroll lands on the next step — with it open, a fold of tiles stays
     between the customer and whatever advanceFromDesign() points at.
     #tplextras and #step2 both live OUTSIDE #allgal, so nothing the advance
     targets is hidden by closing it. */
  var ag = document.getElementById('allgal');
  if (ag) ag.open = false;
  if (t.caps && t.caps.requiresBackground && !st.bg) { ssAskKind(t.key); return; }
  selectTemplate(t.key);
  advanceFromDesign();
}

/* ——— the choice IS the continue (owner 2026-08-08) ————————————————————
 * Step 1 used to end in a "Continue to quantity" button. Picking a design is
 * the decision the step exists for, so picking one moves the flow.
 *
 * It only jumps when step 1 is genuinely FINISHED, though, and that guard is
 * the whole reason this is a function rather than a scrollIntoView on the tile
 * handler. A design that demands an upload, or a brand name still empty, must
 * not be scrolled AWAY from — those land on the thing that is missing, which
 * is what every buy surface in this file already does with blockers()[0].
 * Everything else left in step 1 (material, shape, QR, numbering) has a
 * working default, so a customer who lands on quantity has a complete, valid
 * order rather than a half-configured one.
 *
 * Deliberately called from pickDesign() and NOT from selectTemplate(): boot,
 * ?design= links and both prefill paths all select a template without the
 * customer touching anything, and any of those scrolling the page out from
 * under a first paint would be its own bug. */
function advanceFromDesign() {
  if (stepDone('step1')) {
    smoothTo(document.getElementById('step2'), 'start');
    setActive('step2');
    return;
  }
  /* the chosen design's own requirements render into #tplextras, immediately
     under the gallery — that is where an upload-shaped blocker is answered */
  var need = document.getElementById('tplextras');
  if (need && need.children.length) smoothTo(need, 'center');
}

/* ——————————————— 2. the fit step ——————————————— */
var _fit = { kind: 'bg', sk: 'bg', w: 0, h: 0, drag: null, pts: null, pinch: null, poll: 0 };

/* how many acknowledgements are still unticked — a COUNT, because the
   needline says how many and the button reads differently at zero */
function ssFitPending() {
  var f = st[_fit.sk], n = 0, seen = {};
  if (!f) return 0;
  (f.acks || []).forEach(function (id) {
    if (seen[id]) return;
    seen[id] = 1;
    if (!f.acked[id]) n++;
  });
  return n;
}

/* The zones drawn over the image, straight from SS_SEAL.layout() in
   millimetres — the same geometry the compositor prints. L.art is the framed
   window their picture reads through; everything outside it is dimmed because
   that is where the name, serial and QR panels land on top. This is the whole
   answer to "does it fit", and it cannot drift: it is not a drawing of the
   layout, it IS the layout. */
function ssFitZones() {
  var land = st.orientation === 'landscape';
  /* the SELECTED die, from the renderer's own table (a Large upload used to be
     framed against the Standard art window) */
  var _z = (window.SS_SEAL && SS_SEAL.SIZES && SS_SEAL.SIZES[st.sizeId]) || { longMm: 44.958, shortMm: 19.05 };
  var W = land ? _z.longMm : _z.shortMm, H = land ? _z.shortMm : _z.longMm;
  var L = null;
  try {
    var c = caps();
    var qf = c.supportsQR !== false ? qrField() : '';
    var hasQr = !!(st.tpl.supports && st.tpl.supports.qr && qf &&
                   String(qf).toLowerCase() !== 'none');
    L = window.SS_SEAL.layout(st.orientation, st.tpl, hasQr, false,
                              st.sealStyle, '1', undefined, st.sizeId);
  } catch (_) { L = null; }
  if (!L || !L.art) return '';
  var a = L.art;
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '">' +
    '<defs><mask id="ssfitm"><rect width="' + W + '" height="' + H + '" fill="#fff"/>' +
    '<rect x="' + a.x + '" y="' + a.y + '" width="' + a.w + '" height="' + a.h +
    '" rx="' + (a.r || 0) + '" fill="#000"/></mask></defs>' +
    '<rect width="' + W + '" height="' + H + '" fill="#05070c" opacity=".52" mask="url(#ssfitm)"/>' +
    '<rect x="' + a.x + '" y="' + a.y + '" width="' + a.w + '" height="' + a.h +
    '" rx="' + (a.r || 0) + '" fill="none" stroke="#8fb3f0" stroke-width=".4" ' +
    'stroke-dasharray="1.5 1.1" vector-effect="non-scaling-stroke"/></svg>';
}

/* _bgFit -> CSS, derived from bgCropRect so the stage shows the CROP THAT
   PRINTS rather than an approximation of it. A canvas redraw per drag frame
   would be honest too, and unusably slow on a phone; this is exact and free. */
function ssFitPaint() {
  var box = document.getElementById('ssfit-img');
  if (!box || !st[_fit.sk]) return;
  var src = st[_fit.sk].dataUrl;
  if (_fit.kind !== 'bg' || !_bgImg.ok || !_bgImg.img) {
    /* artwork has no crop model of its own — the compositor crops it to fill,
       so show exactly that and offer no controls that would lie */
    box.style.backgroundImage = 'url("' + src + '")';
    box.style.backgroundSize = 'cover';
    box.style.backgroundPosition = '50% 50%';
    return;
  }
  var img = _bgImg.img, A = bgAspect();
  var r = bgCropRect(img.naturalWidth, img.naturalHeight, _bgFit, A);
  var k = _fit.w / r.w;
  box.style.backgroundImage = 'url("' + src + '")';
  box.style.backgroundSize = (img.naturalWidth * k) + 'px ' + (img.naturalHeight * k) + 'px';
  box.style.backgroundPosition = (-r.x * k) + 'px ' + (-r.y * k) + 'px';
}

function ssFitSize() {
  var wrap = document.getElementById('ssfit-stagewrap');
  var stage = document.getElementById('ssfit-stage');
  if (!wrap || !stage) return;
  var A = bgAspect();
  var avail = Math.max(150, wrap.clientWidth - 2);
  /* tall enough to judge, short enough that Confirm stays reachable without
     scrolling on a 812px phone */
  var h = Math.max(200, Math.min(340, Math.round(window.innerHeight * 0.40)));
  var w = h * A;
  if (w > avail) { w = avail; h = w / A; }
  _fit.w = Math.round(w); _fit.h = Math.round(h);
  stage.style.width = _fit.w + 'px';
  stage.style.height = _fit.h + 'px';
  ssFitPaint();
}

function ssFitSync() {
  var pend = ssFitPending();
  var ok = document.getElementById('ssfit-ok');
  var need = document.getElementById('ssfit-need');
  if (ok) ok.textContent = pend ? 'Confirm' : 'Confirm \u0026 continue \u2192';
  if (need) need.textContent = pend
    ? pend + (pend === 1 ? ' note' : ' notes') + ' still to confirm \u2014 tap Confirm to jump to ' +
      (pend === 1 ? 'it' : 'them') + '.'
    : '';
}

function ssFitEl() {
  var el = document.getElementById('ssfit');
  if (el) return el;
  el = document.createElement('div');
  el.id = 'ssfit';
  el.className = 'ssheet ssfit';
  el.hidden = true;
  el.setAttribute('role', 'dialog');
  el.setAttribute('aria-modal', 'true');
  el.setAttribute('aria-labelledby', 'ssfit-h');
  el.innerHTML =
    '<div class="ssheet-in ssfit-in" tabindex="-1">' +
      '<button class="ssheet-x" type="button" aria-label="Close">&times;</button>' +
      '<h3 id="ssfit-h">Does it fit?</h3>' +
      '<p class="ssheet-sub" id="ssfit-sub"></p>' +
      '<div class="ssfit-stagewrap" id="ssfit-stagewrap">' +
        '<div class="ssfit-stage" id="ssfit-stage">' +
          '<div class="ssfit-img" id="ssfit-img"></div>' +
          '<div class="ssfit-zones" id="ssfit-zones" aria-hidden="true"></div>' +
        '</div>' +
      '</div>' +
      '<p class="ssfit-leg" id="ssfit-leg"></p>' +
      '<div class="ssfit-ctl" id="ssfit-ctl">' +
        '<button class="ssfit-zb" type="button" data-z="-1" aria-label="Zoom out">&minus;</button>' +
        '<input type="range" id="ssfit-zoom" min="100" max="400" step="2" value="100" ' +
          'aria-label="Zoom">' +
        '<button class="ssfit-zb" type="button" data-z="1" aria-label="Zoom in">+</button>' +
        /* NON-DRAG PAN (a11y sweep 2026-08-20, SC 2.5.7 / 2.1.1): the only
           way to position an image used to be dragging it. Same 44x44 style
           as the zoom buttons, same clamp as the drag. */
        '<button class="ssfit-zb" type="button" data-pan="-1,0" aria-label="Move image left">\u2190</button>' +
        '<button class="ssfit-zb" type="button" data-pan="0,-1" aria-label="Move image up">\u2191</button>' +
        '<button class="ssfit-zb" type="button" data-pan="0,1" aria-label="Move image down">\u2193</button>' +
        '<button class="ssfit-zb" type="button" data-pan="1,0" aria-label="Move image right">\u2192</button>' +
        '<button class="ssfit-rs" type="button" id="ssfit-reset">Reset</button>' +
      '</div>' +
      '<div class="rep" id="ssfit-rep"></div>' +
      '<div class="acks" id="ssfit-acks"></div>' +
      /* the logo-placement control, painted by paintLogoPlace() — the same
         markup as the copy under the logo card. It stands here because this
         is where the customer is looking AT the composition. */
      '<div class="ssfit-hl" id="ssfit-hl" hidden></div>' +
      /* the needline lives INSIDE the sticky footer: it is the reason the
         button beside it will not advance, and splitting them put the reason
         off screen while the button stayed pinned */
      '<div class="ssfit-foot">' +
        '<p class="needline" id="ssfit-need"></p>' +
        '<button class="cta" type="button" id="ssfit-ok">Confirm \u0026 continue \u2192</button>' +
        '<button class="btn2" type="button" id="ssfit-swap">Use a different image</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(el);
  ssSheetWire(el, function () { ssFitClose(false); });

  var stage = el.querySelector('#ssfit-stage');
  var zoom = el.querySelector('#ssfit-zoom');

  function setScale(v, keep) {
    _bgFit.s = Math.min(4, Math.max(1, v));
    if (!keep) zoom.value = Math.round(_bgFit.s * 100);
    ssFitPaint();
    bgPreviewSoon();
  }

  /* Drag to move. Identical maths to the big-preview drag (search bgDrag):
     screen pixels -> source pixels via the crop rect, then normalised to the
     -0.5..0.5 offsets _bgFit stores. */
  _fit.pts = {};
  stage.addEventListener('pointerdown', function (e) {
    if (_fit.kind !== 'bg' || !_bgImg.ok) return;
    _fit.pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    try { stage.setPointerCapture(e.pointerId); } catch (_) { }
    var ids = Object.keys(_fit.pts);
    if (ids.length === 2) {
      var a = _fit.pts[ids[0]], b = _fit.pts[ids[1]];
      _fit.pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: +_bgFit.s || 1 };
      _fit.drag = null;
    } else {
      _fit.drag = { px: e.clientX, py: e.clientY, x: +_bgFit.x || 0, y: +_bgFit.y || 0 };
    }
    e.preventDefault();
  });
  stage.addEventListener('pointermove', function (e) {
    if (!_fit.pts[e.pointerId]) return;
    _fit.pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(_fit.pts);
    if (_fit.pinch && ids.length === 2) {
      var a = _fit.pts[ids[0]], b = _fit.pts[ids[1]];
      var d = Math.hypot(a.x - b.x, a.y - b.y) || 1;
      setScale(_fit.pinch.s * (d / _fit.pinch.d));
      e.preventDefault();
      return;
    }
    if (!_fit.drag || !_bgImg.ok) return;
    var img = _bgImg.img;
    var r = bgCropRect(img.naturalWidth, img.naturalHeight,
                       { s: _bgFit.s, x: _fit.drag.x, y: _fit.drag.y }, bgAspect());
    var k = r.w / _fit.w;          /* source px per screen px */
    _bgFit.x = Math.min(.5, Math.max(-.5,
      _fit.drag.x - (e.clientX - _fit.drag.px) * k / img.naturalWidth));
    _bgFit.y = Math.min(.5, Math.max(-.5,
      _fit.drag.y - (e.clientY - _fit.drag.py) * k / img.naturalHeight));
    ssFitPaint();
    bgPreviewSoon();
    e.preventDefault();
  });
  /* NOT pointerleave. Calling setPointerCapture makes Chrome fire
     pointerout/pointerleave on the element it captures to, so listening for
     it here deleted the pointer on the first move and the image never
     budged. The big-preview drag has always used up/cancel only. */
  ['pointerup', 'pointercancel'].forEach(function (ev) {
    stage.addEventListener(ev, function (e) {
      delete _fit.pts[e.pointerId];
      if (Object.keys(_fit.pts).length < 2) _fit.pinch = null;
      if (!Object.keys(_fit.pts).length) _fit.drag = null;
    });
  });

  zoom.oninput = function () { setScale(parseInt(this.value, 10) / 100, true); };
  /* [data-z] only — the pan buttons share the class for styling and would
     otherwise land in setScale(NaN) */
  el.querySelectorAll('.ssfit-zb[data-z]').forEach(function (b) {
    b.onclick = function () { setScale((+_bgFit.s || 1) + (+this.dataset.z) * 0.15); };
  });
  /* dx/dy are in IMAGE-movement terms; the drag decreases _bgFit.x as the
     pointer moves right, so the sign is flipped here to match exactly. */
  function _panBy(dx, dy) {
    var STEP = 0.04;
    _bgFit.x = Math.min(0.5, Math.max(-0.5, (+_bgFit.x || 0) - dx * STEP));
    _bgFit.y = Math.min(0.5, Math.max(-0.5, (+_bgFit.y || 0) - dy * STEP));
    ssFitPaint();
    bgPreviewSoon();
  }
  el.querySelectorAll('[data-pan]').forEach(function (b) {
    b.onclick = function () {
      var p = String(this.dataset.pan).split(',');
      _panBy(+p[0] || 0, +p[1] || 0);
    };
  });
  /* and the stage itself is keyboard-pannable */
  var _stg = el.querySelector('#ssfit-stage');
  if (_stg) {
    _stg.setAttribute('tabindex', '0');
    _stg.setAttribute('role', 'group');
    _stg.setAttribute('aria-label',
      'Position your image \u2014 use the arrow keys to move it');
    _stg.addEventListener('keydown', function (e) {
      var m = { ArrowLeft: [-1, 0], ArrowRight: [1, 0],
                ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
      if (!m) return;
      e.preventDefault();
      _panBy(m[0], m[1]);
    });
  }
  el.querySelector('#ssfit-reset').onclick = function () {
    _bgFit = { s: 1, x: 0, y: 0 };
    zoom.value = 100;
    ssFitPaint();
    bgPreviewSoon();
  };
  el.querySelector('#ssfit-swap').onclick = function () {
    var k = _fit.kind, sk = _fit.sk;
    ssFitClose(false);
    pickFile(k, sk);
  };
  el.querySelector('#ssfit-ok').onclick = function () { ssFitConfirm(); };
  window.addEventListener('resize', function () { if (!el.hidden) ssFitSize(); });
  return el;
}

function ssFitOpen(kind, stateKey) {
  var f = st[stateKey];
  if (!f) return;
  _fit.kind = kind; _fit.sk = stateKey;
  var el = ssFitEl();
  var isBg = kind === 'bg';

  el.querySelector('#ssfit-sub').textContent = isBg
    ? 'Your seal at its real shape. Move and zoom until it sits right.'
    : 'Your artwork at the shape it prints. Check nothing important is cut off.';
  el.querySelector('#ssfit-leg').innerHTML = isBg
    ? 'Drag to move \u00b7 pinch or slide to zoom<br>' +
      '<i>Your name, serial and QR print over the dimmed bands.</i>'
    : '<i>Cropped to fill \u2014 the dashed window is what prints.</i>';
  el.querySelector('#ssfit-ctl').hidden = !isBg;
  el.querySelector('#ssfit-zones').innerHTML = ssFitZones();

  /* where-does-the-logo-go only exists when they have both files */
  paintLogoPlace();

  el.querySelector('#ssfit-rep').innerHTML = f.report ? repHtml(f.report) : '';
  var ah = el.querySelector('#ssfit-acks');
  ah.innerHTML = f.report ? acksHtml(f.report) : '';
  wireAcks(ah, stateKey, ssFitSync);
  ssFitSync();

  ssSheetOpen(el);
  el.querySelector('#ssfit-zoom').value = Math.round((+_bgFit.s || 1) * 100);
  ssFitSize();

  /* bgCropUrl() is what loads _bgImg and, on a fresh upload, auto-centres the
     fit past uniform margins. Kick it, then paint once it lands so the
     customer never sees the picture jump under their thumb. */
  if (isBg) {
    bgCropUrl();
    if (_fit.poll) clearInterval(_fit.poll);
    var tries = 0;
    _fit.poll = setInterval(function () {
      if (++tries > 100 || _bgImg.ok) {
        clearInterval(_fit.poll); _fit.poll = 0;
        el.querySelector('#ssfit-zoom').value = Math.round((+_bgFit.s || 1) * 100);
        ssFitPaint();
      }
    }, 60);
  }
  ssFitPaint();
}

function ssFitClose(advanced) {
  var el = document.getElementById('ssfit');
  if (!el) return;
  if (_fit.poll) { clearInterval(_fit.poll); _fit.poll = 0; }
  ssSheetClose(el);
  /* re-render the panel under the uploader so #bg-rep / #bg-acks carry the
     ticks that were made in here — mountUploader re-runs renderReport and
     wireAcks restores them from st[sk].acked */
  mountUploader(_fit.kind, _fit.sk);
  sync();
  if (!advanced) bgPreviewSoon();
}

function ssFitConfirm() {
  /* the crop is already committed — every drag wrote _bgFit live, which is
     the same object placeOrder ships as _bg_fit. Confirm is about moving on. */
  if (ssFitPending()) {
    /* Point at the blocker instead of closing over it. With the footer pinned,
       the checkbox is usually scrolled out of sight behind it, so "tick the box"
       was an instruction aimed at nothing. Nobody is trapped: the X, Escape and
       the backdrop all close, and the same checkboxes are rendered under the
       uploader either way. */
    var sheet = document.getElementById('ssfit'), first = null;
    sheet.querySelectorAll('#ssfit-acks input[data-ack-id]').forEach(function (cb) {
      if (!first && !cb.checked) first = cb.closest('.ack');
    });
    if (first) {
      first.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center' });
      first.classList.remove('hilite');
      void first.offsetWidth;                 /* restart the pulse on a repeat tap */
      first.classList.add('hilite');
    }
    return;
  }
  ssFitClose(true);
  /* they answered "both" at the fork: hand them the logo picker instead of
     the price. The flag is cleared either way — a promise that already fired
     must not fire again when they come back to re-crop. */
  if (_wantLogoAfterBg && _fit.kind === 'bg') {
    _wantLogoAfterBg = false;
    if (!st.logo) { pickFile('logo', 'logo'); return; }
  }
  _wantLogoAfterBg = false;
  /* "and then it shows pricing" — the price lives at step 2 now */
  var s2 = document.getElementById('step2');
  if (s2) smoothTo(s2, 'start');
  if (typeof setActive === 'function') setActive('step2');
}


function mountUploader(kind, stateKey) {
  var slot = document.getElementById(kind + '-slot');
  if (!slot) return;
  var cur = st[stateKey];
  if (cur) {
    slot.innerHTML =
      '<div class="upfile"><img class="th" alt="Uploaded ' + kind + ' preview" src="' + cur.dataUrl + '">' +
      '<span class="meta"><b>' + SS.esc(cur.name) + '</b>' +
      '<span>' + cur.w + '×' + cur.h + ' px · ' + cur.kb + ' KB' +
      (cur.note ? ' · ' + SS.esc(cur.note) : '') + '</span></span>' +
      '<span class="acts"><button type="button" data-a="replace">Replace</button>' +
      '<button type="button" data-a="remove">Remove</button></span></div>';
    slot.querySelector('[data-a="replace"]').onclick = function () { pickFile(kind, stateKey); };
    if (kind === 'bg' && !st.logo) {
      /* the audit of real orders says this file is often the customer's LOGO
         — uploaded here because this was the first upload they saw, leaving
         the actual logo slot empty. One line, one tap, no modal. */
      var bn = document.createElement('div');
      bn.className = 'bgnote';
      bn.innerHTML = 'Fills the whole label · ' +
        '<button type="button" class="linkish" id="bg-add-logo">Add a logo on top</button>';
      slot.appendChild(bn);
      bn.querySelector('#bg-add-logo').onclick = function () {
        /* same-gesture: the native picker opens on THIS tap */
        try { pickFile('logo', 'logo'); } catch (_) {}
        var t = document.getElementById('logo-tile');
        if (t && typeof smoothTo === 'function') smoothTo(t, 'center');
      };
    }
    slot.querySelector('[data-a="remove"]').onclick = function () {
      st[stateKey] = null; mountUploader(kind, stateKey); sync();
      // the tiles carry the artwork too now, so all kinds must refresh them
      refreshGridSoon();
      if (kind !== 'logo') renderReport(null, null, kind);  // clear a stale verdict
      if (kind === 'logo') { updateGate(); renderExtras(); }
    };
    /* Restore the gate's verdict + ack state whenever the controls re-render —
       renderReport used to run only inside handleFile, so a rebuild left the
       "Confirm the artwork notes" blocker with no checkboxes to tick. */
    if (kind !== 'logo' && cur.report) renderReport(cur.report, null, kind);
    /* No placement toggle: logos are ALWAYS featured front-and-centre at
       full width (owner rule 2026-07-28 — "remove the small in the corner,
       they all want the logo in the middle"). The 'mark' mode survives in
       the compositor only so pre-rule orders print as bought. */
    /* position + zoom for the customer's own design: drag happens on the
       big preview; the slider zooms; Reset recentres */
    /* Position + zoom now live in the FIT STEP (ssFitOpen), which shows the
       image inside the real die at a size a thumb can work with. This is the
       way back into it — the loose slider that used to sit here could zoom
       but not move, and sat below the fold on a phone. Dragging the big
       preview still works and still writes the same _bgFit. */
    if (kind === 'bg') {
      var bs = document.createElement('div');
      bs.className = 'lscale';
      bs.innerHTML = '<button class="btn2 ssfit-open" type="button" id="bg-fit-open">' +
        'Move or zoom your design</button>';
      bs.querySelector('#bg-fit-open').onclick = function () { ssFitOpen('bg', 'bg'); };
      slot.appendChild(bs);
    }
    /* No size slider (owner 2026-08-05: "fit it max width instead of
       allowing to change the size") — every logo fills the slot width, and
       injectLogo contain-fits so nothing ever overflows the die. */
    /* ...but WHERE it goes is a real question the moment a background
       exists, and this card is the one place a logo always has a home. The
       fit sheet shows the same control over the picture; both paint from
       logoPlaceHtml(). */
    if (kind === 'logo') {
      var lp = document.createElement('div');
      lp.id = 'logo-place';
      slot.appendChild(lp);
      paintLogoPlace();
      updateLogoTile();
      /* SIZE OVERRIDE (owner 2026-08-19, after pokebrit's "my logo is not
         fitting into the box"): auto-fit maximises by default — this slider
         lets the customer pull it back. logo_scale already rides the cart
         line (_logo_scale) and the print sidecar honours it; only the UI
         was removed in the 2026-08-05 strip-down. 100% = the auto fit. */
      var lsz = document.createElement('div');
      lsz.className = 'lscale';
      lsz.innerHTML = '<label>Logo size <span id="lgsz-val">' +
        Math.round(Math.min(1, Math.max(0.5, st.logoScale)) * 100) + '%</span></label>' +
        '<input type="range" id="lgsz-r" min="50" max="100" step="5" value="' +
        Math.round(Math.min(1, Math.max(0.5, st.logoScale)) * 100) +
        '" aria-label="Logo size">';
      var lgr = lsz.querySelector('#lgsz-r');
      lgr.oninput = function () {
        st.logoScale = parseInt(lgr.value, 10) / 100;
        var lv = document.getElementById('lgsz-val');
        if (lv) lv.textContent = lgr.value + '%';
        try { buzz(4); } catch (_) {}
        renderPreview();
      };
      slot.appendChild(lsz);
      /* the rights TERM, stated not gated (owner 2026-08-12: "remove the
         confirm logo rights checkbox") */
      var ra = document.createElement('p');
      ra.id = 'logo-rights-note';
      ra.className = 'hint';
      ra.style.marginTop = '8px';
      ra.textContent = RIGHTS_ACK.sub;
      slot.appendChild(ra);
    }
    return;
  }
  /* the Upload Your Own design has NO separate empty-state button - the
     gallery tile is the upload button (owner 2026-08-02). Everything below
     (specs, report, acks, uploaded-state controls) still renders. */
  if (kind === 'bg') { slot.innerHTML = ''; return; }
  /* the logo's empty state is the tile beside the name — nothing renders
     below until a file exists (owner 2026-08-04) */
  if (kind === 'logo') { slot.innerHTML = ''; updateLogoTile(); return; }
  var what = kind === 'logo' ? 'logo' : kind === 'bg' ? 'background' : 'artwork';
  var touch = matchMedia('(hover:none)').matches;   // no drag target on a phone
  slot.innerHTML = '<div class="up" id="' + kind + '-drop" tabindex="0" role="button" ' +
    'aria-label="Upload your ' + what + '">' +
    '<b>' + (touch ? 'Add your ' + what : 'Drop your ' + what + ' here') + '</b>' +
    /* artwork only: bg and logo both return above with a tile-driven empty
       state, so the limit for those two is stated on their tiles instead */
    'PNG or JPG · up to 20 MB · ' +
    (touch ? 'tap to choose a file' : 'click to browse') + '</div>';
  var drop = document.getElementById(kind + '-drop');
  drop.onclick = function () { pickFile(kind, stateKey); };
  drop.onkeydown = function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pickFile(kind, stateKey); }
  };
  ['dragenter', 'dragover'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('over'); });
  });
  ['dragleave', 'drop'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('over'); });
  });
  drop.addEventListener('drop', function (e) {
    var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (f) handleFile(f, kind, stateKey);
  });
}

/* ——— background upload to Shopify Files (via the worker relay) ———
   Fires the moment a file is accepted so the URL is usually ready long before
   Add to cart. placeOrder awaits any still-running upload; a failed upload
   falls back to the old files-by-email note rather than blocking the sale. */
function uploadFile(stateKey) {
  var f = st[stateKey];
  if (!f || f.url || f.uploadP) return;
  /* A HANG IS NOT A FAILURE, SO IT NEVER TOOK THE FAILURE PATH (funnel
     audit 2026-08-17): placeOrder waits on this promise, and a socket that
     stalled without erroring left the buy button on "Saving your file…"
     forever. The abort turns a hang into the same uploadErr fallback a
     failed upload takes — the order proceeds with the files-by-email note. */
  var _ac = null, _tm = null;
  try {
    _ac = new AbortController();
    _tm = setTimeout(function () { _ac.abort(); }, 25000);
  } catch (_) {}
  f.uploadP = fetch(SS_WORKER + '/upload', {
    method: 'POST',
    signal: _ac ? _ac.signal : undefined,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name: f.name, data: f.dataUrl,
                           kind: stateKey === 'logo' ? 'logo'
                               : stateKey === 'bg' ? 'bg' : 'artwork' })
  }).then(function (r) { return r.json(); }).then(function (d) {
    if (_tm) clearTimeout(_tm);
    if (d && d.ok && (d.url || d.id)) {
      f.url = d.url || '';
      f.fileId = d.id || '';
      f.note = (f.note ? f.note + ' · ' : '') + 'saved';
      var kind = stateKey === 'logo' ? 'logo' : stateKey === 'bg' ? 'bg' : 'art';
      if (document.getElementById(kind + '-slot')) mountUploader(kind, stateKey);
    } else { f.uploadErr = true; }
  }).catch(function () {
    if (_tm) clearTimeout(_tm);
    f.uploadErr = true;
  });
}

/* Module-scoped ref: a detached input with no live reference can be GC'd by
   Safari while the native picker is still open — onchange never fires and the
   tap "does nothing". Holding it here pins it for the picker's lifetime. */
var _fileInp = null;
function pickFile(kind, stateKey) {
  var inp = document.createElement('input');
  inp.type = 'file';
  /* Artwork takes any image. The old png/jpeg filter greyed out most of an
     iPhone's camera roll (HEIC) and every WebP screenshot, so people hit a
     picker that refused to show the file they were holding. Logos stay PNG —
     transparency is the whole point there. */
  /* ANY image, logos included (owner 2026-08-12: drop the transparent-PNG
     requirement). accept='image/png' was a hard gate at the OS picker — a
     customer whose logo is a JPG could not select their file at all, which
     reads as a broken button. cleanLogo() still keys out a flat backdrop
     where it can, and the live proof shows exactly what prints. */
  inp.accept = 'image/*';
  inp.onchange = function () {
    if (this.files[0]) handleFile(this.files[0], kind, stateKey);
    if (inp.parentNode) inp.parentNode.removeChild(inp);
    _fileInp = null;
  };
  /* iOS Safari: an input that is not IN the document can silently refuse to
     open the picker ("tapped Both, nothing happened"), and one GC'd mid-pick
     never fires onchange. Attached off-screen + module-pinned covers both. */
  inp.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0';
  /* off-screen + opacity:0 is still FOCUSABLE. Cancelling the OS picker never
     fires onchange, so these used to pile up at the end of <body> as unnamed
     'Choose File' tab stops (4.1.2). Take them out of the tab order, hide them
     from AT, drop any previous one, and sweep this one up on cancel. */
  inp.tabIndex = -1;
  inp.setAttribute('aria-hidden', 'true');
  try {
    var _old = document.querySelectorAll('input[type=file][data-ss-picker]');
    for (var _i = 0; _i < _old.length; _i++) _old[_i].parentNode.removeChild(_old[_i]);
  } catch (_) {}
  inp.setAttribute('data-ss-picker', '1');
  window.addEventListener('focus', function () {
    if (inp.parentNode && !(inp.files && inp.files.length)) {
      try { inp.parentNode.removeChild(inp); } catch (_) {}
    }
  }, { once: true });
  document.body.appendChild(inp);
  _fileInp = inp;
  inp.click();
}

/* Render the gate's verdict: messages, then any acknowledgements the customer
   has to tick before the order will go through. kind picks the host pair
   ('art' \u2192 #art-rep/#art-acks, 'bg' \u2192 #bg-rep/#bg-acks) and the state slot
   the ticks land on. */
/* THE GATE IS UNCHANGED — this only ranks what it says.
   SS_UPLOAD emits one message per check, and printing all of them gave a
   customer six paragraphs to read before they could find the one checkbox
   that unblocks the order. Three rules now:

     · a warning that RAISED AN ACKNOWLEDGEMENT is not printed as a message.
       The acknowledgement says the same thing in the customer's own voice and
       carries the same numbers (the DPI, the crop percentage) — printing both
       was the duplication that made the wall. ss-upload.js tags those
       messages with `ack`, so this is a link, not a guess.
     · everything else collapses into "What we checked", closed by default.
       Nothing is deleted; it is one tap away and screen readers still reach it.
     · the acknowledgements lead, because they are the only part that BLOCKS.

   blockers() is untouched: st[sk].acks still lists every id and every one of
   them still has to be ticked before the order will go through. */
function repHtml(v) {
  var msgs = v.messages || [];
  if (v.tier === 'error') {
    return msgs.map(function (m) {
      return '<div class="m error"><span aria-hidden="true">\u2717</span>' +
             '<span>' + SS.esc(m.text) + '</span></div>';
    }).join('');
  }
  var nAck = repAcks(v).length;
  var rest = msgs.filter(function (m) { return !m.ack; });
  var head = nAck
    ? '<div class="m warning"><span aria-hidden="true">!</span><span>' +
      '<b>Ready to print</b> \u2014 ' + nAck + (nAck === 1 ? ' thing' : ' things') +
      ' to confirm below.</span></div>'
    : '<div class="m pass"><span aria-hidden="true">\u2713</span><span>' +
      '<b>Ready to print.</b> Nothing to confirm \u2014 this will print sharp.</span></div>';
  if (!rest.length) return head;
  return head + '<details class="repmore"><summary>What we checked (' + rest.length +
    ')</summary>' + rest.map(function (m) {
      var icon = m.tier === 'pass' ? '\u2713' : '!';
      return '<div class="m ' + m.tier + '"><span aria-hidden="true">' + icon + '</span>' +
             '<span>' + SS.esc(m.text) + '</span></div>';
    }).join('') + '</details>';
}

/* The upload rights term (owner 2026-08-11), shared by the logo card here and
   mirrored in ss-upload.js validate() for bg/artwork — same id, one flag, one
   meaning: our commercial license covers OUR designs; uploads print under the
   customer's own rights and they must say so. */
var RIGHTS_ACK = { id: 'rights',
  label: 'I own this artwork or have the rights holder’s approval to print it.',
  sub: 'Our included commercial license covers Serial Seal designs only — uploaded artwork prints under your own rights.' };

/* De-duplicated by id. A file more than 10% off-shape trips BOTH shape
   branches in the advisor, which pushed two `offshape` acks — two checkboxes
   writing to one flag, so ticking either left the other looking unticked. */
function repAcks(v) {
  var seen = {}, out = [];
  (v.acks || []).forEach(function (a) {
    if (seen[a.id]) return;
    seen[a.id] = 1; out.push(a);
  });
  return out;
}

function acksHtml(v) {
  return repAcks(v).map(function (a) {
    return '<label class="ack" data-ack="' + a.id + '">' +
      '<input type="checkbox" data-ack-id="' + a.id + '">' +
      '<span><b>' + SS.esc(a.label) + '</b><span>' + SS.esc(a.sub) + '</span></span></label>';
  }).join('');
}

/* One wiring for both hosts — #bg-acks below the uploader and the copy inside
   the fit step. They write the SAME st[sk].acked, so whichever the customer
   uses, the other reflects it the next time it renders. */
function wireAcks(host, sk, after) {
  if (!host) return;
  host.querySelectorAll('input[data-ack-id]').forEach(function (cb) {
    if (st[sk] && st[sk].acked) {
      cb.checked = !!st[sk].acked[cb.dataset.ackId];
      cb.closest('.ack').classList.toggle('on', cb.checked);
    }
    cb.onchange = function () {
      if (!st[sk]) return;
      st[sk].acked[this.dataset.ackId] = this.checked;
      this.closest('.ack').classList.toggle('on', this.checked);
      sync();
      if (after) after();
    };
  });
}

function renderReport(v, busy, kind) {
  kind = kind || 'art';
  var sk = kind === 'bg' ? 'bg' : 'artwork';
  var rep = document.getElementById(kind + '-rep'), acks = document.getElementById(kind + '-acks');
  if (!rep) return;
  if (busy) {
    rep.innerHTML = '<div class="m">' + SS.esc(busy) + '</div>';
    if (acks) acks.innerHTML = '';
    return;
  }
  if (!v) { rep.innerHTML = ''; if (acks) acks.innerHTML = ''; return; }
  rep.innerHTML = repHtml(v);
  if (acks) { acks.innerHTML = acksHtml(v); wireAcks(acks, sk); }
}

function showErr(kind, msg) {
  var e = document.getElementById(kind + '-err');
  if (!e) return;
  e.hidden = !msg; e.textContent = msg || '';
  var d = document.getElementById(kind + '-drop');
  if (d) d.classList.toggle('bad', !!msg);
}

function handleFile(file, kind, stateKey) {
  showErr(kind, '');
  var isLogo = kind === 'logo';

  /* refuse BEFORE the FileReader — see UP_MAX_MB. renderReport(null,...) clears
     any stale "Checking your background..." line so the control does not sit
     there looking busy forever after a refusal. */
  var tooBig = upTooBig(file, kind);
  if (tooBig) {
    showErr(kind, tooBig);
    if (!isLogo) renderReport(null, null, kind);
    try { SS_UI.toast('File too large', true); } catch (_) {}
    return;
  }

  /* Artwork AND background run the full printability gate — same thresholds
     as the VialArt custom-upload flow (200 DPI floor, 600 DPI target, +/-10%
     shape, 20MB). The background design's template is window:'full', so its
     target quotes the WHOLE DIE. */
  if (!isLogo) {
    var what = kind === 'bg' ? 'background' : 'artwork';
    var whatCap = kind === 'bg' ? 'Background' : 'Artwork';
    renderReport(null, 'Checking your ' + what + '\u2026', kind);
    SS_UPLOAD.validate(file, st.tpl, st.orientation).then(function (v) {
      renderReport(v, null, kind);
      if (v.tier === 'error') { st[stateKey] = null; mountUploader(kind, stateKey); sync(); return; }
      var rd2 = new FileReader();
      rd2.onload = function () {
        var im2 = new Image();
        im2.onload = function () {
          if (im2.width * im2.height > UP_MAX_MP * 1000000) {
            showErr(kind, 'That image is ' + im2.width + '×' + im2.height +
              ' — too large to process in a browser. Resize it to about ' +
              '3000×3000 and try again.');
            renderReport(null, null, kind);
            st[stateKey] = null; mountUploader(kind, stateKey); sync();
            return;
          }
          /* JPEG re-encoding fills every transparent pixel with solid black
             (canvas drops alpha over its black backing store), so a
             transparent-background logo uploaded as artwork rendered as a
             black slab in the preview, the cart and the print payload
             (owner bug 2026-08-11). Probe the thumb-sized canvas for alpha
             and keep transparent art as PNG; opaque photos stay JPEG so the
             order payload stays small. */
          var th = downscale(im2, 220, 520, 'image/png');
          var hasAlpha = false;
          try {
            var _d = th.cv.getContext('2d').getImageData(0, 0, th.w, th.h).data;
            for (var _i = 3; _i < _d.length; _i += 4) {
              if (_d[_i] < 250) { hasAlpha = true; break; }
            }
          } catch (_) {}
          var o = hasAlpha ? downscale(im2, 900, 2100, 'image/png')
                           : downscale(im2, 900, 2100, 'image/jpeg', 0.88);
          st[stateKey] = { name: file.name, dataUrl: o.dataUrl, w: v.w, h: v.h,
                         kb: Math.round(o.dataUrl.length / 1365),
                         thumb: hasAlpha ? th.dataUrl
                                         : downscale(im2, 220, 520, 'image/jpeg', 0.75).dataUrl,
                         dpi: v.dpi, ratio: v.ratio,
                         note: v.dpi + ' DPI',
                         report: v,          // survives control re-renders
                         acks: v.acks.map(function (a) { return a.id; }),
                         acked: {} };
          mountUploader(kind, stateKey);
          uploadFile(stateKey);
          refreshGridSoon();     // repaint the gallery tiles with THEIR image
          sync();
          /* THE FIT STEP (owner 2026-08-07: "after upload a new container
             should open and allow them to scale / move the bg if it doesnt
             fit ... and then click confirm to save and then it shows
             pricing"). It opens on every accepted upload, so the customer
             sees their picture inside the real die shape before they see a
             price, and the acknowledgements are answered where they are
             already looking instead of below the fold. */
          ssFitOpen(kind, stateKey);
        };
        im2.src = rd2.result;
      };
      rd2.readAsDataURL(file);
    });
    return;
  }

  /* Logos take any image the browser can decode (owner 2026-07-28: "let them
     upload any image file that will show on the live preview proof"). The
     earlier PNG-only rule existed because transparency is what makes a logo
     sit on the foil — but the customer can SEE the result in the live proof,
     so the honest move is to key out what we can, show them exactly what
     prints, and let them decide. cleanLogo still runs on everything: a JPEG,
     or a PNG flattened onto white, gets its backdrop keyed out where possible
     and a warning where not. Whatever we keep is re-encoded to PNG below. */
  var rd = new FileReader();
  rd.onload = function () {
    var im = new Image();
    im.onload = function () {
      if (im.width * im.height > UP_MAX_MP * 1000000) {
        showErr(kind, 'That image is ' + im.width + '×' + im.height +
          ' — too large to process in a browser. Resize it to about ' +
          '3000×3000 and try again.');
        return;
      }
      if (isLogo) {
        /* Analyse and clean the canvas we actually keep, so the backdrop we key
           out is gone from the stored artwork too — not just from the check. */
        var out = downscale(im, 700, 700, 'image/png');
        var rep = cleanLogo(out.cv);
        if (rep.unreadable) {
          showErr(kind, 'That file could not be read. Try exporting it again, or upload a different image.');
          return;
        }
        if (!rep.blank && faintLogo(out.cv)) {
          showErr(kind, 'This logo won\u2019t show up on the seal. It\u2019s almost all white, silver or ' +
            'chrome with no dark lines, and the printer has no white ink \u2014 light areas print as the ' +
            'bare holographic foil, so the logo disappears into it. Please upload a version with black ' +
            'or strong-colour lines or lettering.');
          return;
        }
        /* Blank and solid-box used to be dead ends. They are now warnings: the
           preview beside this control shows exactly what would print, so the
           customer can see the box for themselves and either accept it or
           upload something else. Only an undecodable file still blocks. */
        var logoWarn = '';
        if (rep.blank) {
          logoWarn = 'This looks blank — check the preview shows your logo.';
        } else if (rep.opaque) {
          /* no automatic removal any more — just say plainly what opaque does */
          logoWarn = 'This file has a solid background, so that background prints as a block ' +
            'over the foil — see the preview. Artwork with a transparent background sits ' +
            'directly on the material, but either one prints.';
        }
        var thumbCv = document.createElement('canvas');
        var ts = Math.min(220 / out.cv.width, 220 / out.cv.height, 1);
        thumbCv.width = Math.max(1, Math.round(out.cv.width * ts));
        thumbCv.height = Math.max(1, Math.round(out.cv.height * ts));
        thumbCv.getContext('2d').drawImage(out.cv, 0, 0, thumbCv.width, thumbCv.height);
        var cleanUrl = out.cv.toDataURL('image/png');
        st.logo = { name: file.name, dataUrl: cleanUrl, w: im.width, h: im.height,
                    kb: Math.round(cleanUrl.length / 1365),
                    thumb: thumbCv.toDataURL('image/png'),
                    plate: !!rep.plate,
                    /* NO rights CHECKBOX on a logo (owner 2026-08-12). The term
                       still reaches the customer — it is stated under the logo
                       row — it just no longer gates the order. */
                    acks: [], acked: {},
                    note: (rep.opaque ? 'prints as uploaded' : 'transparent') +
                          (rep.plate ? ' · dark backing added' : '') };
        /* logos always take the window, front and centre */
        st.logoMode = 'window';
        mountUploader('logo', 'logo');
        uploadFile('logo');
        /* Narrowing the gallery to the logo layouts is now the ANSWER to a
           question they were asked, not a surprise: do it when they came in
           through the logo fork or haven't answered it yet, and leave them
           alone when they are deliberately browsing our designs — there a logo
           is a corner mark on the design they already picked, not a reason to
           pull the gallery out from under them. */
        if (st.path !== 'gallery') setPath('logo', true);
        updateGate(); refreshGridSoon(); renderExtras();
        if (logoWarn) {
          showErr(kind, logoWarn);          // shown, but the order still proceeds
          SS_UI.toast('Logo added — check the preview', true);
        } else {
          SS_UI.toast(rep.cleaned ? 'Logo added — background removed' : 'Logo added');
        }
      }
      sync();
    };
    im.onerror = function () { showErr(kind, 'That image could not be decoded.'); };
    im.src = rd.result;
  };
  rd.readAsDataURL(file);
}

/* ——————————————— validation + order gate ——————————————— */
/* An address with an @ and a dotted domain and no slashes is an EMAIL, not a
   site (owner 2026-08-14: "your email also accepted it will be mailto link if
   entered"). Checked before the https:// fallback, because that fallback would
   otherwise turn hello@shop.com into https://hello@shop.com — a URL whose
   userinfo is the mailbox and whose host is the domain. That scans, opens a
   browser, and lands nowhere. */
var EMAIL_RE = /^[^\s@\/]+@[^\s@\/,;:]+\.[a-z]{2,}$/i;
function isEmailLink(u) {
  return EMAIL_RE.test(String(u || '').trim().replace(/^mailto:/i, ''));
}
function normUrl(u) {
  u = String(u || '').trim();
  if (!u) return '';
  if (/^mailto:/i.test(u)) return u;
  if (isEmailLink(u)) return 'mailto:' + u;             // scans open a new email
  if (!/^https?:\/\//i.test(u)) u = 'https://' + u;   // nobody types the scheme — add it for them
  return u;
}
/* ═══ A LINK PER SEAL (owner 2026-10-20) ═══════════════════════════════════
   "if they add 20 serials it will require them to add 20 links + 20 serials
   for each of the specific links that will be QR codes ... an extra $.10 per
   seal". The sheet engine is assets/sv-qrlist.js (SVQL); these are the hooks.
   The mode is offered only when its fee product is live (SS_QRLIST_CFG) and
   SVQL.PUBLIC is on - or this browser opened the builder with ?qrlist=1 (a
   testing door that never leaves the session). */
var QRLIST = { cfg: window.SS_QRLIST_CFG || {} };
QRLIST.ok = !!(QRLIST.cfg.variantId && QRLIST.cfg.publishedAt && window.SVQL);
function qrListOffered() {
  if (!QRLIST.ok) return false;
  if (SVQL.PUBLIC) return true;
  try {
    if (/[?&]qrlist=1(?:&|$)/.test(location.search)) sessionStorage.setItem('ss_qrlist', '1');
    return sessionStorage.getItem('ss_qrlist') === '1';
  } catch (_) { return false; }
}
/* the sheet row the preview shows (the one tapped in the review, else #1) */
function qrListRow() {
  var l = st.qrMode === 'list' ? st.qrList : null;
  if (!l || !l.ok || !l.rows.length) return null;
  return l.rows[Math.max(0, Math.min(l.rows.length - 1, l.pick || 0))];
}
/* what still stops a per-seal-link order - every line of it a reason a
   seal could not be printed as asked. Nothing here is repaired for them. */
function qrListProblem() {
  if (st.qrMode !== 'list') return null;
  if (!qrListOffered()) return 'A link per seal isn\u2019t available right now \u2014 choose another QR option';
  if (st.sealStyle === 'duo') return 'Duo labels share one QR code \u2014 choose another shape for a link per seal';
  if (st.qty > SVQL.LIMITS.MAX_ROWS) {
    return 'A link per seal takes up to ' + SVQL.LIMITS.MAX_ROWS.toLocaleString('en-US') +
           ' seals per design \u2014 lower the quantity or split it into two designs';
  }
  var l = st.qrList;
  if (!l) return 'Upload your sheet of serials and links';
  if (!l.ok) {
    return 'Fix the ' + (l.errs.length === 1 ? 'problem' : l.errs.length.toLocaleString('en-US') + ' problems') +
           ' in your sheet and upload it again';
  }
  if (l.n !== st.qty) {
    return 'Your sheet has ' + l.n.toLocaleString('en-US') + ' rows but you\u2019re ordering ' +
           st.qty.toLocaleString('en-US') + ' seals \u2014 one row per seal';
  }
  if (!l.ack) return 'Tick that you\u2019ve checked your serials and links';
  return null;
}
/* the panel's view of the builder */
function qrListApi() {
  return {
    qty: function () { return st.qty; },
    list: function () { return st.qrList; },
    set: function (l) { st.qrList = l; refreshGridSoon(); sync(); },
    pick: function () { refreshGridSoon(); sync(); },
    minSeals: function () { return effMinPacks() * PACK_UNIT; },
    maxSeals: function () { return Math.min(PAID_MAX, SVQL.LIMITS.MAX_ROWS); },
    setQty: function (n) { setPaid(n); }
  };
}
/* The fee: ONE line, quantity = the seals, $0.10 each, tied to the seal line
   by the sheet's checksum so the cart page can keep the two in step (and drop
   a fee whose seals are gone). PUBLIC properties say what it is at checkout. */
function qrListFeeLine(list, seals) {
  return {
    id: QRLIST.cfg.variantId,
    quantity: seals,
    properties: {
      'Service': 'A link per seal \u2014 each seal\u2019s QR opens its own link from your sheet',
      'Seals': String(seals),
      '_ss_qrlist': '1',
      '_qrlist_for': list.sha
    }
  };
}
/* drop the fee line(s) that belonged to a seal line being replaced */
function removeQrFee(sha) {
  if (!sha) return Promise.resolve();
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var hits = (cart.items || []).filter(function (it) {
        return it.properties && String(it.properties._qrlist_for || '') === String(sha);
      });
      return hits.reduce(function (chain, it) {
        return chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: 0 })
          });
        });
      }, Promise.resolve());
    })
    .catch(function () {});
}

/* A BLANK link is not a problem — it means "no code on this seal", which is a
   perfectly orderable seal and must never block the CTA (a customer who
   touches nothing has to be able to buy). Only a link that is present and
   unusable is an error. */
function qrProblem() {
  if (st.qrMode !== 'own' && st.qrMode !== 'business') return null;
  var raw = String(st.qr || '').trim();
  /* Blank is fine on an OWN-link seal — it just prints no code, which is a
     perfectly orderable seal. On a BUSINESS seal it is not: the code is
     printed either way and a code with no destination scans to nothing, which
     reads exactly like a dud seal. So the destination is required there. */
  if (!raw) return st.qrMode === 'business'
    ? 'Add the web address your Business QR opens' : null;
  /* A QR is a link the buyer's phone opens on sight. Script and inline-payload
     schemes have no business on a printed seal, and normUrl() would otherwise
     paste https:// in front and ship the mangled result. */
  if (/^\s*(javascript|data|vbscript|file|blob):/i.test(raw)) {
    return 'That link can’t be used — enter a website or profile address';
  }
  /* mailto: has no hostname, so it has to clear before the host test below —
     otherwise a perfectly good email address is rejected as "not a full web
     address" */
  if (isEmailLink(raw)) return null;
  var host = '';
  try { host = new URL(normUrl(raw)).hostname; } catch (_) { host = ''; }
  if (!host || host.indexOf('.') < 0 || /\s/.test(host)) {
    return 'Enter a web address or an email, like instagram.com/yourshop';
  }
  /* THE CODE PRINTS ~7mm WIDE. Every character raises the QR version and
     shrinks the modules, and past roughly version 4 a phone camera stops
     locking onto it at seal size (owner 2026-08-18: "too long and camera
     can't pick it up"). 60 encoded bytes keeps it at version 3-4 with
     comfortable module size. The BUSINESS mode is exempt — the foil carries
     our short code, never the destination. */
  if (st.qrMode === 'own' && normUrl(raw).length > 60) {
    return 'That link is too long to scan at seal size — keep it under ' +
      (60 - (normUrl(raw).length - raw.length)) +
      ' characters, or use a short link (bit.ly, linktr.ee)';
  }
  return null;
}
/* Numbering is the only kind there is, so this one really can block the order:
   a seal with no number is not the product. It only ever fires when the
   customer has deliberately cleared the field — it ships defaulted to 001. */
function serialProblem() {
  /* plain stickers carry no number at all — nothing to enter, nothing to
     outgrow the 11.2mm slot, so numbering can never block the order. Before
     BOTH tests below: serialAt() on a 'none' order would measure a number
     that is not going to print. */
  if (st.serialType === 'none') return null;
  /* random has no start number to enter — the codes are not counted */
  if (st.serialType !== 'rand' &&
      !/^\d{1,9}$/.test(String(st.serialStart || '').trim())) {
    return 'Enter the first serial number';
  }
  if (st.serialType === 'batch' && !batchSeg()) {
    return 'Enter a batch code, like ' + defaultBatch();
  }
  /* LENGTH IS LEGIBILITY, not layout: the serial is fitted into an 11.2mm slot,
     so every extra character sets the number smaller, and past SERIAL_MAX it
     drops under the ~1.3mm at which it can still be read off foil and said
     down a phone. Checked at BOTH ends of the run because a sequence that
     outgrows its pad gets longer as it goes (999 → 1000). */
  var n = Math.max(serialAt(0).length, serialAt(Math.max(0, st.qty - 1)).length);
  if (n > SERIAL_MAX) {
    return 'That numbering runs to ' + n + ' characters — shorten it to ' +
           SERIAL_MAX + ' or the number prints too small to read';
  }
  return null;
}

/* Ordered list of what is still missing, in the order of the NEW flow —
   details first, then the chosen design's needs, then quantity. The first
   entry drives the CTA. */
function blockers() {
  var c = caps(), out = [];
  /* Large is orderable exactly when its product is live with a purchasable
     variant (availability-driven: Draft -> Active is the one switch) */
  if (st.sizeId && st.sizeId !== 'standard_177x075') {
    var _lgP = productForSize();
    var _lgOk = !!(_lgP && (_lgP.variants || []).some(function (v) { return v.available !== false; }));
    if (!_lgOk) out.push('The Large size is coming soon \u2014 switch back to Standard to order');
  }
  /* a foil whose press is down is sold out in Shopify; the picker auto-moves
     off it, this is the belt for a stale page */
  if (materialSoldOut(st.material))
    out.push(materialNotOnSize(st.material)
      ? st.material + ' is Standard size only \u2014 choose another stock or switch to Standard'
      : st.material + ' is temporarily unavailable \u2014 choose another stock');
  /* noBrand() is an ANSWER to this blocker, not a bypass of it: it is only
     ever true when a logo is attached, so the seal still carries something
     that says whose it is. gateOk() states the same rule one way
     (`brand || logo`); this states it the other.
     ⚠ assets/sv-sticky-cta.js pattern-matches this exact string to rewrite a
     CTA tap into a jump to #f-brand. Suppressing it here is correct — there
     is no field for that rescue to jump to when the name is off. */
  if (c.supportsTitle !== false && !noBrand() && !st.brand.trim())
    out.push('Enter your brand name');
  /* a design with no QR slot can't be blocked by the QR options */
  var q = c.supportsQR ? qrProblem() : null; if (q) out.push(q);
  var ql = c.supportsQR ? qrListProblem() : null; if (ql) out.push(ql);
  /* POS + plain stickers is incoherent, not merely odd: the payload IS the
     serial, and a plain sticker has no serial, so ss-seal.js prints no code
     at all (the noSerial guard at its qrLink site). Refusing is the honest
     answer -- silently forcing numbering back on would change what they
     bought, and silently shipping a codeless seal under an "Item code" chip
     is exactly the surprise this blocks. */
  if (c.supportsQR && st.qrMode === 'sku' && st.serialType === 'none') {
    out.push('Item codes need numbering \u2014 choose Unique serials, or pick a ' +
             'different QR option');
  }
  var sp = serialProblem(); if (sp) out.push(sp);
  if (!st.tpl) { out.push('Choose a seal design'); return out; }
  /* a background design cannot ship without its background — the seal IS the
     customer's image; and warnings must be acknowledged, same as artwork */
  if (c.requiresBackground && !st.bg) out.push('Upload your design (tap the Upload Your Own tile)');
  /* ack checks hang on the upload EXISTING, not on the design requiring it —
     an optional layer still carries its warnings and the rights agreement
     (owner 2026-08-11: uploads print under the customer's rights, and they
     must say they have them) */
  else if (st.bg && (st.bg.acks || []).some(function (id) {
    return !st.bg.acked[id];
  })) out.push('Confirm the background notes');
  if (c.requiresArtwork && !st.artwork && !st.logo) {
    out.push(c.allowsLogo ? 'Upload your artwork or a logo' : 'Upload your artwork');
  }
  else if (st.artwork && (st.artwork.acks || []).some(function (id) {
    return !st.artwork.acked[id];
  })) out.push('Confirm the artwork notes');
  if (c.requiresLogo && !st.logo) out.push('Add your logo');
  if (!st.qty) out.push('Choose how many seals you need');
  /* THE BELT ON THE CART-WIDE MINIMUM. setPaid() clamps, but the cart can
     change after it clamped: the 60-seal line that bought this design down to
     one pack is removed on /cart, the customer comes back to this tab, and
     without this the 12-seal line is still addable. onCartRead() raises the
     quantity for them; this refuses the add if anything ever gets past it. */
  else if (st.qty < effMinPacks() * PACK_UNIT) {
    out.push('Order at least ' + sealNum(effMinPacks() * PACK_UNIT) + ' seals');
  }
  return out;
}

/* ——————————————— quantity: the VialArt stepper, copied exactly ———————————
   No pack tiles — a −/+ stepper, the deal shown as an equation
   (100 paid + 20 FREE = 120 seals), the tier grid, the net price with the gross
   struck through, and a nudge to the next tier. All updates happen IN PLACE so
   focus is never destroyed.

   ⚠ THE BIG NUMBER IN THE BOX IS `p.n`, THE TOTAL. It was `p.paid` until
   2026-08-06, under a label that said "seals" — so a customer buying one set
   read "10 seals", received 12, and had no way to reconcile the ladder with
   what was in front of them. One press of −/+ still moves the order by one
   PACK; in this box that reads as ±PACK_UNIT seals, which is what the button
   aria-labels say. Internally nothing changed: setPaid() and applyTier() still
   take PAID seals and PACKS respectively. */
function renderPacks() {
  /* first, and above the #ss-qin guard: the hero is a separate surface and
     must not stop tracking the order just because the stepper went missing */
  renderHeroQty();
  var inp = document.getElementById('ss-qin');
  if (!inp) return;
  var p = pack();
  if (document.activeElement !== inp) inp.value = p.n;
  var _sl = document.getElementById('ss-qsl');
  if (_sl && document.activeElement !== _sl && window._packsToQsl) {
    _sl.value = _packsToQsl(p.packs);
  }
  /* The equation is the ONE place the paid count belongs, because the split is
     the thing being shown — and it is labelled "paid" outright so it can never
     be mistaken for the order size. It ends on the same total as the box above,
     which is where the total comes from. */
  /* No more paid/free split — the ladder prices per seal, so the equation
     states the RATE the order actually lands on (owner 2026-08-12). */
  document.getElementById('ss-qdeq').innerHTML =
    '<span class="qd-chip qd-tot"><b>' + p.n + '</b> seals</span><i>×</i>' +
    '<span class="qd-chip">' + fmtPerSeal(p.price / p.n) + ' each</span><i>=</i>' +
    '<span class="qd-chip"><b>' + fmtMoney(p.price) + '</b></span>';
  /* which chip is lit, derived from the ladder — markTierState() matches on
     data-sstier, so this index is only "how many rungs are earned" (0 = none,
     i.e. the 60-119 band, where no chip lights) */
  /* THE LADDER COUNTS THE ORDER, BUT A CHIP LIGHTS OFF THE LINE.
     p.poolPacks adds the seals of the SAME product already in the cart, which
     is what Shopify's automatic discount counts (see quoteFor), so the RATE,
     the nudge's delta and the #ss-qpool note all read `_pool` below.
     The lit state does NOT, and cannot: every chip's data-sstier is an
     ABSOLUTE rung and applyTier() sets THIS LINE to it, so lighting off the
     pool turned the lit chip into a 10x quantity control - 108 carted + 12
     here lit "120+ seals" while the line held 12, and tapping that already-
     pressed chip set the line to 120 (found 2026-09-08). A control has to
     light for the state its own tap produces.
     The pooled rate is not lost by this: #ss-qper states it outright with no
     chip lit, which is exactly the case the note under #ss-qper already
     blesses ("a customer at 240 seals is on 25% off with no chip to light"),
     and #ss-qpool says where it came from. */
  var _pool = p.poolPacks || p.packs;
  var asc = bulkAsc(), onIdx = 0;
  for (var ti = 0; ti < asc.length; ti++) if (p.packs >= asc[ti][0]) onIdx = ti + 1;
  /* the chips are controls now, so the lit one also has to SAY it is the active
     one — markTierState() carries the same state to #ph-tiers and to aria-pressed */
  markTierState(onIdx, asc);
  /* the strip's tiles include the two LIST rungs, so the lit one is the tile
     of the band THIS LINE is in — same reason as onIdx above: the tile is a
     control that sets its own absolute, so it must light for what it sets */
  var _band = 0;
  document.querySelectorAll('#ss-qtier .qd-tier').forEach(function (t2) {
    var th2 = parseInt(t2.getAttribute('data-sstier'), 10);
    if (p.packs >= th2 && th2 >= _band) _band = th2;
  });
  document.querySelectorAll('#ss-qtier .qd-tier').forEach(function (t2) {
    var on2 = parseInt(t2.getAttribute('data-sstier'), 10) === _band;
    t2.classList.toggle('on', on2);
    t2.setAttribute('aria-pressed', on2 ? 'true' : 'false');
  });
  var was = document.getElementById('ss-qwas');
  if (p.rate) { was.style.display = ''; was.textContent = fmtMoney(p.gross); }
  else was.style.display = 'none';
  document.getElementById('ss-qtot').textContent = fmtMoney(p.price);
  /* One line beside the total: what they saved, then what a seal costs.
     per-seal divides by the TOTAL including the free ones — the deal IS the
     lower per-seal number (VialArt: $8.99/12 = $0.75, not $0.90). The saving
     is quoteFor()'s own truncated figure, so struck-through gross minus this
     equals the price shown, exactly. */
  var per = fmtPerSeal(p.price / p.n) + ' per seal';
  /* The RATE leads this line now. It used to be readable only off the lit chip,
     and since CHIP_SHOW the strip does not carry every rung — a customer at 240
     seals is on 25% off with no chip to light. Their discount must not be
     something they can only infer from a struck-through number. pctOf(), like
     every other statement of a rate, so it can never round 42.6 up to 43. */
  document.getElementById('ss-qper').textContent =
    p.rate ? pctOf(p.rate) + '% off — you save ' + fmtMoney(p.save) + ' · ' + per
           : per;
  /* SAY WHY THE RATE IS WHAT IT IS. Same reason the rush note names both
     halves (owner 2026-08-11, "$119.99 stuck at that"): a discount that came
     from a design already in the cart reads as a mistake on a line that is too
     small to have earned it. Named per SIZE, because Standard and Large sit
     behind separate Shopify discounts and never pool with each other. */
  var _other = _pool - p.packs;
  var _poolEl = document.getElementById('ss-qpool');
  if (_other > 0 && !_poolEl) {
    _poolEl = document.createElement('div');
    _poolEl.id = 'ss-qpool';
    _poolEl.style.cssText = 'margin-top:4px;font-size:12px;line-height:1.45;color:var(--muted)';
    var _perEl2 = document.getElementById('ss-qper');
    if (_perEl2 && _perEl2.parentNode) {
      _perEl2.parentNode.insertBefore(_poolEl, _perEl2.nextSibling);
    }
  }
  if (_poolEl) {
    _poolEl.style.display = _other > 0 ? '' : 'none';
    if (_other > 0) {
      _poolEl.textContent = 'Discounts count your whole order: ' +
        sealNum(_other * PACK_UNIT) + ' ' +
        (st.sizeId === 'large_250x100' ? 'Large' : 'Standard') +
        ' seals already in your cart + ' + sealNum(p.n) + ' here = ' +
        sealNum(_pool * PACK_UNIT) + ' toward the tier';
    }
  }
  /* The big number above is the SEALS total, and it has to stay that: the chips,
     the ladder and every marketing figure on this site quote it. The fee is
     stated right underneath so nothing on screen pretends the order is cheaper
     than it is.

     ⚠ IT DELIBERATELY DOES NOT ADD THE TWO UP. All twelve "Bulk seals"
     automatic discounts are scoped to ALL PRODUCTS on this store, not to the
     seal product, so Shopify takes the tier off the $29.99 line as well: at
     600 seals a measured cart charged $287.70, not the $299.69 that
     seals + fee comes to. A combined total printed here would be a number
     checkout does not honour, which is the one defect this file has fixed more
     times than any other. Once the discounts are scoped to the seal product
     the arithmetic becomes true and this can state a real total — until then
     it names the fee and stops. */
  paintRush();                 /* the tier follows the quantity box, live */
  var dayEl = document.getElementById('ss-dayline');
  var wantDay = st.rush && RUSH.ok;
  if (wantDay && !dayEl) {
    dayEl = document.createElement('div');
    dayEl.id = 'ss-dayline';
    var perEl = document.getElementById('ss-qper');
    if (perEl && perEl.parentNode) perEl.parentNode.appendChild(dayEl);
  }
  if (dayEl) {
    dayEl.style.display = wantDay ? '' : 'none';
    if (wantDay) {
      dayEl.textContent = '+ ' + rushPriceStr() + ' priority production, added at checkout';
    }
  }
  /* Near-miss nudge, in SEALS. This is the line most exposed to the paid-vs-
     total bug, because it names a number the customer is told to ADD: if the
     seals it asks for are not the seals that actually cross the threshold, it
     sends them to a discount they then don't get. So the gap is measured in
     PACKS against the ladder — the unit the discount counts — and only then
     multiplied by PACK_UNIT for display. Both sides of that multiplication are
     whole packs, so "24 more seals" earns the tier exactly, with nothing over
     and nothing short. */
  var nudge = document.getElementById('ss-qnudge');
  var nx = nextTier(_pool);
  /* THE BUTTON MUST BUY THE SEALS IT NAMES. The gap is measured against the
     POOL, because that is the count Shopify's discount reads - but applyTier()
     sets THIS LINE, so the target the button carries has to be the pooled rung
     MINUS the packs already carted. Carrying nx[0] raw made the two disagree
     the moment the cart held seals: 60 carted + 24 here offered "36 more seals
     -> 10% off" and bought 96 (found 2026-09-08), which is this file's own
     cardinal sin - a chip must name the quantity it actually buys.
     nextTier() guarantees nx[0] > _pool >= _otherPk, so _tgtPk is at least 1
     and always strictly above p.packs: the nudge is never a silent no-op. */
  var _otherPk = Math.max(0, _pool - p.packs);
  var _tgtPk = nx ? Math.max(1, nx[0] - _otherPk) : 0;
  /* tierReachable guard: if a future ladder ever puts a tier past PAID_MAX, the
     nudge must go quiet rather than name a target the stepper cannot hold. It
     tests the LINE target, which is what the stepper has to hold - a pooled
     rung may legitimately sit above what one line is allowed to carry. */
  var _nudgeHadFocus = nudge.contains(document.activeElement);
  if (nx && tierReachable(_tgtPk)) {
    var needSeals = sealNum((nx[0] - _pool) * PACK_UNIT);
    nudge.style.display = '';
    /* The highest-intent, lowest-risk line on the page: it names exactly ONE
       unambiguous target, upward by definition, so it is the button that goes
       there. data-sstier carries the LINE target (_tgtPk), not the pooled rung
       — applyTier() is unchanged and the delegated listener below is still
       shared with the chips; only the number handed to it is line-relative. */
    nudge.innerHTML = '<button type="button" class="qn-go" data-sstier="' + _tgtPk + '"' +
      ' aria-label="Add ' + needSeals + ' more seals' +
      ' to get ' + pctOf(nx[1]) + ' percent off your whole order">' +
      '<b>' + needSeals + ' more seals</b>' +
      '<span>→</span><b>' + pctOf(nx[1]) + '% off</b>' +
      '<span>your whole order</span></button>';
    /* SC 2.4.3: pressing this rebuilds the very button that was pressed (the
       nudge re-renders for the NEXT rung), so focus was landing on <body>.
       Only re-focus if the customer was actually in here — otherwise a
       quantity typed elsewhere would yank focus across the page. */
    if (_nudgeHadFocus) _refocus('#ss-qnudge .qn-go');
  } else nudge.style.display = 'none';
}

function setPaid(paid) {
  _qtyUserSet = true;          /* every path here is the customer's own hand */
  paid = Math.round((parseInt(paid, 10) || PACK_PAID) / PACK_PAID) * PACK_PAID;
  var _minPk = effMinPacks();  /* cart-wide since 2026-09-05 */
  var _min = _minPk * PACK_PAID;
  /* NEVER SILENTLY OVERWRITE A TYPED QUANTITY (owner 2026-08-17, funnel
     audit): the old clamp rewrote 12 -> 60 with no message anywhere, at the
     exact moment the price wall bit. The clamp stays — a pack is the
     smallest buyable unit — but the customer is told what happened. */
  if (paid < _min) {
    SS_UI.toast('Smallest run is ' + (_minPk * PACK_UNIT) + ' seals (' +
      fmtMoney(_minPk * packUnitPrice()) + ') — set to the minimum');
  } else if (paid > PAID_MAX) {
    SS_UI.toast('Self-serve tops out at ' + PAID_MAX.toLocaleString() +
      ' seals — bigger runs get volume pricing (link below the chips)');
  }
  paid = Math.max(_min, Math.min(PAID_MAX, paid));
  st.qty = (paid / PACK_PAID) * PACK_UNIT;   // st.qty stays the TOTAL seal count
  renderPacks();
  sync();
  /* the duo note leads with this quantity's cut math - keep it live */
  if (st.sealStyle === 'duo' && typeof setDims === 'function') {
    try { setDims(); } catch (_) {}
  }
}

/* The customer-facing door onto setPaid(). The quantity input holds TOTAL seals
   now, so what arrives from it has to be converted before it reaches the one
   quantity path — every clamp, round and re-render still happens exactly once,
   inside setPaid(). Deliberately a thin wrapper and NOT a second quantity
   setter: setPaid() (the −/+ buttons) and applyTier() (every discount chip)
   keep their PAID/PACK arguments untouched, so the verified chip behaviour does
   not move. Rounds to the nearest whole pack because a pack is the smallest
   thing that can be bought — typing 100 buys 108 seals (9 packs), not 100. */
function setSeals(total) {
  var t = parseInt(total, 10);
  if (!isFinite(t) || t < 1) t = effMinPacks() * PACK_UNIT;
  /* pass the raw pack count through — setPaid owns the floor and SAYS so */
  setPaid(Math.max(1, Math.round(t / PACK_UNIT)) * PACK_PAID);
}

/* ——————————————— summary + sync ——————————————— */
function summaryRows() {
  var c = caps(), p = pack(), rows = [];
  var catLabel = { designer: 'Designer seal', logo: 'Logo seal', artwork: 'Upload artwork' }[c.category];
  rows.push(['Design', st.tpl.name]);
  /* Only when the category actually has a label — the default template's
     category is 'cards', which is unmapped, and pushing it anyway printed
     'Type undefined' to every default-path buyer. */
  if (catLabel) rows.push(['Type', catLabel]);
  /* the review screen must say which SIZE is selected (sweep 2026-08-29) */
  var _zRow = (window.SS_SEAL && SS_SEAL.SIZES && SS_SEAL.SIZES[st.sizeId]) ||
              { displayName: 'Standard', longIn: 1.77, shortIn: 0.75 };
  rows.push(['Size', _zRow.displayName + ' — ' + _zRow.longIn + '″ × ' + _zRow.shortIn + '″']);
  rows.push(['Style', (st.orientation === 'landscape' ? 'Landscape' : 'Portrait') +
    (st.sealStyle === 'topfold2' ? ' · Toploader Banner (wraps the top)'
     : st.sealStyle === 'topfold' ? ' · Slab Banner (wraps the top)'
     : st.sealStyle === 'fold' ? ' · Folded (wraps the seam)' : ' · Single (flat)')]);
  /* Accent appears only when a reorder actually carried one — with the picker
     gone, "Design default" on every summary is noise, not information. */
  if (c.supportsAccent !== false && st.color) {
    var cName = st.color;
    COLORS.forEach(function (p) { if (p[0].toLowerCase() === st.color.toLowerCase()) cName = p[1]; });
    rows.push(['Accent', cName]);
  }
  /* Leads with the TOTAL seal count — the number the customer chose, the number
     on the chips and the number in the box two steps up. The paid/free split
     follows as the explanation of the price, not as the quantity.
     Sized to match, not just ordered: {html:} opts this one value out of the
     SS.esc() path so the total can be set 19px and the split 11.5px (see
     .v-seals in the section stylesheet). Safe because every character of that
     string is a number this file computed — st.qty, p.paid, p.free — with no
     customer input anywhere near it. Any row that carries typed text must keep
     going through SS.esc. */
  rows.push(['Quantity', { html: st.sealStyle === 'duo'
    ? '<b>' + sealNum(st.qty) + ' labels = ' + sealNum(st.qty * 2) + ' seals cut</b><em>' +
      fmtPerSeal(p.price / p.n) + ' per label</em>'
    : '<b>' + sealNum(st.qty) + ' seals</b><em>' +
      fmtPerSeal(p.price / p.n) + ' each</em>' }, 'v-seals']);
  /* The numbering is the customer's own arithmetic, so the summary can quote
     exactly what will print — first number to last, across the whole order. */
  var _dnR = st.sealStyle === 'duo' ? 2 : 1;
  rows.push(['Serials', st.qrMode === 'list'
    ? (st.qrList && st.qrList.ok
        ? st.qrList.n.toLocaleString('en-US') + ' from your sheet \u2014 ' + st.qrList.rows[0].serial +
          ' \u2192 ' + st.qrList.rows[st.qrList.n - 1].serial
        : 'From your sheet \u2014 not uploaded yet')
    : st.serialType === 'none'
    ? 'None — identical seals, no numbers printed'
    : st.serialType === 'rand'
    ? (st.qty * _dnR) + ' random codes — like ' + serialAt(0) + ', no two alike' +
      (_dnR === 2 ? ' (2 per label)' : '')
    : serialAt(0) + ' → ' + serialAt(Math.max(0, st.qty * _dnR - 1)) +
      (st.serialType === 'batch' ? ' — batch ' + batchSeg().replace(/-$/, '')
                                 : ' — your own numbering')]);
  if (st.grade) rows.push(['Grade', st.grade]);
  rows.push(['QR code', !c.supportsQR ? 'Not on this design'
    : st.qrMode === 'list'
        ? (st.qrList && st.qrList.ok
            ? 'A link per seal \u2014 ' + st.qrList.n.toLocaleString('en-US') + ' links from your sheet'
            : 'A link per seal \u2014 upload your sheet')
    : st.qrMode === 'none' ? 'None — the seal prints without a code'
    : st.qrMode === 'sku'
        ? 'Item code \u2014 each seal\u2019s code is its own serial, for ' +
          'scanning at a till'
    : st.qrMode === 'business'
        ? (qrProblem() ? 'Business QR — destination not set yet'
           : 'Business QR — points to ' + normUrl(st.qr) + ', changeable any time')
    : qrProblem() ? 'Your own link — not valid yet'
    : normUrl(st.qr) ? 'Scans to ' + normUrl(st.qr)
    : 'None — no link added, the seal prints without a code']);
  /* The plan is money, so it says so on the review screen even though it is a
     separate cart line — a customer must never first meet a $359.88 charge at
     checkout. 'Active' says the opposite just as plainly. */
  if (st.qrMode === 'business') {
    rows.push(['Business plan', BIZ.state === 'active'
      ? 'Already active — no extra charge' + (BIZ.endsOn ? ' (through ' + BIZ.endsOn + ')' : '')
      : bizBillingLine()]);
  }
  /* the fee is money, so it is on the review screen like the plan is */
  if (st.qrMode === 'list' && st.qrList && st.qrList.ok) {
    rows.push(['Per-seal links', st.qrList.n.toLocaleString('en-US') + ' \u00d7 $0.10 = ' +
               fmtMoney(st.qrList.n * 0.10) + ' \u2014 its own line in the cart']);
  }
  if (c.requiresBackground) rows.push(['Background', st.bg ? st.bg.name : 'Not uploaded']);
  if (c.requiresArtwork) rows.push(['Artwork', st.artwork ? st.artwork.name : 'Not uploaded']);
  if (c.requiresLogo) rows.push(['Logo', st.logo ? st.logo.name : 'Not uploaded']);
  /* both layers on the line: the review screen must say which one wins where,
     because it is the last surface before money changes hands */
  if (logoPlaceOn()) {
    var lpc = logoPlace();
    rows.push(['Your logo', lpc === 'off'
      ? 'Not printed separately \u2014 already in your picture'
      : lpc === 'mark' ? 'Above your name, over your picture'
      : 'On your picture, centred in the frame']);
  }
  return rows.map(function (r) {
    /* r[1] is escaped text by default; {html:...} is the opt-out for the one
       row that needs markup, and r[2] is an optional extra class on the value */
    var v = (r[1] && r[1].html) ? r[1].html : SS.esc(String(r[1]));
    return '<div class="sumline"><span class="k">' + r[0] + '</span>' +
      '<span class="v' + (r[2] ? ' ' + r[2] : '') + '">' + v + '</span></div>';
  }).join('') +
  /* the saving rides the total wherever the total is shown, named against the
     SEAL count that earned it — the same number the chip they tapped promised */
  '<div class="sumline"><span class="k">Price</span>' +
  '<span class="v price-big">' + fmtMoney(p.price) +
  (p.save > 0 ? '<em style="display:block;font:600 12px/1.4 inherit;font-style:normal;' +
     'color:#7ee2a8;margin-top:2px">you save ' + fmtMoney(p.save) + ' &middot; ' +
     pctOf(p.rate) + '% off at ' + sealNum(p.n) + ' seals</em>' : '') +
  '</span></div>';
}

var _pvT = null;

function applyOrientClass() {
  var land = st.orientation === 'landscape';
  document.querySelectorAll('.ss-seal').forEach(function (el) { el.classList.toggle('land', land); });
}

/* INCHES, not millimetres (owner 2026-08-14). The die is 44.958 x 19.05mm
   because it was cut to 1.77" x 0.75" — the inch pair is the round one and the
   spec; the metric figures were the conversion. The renderer still works
   entirely in mm, this is only what the caption says.

   CALLED AT BOOT as well as on an orientation change. It used to live inline
   in the orientation handler, so a fresh page kept whatever the markup shipped
   — which meant the labels read millimetres until the customer happened to
   flip the shape, and read them for the ~30 minutes a cached section render
   survives after a deploy. */
function setDims() {
  var land = st.orientation === 'landscape';
  /* the SELECTED size, not the die constant (owner 2026-08-29: the rulers
     read 1.77/0.75 with Large selected). Standard renders the exact strings
     this function always produced. */
  var z = (window.SS_SEAL && SS_SEAL.SIZES && SS_SEAL.SIZES[st.sizeId]) ||
          { longIn: 1.77, shortIn: 0.75 };
  var lo = String(z.longIn), sh = String(z.shortIn);
  var dh = document.getElementById('dim-h'), dw = document.getElementById('dim-w');
  if (dh) dh.innerHTML = (land ? sh : lo) + '&Prime;';
  if (dw) dw.innerHTML = (land ? lo : sh) + '&Prime;';
  var pd = document.getElementById('pvdims');
  var duo = st.sealStyle === 'duo';
  /* the half a duo customer ends up holding, after their own cut */
  var hl = Math.round((z.longIn / 2) * 1000) / 1000;
  if (pd) pd.textContent = land
    ? ('Printed size: ' + lo + ' by ' + sh + ' inches' +
       (duo ? ' \u2014 two ' + hl + ' by ' + sh + ' inch seals after you cut' : ''))
    : ('Printed size: ' + sh + ' by ' + lo + ' inches' +
       (duo ? ' \u2014 two ' + sh + ' by ' + hl + ' inch seals after you cut' : ''));
  /* HAND-CUT NOTICE (owner 2026-08-30: "clear message must be hand cut").
     Lives under the printed-size line; created once, removed when the shape
     is not duo. setDims runs on every size and shape change, so this always
     tracks the selection. */
  var hn = document.getElementById('ss-duonote');
  if (duo) {
    if (!hn) {
      hn = document.createElement('p');
      hn.id = 'ss-duonote';
      hn.style.cssText = 'margin:10px auto 0;padding:10px 13px;border-radius:10px;' +
        'font-size:13px;line-height:1.55;color:#ffd9a0;background:rgba(255,190,90,.08);' +
        'border:1px solid rgba(255,190,90,.35);max-width:430px';
      /* OUTSIDE the measuring stage: .pvmeas is sized to the SEAL's width
         inside a centring grid, so a wide child there inflates it and shoves
         the whole preview sideways (owner 2026-08-30: "duo portrait moves
         the whole layout"). The note lives after .pvstage instead. */
      var _stg = document.querySelector('.pvstage');
      if (_stg && _stg.parentNode) _stg.parentNode.insertBefore(hn, _stg.nextSibling);
      else if (pd && pd.parentNode) pd.parentNode.insertBefore(hn, pd.nextSibling);
      else document.getElementById('pv').parentNode.appendChild(hn);
    }
    var _half = land ? (hl + '\u2033 \u00d7 ' + sh + '\u2033') : (sh + '\u2033 \u00d7 ' + hl + '\u2033');
    var _full = (land ? lo + '\u2033 \u00d7 ' + sh : sh + '\u2033 \u00d7 ' + lo) + '\u2033';
    var _dq = st.qty || (effMinPacks() * PACK_UNIT);
    hn.innerHTML = '\u2702 <b>' + sealNum(_dq) + ' labels = ' + sealNum(_dq * 2) +
      ' seals once cut.</b> Each printed label is ' + _full +
      ' and carries TWO seals with a dashed guide \u2014 <b>you cut them apart yourself</b> into ' +
      _half + ' seals. Not pre-cut; every seal has its own number.';
  } else if (hn && hn.parentNode) {
    hn.parentNode.removeChild(hn);
  }
}

function renderPreview() {
  if (!st.tpl) return;
  /* true = the ONLY caller that may show the demo QR */
  var f = fields(true);
  applyOrientClass();
  SS.mount(document.getElementById('pv'), st.tpl, f, 1);
  document.getElementById('pv').setAttribute('aria-label',
    st.serialType === 'none'
      ? st.tpl.name + ' seal preview, one of ' + st.qty +
        ' identical seals — no numbering'
      : st.tpl.name + ' seal preview, numbered ' + serialAt(0) + ', one of ' + st.qty +
        ' — every seal carries its own number');
  /* #pv-serial is static copy now (see the markup): with one placeholder in
     the slot there is nothing to announce per render. */
}

function sync() {
  if (!st.tpl) return;
  /* No caps()/fields() call here any more: both existed only to feed the
     serial ticker, which is gone. fields() allocates and re-reads the upload
     data URIs, and sync() runs on every keystroke — leaving the call in was a
     per-keystroke cost with no reader. */

  /* Building a seal at full quality is ~110KB of SVG, twice over. Doing that
     per keystroke janks a phone, so the preview trails the typing slightly
     while the price, counters and gate stay instant. */
  clearTimeout(_pvT);
  _pvT = setTimeout(renderPreview, 160);

  renderPacks();
  /* the placement control appears and disappears with the pair of uploads,
     and either can be removed from a card this function does not own — so
     it is reconciled here, in the one place every change already passes */
  paintLogoPlace();
  /* text-only refresh: the first/last serial line tracks the pack size, which
     lives two steps away, and the collapsed summary chip tracks the modes */
  updateOptions();
  if (window._svqlPanel && st.qrMode === 'list') { try { window._svqlPanel.paint(); } catch (_) {} }
  document.getElementById('sumrows').innerHTML = summaryRows();

  var need = blockers(), ready = need.length === 0, p = pack();
  var cta = document.getElementById('cta'), needEl = document.getElementById('need');
  cta.setAttribute('aria-disabled', ready ? 'false' : 'true');
  /* Not-ready is styled as a live secondary button, never faded: tapping it is
     the flow's best guidance (toast + scroll to the blocking step), and grey
     buttons don't get tapped. The label does NOT change with readiness (owner
     2026-08-12: "remove the Next step →") — the #need line under it already
     says what is missing, and one stable word is what the customer is looking
     for when they are ready to buy. */
  cta.textContent = window._ssEditKey ? 'Update cart' : 'Add to cart';
  needEl.className = 'needline' + (ready ? ' ready' : '');
  needEl.textContent = ready
    ? '✓ Ready to order.'
    : '→ ' + need[0] + (need.length > 1 ? '  (' + (need.length - 1) + ' more to go)' : '');

  /* ——— step 2 buys too ————————————————————————————————————————————————
     Mirrored off the SAME `ready` / `need` pair that drives #cta rather than
     recomputed, so the two surfaces can never disagree about whether the order
     is orderable or about what is blocking it. The label is copied from #cta
     verbatim — including 'Update cart' while a cart line is being edited, which
     is the one label this pair must never get wrong. */
  var s2c = document.getElementById('s2-cta'),
      s2n = document.getElementById('s2-need'),
      s2w = document.getElementById('s2buy');
  if (s2c) {
    s2c.setAttribute('aria-disabled', ready ? 'false' : 'true');
    s2c.textContent = cta.textContent;
  }
  /* always solo now that the pair is one button — the old expression
     REMOVED the .solo the markup ships with and left the survivor in a
     half-width 1fr 1fr column */
  if (s2w) s2w.className = 's2buy solo';
  if (s2n) {
    s2n.className = 'needline' + (ready ? ' ready' : '');
    s2n.textContent = ready
      ? (window._ssEditKey ? '✓ Ready to update your cart.' : '✓ Ready to order.')
      : '→ ' + need[0] + (need.length > 1 ? '  (' + (need.length - 1) + ' more to go)' : '');
  }

  /* THE COUNT LEADS THE CARD. It is shown at every state, ready or not — the
     quantity is chosen long before the order is orderable, and a customer
     reading "From $8.99" with no count beside it has to go back up the page to
     find out what they are being quoted for. TOTAL seals, never p.paid. */
  document.getElementById('m-seals-n').textContent = sealNum(st.qty);
  /* Until it's orderable the price is a floor, not a bill — say so */
  document.getElementById('m-price').textContent = (ready ? '' : 'From ') + fmtMoney(p.price);
  /* The pack count is GONE from this line (owner 2026-08-06: "people don't
     know what packs are") and so is the seal count, which now leads the card
     two lines up rather than being restated here. What is left is what the
     other two lines don't say: the saving, and the promise.
     ⚠ The not-ready branch must keep being exactly need[0]:
     assets/sv-sticky-cta.js reads this element's text to decide whether the
     blocker is the missing brand name, and rewrites the CTA tap into a jump to
     that field. Wrap or reword it and that rescue silently stops firing. */
  document.getElementById('m-qty').textContent = ready
    /* 'none' drops the 'every serial unique' promise — there are no serials
       to promise. READY BRANCH ONLY: the not-ready text below stays exactly
       need[0], which sv-sticky-cta.js pattern-matches (see the warning above). */
    ? (st.serialType === 'none'
        ? (p.save > 0 ? 'you save $' + p.save.toFixed(2) : '')
        : (p.save > 0 ? 'you save $' + p.save.toFixed(2) + ' · ' : '') + 'every serial unique')
    : need[0];
  /* the step-3 serial strip is static copy now — no minted numbers to show */

  markProgress();

  /* audit trails the preview rebuild (160ms debounce) so it measures the
     seal the customer is actually looking at */
  clearTimeout(_pcT);
  _pcT = setTimeout(runPrintCheck, 1000);
}

/* The preview used to cycle through the pack's serials every 2.4s to make the
   point that no two seals match. With one placeholder in the serial slot each
   tick would rebuild ~110KB of identical SVG on the customer's phone for no
   visible change, so the ticker is gone. The strip under the preview and the
   INDIVIDUALLY NUMBERED line on the seal make the same point in words. */

/* ——————————————— print check — audit the FINAL seal, VialArt-style ———————
   Not the upload gate (that already vets files on the way in): this audits
   the composed result the press will actually receive — serial legibility,
   QR density, artwork resolution, ink coverage, security features. */
var _pcT = null, _pcSeq = 0;

function _pcRow(tier, label, detail) {
  var ic = tier === 'pass' ? '✓' : tier === 'fail' ? '✗' : tier === 'warn' ? '!' : '◆';
  return '<div class="pcrow ' + tier + '"><span class="ic" aria-hidden="true">' + ic + '</span>' +
    '<span class="lb">' + label + '</span><span class="dt">' + detail + '</span></div>';
}

function runPrintCheck() {
  var host = document.getElementById('pcheck');
  if (!host || !st.tpl) return;
  var c = caps(), rows = [], seq = ++_pcSeq;

  /* background / artwork / logo sources */
  if (c.requiresBackground) {
    if (st.bg) {
      if (st.bg.dpi == null) {
        /* rehydrated from a cart edit — the file was validated when first
           uploaded; its report did not round-trip */
        rows.push(['pass', 'Background', 'Restored from your cart — prints as previously uploaded']);
      } else {
        var bd = st.bg.dpi;
        rows.push([bd >= SS_UPLOAD.DPI_PASS ? 'pass' : 'warn',
          'Background resolution', bd + ' DPI at print size' +
          (bd >= SS_UPLOAD.DPI_PASS ? ' — crisp' : bd >= SS_UPLOAD.DPI_MIN ? ' — acceptable, ' + SS_UPLOAD.DPI_PASS + ' is best' : ' — will print soft, you confirmed this')]);
      }
      var bun = (st.bg.acks || []).filter(function (id) { return !st.bg.acked[id]; }).length;
      if (bun) rows.push(['fail', 'Background notes', bun + ' unconfirmed — tick the boxes in step 1']);
    } else {
      rows.push(['fail', 'Background', 'Not uploaded yet']);
    }
  }
  if (c.requiresArtwork) {
    if (st.artwork && st.artwork.dpi == null) {
      rows.push(['pass', 'Artwork', 'Restored from your cart — prints as previously uploaded']);
    } else if (st.artwork) {
      var d = st.artwork.dpi;
      /* low DPI is a 'warn', never a 'fail' — the customer has already ticked
         an acknowledgement to get here and the order is allowed to proceed */
      rows.push([d >= SS_UPLOAD.DPI_PASS ? 'pass' : 'warn',
        'Artwork resolution', d + ' DPI at print size' +
        (d >= SS_UPLOAD.DPI_PASS ? ' — crisp' : d >= SS_UPLOAD.DPI_MIN ? ' — acceptable, ' + SS_UPLOAD.DPI_PASS + ' is best' : ' — will print soft, you confirmed this')]);
      var un = (st.artwork.acks || []).filter(function (id) { return !st.artwork.acked[id]; }).length;
      if (un) rows.push(['fail', 'Artwork notes', un + ' unconfirmed — tick the boxes in step 2']);
    } else if (st.logo) {
      rows.push(['pass', 'Artwork', 'Your logo prints on bare foil instead of full artwork']);
    } else {
      rows.push(['fail', 'Artwork', 'Not uploaded yet']);
    }
  }
  if (st.logo) {
    rows.push(['pass', 'Logo', SS.esc(st.logo.note) + ' · ' +
      (st.logoMode === 'mark' && (st.artwork || c.category === 'designer')
        ? 'small, corner lockup' : 'featured in the window')]);
  }

  /* serial legibility — measured off the LIVE composed preview */
  var fs = null;
  var pv = document.querySelector('#pv svg');
  if (pv) pv.querySelectorAll('text[data-fit]').forEach(function (t) {
    if (/-/.test(t.textContent) && !t.hasAttribute('data-micro')) {
      var f = parseFloat(t.getAttribute('font-size'));
      if (f > 1.5 && (fs == null || f > fs)) fs = f;
    }
  });
  if (fs != null) {
    rows.push([fs >= 2.6 ? 'pass' : fs >= 2.0 ? 'warn' : 'fail', 'Serial legibility',
      fs.toFixed(1) + 'mm type' + (fs >= 2.6 ? ' — reads with the naked eye'
        : ' — the serial is rendering small on this layout')]);
  }

  /* QR — the customer's own link, or nothing. Density is the thing that
     decides whether it scans, so it is quoted from the real link. */
  if (c.supportsQR) {
    var qbad = st.qrMode === 'own' ? qrProblem() : null;
    var qurl = (st.qrMode === 'own' && !qbad) ? normUrl(st.qr) : '';
    if (st.qrMode === 'sku') {
      /* There is no link to measure here, so quote the thing that actually
         decides whether it scans: the module grid. A serial is the shortest
         payload this product can carry, so the code comes out COARSER than
         any link -- worth saying, because a customer who has only seen the
         dense URL version will assume every code is that dense. */
      var _sks = skuPreviewCode();
      rows.push([_sks ? 'pass' : 'fail', 'Item code',
        _sks
          ? SS.esc(_sks) + ' \u2014 ' + qrGrid(_sks) + ' modules at ~8mm, the ' +
            'coarsest code a seal can print (a web link needs ' +
            qrGrid(DEMO_QR_LONG) + '). Encoded as plain text, exactly as printed.'
          : 'Choose Unique serials \u2014 an item code needs a number to be']);
    } else if (qbad) {
      rows.push(['fail', 'Your QR link', SS.esc(qbad)]);
    } else if (!qurl) {
      rows.push(['info', 'QR code', 'No code on this seal' +
        (st.qrMode === 'own' ? ' — add a link in step 1 if you want one' : '')]);
    } else {
      rows.push([qurl.length <= QR_MAX ? 'pass' : 'warn', 'Your QR link',
        SS.esc(qurl) + ' — ' + qurl.length + ' characters at ~10mm' +
        (qurl.length <= QR_MAX ? ', reads easily'
                               : '; a shorter link prints a coarser, faster code')]);
    }
  }

  /* always-on printed furniture — the pitch, itemised */
  rows.push(['pass', 'Printed detail',
    'SERIALSEAL.COM foil watermark · serial microtext · rosette · copy-trap raster — ' +
    'all printed on the seal, not preview overlays']);

  /* ink coverage — rasterize the live preview, async */
  rows.push(['info', 'Ink coverage', '<span id="pc-ink">measuring…</span>']);

  var fails = rows.filter(function (r) { return r[0] === 'fail'; }).length;
  var warns = rows.filter(function (r) { return r[0] === 'warn'; }).length;
  var verdict = fails ? ['fail', 'Fix before ordering'] :
                warns ? ['warn', 'Check the notes'] : ['pass', 'Print-ready'];
  host.innerHTML =
    rows.map(function (r) { return _pcRow(r[0], r[1], r[2]); }).join('') +
    /* The numbers really are the customer's now, so the audit genuinely ran on
       what will print — say so plainly and quote the range. */
    '<p class="pcnote">Audited the way we print it — same renderer, same layout. ' +
    (st.serialType === 'none'
      ? 'Your seals print identical — no numbering, exactly as you chose.'
      : 'Your seals are numbered ' + SS.esc(serialAt(0)) + ' to ' +
        SS.esc(serialAt(Math.max(0, st.qty - 1))) + ', exactly as you set them.') +
    '</p>';
  /* verdict lives in the <summary> so a collapsed check still shows its answer */
  var chip = document.getElementById('pc-sum-chip');
  if (chip) { chip.className = 'vchip ' + verdict[0]; chip.textContent = verdict[1]; }
  /* The check stays hidden until the order is actually buildable — a
     'Print-ready' chip beside an 'Enter your brand name' blocker at first
     paint was four signals telling three stories. blockers() is the one
     source of truth here, same as the CTA and the rail. */
  var wrap = document.getElementById('pcwrap');
  if (wrap) wrap.hidden = blockers().length > 0;

  if (pv) {
    try {
      var xml = new XMLSerializer().serializeToString(pv);
      var img = new Image();
      img.onload = function () {
        if (seq !== _pcSeq) return;                     // stale run
        var cv = document.createElement('canvas');
        cv.width = 120; cv.height = Math.round(120 * (st.orientation === 'landscape' ? 19.05 / 44.958 : 44.958 / 19.05));
        var cx = cv.getContext('2d');
        cx.fillStyle = 'rgb(208,208,208)'; cx.fillRect(0, 0, cv.width, cv.height);
        cx.drawImage(img, 0, 0, cv.width, cv.height);
        var px = cx.getImageData(0, 0, cv.width, cv.height).data, ink = 0, tot = cv.width * cv.height;
        for (var i = 0; i < px.length; i += 4) {
          var lum = 0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2];
          ink += Math.max(0, Math.min(1, 1 - lum / 208));
        }
        var pct = Math.round(100 * ink / tot);
        var el = document.getElementById('pc-ink');
        if (el) el.textContent = pct + '% of the die' +
          (pct <= 45 ? ' — foil-forward, the holo does the work' : ' — ink-heavy; more bare foil pops harder');
      };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
    } catch (_) {}
  }
}

/* ——————————————— progress rail ——————————————— */
function stepDone(id) {
  var c = caps();
  if (id === 'step1') {
    /* design is ONE step now: details, material, shape and the chosen
       template all live here, so Done means all of it is satisfied */
    /* mirrors blockers() exactly — the rail and the CTA must never disagree
       about whether step 1 is finished */
    if (c.supportsTitle !== false && !noBrand() && !st.brand.trim()) return false;
    if (c.supportsQR && qrProblem()) return false;
    if (serialProblem()) return false;
    if (!st.tpl) return false;
    if (c.requiresBackground && !st.bg) return false;
    if (st.bg &&
        (st.bg.acks || []).some(function (id) { return !st.bg.acked[id]; })) return false;
    if (c.requiresArtwork && !st.artwork && !st.logo) return false;
    if (st.artwork &&
        (st.artwork.acks || []).some(function (id) { return !st.artwork.acked[id]; })) return false;
    return !(c.requiresLogo && !st.logo);
  }
  /* A later step is 'done' only when its own AND all earlier steps' blockers
     are empty — at first paint the rail must read Design on, nothing done. */
  if (id === 'step2') return stepDone('step1') && !!st.qty;
  return stepDone('step1') && !!st.qty;   // review is done when everything is
}
function markProgress() {
  document.querySelectorAll('#prog a').forEach(function (a) {
    a.classList.toggle('done', stepDone(a.dataset.step));
  });
}
function setActive(id) {
  document.querySelectorAll('#prog a').forEach(function (a) {
    var on = a.dataset.step === id;
    a.classList.toggle('on', on);
    if (on) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current');
  });
}

/* ——————————————— boot ——————————————— */
(function boot() {
  /* Default to a finished designer seal — the first screen has to sell the
     product, not present an empty artwork frame. */
  var m = location.search.match(/[?&]design=([a-z0-9_]+)/i);
  var start = (m && SS.tpl(m[1])) ? m[1] : null;
  if (!start) {
    /* land on CLEAN FOIL (owner 2026-08-10: it is what most orders buy);
       fall back to the first sellable design only if it ever goes away */
    start = (SS.tpl('f_logo_full') ? 'f_logo_full' : '') ||
            ((window.SS_SELLABLE || [])[0] || {}).key ||
            (((window.SS_TEMPLATES || [])[0] || {}).key);
  }
  if (!start) {
    /* ss-templates.js failed to load — say so instead of a dead page with a
       '—' price bar and a CTA that silently does nothing */
    document.getElementById('grid').innerHTML =
      '<p style="color:var(--bad);font-size:15px">The design catalog failed to load. ' +
      'Check your connection and refresh this page.</p>';
    return;
  }
  /* NEVER narrow the gallery at boot: the category chips are gone, so a
     narrowed grid has no on-screen control to widen it — with Clean Foil
     (cat 'logo') as the landing default this silently hid every artwork
     and sports design from the gallery (found in the 2026-08-10 sweep). */
  st.cat = 'all';

  renderOrient();
  renderMaterial();
  renderCats();
  renderDetails();
  /* Clean Foil stays SELECTED (every downstream default, the quick-pick tick
     and add-to-cart all read st.tpl) — it just no longer silences the preview
     carousel, which runs until the customer picks for themselves. A ?design=
     link IS an explicit pick, so that one still stops the loop. */
  _bootSeat = !m;
  selectTemplate(start);
  _bootSeat = false;
  try { svquickPaint(); } catch (_) {}
  /* Ask about the plan once the page is up. No-ops entirely while the plan
     product is Draft, and never blocks anything: the builder is fully usable
     before, during and after the answer lands, and renderBiz() repaints the
     one panel in place when it does. */
  bizCheck();
  /* A link that names a design (?design=key) is an explicit request for that
     card — open the gallery on it rather than making them answer a fork they
     already answered by clicking the link. openStage, not setPath: re-aiming
     the chips here would hide the very design they came for. */
  if (m && SS.tpl(start)) openStage(catOf(SS.tpl(start)) === 'logo' ? 'logo' : 'gallery');
  updateGate();

  /* the locked gallery routes taps to step 1 instead of eating them */
  var gg = document.getElementById('ggate');
  if (gg) gg.onclick = gateNudge;

  /* print check folds shut on phones — it is reassurance, not a decision */
  var pcw = document.getElementById('pcwrap');
  if (pcw && matchMedia('(min-width: 960px)').matches) pcw.open = true;

  function applyZoom() {
    /* the landscape die is 2.36× wider than tall — same pixel WIDTH renders a
       postage stamp, so landscape gets a proportionally wider stage */
    var w = Math.round(ZOOMS[st.zoom] * (st.orientation === 'landscape' ? 2.1 : 1));
    document.querySelector('.pvstage').style.setProperty('--pvw', w + 'px');
    /* the +/- buttons are gone (owner 2026-08-14). st.zoom still exists and
       still sizes the stage; it simply has no control bound to it now. NULL
       GUARDS, not deletion: applyZoom() is also called on orientation change
       and via window.applyZoom, and an unguarded getElementById here throws
       the moment the markup loses the buttons — taking the rest of boot with
       it, which is a blank builder rather than a missing zoom control. */
    var _zo = document.getElementById('zo'), _zi = document.getElementById('zi');
    if (_zo) _zo.disabled = st.zoom === 0;
    if (_zi) _zi.disabled = st.zoom === ZOOMS.length - 1;
  }
  window.applyZoom = applyZoom;
  var _zoB = document.getElementById('zo'), _ziB = document.getElementById('zi');
  if (_zoB) _zoB.onclick = function () { st.zoom = Math.max(0, st.zoom - 1); applyZoom(); };
  if (_ziB) _ziB.onclick = function () { st.zoom = Math.min(ZOOMS.length - 1, st.zoom + 1); applyZoom(); };
  applyZoom();

  var ag = document.getElementById('allgal');
  if (ag) ag.addEventListener('toggle', function () {
    if (ag.open) { renderCats(); renderGrid(); }   // see openGallery()
  });
  var hi = document.getElementById('hc-insp');
  if (hi) hi.onclick = openGallery;

  document.querySelectorAll('[data-go]').forEach(function (b) {
    b.onclick = function () {
      document.getElementById(this.dataset.go).scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      setActive(this.dataset.go);
    };
  });
  document.querySelectorAll('#prog a').forEach(function (a) {
    a.onclick = function () { setActive(this.dataset.step); };
  });

  /* Scroll-spy on a plain scroll listener rather than IntersectionObserver:
     IO only fires when the page is compositing, and where it doesn't, the rail
     silently freezes on step 1 for the whole session. This always runs. */
  var STEPS = ['step1', 'step2', 'step3'];
  var spyQueued = false;
  function spy() {
    if (spyQueued) return;
    spyQueued = true;
    setTimeout(function () {
      spyQueued = false;
      var line = window.innerHeight * 0.35, best = STEPS[0];
      STEPS.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= line) best = id;
      });
      setActive(best);
    }, 60);
  }
  window.addEventListener('scroll', spy, { passive: true, capture: true });
  window.addEventListener('resize', spy);



/* ——— mobile: the customer's fields ride to the TOP of the page ———
   Owner 2026-08-05, from watching real customers: "enter your brand name,
   logo and all the custom text should be top of the page — it's hard for
   the customers to find." Stacked on a phone they sat ~1790px down, behind
   the video, the H1, the price card and the 743px preview. Here they move
   directly under the H1: first thing on the page, with the live preview
   right beneath so it still reacts as they type. Desktop (>=1040px) is a
   two-column grid where the fields are already top-right, so the block is
   returned to step 1 verbatim there. */
(function () {
  /* MOBILE TOP = THE TEMPLATE PICKER (owner 2026-08-11: "on mobile put the
     templates on the top of the page, it's the first thing they pick" —
     replacing the 2026-08-05 details-first move this IIFE used to make; the
     brand field now follows the preview, per "then name"). The whole design
     block travels together — quick picks, the gallery and #tplextras, so a
     chosen design's upload panel stays under the tiles that opened it. */
  var MOBILE = '(max-width: 1039px)';
  var saved = null, moved = false;
  function nodes() {
    /* top order on a phone (owner 2026-08-14: "put the name and logo upload on
       top of page before shape"): NAME + LOGO first, then the shape, the
       background tiles, the gallery, and the chosen design's panel. */
    /* #controls holds the name field, the logo tile and the logo card — and
       nothing else, so the whole element travels as the "name and logo" block
       and renderDetails() keeps rewriting it wherever it now sits. Its <h3>
       comes too: moving a block away from its own heading is what orphaned
       "Choose your background" halfway down the page on 2026-08-12. */
    /* THE PREVIEW LEADS (owner 2026-08-14: "Move the preview to the top of
       the page also"). #pvpane is self-contained — heading, stage, zoom — and
       on desktop it is the sticky right column, which the restore puts back. */
    var pv = document.getElementById('pvpane');
    var bh = document.getElementById('brand-head');
    var ct = document.getElementById('controls');
    var s = document.getElementById('shapepick');
    /* #bgpick wraps the heading AND the three tiles so they travel together —
       moving the tiles alone left "Choose your background" orphaned halfway
       down the page (2026-08-12). Falls back to the bare tiles on a
       render-cached page from before that markup shipped. */
    var q = document.getElementById('bgpick') || document.getElementById('svquick');
    var g = document.getElementById('allgal');
    var l = document.getElementById('svq-logo');
    var x = document.getElementById('tplextras');
    if (!(q && g && x)) return null;
    /* TOP ORDER ON A PHONE: shapes -> the three background choices -> the
       gallery they open (collapsed it draws nothing) -> the logo row -> the
       chosen design's own requirements. The logo has to travel too or it is
       left 600px down the page, under the section it used to live in.
       #shapepick and #svq-logo ship in the section markup; a render-cached
       page from before that deploy won't have them yet, so each is added only
       when present rather than dropping the whole move. */
    var out = [];
    if (pv) out.push(pv);
    if (bh) out.push(bh);
    if (ct) out.push(ct);
    if (s) out.push(s);
    out.push(q, g);
    /* #svq-logo is NOT hoisted any more — it is hidden by apply() while the
       block is up top, because it is a second "upload your logo" button for
       the same pickFile call and with #controls leading the page the customer
       would meet two of them within a screen of each other. The one in
       #controls is the richer control (thumb, replace, remove), so it wins.
       The hide happens in apply(), NOT here: nodes() runs on desktop too, and
       doing it here hid the desktop logo row on a layout that never hoists. */
    out.push(x);
    return out;
  }
  function apply() {
    var n = nodes();
    if (!n) return;
    var head = document.querySelector('.sv-builder .bhead');
    if (!head) return;
    var want = matchMedia(MOBILE).matches;
    if (want === moved) return;
    if (want) {
      /* per-node bookmarks: these nodes come from DIFFERENT spots in the
         desktop column (the shape picker lives after the style chooser),
         so each remembers its own parent + next sibling for the restore */
      saved = n.map(function (el) {
        return { el: el, parent: el.parentNode, next: el.nextSibling };
      });
      var at = head;
      n.forEach(function (el) { at.insertAdjacentElement('afterend', el); at = el; });
      var lgo = document.getElementById('svq-logo');
      if (lgo) lgo.hidden = true;          // the top block carries the logo now
      document.querySelector('.sv-builder').classList.add('picker-top');
    } else if (saved) {
      /* unhide FIRST: this used to sit after the loop, and when the loop threw
         the desktop layout was left with its logo row permanently hidden */
      var lg = document.getElementById('svq-logo');
      if (lg) lg.hidden = false;
      /* REVERSE order, and never trust the saved `next`. The nodes are hoisted
         one after another, so a bookmark's `next` is often another hoisted
         node — by restore time it lives somewhere else, and insertBefore then
         throws "the node before which the new node is to be inserted is not a
         child of this node", aborting every remaining restore. Walking
         backwards puts each anchor back before the node that needs it, and the
         parentNode test falls back to a plain append when it still does not
         line up. */
      saved.slice().reverse().forEach(function (s2) {
        if (!s2.parent || !s2.parent.isConnected) return;
        try {
          if (s2.next && s2.next.parentNode === s2.parent) s2.parent.insertBefore(s2.el, s2.next);
          else s2.parent.appendChild(s2.el);
        } catch (_) {}
      });
      document.querySelector('.sv-builder').classList.remove('picker-top');
    }
    moved = want;
  }
  apply();
  addEventListener('resize', apply);
})();

  setActive('step1');
  renderShapeQuick();
  renderBgCarousel();
  /* WARM EVERY BACKGROUND after boot (owner 2026-08-18: tapping a tile
     showed the bare plate, THEN the artwork popped in — the full-size webp
     was still downloading). Staggered so the first paint keeps the pipe;
     per-shape crops included because the preview picks the crop, not the
     master. */
  setTimeout(function () {
    var urls = [];
    slideList().forEach(function (d) {
      ['bg', 'bg_ls', 'bg_lf', 'bg_pf'].forEach(function (k2) {
        if (d[k2]) urls.push(d[k2]);
      });
    });
    urls.forEach(function (u, i) {
      setTimeout(function () { (new Image()).src = u; }, i * 140);
    });
  }, 1800);
  setDims();          /* the markup ships mm; correct it before first paint */
  startSlideshow();
  spy();


  var mbar = document.getElementById('mbar'), exp = document.getElementById('m-exp');
  /* The summary is an ordinary block in the flow now, so nothing needs to
     reserve space for it. Kept as a no-op because the drawer toggle below
     still calls it. */
  function syncBarHeight() {}
  exp.onclick = function () {
    var open = mbar.classList.toggle('open');
    this.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.textContent = open ? 'Hide details \u25B4' : 'Order details \u25BE';
    syncBarHeight();
  };
  document.addEventListener('click', function (e) {
    if (mbar.classList.contains('open') && !mbar.contains(e.target)) {
      mbar.classList.remove('open');
      exp.setAttribute('aria-expanded', 'false');
      exp.textContent = 'Order details \u25BE';
      syncBarHeight();
    }
  });

  /* Wrappers, NOT a bare `= placeOrder` reference: onclick hands the handler
     the MouseEvent as its first argument, and placeOrder's first argument is
     now the destination. Bound bare, every tap would arrive with an event
     object where 'cart' or 'checkout' belongs. */
  document.getElementById('cta').onclick = function () { placeOrder('cart'); };
  var _s2c = document.getElementById('s2-cta');
  if (_s2c) _s2c.onclick = function () { placeOrder('cart'); };

  /* no #reroll button any more — the browser has nothing left to re-roll */

  /* quantity stepper — QTY_STEP seals per press. Everything still goes through
     setPaid(), which clamps to the pack floor and the self-serve ceiling and
     rounds to a whole pack, so the buttons cannot land the order anywhere the
     ladder cannot price it.

     The jump is expressed in PACKS (QTY_STEP / PACK_UNIT) and then converted
     with PACK_PAID rather than adding QTY_STEP to `paid` directly. Those two
     constants are both 12 today and the shorter form would work — but they have
     been different before (the retired 10-paid-plus-2-free pack), and that
     assumption silently sold seals at 0.83x for a day when it broke. The
     aria-labels are stamped from the same constant, so a screen-reader user is
     promised the jump the box actually makes. */
  document.querySelectorAll('#packs .va-qsb').forEach(function (b) {
    var d = parseInt(b.dataset.qd, 10);
    b.setAttribute('aria-label', QTY_STEP + (d < 0 ? ' fewer' : ' more') + ' seals');
    b.onclick = function () {
      setPaid(pack().paid + parseInt(this.dataset.qd, 10) * (QTY_STEP / PACK_UNIT) * PACK_PAID);
    };
  });
  var qin = document.getElementById('ss-qin');
  if (qin) {
    /* min / step / max in SEALS, derived so the native spinner, the phone
       keypad's validation and the ladder can never disagree. max was still
       hard-coded at 500 from before PAID_MAX went to 5000, which quietly told
       the browser a valid 3000-seal order was out of range. The markup's own
       max= is the same number typed once as a no-JS fallback; this line is the
       source, so raising PAID_MAX raises the spinner with it. */
    /* the 60-seal minimum, less whatever the cart already covers - repainted
       by paintMinSurfaces() on every cart read, so it can never sit stale */
    qin.min = effMinPacks() * PACK_UNIT;
    /* the keyboard's up/down arrows move the same 60 the buttons do — the
       native spinner buttons are hidden in ss-builder.css, but the arrow keys
       still work and would otherwise crawl in twelves */
    qin.step = QTY_STEP;
    qin.max = (PAID_MAX / PACK_PAID) * PACK_UNIT;
    qin.oninput = function () {
      var v = parseInt(this.value, 10);
      /* >= PACK_UNIT, not PACK_PAID: the field counts total seals now, and one
         pack is the smallest real order. Below that we leave them alone mid-
         type rather than snapping the value out from under the caret. */
      if (!isNaN(v) && v >= effMinPacks() * PACK_UNIT) setSeals(v);   // live price while typing
    };
    qin.onblur = function () { setSeals(this.value); this.value = pack().n; };
  }
  /* THE SLIDER (owner 2026-08-17: "make a slider where they can just slide
     … and it will pick how many they want"). Log scale: linear-in-packs
     would bury 24-600 — where every real order lives — in the first tenth
     of the track. Snaps to whole packs; the typed input stays for exact
     numbers. */
  /* the curve's ORIGIN is the live minimum - slider 0 IS the smallest
     order. It was pinned at log(2) (the retired 24-seal entry), so after
     the 60 minimum the thumb loaded partway up the track (owner
     2026-08-30: "the slider loads at the old 60 line"). */
  /* THE ORIGIN IS READ, NOT CAPTURED. It was `Math.log(PACK_MIN)` closed over
     once at boot; with a cart-wide minimum the smallest allowed order can be
     12 rather than 60, and a frozen origin would put slider 0 at a quantity
     setPaid() no longer clamps to - i.e. the thumb's left stop would be a lie
     in one direction or the other depending on the cart. */
  var _LNMX = Math.log(PAID_MAX / PACK_PAID);
  function _qslMin() { return effMinPacks(); }
  window._qslToPacks = function (v) {
    var mn = _qslMin(), ln0 = Math.log(mn);
    var t = Math.max(0, Math.min(1000, +v || 0)) / 1000;
    return Math.max(mn, Math.min(PAID_MAX / PACK_PAID,
      Math.round(Math.exp(ln0 + t * (_LNMX - ln0)))));
  };
  window._packsToQsl = function (k) {
    var mn = _qslMin(), ln0 = Math.log(mn);
    return Math.round(1000 * (Math.log(Math.max(mn, k || mn)) - ln0) / (_LNMX - ln0));
  };
  var qsl = document.getElementById('ss-qsl'), _qslLast = 0;
  if (qsl) {
    qsl.oninput = function () {
      var k = _qslToPacks(this.value);
      if (k !== _qslLast) { _qslLast = k; buzz(4); }   /* a tick per pack snap */
      setSeals(k * PACK_UNIT);
    };
  }

  /* Every tier surface — the step-2 chip grid, the hero ladder strip and the
     near-miss nudge — carries data-sstier="<pack threshold>". ONE delegated
     listener covers all of them and, crucially, survives the re-renders that
     rebuild those strips on every quantity change; per-element handlers bound
     inside renderQtiers()/renderPacks() would have to be re-bound each time and
     would go stale the first time one of them was missed.
     They are real <button>s, so Enter and Space arrive here as clicks already. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-sstier]');
    if (t) applyTier(t.getAttribute('data-sstier'));
  });

  /* Reorder handoff from My Seals: prefill everything that round-trips and
     say so about what doesn't (uploaded files travel by email, not storage). */
  try {
    var ro = JSON.parse(localStorage.getItem('ss_reorder') || 'null');
    localStorage.removeItem('ss_reorder');
    if (ro && ro.template && SS.tpl(ro.template)) {
      st.brand = ro.brand || '';
      /* "buy these again" has to reproduce a NAMELESS seal as a nameless
         seal. Records written before 2026-09-16 carry no brand_mode at all
         and land on '' — the store name — which is exactly what they were. */
      st.brandMode = ro.brand_mode === 'logo' ? 'logo' : '';
      st.color = ro.color ? SS.inkSafe(ro.color) : '';
      _slide.block = true;   /* reorder prefill owns the preview */
      st.qty = ro.qty || 12;
      _qtyUserSet = true;      /* a past order spoke for the quantity */
      st.orientation = ro.orientation || 'portrait';
      st.sealStyle = ro.seal_style || 'single';
      st.sizeId = ro.size_id || 'standard_177x075';
      if (window.SS_applySize) { try { SS_applySize(st.sizeId); } catch (_) {} }
      renderOrient();
      renderDetails();                 // prefill the step-1 inputs with the order
      /* A repeat of a RETIRED design (a pre-made designer seal, say) is still
         honoured — it renders and prints exactly as it did — but its category
         no longer has any cards, so filtering to it left the gallery empty.
         Show the current layouts instead and keep their design selected. */
      var roSell = (window.SS_SELLABLE || []).some(function (t) { return t.key === ro.template; });
      st.cat = roSell ? catOf(SS.tpl(ro.template)) : 'all';
      renderCats();
      renderGrid();
      selectTemplate(ro.template);
      applyOptionPrefill(ro);       // after selectTemplate: it rebuilds the block
      openStage(st.cat === 'logo' ? 'logo' : 'gallery');
      updateGate();
      SS_UI.toast(ro.artwork_attached || ro.logo_attached || ro.bg_attached
        ? 'Order loaded — re-upload your file to finish'
        : (roSell ? 'Order loaded — same design, fresh serials'
                  : 'Order loaded — your original design, fresh serials'));
    }
  } catch (_) {}

  /* Edit handoff from the cart: prefill everything (the uploaded logo
     round-trips via its Shopify Files URL), and remember the cart line so
     Update replaces it instead of adding a duplicate. */
  try {
    var ed = JSON.parse(localStorage.getItem('ss_edit') || 'null');
    localStorage.removeItem('ss_edit');
    if (ed && ed.template && SS.tpl(ed.template)) {
      st.brand = ed.brand || '';
      /* Editing a nameless line must not silently put the name back on. The
         logo it depends on rehydrates asynchronously from ed.logo_url below,
         so noBrand() reads false for those few hundred ms and the preview
         shows the name — then the logo lands, calls updateGate() ->
         paintBrandMode(), and it drops away again. The flag itself survives
         that gap (paintBrandMode never clears it), which is the whole reason
         it does not. Erring toward showing the name in the gap is the safe
         direction: the alternative is a seal briefly carrying nothing.
         ⚠ ss-cart.js must send `brand_mode: p._brand_mode || ''` in the
         ss_edit payload or every edit of a logo-only line comes back named. */
      st.brandMode = ed.brand_mode === 'logo' ? 'logo' : '';
      st.color = ed.color ? SS.inkSafe(ed.color) : '';
      _slide.block = true;   /* cart-edit prefill owns the preview */
      st.qty = ed.qty || 12;
      _qtyUserSet = true;      /* the cart line spoke for the quantity */
      st.orientation = ed.orientation || 'portrait';
      st.sealStyle = ed.seal_style || 'single';
      st.sizeId = ed.size_id || 'standard_177x075';
      if (window.SS_applySize) { try { SS_applySize(st.sizeId); } catch (_) {} }
      /* the line's foil and grade come back too (audit 2026-09-02: an edit
         silently re-added on the default variant and dropped the grade) */
      if (ed.material) st.material = ed.material;
      st.grade = String(ed.grade || '');
      st.logoScale = parseFloat(ed.logo_scale) || 1;
      st.siteText = String(ed.site_text || '');
      window._ssEditKey = ed.key || '';
      window._ssEditQrSha = ed.qr_list_sha || '';
      renderOrient();
      renderDetails();
      st.cat = catOf(SS.tpl(ed.template));
      renderCats();
      renderGrid();
      selectTemplate(ed.template, true);
      applyOptionPrefill(ed);       // after selectTemplate: it rebuilds the block
      openStage(st.cat === 'logo' ? 'logo' : 'gallery');
      updateGate();
      if (ed.logo_url) {
        fetch(ed.logo_url).then(function (r) { return r.blob(); }).then(function (bl) {
          var fr = new FileReader();
          fr.onload = function () {
            st.logo = { name: 'your logo.png', dataUrl: fr.result, w: 0, h: 0,
                        kb: Math.round(fr.result.length / 1365), thumb: fr.result,
                        url: ed.logo_url,
                        plate: String(ed.logo_plate || '') === '1',
                        note: 'from your cart' };
            st.logoMode = 'window';
            mountUploader('logo', 'logo');
            updateGate(); refreshGridSoon(); renderExtras(); sync();
          };
          fr.readAsDataURL(bl);
        }).catch(function () {});
      }
      /* the uploaded background and artwork round-trip the same way the logo
         does — by their Shopify Files URL. (artwork_url is the pre-existing
         bug fix: editing a cart line used to silently drop uploaded artwork;
         ss-cart.js now sends both URLs.) No report/acks on a rehydrate — the
         file was validated and acknowledged when first uploaded. */
      if (ed.bg_url) {
        fetch(ed.bg_url).then(function (r) { return r.blob(); }).then(function (bl) {
          var fr = new FileReader();
          fr.onload = function () {
            st.bg = { name: 'your background', dataUrl: fr.result, w: 0, h: 0,
                      kb: Math.round(fr.result.length / 1365), thumb: fr.result,
                      url: ed.bg_url, note: 'from your cart' };
            renderExtras(); refreshGridSoon(); sync();
          };
          fr.readAsDataURL(bl);
        }).catch(function () {});
      }
      if (ed.artwork_url) {
        fetch(ed.artwork_url).then(function (r) { return r.blob(); }).then(function (bl) {
          var fr = new FileReader();
          fr.onload = function () {
            st.artwork = { name: 'your artwork', dataUrl: fr.result, w: 0, h: 0,
                           kb: Math.round(fr.result.length / 1365), thumb: fr.result,
                           url: ed.artwork_url, note: 'from your cart' };
            renderExtras(); refreshGridSoon(); sync();
          };
          fr.readAsDataURL(bl);
        }).catch(function () {});
      }
      SS_UI.toast('Editing your seals — Update replaces the cart line');
    }
  } catch (_) {}

  /* ——— a per-seal-link design survives a refresh (owner 2026-10-20: "save
     to local storage if they refresh or come back"): the engine kept the
     sheet / typed rows and the mode; a reorder or cart edit still wins ——— */
  if (!_prefilled && !window._ssEditKey && window.SVQL && SVQL.wantsList && SVQL.wantsList() &&
      qrListOffered() && st.qrMode !== 'list') {
    st.qrMode = 'list';
    if (st.serialType === 'none') st.serialType = 'rand';
    renderDetails();
    sync();
  }

  /* ——— the prefix arrives filled in (owner 2026-08-08) ———————————————
     Runs LAST, after the reorder and cart-edit handoffs above, and only on a
     genuinely fresh build:
       · _prefilled — a past order spoke for the numbering, INCLUDING by
         leaving the prefix blank, which is what a pre-2026-08-08 order looks
         like. Seeding over that would renumber a run being repeated on
         purpose.
       · window._ssEditKey — editing a cart line. Same reason, louder: the
         line already exists and Update would replace it with different
         numbers than the customer chose.
     One value per session (sessionPrefix), so the preview cannot reshuffle
     under them on a re-render. */
  if (!_prefilled && !window._ssEditKey && !st.serialPrefix) {
    /* A brand already on screen (restored draft, ?brand= link) outranks the
       random session code — the customer never sees a prefix control now, so
       whatever lands here is what they ship with. */
    st.serialPrefix = prefixFromBrand(st.brand) || sessionPrefix();
    renderOptions();
    sync();
  }

  /* LAST, and deliberately not inside the product fetch: the cart-wide
     minimum must be right even when /products/<handle>.js is slow or 429s,
     and it must be read AFTER the cart-edit handoff above has set
     window._ssEditKey - the line being edited does not buy its own minimum
     down. refreshCartSeals() de-dupes, so the copy inside renderPriceHero()
     costs nothing when this one is already in flight. */
  try { refreshCartSeals(); } catch (_) {}
})();

/* ——— numbering continues across the cart ———
   A second pack must never repeat numbers the first pack already took
   (ss1006: two 600-seal lines overlapped by 499). Returns a Promise of the
   start number to use: the buyer's own if it is clear, otherwise one past the
   highest number already carted under the same prefix. `skipKey` is the line
   being edited, which must not block itself. */
/* The batch segment a CART LINE prints, by the same rule batchSeg() applies to
   the live build. Two lines that carry different batch codes print
   visibly different numbers and cannot collide, so they do not push each
   other along. */
function lineBatchSeg(p) {
  if (String(p._serial_type || '') !== 'batch') return '';
  var b = String(p._serial_batch || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
  return b ? b + '-' : '';
}
function nextFreeStart(prefix, wantStart, skipKey) {
  /* Random numbering has no start number to advance and needs none: Label Farm
     derives every code and checks it against each serial the order has already
     issued, so two random lines cannot collide by construction. A plain
     no-number line prints nothing at all — renumbering it would be shifting a
     start the customer will never see, and a shifted _serial_start on a 'none'
     line reads like a numbering promise downstream. */
  if (st.serialType === 'rand' || st.serialType === 'none') return Promise.resolve(wantStart);
  var seg = batchSeg();
  var mine = parseInt(String(wantStart || '').replace(/[^0-9]/g, ''), 10);
  if (!isFinite(mine)) mine = parseInt(SERIAL_SAMPLE, 10) || 1;
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : { items: [] }; })
    .then(function (cart) {
      var highest = 0;
      (cart.items || []).forEach(function (it) {
        if (skipKey && it.key === skipKey) return;
        var p = it.properties || {};
        if (String(p._serial_prefix || '') !== String(prefix || '')) return;
        /* a random line takes no numbers out of the counted space, and a
           plain no-number line takes none either — its _serial_start is a
           dormant default, not a claim on the sequence */
        var _lt = String(p._serial_type || '');
        if (_lt === 'rand' || _lt === 'none') return;
        if (lineBatchSeg(p) !== seg) return;
        var st0 = parseInt(String(p._serial_start || '').replace(/[^0-9]/g, ''), 10);
        if (!isFinite(st0)) return;
        /* a cart line's seal count is packs x 12 — the same math Label Farm
           uses when it expands the numbering for printing */
        var seals = (it.quantity || 1) * PACK_UNIT;
        highest = Math.max(highest, st0 + seals - 1);
      });
      return highest && mine <= highest ? highest + 1 : mine;
    })
    .catch(function () { return mine; });   /* cart unreadable: keep theirs */
}

/* Asked once when the QR link is blank, so nobody ships QR-less seals by
   accident (owner 2026-08-06). Returns true when placeOrder should stop and
   wait for the customer's answer. */
/* THE MISSING-QR MODAL IS GONE (owner 2026-08-17, funnel audit): it fired
   on the FIRST Add-to-cart tap of every default-path buyer, at peak intent,
   with its primary button steering AWAY from the purchase — in three of the
   audit's own runs it was why the buy button looked dead. Printing without a
   QR code is simply the default now. The decision is still stated where the
   buyer can see it: the summary's 'QR code' row reads "None — the seal
   prints without a code", and the cart properties carry the same truth. */

/* Where a completed add lands. Every surface is 'cart' as of 2026-08-12 —
   the "Buy it now" shortcut was removed on owner instruction, and skipping
   /cart also skipped the page that shows the seal proof. The var and the
   parameter survive because placeOrder re-enters itself (after a
   still-uploading file lands) and that call site is argument-less, so the
   destination cannot live in a plain parameter. */
var _orderDest = 'cart';
/* A press must not be answered out of a cached cart. `_orderRechecking` is the
   read in flight (one per press, never per keystroke); `_orderChecked` marks
   the single re-entry that read produced, so the recheck cannot recurse. */
var _orderRechecking = false, _orderChecked = false;

/* Every buy surface at once. #cta and #s2-cta deliberately show the same word
   at the same moment, so the in-flight label has to reach both — leaving one of
   them reading "Add to cart" mid-flight invites the double-submit. */
function buyLabel(txt) {
  ['cta', 's2-cta'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.textContent = txt;
  });
}

function placeOrder(dest) {
  if (dest) _orderDest = dest;
  /* BLOCKERS FIRST. askAboutMissingQr() used to run ahead of this, so a
     customer who had not typed a brand name yet was asked "print without a QR
     code?" instead of being told the one thing actually stopping the order —
     and had to answer a question about a feature they had not touched before
     the real problem would even surface. */
  var need = blockers();
  if (need.length) {
    SS_UI.toast(need[0], true);
    /* send them to the step that can actually fix it — details live in step 1
       now, the chosen design's uploads in step 2 */
    var c = caps();
    /* every design-side problem now lives in step 1 */
    var target = ((c.supportsTitle !== false && !noBrand() && !st.brand.trim()) ||
        (c.supportsQR && qrProblem()) || (c.supportsQR && qrListProblem()) || serialProblem() ||
        !st.tpl || (c.requiresArtwork && !st.artwork && !st.logo) || (c.requiresLogo && !st.logo) ||
        (c.requiresBackground && !st.bg) ||
        (st.bg && (st.bg.acks || []).some(function (id) {
            return !st.bg.acked[id]; })) ||
        (st.artwork && (st.artwork.acks || []).some(function (id) {
            return !st.artwork.acked[id]; })) ||
        false) ? 'step1' : 'step3';
    document.getElementById(target).scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start' });
    return;
  }
  /* THE CART, READ NOW. blockers() above tested the floor against `_lastCart`,
     which is only refreshed on boot, on visibilitychange and on pageshow -
     none of which fire for two builder windows side by side, a second device,
     or a press landing in the few hundred ms after a tab return. With no
     server-side minimum behind it, a stale cache is the whole difference
     between a 12-seal line being refused and being carted. One read per press.

     If the fresh read MOVED the quantity (onCartRead raises it to the new
     floor and says so), the press stops here: the number they aimed at is no
     longer the number they would buy, and silently adding 60 where they asked
     for 12 is the same defect pointing the other way. They press again.

     BELOW the blockers gate, deliberately: an unfinished design must keep its
     instant local answer, so only a press that is otherwise going to succeed
     pays for the round trip. The re-entry runs blockers() again against the
     cart that just landed, which is the test that actually refuses. */
  if (!_orderChecked) {
    if (_orderRechecking) return;         /* a read is already in flight */
    _orderRechecking = true;
    var _qtyWas = st.qty;
    buyLabel('Checking your cart\u2026');
    var _after = function () {
      _orderRechecking = false;
      buyLabel(window._ssEditKey ? 'Update cart' : 'Add to cart');
      if (st.qty !== _qtyWas) {
        /* The read moved the number under the press, so the press is void -
           they aimed at one order and would be charged for another.
           onCartRead() says why when it RAISED the quantity to a new floor,
           but when it LOWERS an untouched default (the cart grew in another
           window, so this design may now be smaller) nothing has spoken yet,
           and a press that simply stops is a dead button. */
        if (st.qty < _qtyWas) {
          try {
            SS_UI.toast('Your cart changed \u2014 this design is now ' +
                        sealNum(st.qty) + ' seals. Press again to add it.');
          } catch (_) {}
        }
        return;
      }
      _orderChecked = true;
      try { placeOrder(dest); } finally { _orderChecked = false; }
    };
    refreshCartSeals(true).then(_after, _after);
    return;
  }
  var c = caps(), p = pack();
  var variant = packVariant();
  if (!variant) {
    /* self-heal rather than dead-end: the product JSON never arrived (a 429
       or a dropped request), so ask for it again and finish the order the
       moment it lands. The customer sees a beat, not a button that silently
       does nothing for the rest of the page's life. */
    SS_UI.toast('One moment — loading prices…');
    buyLabel('One moment…');
    if (window._svLoadProduct) {
      window._svLoadProduct().then(function () { sync(); placeOrder(); })
        .catch(function () {
          sync();
          SS_UI.toast('Could not reach the store — check your connection', true);
        });
    }
    return;
  }

  /* a file upload may still be in flight \u2014 hold the order for it (it is
     seconds, and an order that carries the CDN URL never needs email chasing) */
  var pending = [];
  [st.artwork, st.bg, st.logo].forEach(function (f) {
    if (f && f.uploadP && !f.url && !f.fileId && !f.uploadErr) pending.push(f.uploadP);
  });
  if (pending.length) {
    buyLabel('Saving your file\u2026');
    /* the uploads self-abort at 25s; this 30s race is the second belt so the
       buy button can NEVER wedge on a promise that refuses to settle */
    var _held = false;
    var _go = function () { if (!_held) { _held = true; placeOrder(); } };
    Promise.all(pending).then(_go);
    setTimeout(_go, 30000);
    return;
  }

  function fileNote(f, what) {
    if (!f) return '';
    return what + ' ' + f.name + (f.url || f.fileId ? ' (uploaded)' : ' (customer will email)');
  }
  var _noBrandLine = noBrand();
  var props = {
    'Design': st.tpl.name,
    /* PUBLIC property — the cart, the checkout, the confirmation email and
       the packing slip all quote it back to the customer. On a logo-only line
       it is DELETED a few lines below rather than set to a sentinel: writing
       the literal 'none' into a property a human reads would put the word
       "none" on their order confirmation under a heading called Brand text.
       The sentinel is a renderer channel; this is a customer-facing one. */
    'Brand text': c.supportsTitle === false ? '' : st.brand,
    /* Every style gets its real name — this label only knew 'fold', so both
       banner styles printed as "· Single" on the order line, and ss1017 read
       as a flat landscape seal that rendered "wrong" when it was actually a
       Slab Banner the customer chose (owner report 2026-08-11). ss-cart.js
       only greps this string for /landscape/i, so the suffix is free text. */
    'Orientation': (st.orientation === 'landscape' ? 'Landscape' : 'Portrait') +
      (st.sealStyle === 'topfold' ? ' · Slab Banner'
        : st.sealStyle === 'topfold2' ? ' · Toploader Banner'
        : st.sealStyle === 'fold' ? ' · Folded' : ' · Single'),
    /* The material also rides on the VARIANT title, which is what Label Farm
       parses to route the job to the press with that roll loaded. Sending it
       as a property too means the operator sees it on the job without having
       to read the variant, and a variant rename can't silently lose it. */
    'Material': st.material || 'Shattered Prism',
    /* THE DIE (launch 2026-09-02). Size is public (checkout + packing slip);
       _label_size_mm is Label Farm's press-routing + page-size key, byte-
       identical to the press row; _label_size_id is the renderer's SIZES key
       the print sidecar composes at. Written on EVERY line so absence never
       has to mean a default. */
    'Size': st.sizeId === 'large_250x100' ? 'Large 2.5\u2033 \u00d7 1\u2033'
                                          : 'Standard 1.77\u2033 \u00d7 0.75\u2033',
    '_label_size_id': st.sizeId || 'standard_177x075',
    '_label_size_mm': st.sizeId === 'large_250x100' ? '63.5x25.4' : '45x19.05',
    /* Empty stays empty rather than 'None': a blank property is hidden in
       the cart and on the packing slip, which is what an unused optional
       field should look like. */
    'Grade': st.grade || '',
    '_seal_style': st.sealStyle,
    /* ═══ THE ONE LINE THAT REACHES CHECKOUT ══════════════════════════════
       'Seals' has no leading underscore, so it is a PUBLIC line-item property:
       it shows in the cart AND on Shopify's hosted checkout, which is the only
       surface of this purchase the theme does not render. The cart line's
       quantity is and stays the PACK count (see the /cart/add.js call below) —
       Label Farm and the Shopify automatic discounts both count packs — so at
       checkout the customer meets a bare "Qty 10". This property is what tells
       them what those 10 are.

       It therefore leads with the TOTAL, exactly like every other surface.
       It used to read "100 paid + 20 free (120 total)" — the paid count first
       and the real number in brackets — which is the paid-vs-total confusion
       parked on the one screen where the customer is handing over money.
       Now: "120 seals (100 paid + 20 free)".
       Downstream this is a display string only: core/shopify_client.py passes
       it through to the job untouched, and the printed quantity is derived
       from the trusted VARIANT title, never from here. */
    'Seals': st.sealStyle === 'duo'
      ? st.qty + ' labels = ' + (st.qty * 2) + ' seals after cutting (' +
        fmtPerSeal(p.price / p.n) + ' per label)'
      : st.qty + ' seals (' + fmtPerSeal(p.price / p.n) + ' each)',
    '_design_key': st.tpl.key,
    '_accent': SS.inkSafe(c.supportsAccent === false ? st.tpl.defaults.color : (st.color || st.tpl.defaults.color)),
    /* No 'Serials' / '_serials' here on purpose: the line carries the PREFIX
       and the START NUMBER, and Label Farm expands them into the printed list
       at ingest, where the real quantity is known. One rule, one place.
       (Lines added before this shipped still carry _serials; the cart and the
       print side keep honouring those.) */
    '_serial_mode': 'own',
    /* the SAME call fields() renders from, so what ships is what they saw */
    '_logo_mode': logoPlace(),
    '_logo_scale': st.logo ? String(st.logoScale) : '',
    '_logo_plate': (st.logo && st.logo.plate) ? '1' : '',
    '_files': [fileNote(st.artwork, 'artwork'), fileNote(st.bg, 'background'),
               fileNote(st.logo, 'logo')].filter(Boolean).join(' + '),
    /* the rights agreement, recorded on the order line: 'agreed' can only be
       written because blockers() refused to cart until every upload's rights
       ack was ticked. Empty when nothing was uploaded — our own designs carry
       our license and there is nothing to agree to. */
    '_rights_ack': (st.artwork || st.bg || st.logo) ? 'agreed' : ''
  };
  /* ——— NO STORE NAME, THE LOGO CARRIES IT (owner 2026-09-16) ——————————
     Written ONLY on a line that actually is one — noBrand() has already
     confirmed a logo is attached. Absence is the default and means "print
     the store name", which is every line ever written before today, so
     nothing downstream has to learn a new default to keep rendering old
     orders exactly as they render now.

     Two halves, and both are required:
       · the PRIVATE key is the instruction. tools/render_seals.py maps it to
         the renderer's brand sentinel (cfg 'brand' -> 'none') and lists it in
         _SIG_FIELDS so flipping it re-renders rather than serving a cached
         seal with the name still on it;
       · the PUBLIC 'Brand text' is REMOVED, not blanked to a sentinel. A
         blank property is hidden in the cart and on the packing slip, which
         is what an unused field should look like — and it means the customer
         never reads the word "none" back as if it were their shop's name.
     ⚠ ss-cart.js must send `brand_mode: p._brand_mode || ''` back in the
     ss_edit payload, or editing one of these lines returns it named. */
  if (_noBrandLine) {
    props['_brand_mode'] = 'logo';
    delete props['Brand text'];
  }
  /* ——— the QR + numbering keys, ALWAYS written ————————————————————————
     Absence used to mean the old defaults (`_qr_mode` = record, `_serial_mode`
     = random, `_registry` = 1), and everything downstream still reads it that
     way for the legacy lines. So a retired-registry order can never leave any
     of them off: it would be read as a registry order and promise a record
     nobody is going to issue. `_registry` is pinned to '0', `_serial_mode` to
     'own' (above), and `_qr_mode` is only ever 'own' or 'none'.
     A blank or unusable link is written as 'none', because that is exactly
     what prints — the property set always describes the actual seal. */
  var qrLink = (c.supportsQR !== false && (st.qrMode === 'own' || st.qrMode === 'business') &&
                !qrProblem()) ? normUrl(st.qr) : '';
  /* ⚠ 'business' is a THIRD value on this key. The two gates downstream of the
     cart — core/shopify_client.py `_seal_opts` and tools/render_seals.py
     `resolve_qr` — downgrade any mode they do not recognise to 'none', which
     does not error: THE SEAL SIMPLY PRINTS BLANK. Neither of those files is in
     this change. They must learn 'business' before the plan product is taken
     off Draft. Nothing here can reach them until then, because a draft variant
     cannot be bought. */
  var _biz = st.qrMode === 'business' && BIZ.ok && qrLink;
  /* 'sku' is a FOURTH value on this key and the only one that writes NO
     'QR link' -- there is no destination; the payload is the seal's own
     serial. The same downgrade warning as 'business' applies: the two gates
     downstream of the cart (core/shopify_client.py `_seal_opts` and
     tools/render_seals.py `resolve_qr`) send a mode they do not recognise to
     'none' and THE SEAL SIMPLY PRINTS BLANK rather than erroring.
     render_seals.py learned 'sku' in the same change as this; shopify_client.py
     must learn it before this chip reaches a live cart.
     Guarded on the serial too: 'sku' with no numbering has nothing to encode,
     so it writes 'none' rather than a mode the press cannot satisfy.
     blockers() refuses that combination up front; this is the belt. */
  var _sku = st.qrMode === 'sku' && c.supportsQR !== false && st.serialType !== 'none';
  /* 'list' is a FIFTH value: a link per seal from the customer's sheet.
     Label Farm (_seal_opts) and the press (resolve_qr) both know it; blockers()
     refused the cart until the sheet passed and was ticked, so this is the belt. */
  var _list = st.qrMode === 'list' && c.supportsQR !== false && !!st.qrList && st.qrList.ok &&
              !qrListProblem();
  props['_qr_mode'] = _sku ? 'sku' : _biz ? 'business' : _list ? 'list' : (qrLink ? 'own' : 'none');
  /* A motif fills the QR SLOT on a seal that has no code (ss-seal.js:
     `hasMotif = !hasQr && ...`). The test used to be "no Business plan and no
     link", and a POS line has neither — so `_motif` and its public `Motif`
     twin rode a line whose slot is occupied by the item code. The renderer
     would not have drawn it, but the order line, the confirmation email and
     the order status page all quote `Motif` back to a customer who chose no
     such thing. `_sku` is the flag two lines up; it belongs in this guard. */
  if (!_sku && !_biz && !_list && !qrLink && st.motif && window.SS_MOTIFS && SS_MOTIFS[st.motif]) {
    props['_motif'] = st.motif;
    props['Motif'] = SS_MOTIFS[st.motif].name;
  }
  /* The destination rides on the same key in both modes. On an own-link seal
     it is what gets encoded; on a Business seal the foil carries our short
     code and this is where that code is pointed FIRST. */
  if (qrLink && !_sku) props['QR link'] = qrLink;
  /* Public (no underscore) -> the confirmation email and the order status
     page. A POS buyer needs to know what their codes say without opening the
     box, and this is the only surface that tells them today. */
  if (_sku) props['QR type'] = 'Item code \u2014 each seal\u2019s code is its own serial';
  if (_biz) {
    props['QR type'] = 'Business — dynamic, destination changeable';
    props['_biz_customer_id'] = String(BIZ.cfg.cid || '');
    /* Which order this is: the one that buys the plan, or one riding a plan
       that is already live. The print side needs neither; support does. */
    props['_biz_plan'] = BIZ.state === 'active' ? 'existing' : 'new';
  }
  props['_serial_prefix'] = st.serialPrefix || '';
  /* never empty: an order without serials is not the product */
  props['_serial_start'] = /^\d{1,9}$/.test(String(st.serialStart || '').trim())
    ? String(st.serialStart).trim() : SERIAL_SAMPLE;
  /* WHICH SCHEME — written on every line, never left to a default. Label Farm
     reads this at ingest to decide how to expand the numbering, and an absent
     key reads as 'seq' there: a line that meant RANDOM and lost this key would
     silently print a counted sequence instead, which is the one thing the
     customer chose it to avoid. */
  props['_serial_type'] = _list ? 'list' : st.serialType;
  if (st.serialType === 'batch') props['_serial_batch'] = batchSeg().replace(/-$/, '');
  props['_registry'] = '0';
  /* the printed wordmark override was READ by the cart and the sidecar but
     never written (found in the large launch recon) */
  if (String(st.siteText || '').trim()) props['_site_text'] = String(st.siteText).trim();
  if (_list) {
    /* THE SHEET rides the line: 'SERIAL<TAB>LINK' rows joined by newlines, in
       print order, plus the row count and a checksum of the exact text so
       Label Farm can tell a sheet altered after this page checked it. The two
       public properties are what the confirmation email and checkout show. */
    props['_qr_list'] = st.qrList.text;
    props['_qr_list_n'] = String(st.qrList.n);
    props['_qr_list_sha'] = st.qrList.sha;
    props['QR links'] = st.qrList.n.toLocaleString('en-US') + ' links \u2014 one per seal, from your sheet';
    props['QR type'] = 'A link per seal';
    props['_site_text'] = 'serialseal.com';
  }
  /* ...unless their picture already contains it ('off'). _logo_mode already
     says so and the renderer already obeys it; withholding the file as well
     means no path downstream can print it by reading the URL alone. */
  if (st.logo && (st.logo.url || st.logo.fileId) && logoPlace() !== 'off')
    props['_logo_url'] = st.logo.url || st.logo.fileId;
  if (st.artwork && (st.artwork.url || st.artwork.fileId)) props['_artwork_url'] = st.artwork.url || st.artwork.fileId;
  if (st.bg) {
    if (st.bg.url || st.bg.fileId) props['_bg_url'] = st.bg.url || st.bg.fileId;
    /* THE CROP RIDES OUTSIDE THE UPLOAD RESULT (fixed 2026-08-08). It used to
       be nested inside the branch above, so a failed upload dropped the
       framing the customer had just confirmed in the fit step: they approved
       one crop and would have been shipped another once support attached the
       file by hand. The crop is the customer's decision and it belongs on the
       line whatever happened to the transfer.
       The sidecar applies it with the same math. */
    if (_bgFit.s !== 1 || _bgFit.x !== 0 || _bgFit.y !== 0) {
      props['_bg_fit'] = JSON.stringify({
        s: +(+_bgFit.s).toFixed(3), x: +(+_bgFit.x).toFixed(4), y: +(+_bgFit.y).toFixed(4) });
    }
  }
  var cta = document.getElementById('cta');
  buyLabel(window._ssEditKey ? 'Updating\u2026' : 'Adding\u2026');
  /* continue the numbering past anything already carted under this prefix */
  var askedStart = props['_serial_start'];
  /* editing a cart line: remove the original first so Update never duplicates.
     A failed removal (line already gone) is fine \u2014 we still add the new one. */
  /* a per-seal-link line numbers from its sheet - nothing to continue */
  var pre = (_list ? Promise.resolve(askedStart)
                   : nextFreeStart(props['_serial_prefix'], askedStart, window._ssEditKey))
    .then(function (startNum) {
      if (String(startNum) !== String(askedStart)) {
        /* keep the buyer's pad width: '0100' stays 4 wide */
        var pad = String(askedStart).length;
        props['_serial_start'] = String(startNum).length < pad
          ? String(startNum).padStart ? String(startNum).padStart(pad, '0')
            : String(startNum) : String(startNum);
        st.serialStart = props['_serial_start'];
        /* "these seals", not "this pack": the customer has never been shown a
           pack anywhere in this flow, so naming one here for the first time in
           a toast about their numbering is the one word they were told not to
           have to learn (owner 2026-08-06). */
        SS_UI.toast('Numbering continues from your cart \u2014 these seals start at ' +
                    (props['_serial_prefix'] || '') + props['_serial_start']);
        if (typeof renderOptions === 'function') renderOptions();
      }
      /* ═══ PUBLIC (no leading underscore) — it reaches Shopify's hosted
         checkout beside 'Seals', which is the one screen of this purchase the
         theme does not render. The numbering is a thing the customer CHOSE, so
         it belongs on the screen where they hand over money.
         Written HERE, after any cart-continuation shift above, so the line
         describes the numbers it will actually print. It is a DESCRIPTION, not
         the list: the real random codes do not exist until ingest, and nothing
         in the browser is allowed to invent one. Downstream it is display-only
         — core/shopify_client.py passes it to the job untouched and _serials is
         what prints. serialAt() is the same function the preview and the review
         summary use, so all three agree by construction. */
      /* duo doubles the NUMBER count (2 per die, hand-cut apart) while the
         purchased quantity stays the die count - the range and the total
         must describe what actually prints */
      var _dn = st.sealStyle === 'duo' ? 2 : 1;
      var _nTot = st.qty * _dn;
      props['Serials'] = _list
        ? st.qrList.n.toLocaleString('en-US') + ' from your sheet, ' + st.qrList.rows[0].serial +
          ' \u2026 ' + st.qrList.rows[st.qrList.n - 1].serial
        : st.serialType === 'none'
        ? _nTot + ' identical seals \u2014 no numbering' + (_dn === 2 ? ' (2 per label, hand-cut)' : '')
        : st.serialType === 'rand'
        ? _nTot + ' random codes, like ' + serialAt(0) + (_dn === 2 ? ' (2 per label, hand-cut)' : '')
        : serialAt(0) + ' \u2192 ' + serialAt(Math.max(0, _nTot - 1)) +
          (st.serialType === 'batch' ? ' (batch ' + batchSeg().replace(/-$/, '') + ')' : '') +
          (_dn === 2 ? ' \u2014 2 per label, hand-cut' : '');
      return window._ssEditKey
        ? fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: window._ssEditKey, quantity: 0 })
          }).catch(function () {})
          /* ...and the per-seal-link fee that belonged to the line being
             replaced (the new line brings its own) */
          .then(function () { return removeQrFee(window._ssEditQrSha); })
        : null;
    });
  pre.then(function () {
    window._ssEditKey = '';
    window._ssEditQrSha = '';
    /* ── ONE plan line, ever ──────────────────────────────────────────────
       The seals and the plan go in as a SINGLE /cart/add.js call using the
       `items:` form, which is all-or-nothing: if the plan variant is rejected
       (Draft, archived, sold out) the seal line is not added either. The
       alternative — two sequential calls — has a failure mode where the
       customer walks away with Business seals and no plan, or a plan and no
       seals, and neither is recoverable from the cart page.

       Before adding, the cart is read: a plan already sitting there means this
       is their second design in one session, and a second $359.88 line would
       be the double-charge this whole feature is built to avoid. Failing to
       READ the cart is not a reason to add a second one — on error we assume
       one is already present and add none, because a missing plan is a support
       email and a duplicate plan is a refund. */
    var items = [{ id: variant.id, quantity: p.packs, properties: props }];
    var wantBiz = bizNeedsPurchase();
    var wantRush = st.rush && RUSH.ok;
    /* No add-on wanted AND none already on the order — the ordinary path, which
       keeps the exact single-item request body it has always used.
       `_cartHasRush` is in the condition because an existing fee line has to be
       RE-PRICED against the bigger order even when this design was not ticked.
       Without that, 12 labels rushed for $29.99 followed by 10,000 plain ones
       ships 10,012 labels to the front of the queue for $29.99. */
    if (!wantBiz && !wantRush && !_cartHasRush && !_list) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: p.packs, properties: props })
      });
    }
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var plan = rushPlan(cart, p.n, wantRush);
        plan.biz = (cart.items || []).some(function (it) {
          return String(it.variant_id) === String(BIZ.cfg.variantId) ||
                 (it.properties && it.properties._ss_business);
        });
        return plan;
      })
      /* couldn't read → change nothing and add no add-on. A duplicate or
         wrongly-priced charge is a refund; a missing add-on is one email. */
      .catch(function () {
        return { biz: true, line: null, tier: null, seals: 0, stale: false, add: false };
      })
      .then(function (s) {
        /* Shopify cannot change a line's VARIANT, only its quantity, so a tier
           move is a remove-then-add. Done before the add, and the add is
           all-or-nothing, so the worst case is a cart with no fee — visible and
           recoverable — rather than one carrying two. */
        var pre = s.stale
          ? fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: s.line.key, quantity: 0 })
            }).catch(function () {})
          : Promise.resolve();
        return pre.then(function () {
          if (wantBiz && !s.biz) items.push(bizPlanLine());
          if (s.add) items.push(rushLine(s.tier, s.seals));
          /* the per-seal-link fee goes in the SAME all-or-nothing add as
             the seals: never seals without the fee, never the fee alone */
          if (_list) items.push(qrListFeeLine(st.qrList, st.qty));
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        });
      });
  }).then(function (r) {
    if (!r.ok) throw new Error('cart ' + r.status);
    /* the rows are in the cart: the saved sheet / typed table is done with */
    if (_list && window.SVQL && SVQL.clearDraft) { try { SVQL.clearDraft(); } catch (_) {} }
    /* keep a local record so My Seals still works */
    try {
      var all = JSON.parse(localStorage.getItem('ss_orders') || '[]');
      all.push({ lane: 'pack', template: st.tpl.key, template_name: st.tpl.name,
        category: c.category, orientation: st.orientation, seal_style: st.sealStyle,
        size_id: st.sizeId || 'standard_177x075',
        /* '' rather than undefined on a logo-only line: the key is deleted
           from props above, and JSON.stringify would drop an undefined value
           entirely — leaving a record whose shape differs from every other
           one for no reason. The text itself is deliberately not kept: this
           order did not buy it. */
        brand: props['Brand text'] || '',
        /* so "buy these again" rebuilds a NAMELESS seal as a nameless seal
           and not as one wearing whatever name happens to be in the box */
        brand_mode: props['_brand_mode'] || '',
        /* no `serials` list: the prefix + start below ARE the numbering, and
           My Seals reads this record with `o.serials || []`, so it shows the
           design and lets the range speak for itself. */
        color: props._accent,
        /* the choices round-trip so "buy these again" rebuilds the same seal */
        serial_mode: 'own',
        serial_prefix: props['_serial_prefix'], serial_start: props['_serial_start'],
        /* round-trips so "buy these again" rebuilds the same NUMBERING, not
           just the same artwork — a repeat run that silently reverted to
           sequential would be a different product */
        serial_type: st.serialType, serial_batch: props['_serial_batch'] || '',
        registry: '0',
        qr_mode: props['_qr_mode'],
        motif: props['_motif'] || '',
        qty: st.qty, qr: qrLink,
        artwork_thumb: (st.artwork && st.artwork.thumb) || '',
        bg_thumb: (st.bg && st.bg.thumb) || '',
        logo_thumb: (st.logo && st.logo.thumb) || '',
        /* booleans, not thumb-presence: thumbs get dropped under localStorage
           quota pressure, and the reorder prefill needs to know a file WAS
           attached to say "re-upload your file to finish" */
        artwork_attached: !!st.artwork,
        bg_attached: !!st.bg,
        logo_attached: !!st.logo,
        rush: !!(st.rush && RUSH.ok),
        price: p.price, order_code: 'cart', status: 'in_cart',
        placed_at: new Date().toISOString(), spec_version: 2 });
      localStorage.setItem('ss_orders', JSON.stringify(all));
    } catch (_) {}
    /* '/checkout' carries the whole cart, which is exactly what the step-2
       note under Buy it now says it does. Same add, same properties, same
       local record — only the landing page differs. */
    window.location.href = _orderDest === 'checkout' ? '/checkout' : '/cart';
  }).catch(function () {
    /* Restore EVERY buy surface, not just #cta: sync() rewrites all of them
       from one blockers() result, so the step-2 pair can never be left
       stranded on the in-flight label with no way back. */
    cta.textContent = 'Add to cart';
    sync();
    SS_UI.toast('Could not add to cart \u2014 please try again', true);
  });
}

/* motif picker: one delegated handler survives every options re-render */
document.addEventListener('click', function (e) {
  var b = e.target && e.target.closest && e.target.closest('.svmot-b');
  if (!b) return;
  st.motif = b.getAttribute('data-mot') || '';
  if (typeof renderOptions === 'function') renderOptions();
  if (typeof renderPreview === 'function') renderPreview();
});

/* quick picks: Clean Foil + Upload your own stay on the page; the rest of
   the catalog is behind the gallery (owner 2026-08-10: most sales are the
   plain foil). Delegated so it works no matter when the row renders. */
function svquickPaint() {
  var k = st.tpl && st.tpl.key;
  document.querySelectorAll('.svq').forEach(function (b) {
    b.classList.toggle('on', !!k && b.getAttribute('data-tpl') === k);
  });
  /* the logo row reads as "done" once a logo is attached, so the customer can
     tell at a glance whether the optional step is satisfied */
  var lg = document.getElementById('svq-logo');
  if (lg) {
    lg.classList.toggle('on', !!st.logo);
    var t = lg.querySelector('.svlogo-tx b');
    if (t) t.textContent = st.logo ? 'Logo added — tap to replace' : 'Upload your logo';
  }
}
/* the logo row under the three background tiles. The picker must open in THIS
   tap: iOS refuses a file input opened later in a promise chain. */
document.addEventListener('click', function (e) {
  var l = e.target && e.target.closest && e.target.closest('#svq-logo');
  if (!l) return;
  if (typeof pickFile === 'function') { try { pickFile('logo', 'logo'); } catch (_) {} }
});
document.addEventListener('click', function (e) {
  var b = e.target && e.target.closest && e.target.closest('.svq');
  if (!b) return;
  /* "Pick a template" is the middle background tile: it carries no template of
     its own, it opens the gallery below (owner 2026-08-12). openGallery() also
     re-renders the grid, which the hidden-getBBox logo bug requires. */
  if (b.getAttribute('data-open') === 'gallery') {
    if (typeof openGallery === 'function') openGallery();
    return;
  }
  var key = b.getAttribute('data-tpl');
  if (typeof selectTemplate === 'function' && SS.tpl(key)) {
    selectTemplate(key, false);
    svquickPaint();
    var ag = document.getElementById('allgal');
    if (ag) ag.open = false;   /* picking a quick option closes the gallery */
    /* "Upload your own" IS the upload button (owner 2026-08-10): the native
       picker opens on THIS tap — same user gesture, no explainer wall in
       between. The long way through the gallery keeps its panel. */
    if (key === 'f_bg_upload' && typeof pickFile === 'function') {
      try { pickFile('bg', 'bg'); } catch (_) {}
    }
  }
});
try { svquickPaint(); } catch (_) {}

/* ——— background carousel under the shape row (owner 2026-08-17) ———
   "under the shape on mobile … a carousel of backgrounds where they can
   scroll through and select … auto rotate … and also an upload your own",
   plus "move the clean foil into the carousel on mobile so we clean up the
   builder". Phones only — the desktop column keeps the full picker, and the
   3-tile #svquick row is display:none under the same breakpoint (see
   ss-builder.css). Tiles are the SAME picks as the gallery: selectTemplate
   does all the real work. The rotation highlight scrolls THE STRIP only —
   scrollIntoView would drag the page vertically (the shape-row lesson,
   2026-08-14). */
function renderBgCarousel() {
  var host = document.getElementById('bgcar');
  if (!host) return;
  var tiles = [];
  if (SS.tpl('f_logo_full')) {
    tiles.push('<button type="button" class="bgcar-t" data-key="f_logo_full" role="option"' +
      ' aria-selected="false" aria-label="Clean Foil — bare holographic foil">' +
      '<span class="bgcar-foil" aria-hidden="true"></span><i>Foil</i></button>');
  }
  /* upload sits SECOND (owner 2026-08-17: "after clean foil, put upload
     your own") — the two bring-your-own options lead, the gallery follows */
  tiles.push('<button type="button" class="bgcar-t bgcar-up" data-key="f_bg_upload" role="option"' +
    ' aria-selected="false" aria-label="Upload your own background — it fills the whole label">' +
    '<span class="bgcar-foil bgcar-plus" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' +
    '<path d="M12 16V5M7.5 9 12 4.5 16.5 9" fill="none" stroke="currentColor" ' +
    'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M5 19h14" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round"/></svg></span><i>Backdrop</i></button>');
  slideList().forEach(function (d) {
    var src = String(d.bg || '');
    src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=180';
    tiles.push('<button type="button" class="bgcar-t" data-key="' + d.key + '" role="option"' +
      ' aria-selected="false" aria-label="' + String(d.name || 'Background').replace(/"/g, '&quot;') + ' background">' +
      '<img src="' + src + '" alt="" loading="lazy" decoding="async">' +
      '<i>' + (d.name || '') + '</i></button>');
  });
  host.innerHTML = tiles.join('');
  if (!host._ssHooked) {
    host._ssHooked = true;
    /* a finger on the strip means they are browsing — the auto-rotation
       yielding here is what makes manual scrolling possible at all */
    host.addEventListener('pointerdown', function () { stopSlideshow(); }, { passive: true });
    /* KEYBOARD PARITY (a11y sweep 2026-08-20): a pointer user stops the
       attract loop the moment they touch the strip, but a keyboard user had
       no equivalent — the preview (and st.tpl with it) kept changing under
       them the whole time they tabbed. Focus entering any builder control is
       the same signal as a finger landing on it. */
  }
  bgcarPaint();
}
function bgcarPaint() {
  var host = document.getElementById('bgcar');
  if (!host || !host.firstChild) return;
  var k = st.tpl && st.tpl.key;
  var on = null;
  host.querySelectorAll('.bgcar-t').forEach(function (b) {
    var hit = b.getAttribute('data-key') === k;
    b.classList.toggle('on', hit);
    b.setAttribute('aria-selected', hit ? 'true' : 'false');
    if (hit) on = b;
  });
  if (on && document.activeElement !== on) {
    var left = Math.max(0, on.offsetLeft - (host.clientWidth - on.offsetWidth) / 2);
    try {
      host.scrollTo({ left: left, behavior:
        matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    } catch (_) { host.scrollLeft = left; }
  }
}
document.addEventListener('click', function (e) {
  var b = e.target && e.target.closest && e.target.closest('.qrmode .qm');
  /* the numbering row borrows .qrmode for its styling only — its chips carry
     data-sm and belong to the .sermode handler below. Without this guard they
     fall through here, and setQrMode(null) coerces to 'own': one tap on a
     numbering chip would silently flip a chosen No-QR seal back to a QR seal.
     .brandmode (Print my name / Logo only) borrows the same furniture and
     carries data-bm — identical trap, identical guard. */
  if (!b || b.closest('.sermode') || b.closest('.brandmode')) return;
  setQrMode(b.getAttribute('data-qm'));
});
/* numbering chips — delegated like the QR row above, so the handler survives
   every renderDetails rebuild. Only two values exist on this row: 'none'
   (plain identical stickers) and 'rand' (the default every new order gets).
   seq/batch still ride in from reorder prefills, invisibly, via
   applyOptionPrefill — tapping "Unique serials" lands on 'rand', which is
   what a new order's serials are. */
document.addEventListener('click', function (e) {
  var b = e.target && e.target.closest && e.target.closest('.sermode .qm');
  if (!b) return;
  var v = b.getAttribute('data-sm') === 'none' ? 'none' : 'rand';
  if (st.serialType === v) return;
  st.serialType = v;
  renderDetails();       /* the chip row + its sub-line live there */
  _refocus('.sermode .qm[data-sm="' + v + '"]');
  renderOptions();       /* mirror setQrMode — the options card may care */
  optionsChanged();      /* refreshGridSoon + sync: the tiles carry the serial */
});
/* ——— "Print my name" / "Logo only" ————————————————————————————————————
   Delegated like the two rows above so it survives every renderDetails()
   rebuild. It deliberately does NOT call renderDetails(): the chips, the
   sub-line and the input's disabled state are all repainted in place by
   paintBrandMode(), which keeps the customer's cursor where they left it and
   keeps the brand demo placeholder from restarting under them. */
document.addEventListener('click', function (e) {
  var b = e.target && e.target.closest && e.target.closest('.brandmode .qm');
  if (!b) return;
  /* 'logo' only where a logo exists. The row is hidden without one, so this
     is the belt for a stale DOM (a rehydrate that failed after the chips
     were painted) — noBrand() would refuse it anyway, but refusing here
     means the chips never show a state the seal will not honour. */
  var v = (b.getAttribute('data-bm') === 'logo' && st.logo) ? 'logo' : '';
  if (st.brandMode === v) return;
  st.brandMode = v;
  /* No _refocus() and no renderDetails(): paintBrandMode() rewrites the row
     in place, so the chip the customer just pressed is still the focused
     element. The QR and numbering rows need the dance only because they
     rebuild #controls out from under themselves. */
  paintBrandMode();
  /* the same helper the QR and numbering chips end on — the gallery/thumb
     tiles carry the brand line too, and sync() repaints the big preview and
     re-runs blockers() for the CTA */
  optionsChanged();
});
document.addEventListener('click', function (e) {
  var b = e.target && e.target.closest && e.target.closest('.bgcar-t');
  if (!b) return;
  var key = b.getAttribute('data-key');
  if (!SS.tpl(key)) return;
  stopSlideshow();
  selectTemplate(key, false);
  svquickPaint();
  var ag = document.getElementById('allgal');
  if (ag) ag.open = false;
  /* same-gesture picker, same reason as the quick tile: iOS refuses a file
     input opened later in a promise chain */
  if (key === 'f_bg_upload' && typeof pickFile === 'function') {
    try { pickFile('bg', 'bg'); } catch (_) {}
  }
});



/* ═══ mouse access for the carousels (owner 2026-08-18: "the carousels on
   desktop can't slide like mobile if no touch screen, needs workaround").
   Hover+fine-pointer devices only — touch already swipes. Arrows page the
   strip, a vertical wheel scrolls it sideways, and the strip drags like a
   swipe; a drag that actually moved swallows the click in the CAPTURE phase
   so releasing over a tile never selects it. Everything binds to the strip
   HOSTS (#shapequick / #bgcar), which survive the attract loop's innerHTML
   repaints. */
(function () {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  ['shapequick', 'bgcar'].forEach(function (id) {
    var strip = document.getElementById(id);
    if (!strip || strip._mousy) return;
    strip._mousy = true;
    /* arrows need a positioning context that does NOT scroll with the
       content — a wrapper around the strip */
    var wrap = document.createElement('div');
    wrap.className = 'carwrap';
    strip.parentNode.insertBefore(wrap, strip);
    wrap.appendChild(strip);
    var arr = {};
    [['l', -1, 'Scroll backwards'], ['r', 1, 'Scroll forwards']].forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'car-arr ' + a[0];
      b.setAttribute('aria-label', a[2]);
      b.innerHTML = a[0] === 'l' ? '\u2039' : '\u203a';
      b.onclick = function () {
        /* browsing intent — the attract loop's paint scrolls the strip back
           to the selected tile every tick and would fight the arrow */
        try { stopSlideshow(); } catch (_) {}
        strip.scrollBy({ left: a[1] * Math.round(strip.clientWidth * 0.8), behavior: 'smooth' });
      };
      wrap.appendChild(b);
      arr[a[0]] = b;
    });
    function paintArrows() {
      var max = strip.scrollWidth - strip.clientWidth;
      arr.l.hidden = max < 8 || strip.scrollLeft < 8;
      arr.r.hidden = max < 8 || strip.scrollLeft > max - 8;
    }
    strip.addEventListener('scroll', paintArrows, { passive: true });
    addEventListener('resize', paintArrows);
    new MutationObserver(paintArrows).observe(strip, { childList: true });
    paintArrows();
    /* vertical wheel = horizontal scroll, only while the strip can move —
       otherwise the page keeps the wheel */
    strip.addEventListener('wheel', function (e) {
      if (strip.scrollWidth - strip.clientWidth < 8) return;
      var d = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      if (!d) return;
      try { stopSlideshow(); } catch (_) {}
      strip.scrollLeft += d;
      e.preventDefault();
    }, { passive: false });
    /* grab-to-drag — the mouse version of the swipe */
    var dn = null;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dn = { x: e.clientX, sl: strip.scrollLeft, moved: false, id: e.pointerId };
    });
    strip.addEventListener('pointermove', function (e) {
      if (!dn) return;
      var dx = e.clientX - dn.x;
      if (!dn.moved && Math.abs(dx) > 4) {
        dn.moved = true;
        strip.classList.add('dragging');
        try { strip.setPointerCapture(dn.id); } catch (_) {}
      }
      if (dn.moved) strip.scrollLeft = dn.sl - dx;
    });
    function dragEnd() {
      if (!dn) return;
      var was = dn.moved;
      dn = null;
      strip.classList.remove('dragging');
      if (was) {
        strip._swallow = true;
        setTimeout(function () { strip._swallow = false; }, 80);
      }
    }
    strip.addEventListener('pointerup', dragEnd);
    strip.addEventListener('pointercancel', dragEnd);
    /* capture phase: a drag-release over a tile is not a pick */
    strip.addEventListener('click', function (e) {
      if (strip._swallow) { e.stopPropagation(); e.preventDefault(); }
    }, true);
  });
})();

/* --- LABEL SIZE CARDS (owner 2026-08-29) --------------------------------
   Standard live; Large visible, locked COMING SOON. The unlock is
   availability-driven: when /products/<WIDE_HANDLE>.js exists AND its first
   variant is available, the card enables with NO redeploy - but selection
   stays a no-op until the cart wiring pass lands, so a stocked product can
   never half-work. */
(function sizeCards() {
  'use strict';
  var WIDE_HANDLE = 'custom-serial-seals-large';   /* created unpublished later */
  var mountEl = document.getElementById('ss-size-pick');
  if (!mountEl) return;
  var SZ = (window.SS_SEAL && SS_SEAL.SIZES) || {};
  function dims(id, fall) {
    var z = SZ[id]; if (!z) return fall;
    return z.longIn + '\u2033 \u00d7 ' + z.shortIn + '\u2033';
  }
  mountEl.innerHTML =
    '<button type="button" class="ss-size-card" role="radio" aria-checked="true" data-size="standard_177x075">' +
      '<b>STANDARD</b><span class="dim">' + dims('standard_177x075', '1.77\u2033 \u00d7 0.75\u2033') + '</span>' +
      '<span class="sub">Original size</span></button>' +
    '<button type="button" class="ss-size-card" role="radio" aria-checked="false" aria-disabled="true" data-size="large_250x100">' +
      '<span class="soon">COMING SOON</span>' +
      '<b>LARGE</b><span class="dim">' + dims('large_250x100', '2.5\u2033 \u00d7 1\u2033') + '</span>' +
      '<span class="sub">More room for branding</span></button>';
  var cards = mountEl.querySelectorAll('.ss-size-card');
  var largeCard = cards[1];
  /* Large is selectable as a LIVE PREVIEW (owner 2026-08-29) - the chip and
     the blockers() gate keep it un-orderable until launch */
  largeCard.removeAttribute('aria-disabled');
  function applySize(id) {
    /* SMOOTH SIZE SWAP (owner 2026-08-30: "the animation when i change the
       paper size needs to be done, its not smooth at all"). The aspect flip
       and the re-mount land in one frame, so the stage used to snap. FLIP:
       measure every visible seal stage BEFORE the switch, let the switch
       land, then tween each stage's height from old to new while the fresh
       mount fades in. Honors prefers-reduced-motion. */
    var _rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var _stages = (_rm || !document.body.animate) ? [] :
      [].slice.call(document.querySelectorAll('.ss-seal'))
        .map(function (el) {
          var sv = el.querySelector('svg');
          return { el: el, h: el.getBoundingClientRect().height,
                   ghost: sv ? sv.cloneNode(true) : null };
        })
        .filter(function (s2) { return s2.h > 0; });
    st.sizeId = id;
    cards.forEach(function (c2) {
      c2.setAttribute('aria-checked', c2.getAttribute('data-size') === id ? 'true' : 'false');
    });
    /* one root class re-aspects every .ss-seal container; sync() is the
       same master repaint a shape change runs, so every surface re-mounts */
    document.documentElement.classList.toggle('ss-size-large', id === 'large_250x100');
    if (typeof renderOrient === 'function') { try { renderOrient(); } catch (_) {} }
    if (typeof renderShapeQuick === 'function') { try { setTimeout(renderShapeQuick, 0); } catch (_) {} }
    /* the tier strip re-prices for the selected size (large = 2x pack) */
    if (typeof renderQtiers === 'function') { try { renderQtiers(); } catch (_) {} }
    if (typeof setDims === 'function') { try { setDims(); } catch (_) {} }
    /* foil availability is PER SIZE (two products) - repaint the picker */
    if (typeof renderMaterial === 'function') { try { renderMaterial(); } catch (_) {} }
    if (window._svPaintPrice) { try { window._svPaintPrice(); } catch (_) {} }
    /* stored upload verdicts were computed against the OLD physical size -
       re-derive DPI against the new target; drop the bg crop cache so the
       crop re-runs at the new aspect */
    _bgCropCache = { sig: '', url: '' };
    ['bg', 'artwork'].forEach(function (sk) {
      var it = st[sk];
      if (!it || !it.dataUrl || it.dpi == null) return;
      var im2 = new Image();
      im2.onload = function () {
        try {
          var T2 = SS_UPLOAD.target(st.tpl, st.orientation);
          it.dpi = Math.floor(Math.min(im2.naturalWidth / T2.wIn, im2.naturalHeight / T2.hIn));
        } catch (_) {}
      };
      im2.src = it.dataUrl;
    });
    if (typeof sync === 'function') { try { sync(); } catch (_) {} }
    else if (typeof renderPreview === 'function') { try { renderPreview(); } catch (_) {} }
    if (typeof paintPrice === 'function') { try { paintPrice(); } catch (_) {} }
    if (_stages.length) requestAnimationFrame(function () {
      _stages.forEach(function (s2) {
        if (!document.contains(s2.el)) return;
        var h1 = s2.el.getBoundingClientRect().height;
        if (Math.abs(h1 - s2.h) < 1) return;
        /* Apple-feel: one long settling curve (the iOS sheet spring) and a
           pure cross-dissolve - the ghost fading out on TOP of the live
           proof IS the dissolve, so nothing ever dips dark. */
        var DUR = 480, EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
        /* Both proofs STRETCH to fill the stage while it morphs
           (preserveAspectRatio none) - the mid-tween aspect mismatch used to
           letterbox and show the page behind as white bars. The old proof
           rides on top as a ghost and crossfades into the new one, so the
           swap reads as one continuous morph. */
        /* the fresh proof can mount a frame or two AFTER this runs (sync is
           debounced), so assert the stretch on whatever svg is live on EVERY
           frame of the tween, then clear it once settled */
        var _t0 = performance.now();
        (function _stretchTick() {
          var s = s2.el.querySelector('svg:not([data-ghost])');
          if (performance.now() - _t0 < DUR + 40) {
            if (s && s.getAttribute('preserveAspectRatio') !== 'none')
              s.setAttribute('preserveAspectRatio', 'none');
            requestAnimationFrame(_stretchTick);
          } else if (s) s.removeAttribute('preserveAspectRatio');
        })();
        var holder = null;
        if (s2.ghost) {
          s2.ghost.setAttribute('preserveAspectRatio', 'none');
          s2.ghost.setAttribute('data-ghost', '1');
          s2.ghost.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block;';
          holder = document.createElement('div');
          holder.style.cssText = 'position:absolute;inset:0;pointer-events:none;overflow:hidden;';
          holder.style.borderRadius = getComputedStyle(s2.el).borderRadius;
          holder.appendChild(s2.ghost);
          /* the overlay lives in the stage's PARENT: the debounced re-mount
             wipes the stage's own children mid-tween, and the ghost died
             with them - the dissolve popped at ~40% instead of riding the
             full curve */
          var _host = s2.el.parentElement || s2.el;
          if (getComputedStyle(_host).position === 'static') _host.style.position = 'relative';
          _host.appendChild(holder);
        }
        var anim = s2.el.animate([{ height: s2.h + 'px' }, { height: h1 + 'px' }],
                                 { duration: DUR, easing: EASE });
        if (holder) holder.animate([{ opacity: 1 }, { opacity: 0 }],
                                   { duration: DUR, easing: EASE });
        function _done() {
          if (holder && holder.parentNode) holder.parentNode.removeChild(holder);
        }
        if (anim.finished && anim.finished.then) anim.finished.then(_done, _done);
        else setTimeout(_done, DUR + 60);
      });
    });
  }
  window.SS_applySize = applySize;   /* prefills (reorder / cart edit) call this */
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      applySize(card.getAttribute('data-size'));
    });
  });
  /* a prefill that landed before this IIFE ran already set st.sizeId; the
     Large product page hands off with ?size=large (product.redirect-large) */
  if (st.sizeId !== 'large_250x100' && /[?&]size=large(?:_250x100)?(?:&|$)/.test(location.search)) st.sizeId = 'large_250x100';
  if (st.sizeId === 'large_250x100') { try { applySize('large_250x100'); } catch (_) {} }
  /* availability probe - 404/unavailable keeps COMING SOON; available flips
     the chip copy so launch day reads right even before the wiring pass */
  /* RETRY like the Standard loader: one 429 / dropped response used to strand
     the whole session on COMING SOON with Large un-orderable (audit 2026-09-02) */
  var _lgTries = 0;
  function loadLarge() {
  fetch('/products/' + WIDE_HANDLE + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
    .then(function (p) {
      /* the same fetch that answers "is it live yet" also carries the LIVE
         market-localized price - hand it to the pricing engine */
      try { if (p && p.variants && p.variants.length) SV_PRODUCT_LG = p; } catch (_) {}
      var avail = !!(p && p.variants && p.variants.some(function (v) { return v.available; }));
      if (avail) {
        /* LIVE: the chip goes, the card is a plain size choice */
        var chip = largeCard.querySelector('.soon');
        if (chip && chip.parentNode) chip.parentNode.removeChild(chip);
        largeCard.setAttribute('data-live', '1');
      }
      /* the Large product's own availability drives the foil picker + price
         when Large is the selected size */
      if (typeof renderMaterial === 'function') { try { renderMaterial(); } catch (_) {} }
      if (window._svPaintPrice) { try { window._svPaintPrice(); } catch (_) {} }
      if (typeof renderQtiers === 'function') { try { renderQtiers(); } catch (_) {} }
      if (typeof sync === 'function') { try { sync(); } catch (_) {} }
    })
    .catch(function () {
      /* a 404 means not published (COMING SOON stands); anything else is a
         transient and gets four more tries before we believe it */
      if (++_lgTries <= 4) setTimeout(loadLarge, _lgTries * 1500);
    });
  }
  loadLarge();
})();
